(function () {
  if (window.OptiplexVtToolsInitialized) return;
  window.OptiplexVtToolsInitialized = true;

  var apps = document.querySelectorAll('[data-vt-app]');
  var DTVP_WORKSHEET_PDF_URL = 'https://cdn.shopify.com/s/files/1/0379/9148/1480/files/DTVP_hand_Drawing_HD.pdf?v=1782561053';

  var exerciseInstructions = {
    'Hart chart near-far practice': 'Read from the far chart, then the near chart, switching between the two. Try to keep the letters clear. Stop if it causes significant discomfort.',
    'accommodative flippers': 'Look through the lenses and wait until the letters become clear before flipping to the other side. Stop if it causes significant discomfort.',
    'near-far jumps': 'Look from the near target to the far target as instructed. Try to keep each target clear before switching.',
    'Brock string': 'Look at the bead and try to keep it single. The strings should appear to cross at the bead. Stop if double vision does not resolve or symptoms worsen.',
    'saccadic charts': 'Move your eyes between the targets as accurately as possible while keeping your head still.',
    'pursuit/tracking target': 'Follow the moving target smoothly with your eyes while keeping your head still.',
    'Marsden ball': 'Follow or call out the target on the ball as instructed. Keep movements controlled and stop if dizzy or uncomfortable.',
    'line walking': 'Walk along the line slowly while keeping eyes on the target as instructed. Stop if balance or dizziness becomes a concern.',
    'eye stretches / eye circles': 'Move the eyes slowly as instructed. Do not force movement. Stop if pain occurs.',
    'home reinforcement task': 'Complete the home reinforcement task as instructed. Stop if it causes significant discomfort.',
    'custom exercise': 'Complete the custom exercise only as instructed. Stop if symptoms become significant.'
  };

  apps.forEach(function (app) {
    var state = {
      notes: [],
      metronomes: new Map(),
      timers: new Map(),
      exerciseTimers: new Map(),
      exerciseAnimations: new Map(),
      promptTimers: new Map(),
      visualTimers: new Map(),
      visualTimeouts: new Map(),
      activeOverlayModule: null,
      toastTimer: null,
      audioContext: null
    };

    initPinGate(app);
    initDefaultReview(app);
    initFormalTestGates(app);
    initVisualProcessing(app, state);
    initVipAssessments(app);
    refreshAllModules(app);
    renderSummary(app, state);

    app.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-vt-tab]');
      var go = event.target.closest('[data-vt-go]');
      var action = event.target.closest('[data-vt-action]');

      if (tab && app.contains(tab)) {
        if (app.getAttribute('data-vt-unlocked') !== 'true' && app.getAttribute('data-pin-enabled') === 'true') {
          return;
        }
        setTab(app, tab.getAttribute('data-vt-tab'));
        return;
      }

    if (go && app.contains(go)) {
        if (app.getAttribute('data-vt-unlocked') !== 'true' && app.getAttribute('data-pin-enabled') === 'true') {
          return;
        }
        setTab(app, go.getAttribute('data-vt-go'));
        return;
      }

      if (!action || !app.contains(action)) {
        return;
      }

      var actionName = action.getAttribute('data-vt-action');
      if (app.getAttribute('data-vt-unlocked') !== 'true' && app.getAttribute('data-pin-enabled') === 'true' && actionName !== 'unlock-pin') {
        return;
      }

      handleAction(app, state, action);
    });

    app.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' || !event.target.matches('[data-vt-pin-input]')) {
        if (event.key === 'Escape') {
          closeVisualFullscreen(app);
          closeVipGameFullscreen(app);
          closeVipCompletionDialog(app);
        }
        return;
      }

      event.preventDefault();
      unlockPin(app);
    });

    app.addEventListener('input', function (event) {
      var module = event.target.closest('[data-vt-module]');
      if (module) {
        updateModule(module);
        updateExerciseVisual(module);
      }

      if (event.target.matches('[data-vt-overlay-size]')) {
        updateOverlayTargetSize(state.activeOverlayModule, event.target.value);
      }

      if (event.target.matches('[data-vt-calibration-field]')) {
        updateCalibration(app);
      }

      if (event.target.matches('[data-vt-summary-field]')) {
        renderSummary(app, state);
      }

      if (event.target.matches('[data-vt-dtvp-age-input]')) {
        updateDtvpAgeWorkflow(app);
        updateVipAssessmentModules(app);
      }

      if (event.target.closest('[data-vt-exercises]')) {
        renderParentInstructions(module);
        renderSummary(app, state);
      }
    });

    app.addEventListener('change', function (event) {
      var module = event.target.closest('[data-vt-module]');
      if (module) {
        updateModule(module);
        updateExerciseVisual(module);
      }

      if (event.target.matches('[data-vt-overlay-size]')) {
        updateOverlayTargetSize(state.activeOverlayModule, event.target.value);
      }

      if (event.target.matches('[data-vt-calibration-field]')) {
        updateCalibration(app);
      }

      if (event.target.matches('[data-vt-summary-field]')) {
        renderSummary(app, state);
      }

      if (event.target.matches('[data-vt-formal-unlock]')) {
        toggleFormalTestGate(event.target.closest('[data-vt-module]'));
      }

      if (event.target.matches('[data-vt-vp-age-band]')) {
        updateVisualAgeGuides(app);
      }

      if (event.target.matches('[data-vt-vip-age-band]')) {
        updateDtvpAgeWorkflow(app);
        updateVipAssessmentModules(app);
        renderVipOverallSummary(app);
      }

      if (event.target.matches('[data-vt-dtvp-age-input], [data-vt-dtvp-testing-mode]')) {
        updateDtvpAgeWorkflow(app);
        updateVipAssessmentModules(app);
      }

      if (event.target.closest('[data-vt-exercises]')) {
        renderParentInstructions(module);
        renderSummary(app, state);
      }
    });

    updateCalibration(app);
    app.dataset.vtPrimaryReady = 'true';
  });

  function initPinGate(app) {
    var enabled = true;
    var configured = app.getAttribute('data-pin-configured') === 'true';
    var pinPanel = app.querySelector('[data-vt-pin-panel]');
    var tool = app.querySelector('[data-vt-tool]');

    app.setAttribute('data-vt-unlocked', enabled ? 'false' : 'true');
    if (enabled) {
      if (pinPanel) {
        pinPanel.hidden = false;
      }
      if (tool) {
        tool.hidden = true;
        tool.style.setProperty('display', 'none', 'important');
        tool.classList.add('vt-locked-content');
        tool.setAttribute('aria-hidden', 'true');
      }
      setUnlockedOnly(app, false);
      return;
    }

    if (!enabled || configured) {
      if (pinPanel) {
        pinPanel.hidden = true;
      }
      if (tool) {
        tool.hidden = false;
        tool.style.removeProperty('display');
        tool.classList.remove('vt-locked-content');
        tool.removeAttribute('aria-hidden');
      }
      setUnlockedOnly(app, true);
    }
  }

  function initDefaultReview(app) {
    var defaultReview = app.getAttribute('data-default-review') || '';
    var reviewSelect = app.querySelector('[data-vt-summary-field="review"]');
    if (reviewSelect && defaultReview) {
      reviewSelect.value = defaultReview;
    }
  }

  function initFormalTestGates(app) {
    app.querySelectorAll('.vt-formal-entry').forEach(function (module) {
      toggleFormalTestGate(module);
    });
  }

  function toggleFormalTestGate(module) {
    if (!module) {
      return;
    }
    var confirmation = module.querySelector('[data-vt-formal-unlock]');
    var enabled = !!(confirmation && confirmation.checked);
    module.querySelectorAll('[data-vt-formal-controlled]').forEach(function (field) {
      field.disabled = !enabled;
    });
  }

  function handleAction(app, state, actionButton) {
    var action = actionButton.getAttribute('data-vt-action');
    var module = actionButton.closest('[data-vt-module]');
    if (!module && actionButton.hasAttribute('data-vt-overlay-control')) {
      module = state.activeOverlayModule;
    }

    if (action === 'unlock-pin') {
      unlockPin(app);
      return;
    }

    if (action === 'add-summary' && module) {
      addModuleToSummary(app, state, module);
      return;
    }

    if (action === 'copy-module' && module) {
      copyText(app, moduleNote(module), 'Module note copied.');
      return;
    }

    if (action === 'reset-module' && module) {
      resetModule(module, state);
      state.notes = state.notes.filter(function (item) {
        return item.key !== module.getAttribute('data-vt-module');
      });
      renderSummary(app, state);
      showToast(app, 'Module reset.');
      return;
    }

    if (action === 'copy-full-summary') {
      renderSummary(app, state);
      copyText(app, fullSummaryText(app, state.notes), 'Full Optomate summary copied.');
      return;
    }

    if (action === 'print-summary') {
      setTab(app, 'summary');
      renderSummary(app, state);
      window.print();
      return;
    }

    if (action === 'print-dtvp-materials') {
      printDtvpMaterials(app);
      return;
    }

    if (action === 'reset-all') {
      resetAll(app, state);
      return;
    }

    if (action === 'lock-and-clear') {
      lockAndClear(app, state);
      return;
    }

    if (action === 'go-summary') {
      setTab(app, 'summary');
      return;
    }

    if (action === 'toggle-metronome') {
      toggleMetronome(app, state, actionButton);
      return;
    }

    if (action === 'toggle-random-grid' && module) {
      toggleRandomGrid(module, actionButton);
      updateModule(module);
      return;
    }

    if (action === 'exercise-start' && module) {
      startLiveExercise(app, state, module);
      return;
    }

    if (action === 'exercise-pause' && module) {
      pauseLiveExercise(state, module);
      return;
    }

    if (action === 'exercise-reset' && module) {
      resetLiveExercise(state, module);
      updateModule(module);
      return;
    }

    if (action === 'exercise-counter' && module) {
      incrementExerciseCounter(module, actionButton.getAttribute('data-vt-counter'));
      updateModule(module);
      return;
    }

    if (action === 'exercise-next-prompt' && module) {
      switchPrompt(module);
      updateModule(module);
      return;
    }

    if (action === 'line-next' && module) {
      moveReadingLine(module, 1);
      return;
    }

    if (action === 'line-prev' && module) {
      moveReadingLine(module, -1);
      return;
    }

    if (action === 'open-patient-screen' && module) {
      openPatientScreen(app, state, module);
      return;
    }

    if (action === 'close-patient-screen') {
      closePatientScreen(app, state);
      return;
    }

    if (action === 'exercise-pause-overlay') {
      if (state.activeOverlayModule) {
        pauseLiveExercise(state, state.activeOverlayModule);
        updateOverlayControls(app, state.activeOverlayModule);
      }
      return;
    }

    if (action === 'add-home-plan' && module) {
      addExerciseToHomePlan(app, module.getAttribute('data-vt-title') || 'custom exercise');
      return;
    }

    if (action === 'add-home-plan-library') {
      addExerciseToHomePlan(app, libraryExerciseName(actionButton));
      return;
    }

    if (action === 'show-parent-plan') {
      showParentPlan(app, state);
      return;
    }

    if (action === 'copy-home-plan') {
      var planModule = app.querySelector('[data-vt-module="exercisePlan"]');
      copyText(app, planModule ? moduleNote(planModule) : '', 'Home exercise plan copied.');
      return;
    }

    if (action.indexOf('apply-calibration-') === 0) {
      applyCalibration(app, action.replace('apply-calibration-', ''));
      return;
    }

    if (action === 'vp-pathway') {
      setVisualPathway(app, actionButton.getAttribute('data-vt-vp-pathway') || 'assessment');
      return;
    }

    if (action === 'vp-apply-age-settings') {
      applyVisualAgeSettings(app, state);
      return;
    }

    if (action === 'vip-assessment-switch') {
      switchVipAssessment(app, actionButton.getAttribute('data-vt-vip-target') || 'dtvp');
      return;
    }

    if (action === 'dtvp-age-advanced-toggle') {
      toggleDtvpAgeAdvanced(app, actionButton);
      return;
    }

    if (action === 'vip-complete-close') {
      closeVipCompletionDialog(app);
      return;
    }

    if (action === 'vip-complete-exit') {
      closeVipCompletionDialog(app);
      closeVipGameFullscreen(app);
      return;
    }

    if (action === 'vip-go-training') {
      closeVipCompletionDialog(app);
      closeVipGameFullscreen(app);
      setTab(app, 'vision-processing-training');
      return;
    }

    if (action.indexOf('vip-game-') === 0 && module) {
      handleVipGameAction(app, module, actionButton, action);
      return;
    }

    if (action.indexOf('vp-') === 0 && module) {
      handleVisualProcessingAction(app, state, module, actionButton, action);
      return;
    }

    if (action.indexOf('timer-') === 0) {
      handleTimer(app, state, actionButton, action);
    }
  }

  function printDtvpMaterials(app) {
    var opened = window.open(DTVP_WORKSHEET_PDF_URL, '_blank', 'noopener');
    if (!opened) {
      showToast(app, 'Worksheet PDF blocked. Allow pop-ups, or open: ' + DTVP_WORKSHEET_PDF_URL);
      return;
    }
    showToast(app, 'Worksheet PDF opened in a new tab.');
  }

  function dtvpPrintReferenceImage(key, alt, className, fallbackHtml) {
    var images = window.OptiplexDtvpPrintImages || {};
    var src = images[key];
    if (!src) return fallbackHtml || '';
    return '<img class="print-hand-eye-img ' + className + '" src="' + src + '" alt="' + alt + '" loading="eager" decoding="sync">';
  }

  function dtvpPrintWorksheetPageImage(key, alt) {
    var pages = window.OptiplexDtvpWorksheetPages || {};
    var src = pages[key];
    if (!src) return '<p class="sheet-note">Worksheet image unavailable. Re-upload the DTVP hand Drawing worksheet assets.</p>';
    return '<img class="worksheet-page-image" src="' + src + '" alt="' + alt + '" loading="eager" decoding="sync">';
  }

  function dtvpPrintTraceSvg(kind, title, className) {
    var body = '';
    if (kind === 'straight-wide') {
      body = dtvpSvgStraightTrack(32, 50, 264, 50, 24, 8) + dtvpSvgMouse(18, 50) + dtvpSvgCheese(282, 50);
    } else if (kind === 'straight-narrow') {
      body = dtvpSvgStraightTrack(32, 50, 264, 50, 14, 8) + dtvpSvgCar(18, 50, 0.42) + dtvpSvgHouse(282, 50);
    } else if (kind === 'straight-lined') {
      body = dtvpSvgStraightTrack(32, 52, 264, 52, 20, 8) + dtvpSvgDog(18, 52) + dtvpSvgBone(282, 52);
    } else if (kind === 'curved-s') {
      body = '<path class="path-bg" d="M28 70 H72 C95 70 88 120 118 120 C150 120 150 44 183 44 C207 44 204 120 224 120 C252 120 244 68 274 68 H292"/>' +
        dtvpSvgLanePath('M28 70 H72 C95 70 88 120 118 120 C150 120 150 44 183 44 C207 44 204 120 224 120 C252 120 244 68 274 68 H292', 19) +
        dtvpSvgBee(14, 70) + dtvpSvgFlower(306, 68);
    } else {
      body = '<path class="path-bg" d="M160 154 C264 154 288 52 160 52 C32 52 56 154 160 154"/>' +
        dtvpSvgLanePath('M160 154 C264 154 288 52 160 52 C32 52 56 154 160 154', 17) +
        dtvpSvgCar(160, 166, 0.5);
    }
    return '<div class="' + className + '"><svg viewBox="0 0 320 180" role="img" aria-label="' + title + '"><text x="8" y="12" class="label">' + title + '</text>' + body + '</svg></div>';
  }

  function dtvpSvgStraightTrack(x1, y1, x2, y2, halfWidth, segments) {
    var lines = '<path class="path-bg" d="M' + x1 + ' ' + y1 + ' H' + x2 + '"/>';
    for (var lane = -halfWidth; lane <= halfWidth; lane += halfWidth / 3) {
      lines += '<path class="lane" d="M' + x1 + ' ' + (y1 + lane) + ' H' + x2 + '"/>';
    }
    lines += '<path class="track" d="M' + x1 + ' ' + y1 + ' H' + x2 + '"/>';
    for (var i = 1; i <= segments; i += 1) {
      var x = x1 + (x2 - x1) * i / (segments + 1);
      lines += '<text class="small-label" x="' + (x - 2) + '" y="' + (y1 - halfWidth - 5) + '">' + i + '</text>';
    }
    return lines;
  }

  function dtvpSvgLanePath(path, segments) {
    var svg = '';
    for (var i = 0; i < 6; i += 1) svg += '<path class="lane" d="' + path + '"/>';
    svg += '<path class="track" d="' + path + '"/>';
    for (var n = 1; n <= segments; n += 1) {
      svg += '<text class="small-label" x="' + (22 + n * 14) + '" y="' + (n % 2 ? 36 : 148) + '">' + n + '</text>';
    }
    return svg;
  }

  function dtvpPrintCopyCards(start, end) {
    var names = ['Vertical line', 'Horizontal line', 'Descending diagonal', 'Ascending diagonal', 'Circle', 'Cross', 'X / diagonals', 'Square', 'Triangle', 'Circle + lines', 'Four-section rectangle', 'Curved-side triangle', 'Trapezoid', 'Diamond + cross', 'Rectangle + diamond', 'Pentagon', 'Triangle/circle/spokes', 'Complex angular form'];
    var shapes = ['verticalLine', 'horizontalLine', 'diagDown', 'diagUp', 'circle', 'cross', 'xShape', 'square', 'triangle', 'circleSegments', 'fourRect', 'curvedTriangle', 'trapezoid', 'diamondCross', 'rectangleDiamond', 'pentagon', 'triangleCircleSpokes', 'complexDiamondTriangle'];
    var html = '';
    for (var i = start; i <= end; i += 1) {
      html += '<article class="copy-card"><h3>Item ' + i + ' — ' + names[i - 1] + '</h3><div class="copy-model">' + dtvpCopySvg(shapes[i - 1]) + '</div><div class="draw-box"></div></article>';
    }
    return html;
  }

  function dtvpCopySvg(shape) {
    var body = {
      verticalLine: '<line class="track" x1="80" y1="18" x2="80" y2="82"/>',
      horizontalLine: '<line class="track" x1="30" y1="50" x2="130" y2="50"/>',
      diagDown: '<line class="track" x1="40" y1="22" x2="120" y2="78"/>',
      diagUp: '<line class="track" x1="40" y1="78" x2="120" y2="22"/>',
      circle: '<circle class="track" cx="80" cy="50" r="28"/>',
      cross: '<line class="track" x1="40" y1="50" x2="120" y2="50"/><line class="track" x1="80" y1="15" x2="80" y2="85"/>',
      xShape: '<line class="track" x1="45" y1="18" x2="115" y2="82"/><line class="track" x1="115" y1="18" x2="45" y2="82"/>',
      square: '<rect class="track" x="52" y="22" width="56" height="56"/>',
      triangle: '<path class="track" d="M80 18 L118 78 H42 Z"/>',
      circleSegments: '<circle class="track" cx="80" cy="50" r="30"/><line class="track" x1="52" y1="50" x2="108" y2="50"/><line class="track" x1="80" y1="22" x2="80" y2="78"/>',
      fourRect: '<rect class="track" x="42" y="24" width="76" height="52"/><line class="track" x1="80" y1="24" x2="80" y2="76"/><line class="track" x1="42" y1="50" x2="118" y2="50"/>',
      curvedTriangle: '<path class="track" d="M52 16 Q32 50 52 84 M108 16 Q128 50 108 84 M80 20 L112 76 H48 Z"/>',
      trapezoid: '<path class="track" d="M58 28 H102 L122 76 H38 Z"/>',
      diamondCross: '<path class="track" d="M80 16 L120 50 L80 84 L40 50 Z M80 16 V84 M40 50 H120"/>',
      rectangleDiamond: '<rect class="track" x="36" y="24" width="88" height="52"/><path class="track" d="M80 28 L112 50 L80 72 L48 50 Z"/>',
      pentagon: '<path class="track" d="M80 14 L118 42 L104 84 H56 L42 42 Z"/>',
      triangleCircleSpokes: '<path class="track" d="M80 14 L122 82 H38 Z"/><circle class="track" cx="80" cy="54" r="18"/><line class="track" x1="80" y1="36" x2="80" y2="72"/><line class="track" x1="64" y1="46" x2="96" y2="62"/><line class="track" x1="96" y1="46" x2="64" y2="62"/>',
      complexDiamondTriangle: '<path class="track" d="M80 12 L124 50 L80 88 L36 50 Z M36 50 L80 12 L124 50 M56 74 L80 42 L104 74"/>'
    }[shape] || '';
    return '<svg viewBox="0 0 160 100" aria-hidden="true">' + body + '</svg>';
  }

  function dtvpSvgMouse(x, y) {
    return '<g transform="translate(' + x + ' ' + y + ')"><ellipse class="icon" cx="0" cy="0" rx="12" ry="8"/><circle class="icon" cx="10" cy="-4" r="5"/><path class="icon" d="M-12 2 Q-24 8 -30 0"/><circle cx="12" cy="-5" r="1.2"/></g>';
  }

  function dtvpSvgCheese(x, y) {
    return '<g transform="translate(' + x + ' ' + y + ')"><path class="icon" d="M-14 10 L-6 -12 L18 -5 L12 12 Z"/><circle class="icon" cx="2" cy="0" r="2.5"/><circle class="icon" cx="10" cy="-4" r="2"/></g>';
  }

  function dtvpSvgCar(x, y, scale) {
    return '<g transform="translate(' + x + ' ' + y + ') scale(' + (scale || 1) + ')"><rect class="icon" x="-28" y="-10" width="56" height="22" rx="6"/><path class="icon" d="M-10 -10 L0 -22 H16 L26 -10"/><circle class="icon" cx="-18" cy="14" r="6"/><circle class="icon" cx="18" cy="14" r="6"/></g>';
  }

  function dtvpSvgHouse(x, y) {
    return '<g transform="translate(' + x + ' ' + y + ')"><path class="icon" d="M-18 12 V-8 L0 -22 L18 -8 V12 Z"/><rect class="icon" x="-7" y="-2" width="14" height="14"/></g>';
  }

  function dtvpSvgDog(x, y) {
    return '<g transform="translate(' + x + ' ' + y + ')"><ellipse class="icon" cx="0" cy="0" rx="16" ry="8"/><circle class="icon" cx="15" cy="-5" r="7"/><path class="icon" d="M-14 2 L-22 10 M-4 7 L-4 18 M8 7 L8 18 M20 -5 L26 -9"/><circle cx="17" cy="-6" r="1"/></g>';
  }

  function dtvpSvgBone(x, y) {
    return '<g transform="translate(' + x + ' ' + y + ')"><path class="icon" d="M-18 -6 C-26 -16 -38 -4 -28 4 C-38 14 -24 24 -16 12 H16 C24 24 38 14 28 4 C38 -4 26 -16 18 -6 Z"/></g>';
  }

  function dtvpSvgBee(x, y) {
    return '<g transform="translate(' + x + ' ' + y + ')"><ellipse class="icon" cx="0" cy="0" rx="12" ry="8"/><path class="icon" d="M-4 -8 Q-14 -22 -24 -10 M4 -8 Q14 -22 24 -10 M-16 0 H16 M-6 -8 V8 M6 -8 V8"/></g>';
  }

  function dtvpSvgFlower(x, y) {
    return '<g transform="translate(' + x + ' ' + y + ')"><circle class="icon" cx="0" cy="0" r="5"/><circle class="icon" cx="0" cy="-10" r="5"/><circle class="icon" cx="10" cy="0" r="5"/><circle class="icon" cx="-10" cy="0" r="5"/><circle class="icon" cx="0" cy="10" r="5"/><path class="icon" d="M0 12 V34 M0 24 Q-12 24 -14 34"/></g>';
  }

  function unlockPin(app) {
    var code = app.getAttribute('data-pin-code') || '';
    var configured = app.getAttribute('data-pin-configured') === 'true';
    var input = app.querySelector('[data-vt-pin-input]');
    var error = app.querySelector('[data-vt-pin-error]');
    var panel = app.querySelector('[data-vt-pin-panel]');
    var tool = app.querySelector('[data-vt-tool]');
    var entered = input ? input.value.trim() : '';

    if (configured && code.trim() && entered === code.trim()) {
      if (panel) {
        panel.hidden = true;
      }
      if (tool) {
        tool.hidden = false;
        tool.style.removeProperty('display');
        tool.classList.remove('vt-locked-content');
        tool.removeAttribute('aria-hidden');
      }
      app.setAttribute('data-vt-unlocked', 'true');
      setUnlockedOnly(app, true);
      if (input) {
        input.value = '';
      }
      showToast(app, 'Tools unlocked for this page session.');
    } else if (error) {
      error.hidden = false;
    }
  }

  function setUnlockedOnly(app, unlocked) {
    app.querySelectorAll('[data-vt-unlocked-only]').forEach(function (item) {
      item.hidden = !unlocked;
      if (unlocked) {
        item.style.removeProperty('display');
      } else {
        item.style.setProperty('display', 'none', 'important');
      }
      item.classList.toggle('vt-hidden-before-unlock', !unlocked);
    });
  }

  function setTab(app, tabName) {
    if (tabName !== 'vision-processing-training') {
      closeVisualFullscreen(app);
    }
    if (tabName !== 'vision-processing-assessment') {
      closeVipGameFullscreen(app);
      closeVipCompletionDialog(app);
    }
    app.querySelectorAll('[data-vt-tab]').forEach(function (tab) {
      tab.classList.toggle('is-active', tab.getAttribute('data-vt-tab') === tabName);
    });

    app.querySelectorAll('[data-vt-panel]').forEach(function (panel) {
      panel.classList.toggle('is-active', panel.getAttribute('data-vt-panel') === tabName);
    });
  }

  function refreshAllModules(app) {
    app.querySelectorAll('[data-vt-module]').forEach(function (module) {
      updateModule(module);
      renderParentInstructions(module);
    });
  }

  function getValue(module, fieldName) {
    var field = module.querySelector('[data-vt-field="' + fieldName + '"]');
    if (!field) {
      return '';
    }

    if (field.matches('fieldset')) {
      return Array.prototype.slice.call(field.querySelectorAll('input:checked')).map(function (input) {
        return input.value;
      }).join(', ');
    }

    if (field.type === 'checkbox') {
      return field.checked ? (field.value || 'on') : '';
    }

    return (field.value || '').trim();
  }

  function setModuleFieldValue(module, fieldName, value) {
    var field = module ? module.querySelector('[data-vt-field="' + fieldName + '"]') : null;
    if (field) {
      field.value = value;
    }
  }

  function formalResultTypeLabel(value) {
    return {
      'standard-score': 'standard score',
      'scaled-score': 'scaled score',
      percentile: 'percentile rank',
      't-score': 'T-score',
      'manual-only': 'manual interpretation only'
    }[value] || '';
  }

  function formalRangeIndicator(module) {
    var type = getValue(module, 'resultType');
    var value = parseFloat(getValue(module, 'standardResult'));
    var ranges = {
      'standard-score': { low: 85, high: 115 },
      'scaled-score': { low: 7, high: 13 },
      percentile: { low: 16, high: 84 },
      't-score': { low: 40, high: 60 }
    };

    if (type === 'manual-only') {
      return getValue(module, 'interpretation') || '__';
    }
    if (!ranges[type] || !isFinite(value)) {
      return '__';
    }
    if (value < ranges[type].low) {
      return 'below expected range';
    }
    if (value > ranges[type].high) {
      return 'above expected range';
    }
    return 'within normal range';
  }

  function switchVipAssessment(app, target) {
    target = target === 'tvps' ? 'tvps' : 'dtvp';
    app.querySelectorAll('[data-vt-vip-target]').forEach(function (button) {
      var active = button.getAttribute('data-vt-vip-target') === target;
      button.classList.toggle('is-active', active);
      button.classList.toggle('vt-button-secondary', !active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    app.querySelectorAll('[data-vt-vip-assessment]').forEach(function (module) {
      var active = module.getAttribute('data-vt-vip-assessment') === target;
      module.hidden = !active;
      module.classList.toggle('is-active', active);
    });
    app.querySelectorAll('[data-vt-vip-age-selector]').forEach(function (selector) {
      selector.hidden = selector.getAttribute('data-vt-vip-age-selector') !== target;
    });
  }

  function vipAssessmentDefinitions(key) {
    if (key === 'vipTvps') {
      return {
        title: 'Optiplex Motor-Free Visual Perception (TVPS-4)',
        scoreFields: [
          { field: 'visualDiscriminationScaled', label: 'Visual discrimination', scale: 'scaled', training: ['Visual Discrimination Match', 'Spatial Relations / Rotation'] },
          { field: 'visualMemoryScaled', label: 'Visual memory', scale: 'scaled', training: ['Visual Memory Grid', 'Visual Sequential Memory'] },
          { field: 'spatialRelationshipsScaled', label: 'Spatial relationships', scale: 'scaled', training: ['Spatial Relations / Rotation', 'Reversal Awareness'] },
          { field: 'formConstancyScaled', label: 'Form consistency', scale: 'scaled', training: ['Visual Discrimination Match', 'Spatial Relations / Rotation'] },
          { field: 'sequentialMemoryScaled', label: 'Sequential memory', scale: 'scaled', training: ['Visual Sequential Memory', 'Visual Memory Grid'] },
          { field: 'figureGroundScaled', label: 'Figure-ground', scale: 'scaled', training: ['Figure-Ground Search', 'Visual Scanning / Cancellation'] },
          { field: 'visualClosureScaled', label: 'Visual closure', scale: 'scaled', training: ['Visual Closure', 'Pattern Copying'] },
          { field: 'overallStandard', label: 'Overall visual perception', scale: 'standard', training: ['Use the below-range subtests to select training priorities'] },
          { field: 'percentileRank', label: 'Percentile rank', scale: 'percentile', training: ['Use the below-range subtests to select training priorities'] }
        ]
      };
    }
    return {
      title: 'Optiplex Visual Motor Integration and Perception (DTVP-3)',
      scoreFields: []
    };
  }

  function vipScoreStatus(value, scale) {
    var number = parseFloat(value);
    if (!isFinite(number)) {
      return null;
    }
    var low = scale === 'standard' ? 85 : scale === 'percentile' ? 16 : 7;
    var high = scale === 'standard' ? 115 : scale === 'percentile' ? 84 : 13;
    if (number < low) {
      return { level: 'below', label: 'below expected range', value: number, range: low + '–' + high };
    }
    if (number > high) {
      return { level: 'above', label: 'above expected range', value: number, range: low + '–' + high };
    }
    return { level: 'normal', label: 'within normal range', value: number, range: low + '–' + high };
  }

  function vipAgeText(module) {
    var age = getValue(module, 'ageAtTesting');
    if (age) return age;
    var app = module.closest('[data-vt-app]');
    var suite = module && module.getAttribute ? (module.getAttribute('data-vt-vip-assessment') || 'dtvp') : 'dtvp';
    if (suite === 'dtvp') {
      var dtvpAge = dtvpResolvedAgeStatus(module);
      if (dtvpAge.valid) return (dtvpAge.displayAge ? dtvpAge.displayAge + ' | ' : '') + vipAgeBandReadable(dtvpAge.band);
    }
    var band = vipAgeBandField(app, suite);
    return band && band.options[band.selectedIndex] ? band.options[band.selectedIndex].textContent : '';
  }

  function vipAssessmentSummary(module, key) {
    var definition = vipAssessmentDefinitions(key);
    var statuses = vipGameStatuses(module);
    var recommendations = [];
    statuses.forEach(function (entry) {
      if (entry.status.level === 'below' || entry.trainingFlag) {
        entry.training.forEach(function (training) {
          if (recommendations.indexOf(training) === -1) recommendations.push(training);
        });
      }
    });
    appendDtvpCompositeStatuses(module, statuses, recommendations);
    definition.scoreFields.forEach(function (item) {
      var status = vipScoreStatus(getValue(module, item.field), item.scale);
      if (!status) return;
      statuses.push({ label: item.label, status: status, training: item.training });
      if (status.level === 'below') {
        item.training.forEach(function (training) {
          if (recommendations.indexOf(training) === -1) recommendations.push(training);
        });
      }
    });
    return { definition: definition, statuses: statuses, recommendations: recommendations };
  }

  function appendDtvpCompositeStatuses(module, statuses, recommendations) {
    if (!module || module.getAttribute('data-vt-vip-assessment') !== 'dtvp') return;
    var byKey = {};
    statuses.forEach(function (entry) {
      if (entry.key && entry.status && !entry.status.manualRequired && Number.isFinite(Number(entry.status.value))) {
        byKey[entry.key] = entry.status;
      }
    });
    var hasAnyDtvpResult = statuses.some(function (entry) {
      return entry.key && ['eyeHand', 'copying', 'figureGround', 'visualClosure', 'formConstancy'].indexOf(entry.key) !== -1;
    });
    [
      { key: 'vmi', label: 'Visual Motor Integration composite', subtests: ['eyeHand', 'copying'], training: ['Pattern Copying', 'Maze / Path Following'] },
      { key: 'mrvp', label: 'Motor-Reduced Visual Perception composite', subtests: ['figureGround', 'visualClosure', 'formConstancy'], training: ['Figure-Ground Search', 'Visual Closure', 'Visual Discrimination Match'] },
      { key: 'gvp', label: 'General Visual Perception composite', subtests: ['eyeHand', 'copying', 'figureGround', 'visualClosure', 'formConstancy'], training: ['Use the below-range subtests to select training priorities'] }
    ].forEach(function (composite) {
      var missing = composite.subtests.some(function (key) { return !byKey[key]; });
      if (missing) {
        if (hasAnyDtvpResult) {
          statuses.push({
            label: composite.label,
            key: composite.key,
            status: {
              level: 'manual',
              label: 'not calculated',
              value: '—',
              range: 'Composite not calculated: missing exact DTVP scaled score.',
              manualRequired: true
            },
            training: []
          });
        }
        return;
      }
      var sum = composite.subtests.reduce(function (total, key) { return total + Number(byKey[key].value); }, 0);
      var status = vipDtvpCompositeLookupStatus(composite.key, sum);
      if (!status) return;
      statuses.push({ label: composite.label, key: composite.key, status: status, training: composite.training });
      if (status.level === 'below') {
        composite.training.forEach(function (training) {
          if (training && recommendations.indexOf(training) === -1 && training.indexOf('Use the below-range') !== 0) recommendations.push(training);
        });
      }
    });
  }

  function vipParentResultLabel(status) {
    if (!status) return 'Result recorded';
    return status.descriptiveTerm || status.label || 'Result recorded';
  }

  function vipParentFriendlyDescription(key, label) {
    var lookup = {
      eyeHand: 'This test looks at how well a child coordinates what they see with how they move their hand, especially when drawing or tracing. In everyday life, this can affect pencil control, handwriting, colouring, cutting, drawing within lines, and how easily a child can copy work from the board or a page.',
      copying: 'This test looks at how accurately a child can copy shapes. It helps us understand visual-motor integration, planning, and control when reproducing forms. In real life, this can affect handwriting, drawing, copying diagrams, forming letters and numbers, and overall neatness and organisation on the page.',
      figureGround: 'This test looks at how well a child can find important visual information when it is surrounded by other shapes or details. In daily life, this can affect finding items in a busy space, locating information on a crowded worksheet, keeping place while reading, and picking out relevant details from visual clutter.',
      visualClosure: 'This test looks at how well a child can recognise a whole shape when only part of it is shown. In everyday life, this can affect recognising letters or words quickly, understanding incomplete visual information, reading fluency, and identifying objects or symbols when they are partly hidden or only briefly seen.',
      formConstancy: 'This test looks at how well a child recognises the same shape even when it changes in size, position, or shading. In real life, this can affect recognising letters and numbers in different fonts or styles, matching shapes and symbols, reading, and understanding that something is the same even when it looks slightly different.',
      vmi: 'This combined score reflects how well visual information and hand movements work together. It gives an overall picture of the skills used for drawing, handwriting, copying, and other school tasks that require both seeing accurately and responding with controlled movement.',
      mrvp: 'This combined score reflects visual perception skills with less emphasis on fine motor output. It helps show how well a child understands and interprets visual information without the result being heavily influenced by pencil control or drawing ability. In everyday life, this supports visual learning, recognising patterns, and understanding visual information on the page.',
      gvp: 'This combined score gives an overall picture of a child’s visual perceptual abilities across the assessment. These skills support reading, written work, visual attention, recognising patterns and forms, and coping with classroom tasks that rely on interpreting visual information efficiently.'
    };
    if (lookup[key]) return lookup[key];
    var text = String(label || key || '').toLowerCase();
    if (text.indexOf('eye-hand') !== -1 || text.indexOf('hand-eye') !== -1) return lookup.eyeHand;
    if (text.indexOf('copying') !== -1) return lookup.copying;
    if (text.indexOf('figure-ground') !== -1 || text.indexOf('figure ground') !== -1) return lookup.figureGround;
    if (text.indexOf('visual closure') !== -1) return lookup.visualClosure;
    if (text.indexOf('form constancy') !== -1) return lookup.formConstancy;
    if (text.indexOf('visual motor integration') !== -1) return lookup.vmi;
    if (text.indexOf('motor-reduced') !== -1 || text.indexOf('motor reduced') !== -1) return lookup.mrvp;
    if (text.indexOf('general visual perception') !== -1) return lookup.gvp;
    return '';
  }

  function vipParentDescriptionHtml(entryOrKey, label) {
    var key = entryOrKey && typeof entryOrKey === 'object' ? entryOrKey.key : entryOrKey;
    var displayLabel = entryOrKey && typeof entryOrKey === 'object' ? entryOrKey.label : label;
    var description = vipParentFriendlyDescription(key, displayLabel);
    return description ? '<p class="vt-vip-parent-description">' + escapeHtml(description) + '</p>' : '';
  }

  function renderVipAssessmentPanel(module, summary) {
    var panel = module.querySelector('[data-vt-vip-result-panel]');
    if (!panel) return;
    panel.innerHTML = '';
    if (!summary.statuses.length) {
      panel.innerHTML = '<p>Enter scaled, standard, or percentile scores to show normal-range indicators and training recommendations.</p>';
      return;
    }
    var list = document.createElement('ul');
    list.className = 'vt-vip-result-list';
    summary.statuses.forEach(function (entry) {
      var li = document.createElement('li');
      li.setAttribute('data-vt-vip-status', entry.status.level);
      li.innerHTML = '<strong>' + escapeHtml(entry.label) + ': ' + escapeHtml(vipParentResultLabel(entry.status)) + '</strong><span>Score: ' + escapeHtml(entry.status.value) + ' | Expected range: ' + escapeHtml(entry.status.range) + ' | ' + escapeHtml(entry.status.label) + '</span>' + vipParentDescriptionHtml(entry);
      list.appendChild(li);
    });
    panel.appendChild(list);
    if (summary.recommendations.length) {
      var rec = document.createElement('p');
      rec.className = 'vt-vip-recommendation-note';
      rec.textContent = 'Suggested Next Steps: ' + summary.recommendations.join(', ') + '.';
      panel.appendChild(rec);
    }
  }

  function vipAssessmentNote(module, key) {
    var summary = vipAssessmentSummary(module, key);
    renderVipAssessmentPanel(module, summary);
    var results = summary.statuses.map(function (entry) {
      var rawDetail = typeof entry.status.raw === 'number' ? ', raw ' + entry.status.raw : '';
      return entry.label + ' ' + entry.status.value + ' (' + entry.status.label + rawDetail + ')';
    }).join('; ');
    var normal = summary.statuses.map(function (entry) {
      return entry.label + ': ' + entry.status.label;
    }).join('; ');
    var recommendations = summary.recommendations.join(', ');
    return summary.definition.title + ' assessment. Age: ' + valueOrBlank(vipAgeText(module)) + '. Result source: ' + valueOrBlank(getValue(module, 'resultSource')) + '. Results: ' + valueOrBlank(results) + '. Normal-range indicators: ' + valueOrBlank(normal) + '. Training recommendations: ' + valueOrBlank(recommendations || 'none flagged') + '. Observations: ' + valueOrBlank(getValue(module, 'observations')) + '. Notes: ' + valueOrBlank(getValue(module, 'notes')) + '. Original Optiplex stimuli used with permitted age-band comparison ranges.';
  }

  function updateVipAssessmentModules(app) {
    app.querySelectorAll('[data-vt-module="vipDtvp"], [data-vt-module="vipTvps"]').forEach(function (module) {
      updateModule(module);
    });
    renderVipOverallSummary(app);
    renderVisualRecommendationPanel(app);
  }

  function initVipAssessments(app) {
    populateDtvpAgeBandOptions(app);
    updateDtvpAgeWorkflow(app);
    app.querySelectorAll('[data-vt-vip-game-grid]').forEach(function (grid) {
      var suite = grid.getAttribute('data-vt-vip-suite') || 'dtvp';
      var module = grid.closest('[data-vt-module]');
      if (!module || grid.getAttribute('data-vt-ready') === 'true') return;
      module._vtVipGames = module._vtVipGames || {};
      grid.innerHTML = '';
      vipGameDefinitions(suite).forEach(function (game) {
        grid.appendChild(createVipGameCard(game));
      });
      grid.setAttribute('data-vt-ready', 'true');
    });
    updateVipAssessmentModules(app);
  }

  function populateDtvpAgeBandOptions(app) {
    var select = app.querySelector('[data-vt-vip-age-band][data-vt-vip-age-suite="dtvp"]') || app.querySelector('[data-vt-vip-age-band]');
    var normData = dtvpNormData();
    if (!select || select.getAttribute('data-vt-dtvp-age-ready') === 'true' || !normData.ageBands || !normData.ageBands.length) return;
    select.innerHTML = '';
    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = 'Select exact DTVP age band';
    select.appendChild(placeholder);
    normData.ageBands.forEach(function (band) {
      var option = document.createElement('option');
      option.value = band.value;
      option.textContent = band.label || band.value;
      select.appendChild(option);
    });
    select.setAttribute('data-vt-dtvp-age-ready', 'true');
  }

  function updateDtvpAgeWorkflow(app) {
    if (!app) return;
    var status = dtvpResolvedAgeStatus(app);
    var statusTarget = app.querySelector('[data-vt-dtvp-age-status]');
    var select = vipAgeBandField(app, 'dtvp');
    if (select && status.source !== 'manual') {
      select.value = status.band || '';
    }
    app.dataset.vtDtvpResolvedAgeBand = status.band || '';
    app.dataset.vtDtvpAgeSource = status.source || '';
    if (statusTarget) {
      statusTarget.textContent = status.message || 'Enter DOB/test date or age in years/months before starting DTVP testing.';
      statusTarget.setAttribute('data-vt-dtvp-age-state', status.valid ? 'valid' : (status.outOfRange ? 'out-of-range' : 'missing'));
    }
  }

  function toggleDtvpAgeAdvanced(app, button) {
    var panel = app && app.querySelector('[data-vt-dtvp-manual-age-panel]');
    if (!panel) return;
    panel.hidden = !panel.hidden;
    if (button) {
      button.textContent = panel.hidden ? 'Manual age-band override' : 'Hide manual override';
      button.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
    }
    updateDtvpAgeWorkflow(app);
    updateVipAssessmentModules(app);
  }

  function dtvpResolvedAgeStatus(context) {
    var app = context && context.closest ? context.closest('[data-vt-app]') : context;
    if (!app) return { valid: false, band: '', source: '', message: 'Enter DOB/test date or age in years/months before starting DTVP testing.' };
    var select = vipAgeBandField(app, 'dtvp');
    var manualPanel = app.querySelector('[data-vt-dtvp-manual-age-panel]');
    var manualValue = select ? select.value : '';
    if (manualPanel && !manualPanel.hidden && vipDtvpExactAgeBand(manualValue)) {
      return {
        valid: true,
        band: manualValue,
        source: 'manual',
        message: 'Manual DTVP age band selected: ' + vipAgeBandReadable(manualValue) + '.'
      };
    }

    var dobField = app.querySelector('[data-vt-dtvp-dob]');
    var testDateField = app.querySelector('[data-vt-dtvp-test-date]');
    var dobValue = dobField ? dobField.value : '';
    var testDateValue = testDateField ? testDateField.value : '';
    if (dobValue || testDateValue) {
      if (!dobValue || !testDateValue) {
        return { valid: false, band: '', source: 'dob', message: 'Enter both date of birth and date of testing, or use direct years/months entry.' };
      }
      var dob = parseDtvpIsoDate(dobValue);
      var testDate = parseDtvpIsoDate(testDateValue);
      if (!dob || !testDate) {
        return { valid: false, band: '', source: 'dob', message: 'Enter valid date of birth and date of testing.' };
      }
      var totalMonths = dtvpChronologicalAgeMonths(dob, testDate);
      if (totalMonths < 0) {
        return { valid: false, band: '', source: 'dob', message: 'Date of testing must be after date of birth.' };
      }
      return dtvpAgeStatusFromMonths(totalMonths, 'dob');
    }

    var yearsField = app.querySelector('[data-vt-dtvp-age-years]');
    var monthsField = app.querySelector('[data-vt-dtvp-age-months]');
    var yearsValue = yearsField ? yearsField.value : '';
    var monthsValue = monthsField ? monthsField.value : '';
    if (yearsValue !== '' || monthsValue !== '') {
      var years = Number(yearsValue);
      var months = monthsValue === '' ? 0 : Number(monthsValue);
      if (!Number.isFinite(years) || !Number.isFinite(months) || years < 0 || months < 0 || months > 11) {
        return { valid: false, band: '', source: 'direct', message: 'Enter age as whole years and 0–11 months.' };
      }
      return dtvpAgeStatusFromMonths(Math.floor(years) * 12 + Math.floor(months), 'direct');
    }

    return {
      valid: false,
      band: '',
      source: '',
      message: 'Enter DOB/test date or age in years/months before starting DTVP testing.'
    };
  }

  function parseDtvpIsoDate(value) {
    var match = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return null;
    return { year: Number(match[1]), month: Number(match[2]), day: Number(match[3]) };
  }

  function dtvpChronologicalAgeMonths(dob, testDate) {
    var months = (testDate.year - dob.year) * 12 + (testDate.month - dob.month);
    if (testDate.day < dob.day) months -= 1;
    return months;
  }

  function dtvpAgeStatusFromMonths(totalMonths, source) {
    var years = Math.floor(totalMonths / 12);
    var months = totalMonths % 12;
    var band = dtvpAgeBandForMonths(totalMonths);
    if (!band) {
      return {
        valid: false,
        outOfRange: true,
        band: '',
        source: source,
        displayAge: years + ' years ' + months + ' months',
        message: 'Age is outside the DTVP-3 normed range for this app.'
      };
    }
    return {
      valid: true,
      band: band,
      source: source,
      displayAge: years + ' years ' + months + ' months',
      message: 'Age at test: ' + years + ' years ' + months + ' months. DTVP band used: ' + vipAgeBandReadable(band) + '.'
    };
  }

  function dtvpAgeBandForMonths(totalMonths) {
    var bands = (dtvpNormData().ageBands || []).map(function (band) { return band.value; });
    for (var index = 0; index < bands.length; index += 1) {
      var range = dtvpAgeBandMonthRange(bands[index]);
      if (range && totalMonths >= range.min && totalMonths <= range.max) return bands[index];
    }
    return '';
  }

  function dtvpAgeBandMonthRange(value) {
    var match = String(value || '').match(/^(\d+)-(\d+)\s+to\s+(\d+)-(\d+)$/);
    if (!match) return null;
    return {
      min: Number(match[1]) * 12 + Number(match[2]),
      max: Number(match[3]) * 12 + Number(match[4])
    };
  }

  function dtvpTestingMode(module) {
    var app = module && module.closest ? module.closest('[data-vt-app]') : module;
    var toggle = app ? app.querySelector('[data-vt-dtvp-testing-mode]') : null;
    return !!(toggle && toggle.checked);
  }

  function dtvpTestingModeStatusHtml(module) {
    return dtvpTestingMode(module) ? '<p class="vt-dtvp-control-note"><strong>Testing mode:</strong> ceiling ignored for app review.</p>' : '';
  }

  function vipGameDefinitions(suite) {
    if (suite === 'tvps') {
      return [
        { key: 'visualDiscrimination', field: 'visualDiscriminationScaled', title: 'Visual Discrimination', kind: 'match', rounds: 18, options: 5, tvpsCode: 'DIS', note: '18 scored items: matching the exact form among five similar choices', training: ['Visual Discrimination Match', 'Spatial Relations / Rotation'] },
        { key: 'visualMemory', field: 'visualMemoryScaled', title: 'Visual Memory', kind: 'memory', rounds: 18, options: 4, tvpsCode: 'MEM', displayMs: 5000, note: '18 scored items: remembering one briefly shown visual form after a 5-second view', training: ['Visual Memory Grid', 'Visual Sequential Memory'] },
        { key: 'spatialRelationships', field: 'spatialRelationshipsScaled', title: 'Spatial Relationships', kind: 'oddSpatial', rounds: 18, options: 5, tvpsCode: 'SPA', note: '18 scored items: finding the one form that is turned, reversed, or positioned differently from the others', training: ['Spatial Relations / Rotation', 'Reversal Awareness'] },
        { key: 'formConstancy', field: 'formConstancyScaled', title: 'Form Consistency', kind: 'constancy', rounds: 18, options: 5, tvpsCode: 'CON', note: '18 scored items: matching a form despite size, rotation or embedded-detail changes', training: ['Visual Discrimination Match', 'Spatial Relations / Rotation'] },
        { key: 'sequentialMemory', field: 'sequentialMemoryScaled', title: 'Sequential Memory', kind: 'sequence', rounds: 18, options: 4, tvpsCode: 'SEQ', displayMs: 5000, note: '18 scored items: remembering a sequence after a 5-second view', training: ['Visual Sequential Memory', 'Visual Memory Grid'] },
        { key: 'figureGround', field: 'figureGroundScaled', title: 'Figure-Ground', kind: 'search', rounds: 18, options: 4, tvpsCode: 'FGR', note: '18 scored items: finding the target embedded in one of four complex designs', training: ['Figure-Ground Search', 'Visual Scanning / Cancellation'] },
        { key: 'visualClosure', field: 'visualClosureScaled', title: 'Visual Closure', kind: 'closure', rounds: 18, options: 4, tvpsCode: 'CLO', note: '18 scored items: matching an incomplete target to the completed form', training: ['Visual Closure', 'Pattern Copying'] }
      ];
    }
    var dtvpConfig = dtvpSubtestConfig();
    var dtvpGames = [
      dtvpGameFromConfig(dtvpConfig.eyeHand, 'ehcScaled'),
      dtvpGameFromConfig(dtvpConfig.copying, 'copyingScaled'),
      dtvpGameFromConfig(dtvpConfig.figureGround, 'figureGroundScaled'),
      dtvpGameFromConfig(dtvpConfig.visualClosure, 'visualClosureScaled'),
      dtvpGameFromConfig(dtvpConfig.formConstancy, 'formConstancyScaled')
    ];
    return dtvpGames.filter(Boolean);
  }

  function dtvpSubtestConfig() {
    return window.OptiplexDtvpSubtests || {};
  }

  function dtvpNormData() {
    return window.OptiplexDtvpNorms || { averageScaledRange: [8, 12], averageCompositeRange: [90, 110], ageBands: [], rawToScaled: [], compositeIndex: [], descriptiveTerms: [] };
  }

  function dtvpGameFromConfig(subtest, field) {
    if (!subtest) return null;
    return {
      key: subtest.key,
      field: field,
      title: subtest.title,
      kind: 'dtvpAssessment',
      rounds: subtest.items ? subtest.items.length : 0,
      note: subtest.note,
      training: subtest.recommendations || [],
      maxRaw: subtest.rawMax || (subtest.items ? subtest.items.length : 0)
    };
  }

  function createVipGameCard(game) {
    var article = document.createElement('article');
    var worksheetButton = game.kind === 'dtvpAssessment' && game.key === 'eyeHand'
      ? '<button class="vt-button vt-button-secondary" type="button" data-vt-action="print-dtvp-materials">Print Worksheet</button>'
      : '';
    article.className = 'vt-vip-game-card';
    article.setAttribute('data-vt-vip-game', game.key);
    article.setAttribute('data-vt-vip-kind', game.kind);
    article.innerHTML =
      '<div class="vt-vip-game-head"><div><p class="vt-kicker">Manual-structure digital subtest</p><h3>' + game.title + '</h3><p>' + game.note + '</p></div><span data-vt-vip-game-status>Not started</span></div>' +
      '<div class="vt-vip-game-stage" data-vt-vip-stage></div>' +
      '<div class="vt-counter-row vt-vip-score-row" data-vt-vip-score-row hidden><span>Raw score <strong data-vt-vip-count="raw">0</strong></span><span>Items/inputs <strong data-vt-vip-count="attempts">0</strong></span><span>Completed <strong data-vt-vip-count="round">0</strong>/' + game.rounds + '</span><span>Result <strong data-vt-vip-count="range">__</strong></span></div>' +
      '<div class="vt-actions"><button class="vt-button" type="button" data-vt-action="vip-game-start" data-vt-vip-game-key="' + game.key + '">Start Test</button>' + worksheetButton + '<button class="vt-button vt-button-secondary vt-vip-runner-only" type="button" data-vt-action="vip-game-prev" data-vt-vip-game-key="' + game.key + '">Previous</button><button class="vt-button vt-vip-runner-only" type="button" data-vt-action="vip-game-next" data-vt-vip-game-key="' + game.key + '">Next</button><button class="vt-button vt-button-secondary vt-vip-exit-fullscreen" type="button" data-vt-action="vip-game-exit" data-vt-vip-game-key="' + game.key + '">Exit Full Screen</button><button class="vt-button vt-button-ghost" type="button" data-vt-action="vip-game-reset" data-vt-vip-game-key="' + game.key + '">Reset</button></div>';
    renderVipSamplePreview(article, game);
    return article;
  }

  function renderVipSamplePreview(card, game) {
    var stage = card.querySelector('[data-vt-vip-stage]');
    if (!stage) return;
    var sample = vipSampleShape(game);
    if (game.kind === 'dtvpAssessment') {
      renderDtvpSamplePreview(stage, game);
      return;
    }
    if (game.kind === 'copy') {
      stage.innerHTML = '<p class="vt-vip-game-prompt">Sample: copy the model on paper, then score using the criteria.</p><canvas class="vt-vip-copy-canvas vt-vip-sample-canvas" width="520" height="180"></canvas>';
      drawVipCopyPattern(stage.querySelector('canvas'));
      return;
    }
    if (game.kind === 'trace') {
      stage.innerHTML = '<p class="vt-vip-game-prompt">Sample: trace from start to finish while staying inside the path.</p><div class="vt-vip-trace-wrap"><canvas class="vt-vip-trace-canvas vt-vip-sample-canvas" width="640" height="280"></canvas></div>';
      drawVipTraceCanvas(stage.querySelector('canvas'), vipTracePath(1), []);
      return;
    }
    if (game.kind === 'path') {
      stage.innerHTML = '<p class="vt-vip-game-prompt">Sample: tap the stepping stones in order.</p><div class="vt-vip-path-grid vt-vip-sample-path"><button class="vt-vip-path-dot" type="button">1</button><button class="vt-vip-path-dot" type="button">2</button><button class="vt-vip-path-dot" type="button">3</button><button class="vt-vip-path-dot" type="button">4</button></div>';
      return;
    }
    if (game.kind === 'search') {
      stage.innerHTML = '<p class="vt-vip-game-prompt">Sample: find each matching form in the field.</p><div class="vt-vip-search-target"></div><div class="vt-vip-sample-search"><span></span><span></span><span></span><span></span></div>';
      vipRenderShape(stage.querySelector('.vt-vip-search-target'), sample, false);
      Array.prototype.slice.call(stage.querySelectorAll('.vt-vip-sample-search span')).forEach(function (item, index) {
        vipRenderShape(item, index === 1 ? sample : vipSampleShape({ kind: 'match' }), false);
      });
      return;
    }
    if (game.kind === 'sequence') {
      stage.innerHTML = '<p class="vt-vip-game-prompt">Sample: watch the order, then tap it back.</p><div class="vt-vip-sequence-answer vt-vip-sample-sequence"></div>';
      vipSequencePalette().slice(0, 4).forEach(function (shape) {
        var token = document.createElement('span');
        token.className = 'vt-vip-sequence-token';
        vipRenderShape(token, shape, false);
        stage.querySelector('.vt-vip-sample-sequence').appendChild(token);
      });
      return;
    }
    if (game.kind === 'oddSpatial') {
      stage.innerHTML = '<p class="vt-vip-game-prompt">Sample: choose the one that is different from the others.</p><div class="vt-vip-options vt-vip-sample-options"><span></span><span></span><span></span><span></span><span></span></div>';
      var same = { shape: 'arrow', rotation: 90, fill: '#163158', scale: 1, mirror: false };
      var odd = { shape: 'arrow', rotation: 270, fill: '#163158', scale: 1, mirror: false };
      Array.prototype.slice.call(stage.querySelectorAll('.vt-vip-sample-options span')).forEach(function (item, index) {
        vipRenderShape(item, index === 2 ? odd : same, false);
      });
      return;
    }
    if (game.kind === 'multiSearch') {
      stage.innerHTML = '<p class="vt-vip-game-prompt">Sample: tap every option that is part of the busy picture.</p><div class="vt-vip-embedded-field"></div><div class="vt-vip-options vt-vip-sample-options"><span></span><span></span><span></span><span></span></div>';
      var embeddedTarget = { shape: 'triangle', rotation: 0, fill: '#163158', scale: 1, mirror: false };
      var field = stage.querySelector('.vt-vip-embedded-field');
      drawVipEmbeddedField(field, [embeddedTarget, { shape: 'star', rotation: 45, fill: '#163158', scale: 0.85, mirror: false }], game);
      Array.prototype.slice.call(stage.querySelectorAll('.vt-vip-sample-options span')).forEach(function (item, index) {
        vipRenderShape(item, index === 1 ? embeddedTarget : vipSampleShape({ kind: 'match' }), false);
      });
      return;
    }
    var sampleOptionCount = vipOptionCount(game);
    var sampleSpans = '';
    for (var sampleIndex = 0; sampleIndex < sampleOptionCount; sampleIndex += 1) sampleSpans += '<span></span>';
    stage.innerHTML = '<p class="vt-vip-game-prompt">Sample: choose the matching answer.</p><div class="vt-vip-choice-target"></div><div class="vt-vip-options vt-vip-sample-options">' + sampleSpans + '</div>';
    vipRenderShape(stage.querySelector('.vt-vip-choice-target'), sample, game.kind === 'closure');
    var sampleOptions = [
      { shape: 'triangle', rotation: 0, fill: '#163158', scale: 1, mirror: false },
      sample,
      { shape: 'square', rotation: 45, fill: '#163158', scale: 1, mirror: false },
      { shape: 'star', rotation: 0, fill: '#163158', scale: 1, mirror: false }
    ];
    while (sampleOptions.length < sampleOptionCount) {
      sampleOptions.push({ shape: 'arrow', rotation: 90 + sampleOptions.length * 45, fill: '#163158', scale: 0.9, mirror: sampleOptions.length % 2 === 0 });
    }
    Array.prototype.slice.call(stage.querySelectorAll('.vt-vip-sample-options span')).forEach(function (item, index) {
      vipRenderShape(item, sampleOptions[index], false);
    });
  }

  function handleVipGameAction(app, module, button, action) {
    var key = button.getAttribute('data-vt-vip-game-key') || (button.closest('[data-vt-vip-game]') && button.closest('[data-vt-vip-game]').getAttribute('data-vt-vip-game'));
    var game = vipFindGame(module, key);
    if (!game) return;
    if (action === 'vip-game-start') {
      if (startVipGame(module, game) !== false) {
        openVipGameFullscreen(app, module, game);
      }
    } else if (action === 'vip-game-choice') {
      chooseVipGameOption(module, game, button);
    } else if (action === 'vip-game-prev') {
      navigateDtvpAssessmentItem(module, game, -1);
    } else if (action === 'vip-game-next') {
      navigateDtvpAssessmentItem(module, game, 1);
    } else if (action === 'vip-game-submit') {
      if (game.kind === 'dtvpAssessment') {
        submitDtvpMultiSelectItem(module, game);
      } else {
        submitVipMultiSearchGame(module, game, button);
      }
    } else if (action === 'vip-game-trace-segment-score') {
      scoreDtvpTraceSegment(module, game, button);
    } else if (action === 'vip-game-trace-score') {
      scoreDtvpTraceItem(module, game, button);
    } else if (action === 'vip-game-trace-finish') {
      if (game.kind === 'dtvpAssessment') {
        finishDtvpTraceItem(module, game);
      } else {
        finishVipTraceItem(module, game);
      }
    } else if (action === 'vip-game-score') {
      scoreVipClinicianGame(module, game, button);
    } else if (action === 'vip-game-finish') {
      if (game.kind === 'dtvpAssessment') commitDtvpCurrentEntry(module, game);
      finishVipGame(module, game);
    } else if (action === 'vip-game-exit') {
      closeVipGameFullscreen(app);
    } else if (action === 'vip-game-reset') {
      resetVipGame(module, game);
    }
    updateModule(module);
    renderVipOverallSummary(app);
    renderVisualRecommendationPanel(app);
  }

  function vipFindGame(module, key) {
    var suite = module.getAttribute('data-vt-vip-assessment') || 'dtvp';
    return vipGameDefinitions(suite).filter(function (game) { return game.key === key; })[0];
  }

  function vipGameCard(module, key) {
    return module.querySelector('[data-vt-vip-game="' + key + '"]');
  }

  function toggleVipGameFullscreen(app, module, game) {
    var card = vipGameCard(module, game.key);
    if (!card) return;
    if (card.classList.contains('is-vip-fullscreen')) {
      closeVipGameFullscreen(app);
      return;
    }
    openVipGameFullscreen(app, module, game);
  }

  function openVipGameFullscreen(app, module, game) {
    var card = vipGameCard(module, game.key);
    if (!card) return;
    closeVipGameFullscreen(app);
    card.classList.add('is-vip-fullscreen');
    app.classList.add('vt-vip-fullscreen-open');
    app._vtVipFullscreenCard = card;
    var stage = card.querySelector('[data-vt-vip-stage]');
    if (stage && !stage.textContent.trim()) {
      stage.innerHTML = '<p class="vt-vip-game-prompt">Press Start Test to begin this full-screen assessment game.</p>';
    }
  }

  function closeVipGameFullscreen(app) {
    if (!app) return;
    var active = app._vtVipFullscreenCard || app.querySelector('.vt-vip-game-card.is-vip-fullscreen');
    if (active) {
      active.classList.remove('is-vip-fullscreen');
    }
    app.classList.remove('vt-vip-fullscreen-open');
    app._vtVipFullscreenCard = null;
  }

  function startVipGame(module, game) {
    if (game.kind === 'dtvpAssessment') {
      var ageStatus = dtvpResolvedAgeStatus(module);
      if (!ageStatus.valid || !vipDtvpExactAgeBand(ageStatus.band)) {
        showToast(module.closest('[data-vt-app]'), ageStatus.outOfRange ? 'Age is outside the DTVP-3 normed range for this app.' : 'Enter DOB/test date or age in years/months before starting DTVP testing.');
        updateDtvpAgeWorkflow(module.closest('[data-vt-app]'));
        return false;
      }
    }
    module._vtVipGames = module._vtVipGames || {};
    var card = vipGameCard(module, game.key);
    if (card) {
      card.classList.add('is-vip-running');
      card.classList.remove('is-vip-complete');
    }
    var scoreRow = card ? card.querySelector('[data-vt-vip-score-row]') : null;
    if (scoreRow) scoreRow.hidden = true;
    var startCredit = vipTvpsStartCredit(module, game);
    var runnerData = game.kind === 'dtvpAssessment' ? { startCredit: 0, itemScores: [], index: 0, responses: {}, completedIds: {} } : { startCredit: startCredit, itemScores: [] };
    module._vtVipGames[game.key] = {
      raw: startCredit,
      errors: 0,
      round: startCredit,
      max: vipNormMax(module, game),
      complete: false,
      sequenceMax: game.kind === 'sequence' ? vipSequenceTotalSteps(game) : 0,
      data: runnerData
    };
    renderVipGameRound(module, game);
    return true;
  }

  function resetVipGame(module, game) {
    if (module._vtVipGames) delete module._vtVipGames[game.key];
    var card = vipGameCard(module, game.key);
    if (!card) return;
    card.classList.remove('is-vip-running', 'is-vip-complete');
    renderVipSamplePreview(card, game);
    vipSetGameCount(card, 'raw', '0');
    vipSetGameCount(card, 'attempts', '0');
    vipSetGameCount(card, 'round', '0');
    vipSetGameCount(card, 'range', '__');
    var scoreRow = card.querySelector('[data-vt-vip-score-row]');
    if (scoreRow) scoreRow.hidden = true;
    var status = card.querySelector('[data-vt-vip-game-status]');
    if (status) status.textContent = 'Not started';
  }

  function renderVipGameRound(module, game) {
    var state = module._vtVipGames && module._vtVipGames[game.key];
    var card = vipGameCard(module, game.key);
    if (!state || !card) return;
    var stage = card.querySelector('[data-vt-vip-stage]');
    var status = card.querySelector('[data-vt-vip-game-status]');
    if (status) status.textContent = 'In progress';
    if (state.complete) return;
    if (game.kind === 'dtvpAssessment') {
      renderDtvpAssessmentRunner(module, game, stage, state);
    } else if (game.kind === 'search') {
      renderVipSearchGame(module, game, stage, state);
    } else if (game.kind === 'multiSearch') {
      renderVipMultiSearchGame(module, game, stage, state);
    } else if (game.kind === 'path') {
      renderVipPathGame(module, game, stage, state);
    } else if (game.kind === 'trace') {
      renderVipTraceGame(module, game, stage, state);
    } else if (game.kind === 'copy') {
      renderVipCopyGame(module, game, stage, state);
    } else if (game.kind === 'sequence') {
      renderVipSequenceGame(module, game, stage, state);
    } else if (game.kind === 'oddSpatial') {
      renderVipOddSpatialGame(module, game, stage, state);
    } else {
      renderVipChoiceGame(module, game, stage, state);
    }
    updateVipGameCounters(module, game);
  }

  function dtvpSubtestForGame(game) {
    return dtvpSubtestConfig()[game.key] || null;
  }

  function dtvpEntries(subtest) {
    var examples = (subtest.examples || []).map(function (entry) {
      return Object.assign({}, entry, { scored: false, displayNumber: 'Example ' + entry.number });
    });
    var items = (subtest.items || []).map(function (entry) {
      return Object.assign({}, entry, { scored: true, displayNumber: 'Item ' + entry.number });
    });
    return examples.concat(items);
  }

  function renderDtvpSamplePreview(stage, game) {
    var subtest = dtvpSubtestForGame(game);
    if (!subtest) {
      stage.innerHTML = '<p class="vt-vip-game-prompt">DTVP subtest data is unavailable.</p>';
      return;
    }
    var first = (subtest.examples && subtest.examples[0]) || (subtest.items && subtest.items[0]);
    var imageSrc = dtvpEntryImageSrc(first, subtest);
    if (imageSrc) {
      stage.innerHTML = '<p class="vt-vip-game-prompt">Sample: fixed ' + subtest.title + ' assessment item. Press Start Test for full-screen patient mode.</p><div class="vt-dtvp-sample-preview"><img class="vt-dtvp-image-stimulus" src="' + imageSrc + '" alt="' + subtest.title + ' sample item"></div>';
      return;
    }
    stage.innerHTML = '<p class="vt-vip-game-prompt">Sample: fixed ' + subtest.title + ' assessment item. Press Start Test for full-screen patient mode.</p><div class="vt-dtvp-sample-preview"><canvas width="520" height="260"></canvas></div>';
    dtvpDrawEntry(stage.querySelector('canvas'), subtest, first, true);
  }

  function renderDtvpAssessmentRunner(module, game, stage, state) {
    var subtest = dtvpSubtestForGame(game);
    if (!subtest) {
      stage.innerHTML = '<p class="vt-vip-game-prompt">DTVP subtest data is unavailable.</p>';
      return;
    }
    var entries = dtvpEntries(subtest);
    state.data.index = Math.max(0, Math.min(entries.length - 1, state.data.index || 0));
    var entry = entries[state.data.index];
    var response = state.data.responses[entry.id] || {};
    var clinicianNote = entry.scored ? 'Scored item' : 'Practice example - not included in raw score';
    var itemPosition = (state.data.index + 1) + ' / ' + entries.length;
    var completed = dtvpCompletedCount(state);
    var splitAssets = dtvpEntrySplitAssets(entry, subtest);
    var imageSrc = (splitAssets && splitAssets.stimulus) || dtvpEntryImageSrc(entry, subtest);
    if (dtvpFormalAssetMissing(entry, subtest, imageSrc)) {
      renderDtvpMissingAssetRunner(stage, state, subtest, entry, clinicianNote, itemPosition, completed);
      return;
    }
    if (subtest.mode === 'tracing') {
      response = ensureDtvpTraceDefaultResponse(module, game, state, subtest, entry);
      completed = dtvpCompletedCount(state);
      renderDtvpTraceRunner(module, game, stage, state, subtest, entry, response, clinicianNote, itemPosition, completed);
      return;
    }
    var optionCount = (entry.options || []).length;
    stage.innerHTML =
      '<div class="vt-dtvp-runner vt-dtvp-choice-runner" data-vt-dtvp-runner>' +
      '<div class="vt-dtvp-patient-display">' +
      '<p class="vt-vip-game-prompt vt-dtvp-instruction">' + dtvpPatientPrompt(subtest) + '</p>' +
      '<div class="vt-dtvp-plate-wrap">' +
      (imageSrc ? '<img class="vt-dtvp-image-stimulus" src="' + imageSrc + '" alt="' + subtest.title + ' ' + entry.displayNumber + '">' : '<canvas class="vt-dtvp-stimulus-canvas" width="760" height="430" data-vt-dtvp-canvas></canvas>') +
      '</div>' +
      '<div class="vt-dtvp-option-grid vt-dtvp-choice-controls" data-vt-dtvp-options data-option-count="' + optionCount + '" style="--option-count:' + optionCount + '"></div>' +
      '</div>' +
      '<div class="vt-dtvp-clinician-panel">' +
      '<strong>' + subtest.title + ' - ' + entry.displayNumber + '</strong>' +
      '<span>' + clinicianNote + ' | Position ' + itemPosition + ' | Scored items completed ' + completed + ' / ' + subtest.items.length + '</span>' +
      '<span>Raw score recorded: ' + Math.round(state.raw || 0) + ' / ' + subtest.rawMax + '</span>' +
      dtvpTestingModeStatusHtml(module) +
      '<div data-vt-dtvp-clinician-controls></div>' +
      '</div>' +
      '</div>';
    if (!imageSrc) dtvpDrawEntry(stage.querySelector('[data-vt-dtvp-canvas]'), subtest, entry, false);
    if (subtest.mode === 'copying') {
      renderDtvpCopyingControls(stage.querySelector('[data-vt-dtvp-clinician-controls]'), game, entry, response);
    } else {
      renderDtvpChoiceOptions(stage.querySelector('[data-vt-dtvp-options]'), game, entry, response, subtest);
      renderDtvpChoiceControls(stage.querySelector('[data-vt-dtvp-clinician-controls]'), subtest, entry, response);
    }
  }

  function dtvpRequiresFormalAsset(subtest) {
    return !!(subtest && ['eyeHand', 'copying', 'figureGround', 'visualClosure', 'formConstancy'].indexOf(subtest.key) !== -1);
  }

  function dtvpFormalAssetMissing(entry, subtest, imageSrc) {
    return !!(dtvpRequiresFormalAsset(subtest) && entry && entry.imageAsset && !imageSrc);
  }

  function renderDtvpMissingAssetRunner(stage, state, subtest, entry, clinicianNote, itemPosition, completed) {
    if (!stage) return;
    stage.innerHTML =
      '<div class="vt-dtvp-runner" data-vt-dtvp-runner>' +
      '<div class="vt-dtvp-patient-display">' +
      '<p class="vt-vip-game-prompt">Please wait while the clinician checks this item.</p>' +
      '<div class="vt-dtvp-neutral-placeholder" aria-hidden="true"></div>' +
      '</div>' +
      '<div class="vt-dtvp-clinician-panel">' +
      '<strong>' + subtest.title + ' - ' + entry.displayNumber + '</strong>' +
      '<span>' + clinicianNote + ' | Position ' + itemPosition + ' | Scored items completed ' + completed + ' / ' + subtest.items.length + '</span>' +
      '<span>Raw score recorded: ' + Math.round(state.raw || 0) + ' / ' + subtest.rawMax + '</span>' +
      '<p class="vt-dtvp-todo">Formal DTVP asset missing — do not use this item for scoring.</p>' +
      '<p class="vt-dtvp-control-note">Upload or map the formal asset for image key <strong>' + (entry.imageKey || entry.id || 'unknown') + '</strong>, then rerun this item.</p>' +
      '</div>' +
      '</div>';
  }

  function renderDtvpTraceRunner(module, game, stage, state, subtest, entry, response, clinicianNote, itemPosition, completed) {
    var itemMax = dtvpTraceItemMax(subtest, entry);
    var scoreNote = dtvpTraceScoringInstruction(entry);
    stage.innerHTML =
      '<div class="vt-dtvp-runner vt-dtvp-trace-runner" data-vt-dtvp-runner>' +
      '<div class="vt-dtvp-patient-display">' +
      '<p class="vt-vip-game-prompt">' + dtvpPatientPrompt(subtest) + '</p>' +
      '<canvas class="vt-dtvp-stimulus-canvas vt-dtvp-trace-canvas" width="900" height="520" data-vt-dtvp-canvas></canvas>' +
      '</div>' +
      '<div class="vt-dtvp-clinician-panel">' +
      '<strong>' + subtest.title + ' - ' + entry.displayNumber + '</strong>' +
      '<span data-vt-dtvp-trace-progress>' + clinicianNote + ' | Position ' + itemPosition + ' | Tracing items completed ' + completed + ' / ' + subtest.items.length + '</span>' +
      '<span data-vt-dtvp-trace-raw>Raw score recorded: ' + Math.round(state.raw || 0) + ' / ' + subtest.rawMax + '</span>' +
      dtvpTestingModeStatusHtml(module) +
      '<p class="vt-dtvp-control-note">' + (entry.focus || 'Trace the displayed path.') + '</p>' +
      '<div class="vt-dtvp-score-panel">' +
      '<strong>Score each numbered segment</strong>' +
      '<p class="vt-dtvp-control-note">' + scoreNote + ' Item maximum: ' + itemMax + ' raw points.</p>' +
      '<p class="vt-dtvp-control-note"><strong>Segments are pre-filled at full score for clinician efficiency.</strong> Reduce any segment score where the line leaves the path, enters an adjacent interval, breaks continuity, is omitted, or is not scorable.</p>' +
      '<p class="vt-dtvp-prefill-label">Pre-filled full score — adjust errors down.</p>' +
      dtvpRenderTraceSegmentScorePanel(game, entry, response) +
      '</div>' +
      '</div>' +
      '</div>';
    var canvas = stage.querySelector('[data-vt-dtvp-canvas]');
    dtvpDrawEntry(canvas, subtest, entry, false, state);
    attachDtvpTraceEvents(canvas, module, game, state, entry);
  }

  function dtvpPatientPrompt(subtest) {
    if (subtest.mode === 'tracing') return 'Trace from START to FINISH. Stay inside the path as carefully as you can.';
    if (subtest.mode === 'copying') return 'Copy this drawing as carefully as you can.';
    if (subtest.key === 'figureGround') return 'Look carefully. Tap every shape represented in the top picture, then tell the clinician when you are finished.';
    if (subtest.key === 'visualClosure') return 'Which unfinished drawing would look like the top picture if it was completed?';
    if (subtest.key === 'formConstancy') return 'Tap every option that shows the same form, even if it is turned, smaller, larger, or shaded.';
    return 'Choose the best answer.';
  }

  function dtvpUsesMultiSelectScoring(subtest) {
    return !!(subtest && (subtest.key === 'figureGround' || subtest.key === 'formConstancy'));
  }

  function dtvpChoiceSubmitHtml(subtest, game) {
    if (!dtvpUsesMultiSelectScoring(subtest)) return '';
    return '<div class="vt-actions vt-dtvp-submit-row"><button class="vt-button" type="button" data-vt-action="vip-game-submit" data-vt-vip-game-key="' + game.key + '">Score item</button></div>';
  }

  function dtvpImageAssetMapForSubtest(subtest) {
    var key = subtest && subtest.key;
    if (key === 'figureGround') return window.OptiplexDtvpFigureGroundImages || {};
    if (key === 'visualClosure') return window.OptiplexDtvpVisualClosureImages || {};
    if (key === 'formConstancy') return window.OptiplexDtvpFormConstancyImages || {};
    if (key === 'copying') return window.OptiplexDtvpCopyingImages || {};
    if (key === 'eyeHand') return window.OptiplexDtvpHandEyeImages || window.OptiplexDtvpPrintImages || {};
    return window.OptiplexDtvpImages || {};
  }

  function dtvpEntryImageSrc(entry, subtest) {
    if (!entry || !entry.imageAsset) return '';
    if (typeof entry.imageAsset === 'string') return entry.imageAsset;
    var map = dtvpImageAssetMapForSubtest(subtest);
    return map[entry.imageKey] || map[entry.id] || '';
  }

  function dtvpSplitAssetMapForSubtest(subtest) {
    var key = subtest && subtest.key;
    var maps = window.OptiplexDtvpSplitImages || {};
    if (key === 'figureGround') return maps.figureGround || {};
    if (key === 'visualClosure') return maps.visualClosure || {};
    if (key === 'formConstancy') return maps.formConstancy || {};
    return {};
  }

  function dtvpEntrySplitAssets(entry, subtest) {
    if (!entry) return null;
    var map = dtvpSplitAssetMapForSubtest(subtest);
    return map[entry.imageKey] || map[entry.id] || null;
  }

  function dtvpEntryOptionImageSrc(entry, subtest, optionLabel) {
    var split = dtvpEntrySplitAssets(entry, subtest);
    if (!split || !split.optionImages || !optionLabel) return '';
    var label = String(optionLabel).toUpperCase();
    return split.optionImages[label] || split.optionImages[label.toLowerCase()] || '';
  }

  function dtvpChoiceProgressHtml(subtest, entry, response) {
    return '';
  }

  function renderDtvpChoiceOptions(container, game, entry, response, subtest) {
    if (!container) return;
    container.innerHTML = '';
    var selectedValues = dtvpSelectedAnswerIds(response);
    var locked = !!(response && response.locked);
    (entry.options || []).forEach(function (option) {
      var optionImageSrc = dtvpEntryOptionImageSrc(entry, subtest, option.label);
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'vt-dtvp-option' + (optionImageSrc ? ' vt-dtvp-option-image-card' : (entry.imageAsset || option.imageOptionOnly ? ' vt-dtvp-option-label-only' : ''));
      if (selectedValues.indexOf(option.label) !== -1) button.classList.add('is-selected');
      button.setAttribute('data-vt-action', 'vip-game-choice');
      button.setAttribute('data-vt-vip-game-key', game.key);
      button.setAttribute('data-vt-dtvp-option', option.label);
      button.setAttribute('aria-label', 'Option ' + option.label);
      if (locked) button.disabled = true;
      if (optionImageSrc) {
        var optionImage = document.createElement('img');
        optionImage.className = 'vt-dtvp-option-image';
        optionImage.src = optionImageSrc;
        optionImage.alt = 'Option ' + option.label;
        button.appendChild(optionImage);
      } else {
        var label = document.createElement('span');
        label.className = 'vt-dtvp-option-label';
        label.textContent = option.label;
        button.appendChild(label);
        if (!(entry.imageAsset || option.imageOptionOnly)) {
          var canvas = document.createElement('canvas');
          canvas.width = 132;
          canvas.height = 112;
          button.appendChild(canvas);
          dtvpDrawShapeCanvas(canvas, option, { fragment: option.fragment, option: true });
        }
      }
      container.appendChild(button);
    });
  }

  function renderDtvpCopyingControls(container, game, entry, response) {
    if (!container) return;
    var criteria = (entry.criteria || []).map(function (criterion) {
      return '<li>' + criterion + '</li>';
    }).join('');
    container.innerHTML =
      '<div class="vt-dtvp-copy-controls">' +
      '<p><strong>Clinician scoring criteria</strong></p>' +
      '<ul>' + criteria + '</ul>' +
      '<div class="vt-dtvp-score-buttons">' +
      [0, 1, 2, 3].map(function (score) {
        var selected = Number(response.score) === score ? ' is-selected' : '';
        return '<button class="vt-button vt-button-secondary' + selected + '" type="button" data-vt-action="vip-game-score" data-vt-vip-game-key="' + game.key + '" data-vt-score="' + score + '">' + score + '</button>';
      }).join('') +
      '</div>' +
      '<p class="vt-dtvp-control-note">Choose 0, 1, 2, or 3 using the listed criteria. The test advances after scoring. Stop after three consecutive zero-score items.</p>' +
      '</div>';
  }

  function renderDtvpChoiceControls(container, subtest, entry, response) {
    if (!container) return;
    var selectedIds = dtvpSelectedAnswerIds(response);
    var selected = selectedIds.length ? selectedIds.join(', ') : 'not selected';
    if (dtvpUsesMultiSelectScoring(subtest)) {
      container.innerHTML =
        '<p class="vt-dtvp-control-note"><strong>Select all matching forms you can identify.</strong></p>' +
        '<p class="vt-dtvp-control-note">You may toggle selections. Press <strong>Score item</strong> when finished; the item will then be scored and the test will continue.</p>' +
        '<p class="vt-dtvp-control-note"><strong>Scoring:</strong> ' + dtvpChoiceScoringInstruction(subtest) + '</p>' +
        '<p class="vt-dtvp-control-note">Selected options: ' + selectedIds.length + '.</p>' +
        '<p class="vt-dtvp-control-note">Selected response: ' + selected + '.</p>' +
        dtvpChoiceSubmitHtml(subtest, { key: subtest.key });
      return;
    }
    container.innerHTML =
      '<p class="vt-dtvp-control-note"><strong>Scoring:</strong> ' + dtvpChoiceScoringInstruction(subtest) + '</p>' +
      '<p class="vt-dtvp-control-note">Selected response: ' + selected + '.</p>';
  }

  function dtvpChoiceScoringInstruction(subtest) {
    if (!subtest) return 'Score according to the authorised/manual criteria.';
    if (subtest.key === 'figureGround') return 'Award one raw point for each correct represented form selected. If any wrong form is selected, or no response is made, the item scores zero.';
    if (subtest.key === 'formConstancy') return 'Award one raw point for each correct matching form selected. If any wrong form is selected, or no response is made, the item scores zero.';
    if (subtest.key === 'visualClosure') return 'award 1 raw point for the correct option and 0 for an incorrect or omitted response. Apply the three-consecutive-zero ceiling rule.';
    return 'score according to the authorised/manual criteria.';
  }

  function navigateDtvpAssessmentItem(module, game, direction) {
    var state = module._vtVipGames && module._vtVipGames[game.key];
    if (!state || game.kind !== 'dtvpAssessment' || state.complete) return;
    var subtest = dtvpSubtestForGame(game);
    if (!subtest) return;
    var entries = dtvpEntries(subtest);
    var currentIndex = state.data.index || 0;
    var entry = entries[currentIndex];
    if (direction > 0 && !dtvpEntryReadyForNext(state, subtest, entry)) {
      showToast(module.closest('[data-vt-app]'), dtvpEntryIncompleteMessage(subtest));
      return;
    }
    commitDtvpCurrentEntry(module, game);
    if (direction > 0 && currentIndex >= entries.length - 1) {
      finishVipGame(module, game);
      updateModule(module);
      return;
    }
    state.data.index = Math.max(0, Math.min(entries.length - 1, currentIndex + direction));
    updateDtvpRawFromResponses(module, game, state);
    renderVipGameRound(module, game);
    updateModule(module);
  }

  function dtvpEntryReadyForNext(state, subtest, entry) {
    if (!state || !subtest || !entry || !entry.scored) return true;
    var response = state.data.responses[entry.id];
    if (!response) return false;
    if (subtest.mode === 'tracing') {
      return dtvpTraceSegmentValues(response, entry).every(function (value) { return value !== null; });
    }
    if (dtvpUsesMultiSelectScoring(subtest)) {
      return typeof response.score !== 'undefined';
    }
    return typeof response.score !== 'undefined';
  }

  function dtvpEntryIncompleteMessage(subtest) {
    if (!subtest) return 'Score this item before moving to the next item.';
    if (subtest.mode === 'tracing') return 'Score every numbered segment before moving to the next hand-eye item.';
    if (subtest.mode === 'copying') return 'Choose a 0, 1, 2, or 3 score before moving to the next copying item.';
    if (dtvpUsesMultiSelectScoring(subtest)) return 'Press Score item when finished before moving to the next item.';
    return 'Score this item before moving to the next item.';
  }

  function autoAdvanceDtvpAssessment(module, game, delay) {
    var state = module._vtVipGames && module._vtVipGames[game.key];
    var subtest = dtvpSubtestForGame(game);
    if (!state || !subtest || state.complete) return;
    var entries = dtvpEntries(subtest);
    if ((state.data.index || 0) >= entries.length - 1) {
      window.setTimeout(function () {
        commitDtvpCurrentEntry(module, game);
        finishVipGame(module, game);
        updateModule(module);
      }, delay || 0);
      return;
    }
    window.setTimeout(function () {
      if (!module._vtVipGames || module._vtVipGames[game.key] !== state || state.complete) return;
      state.data.index = Math.max(0, Math.min(entries.length - 1, (state.data.index || 0) + 1));
      renderVipGameRound(module, game);
      updateModule(module);
    }, delay || 0);
  }

  function dtvpCorrectKeysForEntry(subtest, entry) {
    if (!entry) return [];
    if (Array.isArray(entry.correctAnswerIds) && entry.correctAnswerIds.length) return entry.correctAnswerIds.slice();
    if (Array.isArray(entry.answerKeys) && entry.answerKeys.length) return entry.answerKeys.slice();
    if (subtest && subtest.key === 'figureGround') {
      var optionsByShape = {};
      (entry.options || []).forEach(function (option) {
        if (!optionsByShape[option.shape]) optionsByShape[option.shape] = [];
        optionsByShape[option.shape].push(option.label);
      });
      var keys = [];
      (entry.stimulusShapes || []).forEach(function (shape) {
        var labels = optionsByShape[shape.shape] || [];
        labels.forEach(function (label) {
          if (keys.indexOf(label) === -1) keys.push(label);
        });
      });
      return keys.length ? keys : (entry.answerKey ? [entry.answerKey] : []);
    }
    if (subtest && subtest.key === 'formConstancy') {
      return entry.answerKey ? [entry.answerKey] : [];
    }
    return entry.answerKey ? [entry.answerKey] : [];
  }

  function dtvpRequiredSelectionsForEntry(subtest, entry) {
    if (!entry) return 1;
    var correctKeys = dtvpCorrectKeysForEntry(subtest, entry);
    return Math.max(1, Number(entry.requiredSelections) || correctKeys.length || 1);
  }

  function dtvpSelectedAnswerIds(response) {
    if (!response) return [];
    if (Array.isArray(response.selectedAnswerIds)) return response.selectedAnswerIds.slice();
    if (Array.isArray(response.values)) return response.values.slice();
    if (response.value) return String(response.value).split(',').filter(Boolean);
    return [];
  }

  function chooseDtvpAssessmentOption(module, game, button) {
    var state = module._vtVipGames && module._vtVipGames[game.key];
    if (!state || state.complete) return;
    var subtest = dtvpSubtestForGame(game);
    var entry = dtvpEntries(subtest)[state.data.index || 0];
    if (!entry) return;
    state.data.responses[entry.id] = state.data.responses[entry.id] || {};
    var value = button.getAttribute('data-vt-dtvp-option') || '';
    var response = state.data.responses[entry.id];
    if (dtvpUsesMultiSelectScoring(subtest)) {
      if (response.locked) return;
      var selectedIds = dtvpSelectedAnswerIds(response);
      var selectedIndex = selectedIds.indexOf(value);
      if (selectedIndex !== -1) {
        selectedIds.splice(selectedIndex, 1);
      } else {
        selectedIds.push(value);
      }
      response.selectedAnswerIds = selectedIds.slice();
      response.values = selectedIds.slice();
      response.value = selectedIds.join(',');
      response.correctAnswerIds = dtvpCorrectKeysForEntry(subtest, entry);
      response.scored = !!entry.scored;
      renderVipGameRound(module, game);
      return;
    }
    response.value = value;
    response.values = [value];
    response.scored = !!entry.scored;
    commitDtvpCurrentEntry(module, game);
    renderVipGameRound(module, game);
    if (dtvpCeilingReached(state, subtest, module)) {
      window.setTimeout(function () { finishVipGame(module, game); updateModule(module); }, 360);
    } else {
      autoAdvanceDtvpAssessment(module, game, 360);
    }
  }

  function submitDtvpMultiSelectItem(module, game) {
    var state = module._vtVipGames && module._vtVipGames[game.key];
    if (!state || state.complete) return;
    var subtest = dtvpSubtestForGame(game);
    if (!dtvpUsesMultiSelectScoring(subtest)) return;
    var entries = dtvpEntries(subtest);
    var entry = entries[state.data.index || 0];
    if (!entry) return;
    state.data.responses[entry.id] = state.data.responses[entry.id] || {};
    var response = state.data.responses[entry.id];
    response.selectedAnswerIds = dtvpSelectedAnswerIds(response);
    response.values = response.selectedAnswerIds.slice();
    response.value = response.selectedAnswerIds.join(',');
    response.correctAnswerIds = dtvpCorrectKeysForEntry(subtest, entry);
    response.scored = !!entry.scored;
    response.locked = true;
    commitDtvpCurrentEntry(module, game);
    renderVipGameRound(module, game);
    if (dtvpCeilingReached(state, subtest, module)) {
      window.setTimeout(function () { finishVipGame(module, game); updateModule(module); }, 360);
    } else {
      autoAdvanceDtvpAssessment(module, game, 360);
    }
  }

  function scoreDtvpAssessmentItem(module, game, button) {
    var state = module._vtVipGames && module._vtVipGames[game.key];
    if (!state || state.complete) return;
    var subtest = dtvpSubtestForGame(game);
    var entry = dtvpEntries(subtest)[state.data.index || 0];
    if (!entry) return;
    var score = Math.max(0, Math.min(3, parseInt(button.getAttribute('data-vt-score'), 10) || 0));
    state.data.responses[entry.id] = {
      value: String(score),
      score: score,
      scored: !!entry.scored
    };
    updateDtvpRawFromResponses(module, game, state);
    var entries = dtvpEntries(subtest);
    if (dtvpCeilingReached(state, subtest, module) || (state.data.index || 0) >= entries.length - 1) {
      finishVipGame(module, game);
      return;
    }
    state.data.index = Math.max(0, Math.min(entries.length - 1, (state.data.index || 0) + 1));
    renderVipGameRound(module, game);
  }

  function commitDtvpCurrentEntry(module, game) {
    var state = module._vtVipGames && module._vtVipGames[game.key];
    var subtest = dtvpSubtestForGame(game);
    if (!state || !subtest || game.kind !== 'dtvpAssessment') return;
    var entry = dtvpEntries(subtest)[state.data.index || 0];
    if (!entry) return;
    var response = state.data.responses[entry.id];
    if (!response) return;
    response.scored = !!entry.scored;
    if (entry.scored && subtest.mode === 'tracing') {
      if (typeof response.score === 'undefined') return;
    } else if (entry.scored && subtest.mode !== 'copying') {
      var correctKeys = dtvpCorrectKeysForEntry(subtest, entry);
      if (dtvpUsesMultiSelectScoring(subtest)) {
        var selected = dtvpSelectedAnswerIds(response);
        var hasWrong = selected.some(function (key) { return correctKeys.indexOf(key) === -1; });
        var correctSelected = selected.filter(function (key) { return correctKeys.indexOf(key) !== -1; }).length;
        response.selectedAnswerIds = selected.slice();
        response.values = selected.slice();
        response.value = selected.join(',');
        response.correctAnswerIds = correctKeys.slice();
        response.scoringRule = entry.scoringRule || 'multi-select-zero-if-any-wrong';
        response.maxPoints = Number(entry.maxPoints) || correctKeys.length;
        response.correctSelected = correctSelected;
        response.hasWrongSelection = hasWrong;
        response.isCorrect = !hasWrong && selected.length > 0 && correctSelected === selected.length;
        response.correct = response.isCorrect;
        response.score = (!selected.length || hasWrong) ? 0 : correctSelected;
        response.itemScore = response.score;
        response.scoringResult = response.score > 0 ? 'credited' : 'zero';
      } else {
        response.correct = response.value === entry.answerKey;
        response.score = response.correct ? 1 : 0;
      }
    }
    updateDtvpRawFromResponses(module, game, state);
  }

  function updateDtvpRawFromResponses(module, game, state) {
    var subtest = dtvpSubtestForGame(game);
    if (!subtest || !state) return;
    var entries = dtvpEntries(subtest).filter(function (entry) { return entry.scored; });
    var raw = 0;
    var completed = 0;
    var itemScores = [];
    var zeroStreak = 0;
    var ceilingReached = false;
    var ignoreCeiling = dtvpTestingMode(module);
    entries.forEach(function (entry) {
      if (ceilingReached && !ignoreCeiling) return;
      var response = state.data.responses[entry.id];
      if (!response || typeof response.score === 'undefined') return;
      if (subtest.mode === 'tracing' && !dtvpTraceSegmentValues(response, entry).every(function (value) { return value !== null; })) {
        return;
      }
      var score = Number(response.score) || 0;
      raw += score;
      completed += 1;
      itemScores.push(score > 0 ? 1 : 0);
      if (subtest.key !== 'eyeHand') {
        zeroStreak = score === 0 ? zeroStreak + 1 : 0;
        if (zeroStreak >= 3) ceilingReached = true;
      }
    });
    state.raw = Math.max(0, Math.min(subtest.rawMax || raw, raw));
    state.round = completed;
    state.errors = Math.max(0, completed - raw);
    state.max = subtest.rawMax;
    state.data.itemScores = itemScores;
    state.data.ceilingReached = ceilingReached;
    state.data.ceilingIgnored = !!(ceilingReached && ignoreCeiling);
    state.data.completedIds = state.data.completedIds || {};
    updateVipGameCounters(module, game);
  }

  function dtvpCeilingReached(state, subtest, module) {
    if (!state || !subtest || subtest.key === 'eyeHand') return false;
    if (dtvpTestingMode(module)) return false;
    if (state.data && state.data.ceilingReached) return true;
    var scoredEntries = dtvpEntries(subtest).filter(function (entry) { return entry.scored; });
    var scoredResponses = [];
    scoredEntries.forEach(function (entry) {
      var response = state.data.responses[entry.id];
      if (response && typeof response.score !== 'undefined') scoredResponses.push(Number(response.score) || 0);
    });
    if (scoredResponses.length < 3) return false;
    var lastThree = scoredResponses.slice(-3);
    return lastThree.every(function (score) { return score === 0; });
  }

  function dtvpCompletedCount(state) {
    return state && state.round ? state.round : 0;
  }

  function dtvpTraceTotalSegments(subtest) {
    return (subtest.items || []).reduce(function (total, item) {
      return total + (Number(item.segments) || 1);
    }, 0) || 1;
  }

  function dtvpTraceItemMax(subtest, entry) {
    return Math.max(1, (Number(entry && entry.segments) || 1) * dtvpTraceSegmentMax(entry));
  }

  function dtvpTraceSegmentMax(entry) {
    return Number(entry && entry.number) <= 2 ? 1 : 4;
  }

  function dtvpTraceScoringInstruction(entry) {
    if (Number(entry && entry.number) <= 2) {
      return 'Items 1 and 2: each numbered segment scores 1 if the line remains within the path and is continuous; score 0 if it leaves the path, is broken, omitted, or not scorable.';
    }
    return 'Items 3 to 5: each numbered segment scores 0 to 4 according to path control. Score 4 for best centre-path control, reduce for increasing deviation, and score 0 if continuity is broken, omitted, or not scorable.';
  }

  function ensureDtvpTraceDefaultResponse(module, game, state, subtest, entry) {
    if (!state || !subtest || !entry) return {};
    state.data.responses = state.data.responses || {};
    var response = state.data.responses[entry.id] || {};
    var count = Number(entry && entry.segments) || 1;
    var segmentMax = dtvpTraceSegmentMax(entry);
    var source = Array.isArray(response.segments) ? response.segments : [];
    var values = [];
    for (var index = 0; index < count; index += 1) {
      var existing = Number(source[index]);
      values.push(Number.isFinite(existing) ? Math.max(0, Math.min(segmentMax, existing)) : segmentMax);
    }
    var raw = values.reduce(function (total, value) {
      return total + (Number(value) || 0);
    }, 0);
    state.data.responses[entry.id] = Object.assign({}, response, {
      value: 'segment-scores',
      score: raw,
      segments: values,
      scored: !!entry.scored,
      itemMax: dtvpTraceItemMax(subtest, entry),
      defaultMaxPreselected: true
    });
    updateDtvpRawFromResponses(module, game, state);
    return state.data.responses[entry.id];
  }

  function dtvpTraceSegmentValues(response, entry) {
    var count = Number(entry && entry.segments) || 1;
    var source = Array.isArray(response && response.segments) ? response.segments : [];
    var values = [];
    for (var index = 0; index < count; index += 1) {
      var value = Number(source[index]);
      values.push(Number.isFinite(value) ? value : null);
    }
    return values;
  }

  function dtvpRenderTraceSegmentScorePanel(game, entry, response) {
    var values = dtvpTraceSegmentValues(response, entry);
    var segmentMax = dtvpTraceSegmentMax(entry);
    var scoreButtons = [];
    for (var score = 0; score <= segmentMax; score += 1) scoreButtons.push(score);
    var segmentSplit = Math.ceil(values.length / 2);
    return '<div class="vt-dtvp-segment-score-list" style="--vt-segment-split:' + segmentSplit + '">' + values.map(function (value, index) {
      return '<div class="vt-dtvp-segment-score-row" data-vt-segment-row="' + index + '">' +
        '<span class="vt-dtvp-segment-label">Segment ' + (index + 1) + '</span>' +
        '<div class="vt-dtvp-segment-buttons">' +
        scoreButtons.map(function (score) {
          var selected = value === score ? ' is-selected' : '';
          return '<button class="vt-button vt-button-secondary' + selected + '" type="button" data-vt-action="vip-game-trace-segment-score" data-vt-vip-game-key="' + game.key + '" data-vt-segment-index="' + index + '" data-vt-segment-score="' + score + '">' + score + '</button>';
        }).join('') +
        '</div>' +
        '</div>';
    }).join('') + '</div>';
  }

  function dtvpScoreTraceEntry(state, subtest, entry) {
    state.data.tracePointsById = state.data.tracePointsById || {};
    var points = state.data.tracePointsById[entry.id] || [];
    var spec = dtvpTraceSpec(entry, { width: 900, height: 520 });
    var accuracy = vipTraceAccuracy(points, spec);
    var itemMax = dtvpTraceItemMax(subtest, entry);
    return {
      accuracy: accuracy,
      raw: Math.max(0, Math.min(itemMax, Math.round(accuracy * itemMax)))
    };
  }

  function scoreDtvpTraceItem(module, game, button) {
    showToast(module.closest('[data-vt-app]'), 'Score each numbered segment before moving to the next hand-eye item.');
  }

  function scoreDtvpTraceSegment(module, game, button) {
    var state = module._vtVipGames && module._vtVipGames[game.key];
    var subtest = dtvpSubtestForGame(game);
    if (!state || !subtest || state.complete || subtest.mode !== 'tracing') return;
    var entries = dtvpEntries(subtest);
    var entry = entries[state.data.index || 0];
    if (!entry) return;
    var segmentIndex = parseInt(button.getAttribute('data-vt-segment-index'), 10);
    var segmentScore = parseInt(button.getAttribute('data-vt-segment-score'), 10);
    if (!Number.isFinite(segmentIndex) || !Number.isFinite(segmentScore)) return;
    var values = dtvpTraceSegmentValues(state.data.responses[entry.id] || {}, entry);
    var segmentMax = dtvpTraceSegmentMax(entry);
    values[segmentIndex] = Math.max(0, Math.min(segmentMax, segmentScore));
    var raw = values.reduce(function (total, value) {
      return total + (Number(value) || 0);
    }, 0);
    state.data.responses[entry.id] = {
      value: 'segment-scores',
      score: raw,
      segments: values,
      scored: !!entry.scored,
      itemMax: dtvpTraceItemMax(subtest, entry)
    };
    updateDtvpRawFromResponses(module, game, state);
    updateDtvpTraceSegmentUi(module, game, button, entry, values, state.raw);
    if (button && typeof button.blur === 'function') button.blur();
  }

  function updateDtvpTraceSegmentUi(module, game, button, entry, values, raw) {
    var card = vipGameCard(module, game.key);
    var subtest = dtvpSubtestForGame(game);
    if (!card || !subtest) return;
    var row = button && button.closest ? button.closest('[data-vt-segment-row]') : null;
    if (row) {
      Array.prototype.slice.call(row.querySelectorAll('.vt-button')).forEach(function (item) {
        item.classList.remove('is-selected');
      });
      button.classList.add('is-selected');
    }
    var rawField = card.querySelector('[data-vt-dtvp-trace-raw]');
    if (rawField) rawField.textContent = 'Raw score recorded: ' + Math.round(raw || 0) + ' / ' + subtest.rawMax;
    var progressField = card.querySelector('[data-vt-dtvp-trace-progress]');
    if (progressField) {
      var entries = dtvpEntries(subtest);
      var completed = dtvpCompletedCount(module._vtVipGames && module._vtVipGames[game.key]);
      var currentIndex = entries.findIndex(function (item) { return item.id === entry.id; });
      var position = (currentIndex + 1) + ' / ' + entries.length;
      var clinicianNote = entry.scored ? 'Scored item' : 'Practice example - not included in raw score';
      progressField.textContent = clinicianNote + ' | Position ' + position + ' | Tracing items completed ' + completed + ' / ' + subtest.items.length;
    }
    var allScored = values.every(function (value) { return value !== null; });
    card.classList.toggle('is-dtvp-current-item-complete', allScored);
  }

  function finishDtvpTraceItem(module, game) {
    var state = module._vtVipGames && module._vtVipGames[game.key];
    var subtest = dtvpSubtestForGame(game);
    if (!state || !subtest || state.complete || subtest.mode !== 'tracing') return;
    commitDtvpCurrentEntry(module, game);
    var entries = dtvpEntries(subtest);
    if ((state.data.index || 0) >= entries.length - 1) {
      finishVipGame(module, game);
      return;
    }
    state.data.index = Math.max(0, Math.min(entries.length - 1, (state.data.index || 0) + 1));
    renderVipGameRound(module, game);
  }

  function dtvpDrawEntry(canvas, subtest, entry, sample, state) {
    if (!canvas || !entry) return;
    var ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.strokeStyle = '#1d1d1f';
    ctx.fillStyle = '#f1f1f1';
    ctx.lineWidth = 3;
    ctx.lineJoin = 'round';
    ctx.lineCap = 'round';
    ctx.strokeRect(18, 18, canvas.width - 36, canvas.height - 36);
    ctx.fillStyle = '#1d1d1f';
    ctx.font = '700 18px system-ui, sans-serif';
    ctx.fillText(sample ? 'Sample preview' : (entry.displayNumber || ''), 34, 48);
    if (subtest.mode === 'tracing') {
      var tracePoints = state && state.data && state.data.tracePointsById ? state.data.tracePointsById[entry.id] : [];
      drawDtvpTraceCanvas(canvas, entry, tracePoints || [], sample);
      return;
    }
    if (subtest.mode === 'copying') {
      dtvpDrawCopyFigure(ctx, entry.figure, canvas.width / 2, canvas.height / 2 + 10, Math.min(canvas.width, canvas.height) * 0.34);
      return;
    }
    var shapes = entry.stimulusShapes || [];
    if (subtest.key === 'figureGround') {
      dtvpDrawClutter(ctx, canvas.width, canvas.height, Math.min(7, 2 + Math.floor((Number(entry.number) || 1) / 2)));
    }
    if (subtest.key === 'visualClosure') {
      ctx.fillStyle = '#f7f7f7';
      ctx.fillRect(canvas.width / 2 - 110, 78, 220, 220);
      ctx.strokeStyle = '#444';
      ctx.strokeRect(canvas.width / 2 - 110, 78, 220, 220);
    }
    shapes.forEach(function (shape, index) {
      var x = canvas.width / 2 + (shape.x || 0) * 2.3;
      var y = subtest.key === 'visualClosure' ? 188 + (shape.y || 0) : canvas.height / 2 + 20 + (shape.y || 0) * 2.1;
      var radius = subtest.key === 'figureGround' ? 52 : 72;
      dtvpDrawShape(ctx, shape.shape, x, y, radius * (shape.scale || 1), shape);
      if (subtest.key === 'formConstancy') {
        ctx.fillStyle = '#1d1d1f';
        ctx.font = '800 16px system-ui, sans-serif';
        ctx.fillText('Target', 46, 76);
      }
    });
  }

  function dtvpDrawShapeCanvas(canvas, shape, options) {
    if (!canvas || !shape) return;
    var ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    dtvpDrawShape(ctx, shape.shape, canvas.width / 2, canvas.height / 2 + 4, 38 * (shape.scale || 1), Object.assign({}, shape, options || {}));
  }

  function dtvpDrawClutter(ctx, width, height, level) {
    ctx.save();
    ctx.strokeStyle = 'rgba(30, 30, 30, 0.22)';
    ctx.lineWidth = 2;
    for (var line = 0; line < 10 + level * 3; line += 1) {
      ctx.beginPath();
      var startX = 54 + (line * 47) % (width - 100);
      var startY = 80 + (line * 31) % (height - 140);
      ctx.moveTo(startX, startY);
      ctx.bezierCurveTo(width * 0.22 + line * 9, height * 0.22 + (line % 5) * 35, width * 0.72 - line * 6, height * 0.68 - (line % 4) * 22, width - 70 - (line * 23) % 180, height - 60 - (line % 7) * 18);
      ctx.stroke();
    }
    for (var ring = 0; ring < level; ring += 1) {
      ctx.beginPath();
      ctx.ellipse(160 + ring * 72, 124 + (ring % 3) * 58, 34 + ring * 3, 20 + ring * 2, ring * 0.4, 0, Math.PI * 2);
      ctx.stroke();
    }
    ctx.restore();
  }

  function dtvpDrawShape(ctx, shape, x, y, radius, descriptor) {
    descriptor = descriptor || {};
    ctx.save();
    ctx.translate(x, y);
    ctx.rotate((descriptor.rotation || 0) * Math.PI / 180);
    ctx.scale(descriptor.mirror ? -1 : 1, 1);
    ctx.lineWidth = Math.max(2, 4 * (descriptor.thickness || 1));
    ctx.lineJoin = 'round';
    ctx.lineCap = 'round';
    ctx.strokeStyle = '#111111';
    ctx.fillStyle = descriptor.shade ? '#d7d7d7' : 'rgba(255,255,255,0)';
    if (descriptor.fragment) {
      ctx.setLineDash([14, 10]);
    } else {
      ctx.setLineDash([]);
    }
    dtvpTraceShape(ctx, shape, radius);
    if (descriptor.shade) ctx.fill();
    ctx.stroke();
    ctx.restore();
  }

  function dtvpTraceShape(ctx, shape, radius) {
    ctx.beginPath();
    if (shape === 'verticalLine') {
      ctx.moveTo(0, -radius);
      ctx.lineTo(0, radius);
    } else if (shape === 'horizontalLine') {
      ctx.moveTo(-radius, 0);
      ctx.lineTo(radius, 0);
    } else if (shape === 'diagDown') {
      ctx.moveTo(-radius, -radius);
      ctx.lineTo(radius, radius);
    } else if (shape === 'diagUp') {
      ctx.moveTo(-radius, radius);
      ctx.lineTo(radius, -radius);
    } else if (shape === 'cross') {
      ctx.moveTo(-radius, 0);
      ctx.lineTo(radius, 0);
      ctx.moveTo(0, -radius);
      ctx.lineTo(0, radius);
    } else if (shape === 'x' || shape === 'xShape') {
      ctx.moveTo(-radius, -radius);
      ctx.lineTo(radius, radius);
      ctx.moveTo(radius, -radius);
      ctx.lineTo(-radius, radius);
    } else if (shape === 'diamond') {
      ctx.moveTo(0, -radius);
      ctx.lineTo(radius, 0);
      ctx.lineTo(0, radius);
      ctx.lineTo(-radius, 0);
      ctx.closePath();
    } else if (shape === 'rectangle') {
      ctx.rect(-radius * 1.25, -radius * 0.62, radius * 2.5, radius * 1.24);
    } else if (shape === 'oval') {
      ctx.ellipse(0, 0, radius * 1.2, radius * 0.62, 0, 0, Math.PI * 2);
    } else if (shape === 'crescent') {
      ctx.arc(-radius * 0.18, 0, radius, Math.PI * 0.18, Math.PI * 1.82);
      ctx.arc(radius * 0.24, 0, radius * 0.78, Math.PI * 1.72, Math.PI * 0.28, true);
      ctx.closePath();
    } else if (shape === 'angle') {
      ctx.moveTo(-radius, -radius * 0.7);
      ctx.lineTo(0, 0);
      ctx.lineTo(radius, -radius * 0.7);
      ctx.moveTo(0, 0);
      ctx.lineTo(0, radius);
    } else if (shape === 'pentagon') {
      for (var p = 0; p < 5; p += 1) {
        var pa = -Math.PI / 2 + p * Math.PI * 2 / 5;
        var px = Math.cos(pa) * radius;
        var py = Math.sin(pa) * radius;
        if (p === 0) ctx.moveTo(px, py); else ctx.lineTo(px, py);
      }
      ctx.closePath();
    } else if (shape === 'hexagon') {
      for (var h = 0; h < 6; h += 1) {
        var ha = Math.PI / 6 + h * Math.PI * 2 / 6;
        var hx = Math.cos(ha) * radius;
        var hy = Math.sin(ha) * radius;
        if (h === 0) ctx.moveTo(hx, hy); else ctx.lineTo(hx, hy);
      }
      ctx.closePath();
    } else if (shape === 'ring') {
      ctx.arc(0, 0, radius, 0, Math.PI * 2);
      ctx.moveTo(radius * 0.55, 0);
      ctx.arc(0, 0, radius * 0.55, 0, Math.PI * 2);
    } else if (shape === 'spiral') {
      for (var s = 0; s < 54; s += 1) {
        var sa = s * 0.36;
        var sr = radius * s / 54;
        var sx = Math.cos(sa) * sr;
        var sy = Math.sin(sa) * sr;
        if (s === 0) ctx.moveTo(sx, sy); else ctx.lineTo(sx, sy);
      }
    } else if (shape === 'loopField') {
      for (var l = 0; l < 3; l += 1) {
        ctx.moveTo(-radius + l * radius * 0.5, -radius * 0.2);
        ctx.bezierCurveTo(-radius * 0.8, -radius, radius * 0.8, -radius, radius - l * radius * 0.4, radius * 0.2);
        ctx.bezierCurveTo(radius * 0.5, radius, -radius * 0.5, radius, -radius + l * radius * 0.5, -radius * 0.2);
      }
    } else if (shape === 'cube') {
      ctx.rect(-radius * 0.75, -radius * 0.55, radius * 1.1, radius * 1.1);
      ctx.moveTo(-radius * 0.75, -radius * 0.55);
      ctx.lineTo(-radius * 0.35, -radius * 0.92);
      ctx.lineTo(radius * 0.76, -radius * 0.92);
      ctx.lineTo(radius * 0.35, -radius * 0.55);
      ctx.moveTo(radius * 0.35, radius * 0.55);
      ctx.lineTo(radius * 0.76, radius * 0.16);
      ctx.lineTo(radius * 0.76, -radius * 0.92);
    } else if (shape === 'puzzle') {
      ctx.moveTo(-radius, -radius * 0.7);
      ctx.lineTo(-radius * 0.1, -radius * 0.7);
      ctx.quadraticCurveTo(0, -radius * 1.1, radius * 0.24, -radius * 0.7);
      ctx.lineTo(radius, -radius * 0.7);
      ctx.lineTo(radius, radius * 0.72);
      ctx.lineTo(radius * 0.2, radius * 0.72);
      ctx.quadraticCurveTo(0, radius * 0.38, -radius * 0.2, radius * 0.72);
      ctx.lineTo(-radius, radius * 0.72);
      ctx.closePath();
    } else if (shape === 'polygon') {
      ctx.moveTo(-radius, -radius * 0.2);
      ctx.lineTo(-radius * 0.2, -radius);
      ctx.lineTo(radius * 0.9, -radius * 0.58);
      ctx.lineTo(radius * 0.65, radius * 0.55);
      ctx.lineTo(-radius * 0.46, radius);
      ctx.closePath();
    } else if (shape === 'hourglass') {
      ctx.moveTo(-radius, -radius);
      ctx.lineTo(radius, -radius);
      ctx.lineTo(-radius, radius);
      ctx.lineTo(radius, radius);
      ctx.closePath();
    } else if (shape === 'notchRect') {
      ctx.moveTo(-radius, -radius * 0.65);
      ctx.lineTo(radius, -radius * 0.65);
      ctx.lineTo(radius, radius * 0.65);
      ctx.lineTo(radius * 0.14, radius * 0.65);
      ctx.lineTo(radius * 0.14, radius * 0.18);
      ctx.lineTo(-radius * 0.28, radius * 0.18);
      ctx.lineTo(-radius * 0.28, radius * 0.65);
      ctx.lineTo(-radius, radius * 0.65);
      ctx.closePath();
    } else if (shape === 'dashLine') {
      ctx.moveTo(-radius, 0);
      ctx.lineTo(-radius * 0.3, 0);
      ctx.moveTo(radius * 0.15, 0);
      ctx.lineTo(radius, 0);
    } else if (shape === 'circleTriangle') {
      ctx.arc(-radius * 0.18, 0, radius * 0.66, 0, Math.PI * 2);
      ctx.moveTo(radius * 0.22, -radius * 0.75);
      ctx.lineTo(radius, radius * 0.72);
      ctx.lineTo(-radius * 0.12, radius * 0.72);
      ctx.closePath();
    } else if (shape === 'starCrescent') {
      dtvpTraceShape(ctx, 'star', radius * 0.62);
      ctx.moveTo(radius * 0.92, 0);
      ctx.arc(radius * 0.45, 0, radius * 0.48, Math.PI * 0.22, Math.PI * 1.78);
    } else if (shape === 'triangleRectangle') {
      ctx.rect(-radius, -radius * 0.4, radius * 1.1, radius * 0.8);
      ctx.moveTo(radius * 0.1, -radius * 0.72);
      ctx.lineTo(radius, 0);
      ctx.lineTo(radius * 0.1, radius * 0.72);
      ctx.closePath();
    } else if (shape === 'overlapCircles') {
      ctx.arc(-radius * 0.36, 0, radius * 0.62, 0, Math.PI * 2);
      ctx.moveTo(radius * 0.98, 0);
      ctx.arc(radius * 0.36, 0, radius * 0.62, 0, Math.PI * 2);
    } else if (shape === 'starBox') {
      ctx.rect(-radius, -radius * 0.72, radius * 2, radius * 1.44);
      ctx.moveTo(0, -radius * 0.55);
      for (var sp = 0; sp < 10; sp += 1) {
        var spa = -Math.PI / 2 + sp * Math.PI / 5;
        var spr = sp % 2 ? radius * 0.22 : radius * 0.48;
        var spx = Math.cos(spa) * spr;
        var spy = Math.sin(spa) * spr;
        if (sp === 0) ctx.moveTo(spx, spy); else ctx.lineTo(spx, spy);
      }
      ctx.closePath();
    } else if (shape === 'dashedHexagon') {
      ctx.setLineDash([10, 8]);
      dtvpTraceShape(ctx, 'hexagon', radius);
    } else if (shape === 'doubleTriangle') {
      ctx.moveTo(-radius, radius * 0.75);
      ctx.lineTo(0, -radius);
      ctx.lineTo(radius, radius * 0.75);
      ctx.closePath();
      ctx.moveTo(-radius * 0.58, radius * 0.35);
      ctx.lineTo(0, -radius * 0.52);
      ctx.lineTo(radius * 0.58, radius * 0.35);
      ctx.closePath();
    } else if (shape === 'shadedBlock') {
      ctx.rect(-radius, -radius * 0.58, radius * 2, radius * 1.16);
      ctx.moveTo(-radius, -radius * 0.58);
      ctx.lineTo(-radius * 0.55, -radius);
      ctx.lineTo(radius * 1.45, -radius);
      ctx.lineTo(radius, -radius * 0.58);
      ctx.moveTo(radius, radius * 0.58);
      ctx.lineTo(radius * 1.45, radius * 0.15);
      ctx.lineTo(radius * 1.45, -radius);
    } else if (shape === 'abstractWave') {
      ctx.moveTo(-radius, -radius * 0.2);
      ctx.bezierCurveTo(-radius * 0.4, -radius, radius * 0.35, radius, radius, radius * 0.14);
      ctx.bezierCurveTo(radius * 0.55, radius * 0.85, -radius * 0.35, -radius * 0.7, -radius, radius * 0.35);
    } else if (shape === 'circleSegments') {
      ctx.arc(0, 0, radius, 0, Math.PI * 2);
      ctx.moveTo(-radius * 0.55, -radius * 0.2);
      ctx.lineTo(radius * 0.55, -radius * 0.2);
      ctx.moveTo(0, -radius * 0.78);
      ctx.lineTo(0, radius * 0.78);
    } else if (shape === 'fourRect') {
      ctx.rect(-radius, -radius * 0.66, radius * 2, radius * 1.32);
      ctx.moveTo(0, -radius * 0.66);
      ctx.lineTo(0, radius * 0.66);
      ctx.moveTo(-radius, 0);
      ctx.lineTo(radius, 0);
    } else if (shape === 'curvedTriangle') {
      ctx.moveTo(-radius * 0.9, -radius);
      ctx.quadraticCurveTo(-radius * 1.25, 0, -radius * 0.9, radius);
      ctx.moveTo(radius * 0.9, -radius);
      ctx.quadraticCurveTo(radius * 1.25, 0, radius * 0.9, radius);
      ctx.moveTo(0, -radius * 0.75);
      ctx.lineTo(radius * 0.55, radius * 0.6);
      ctx.lineTo(-radius * 0.55, radius * 0.6);
      ctx.closePath();
    } else if (shape === 'trapezoid') {
      ctx.moveTo(-radius * 0.65, -radius * 0.55);
      ctx.lineTo(radius * 0.65, -radius * 0.55);
      ctx.lineTo(radius, radius * 0.55);
      ctx.lineTo(-radius, radius * 0.55);
      ctx.closePath();
    } else if (shape === 'diamondCross') {
      dtvpTraceShape(ctx, 'diamond', radius);
      ctx.moveTo(0, -radius);
      ctx.lineTo(0, radius);
      ctx.moveTo(-radius, 0);
      ctx.lineTo(radius, 0);
    } else if (shape === 'rectangleDiamond') {
      ctx.rect(-radius, -radius * 0.65, radius * 2, radius * 1.3);
      ctx.moveTo(0, -radius * 0.52);
      ctx.lineTo(radius * 0.58, 0);
      ctx.lineTo(0, radius * 0.52);
      ctx.lineTo(-radius * 0.58, 0);
      ctx.closePath();
    } else if (shape === 'triangleCircleSpokes') {
      dtvpTraceShape(ctx, 'triangle', radius);
      ctx.moveTo(radius * 0.42, 0);
      ctx.arc(0, 0, radius * 0.42, 0, Math.PI * 2);
      ctx.moveTo(0, -radius * 0.42);
      ctx.lineTo(0, radius * 0.42);
      ctx.moveTo(-radius * 0.36, radius * 0.2);
      ctx.lineTo(radius * 0.36, -radius * 0.2);
      ctx.moveTo(-radius * 0.36, -radius * 0.2);
      ctx.lineTo(radius * 0.36, radius * 0.2);
    } else if (shape === 'complexDiamondTriangle') {
      dtvpTraceShape(ctx, 'diamond', radius);
      ctx.moveTo(-radius, 0);
      ctx.lineTo(0, -radius);
      ctx.lineTo(radius, 0);
      ctx.moveTo(-radius * 0.58, radius * 0.58);
      ctx.lineTo(0, -radius * 0.18);
      ctx.lineTo(radius * 0.58, radius * 0.58);
    } else {
      traceVisualShape(ctx, shape, radius);
    }
  }

  function dtvpDrawCopyFigure(ctx, figure, x, y, radius) {
    dtvpDrawShape(ctx, figure, x, y, radius, { thickness: 1 });
  }

  function dtvpTraceSpec(entry, size) {
    var width = size && size.width ? size.width : 900;
    var height = size && size.height ? size.height : 520;
    if (!entry || entry.traceKind === 'straight-wide') {
      return { width: 78, points: [{ x: width * 0.15, y: height * 0.52 }, { x: width * 0.84, y: height * 0.52 }] };
    }
    if (entry.traceKind === 'straight-narrow') {
      return { width: 46, points: [{ x: width * 0.15, y: height * 0.52 }, { x: width * 0.84, y: height * 0.52 }] };
    }
    if (entry.traceKind === 'straight-lined') {
      return { width: 62, points: [{ x: width * 0.15, y: height * 0.55 }, { x: width * 0.84, y: height * 0.55 }] };
    }
    if (entry.traceKind === 'curved-s') {
      return {
        width: 72,
        points: [
          { x: width * 0.12, y: height * 0.50 },
          { x: width * 0.26, y: height * 0.50 },
          { x: width * 0.31, y: height * 0.72 },
          { x: width * 0.46, y: height * 0.72 },
          { x: width * 0.53, y: height * 0.27 },
          { x: width * 0.64, y: height * 0.29 },
          { x: width * 0.64, y: height * 0.72 },
          { x: width * 0.78, y: height * 0.72 },
          { x: width * 0.74, y: height * 0.37 },
          { x: width * 0.88, y: height * 0.48 }
        ]
      };
    }
    if (entry.traceKind === 'oval-track') {
      var points = [];
      var cx = width * 0.5;
      var cy = height * 0.52;
      var rx = width * 0.36;
      var ry = height * 0.34;
      for (var i = 0; i <= 44; i += 1) {
        var theta = Math.PI / 2 - i * Math.PI * 1.86 / 44;
        points.push({ x: cx + Math.cos(theta) * rx, y: cy + Math.sin(theta) * ry });
      }
      return { width: 70, points: points };
    }
    return { width: 68, points: [{ x: width * 0.15, y: height * 0.52 }, { x: width * 0.84, y: height * 0.52 }] };
  }

  function drawDtvpTraceCanvas(canvas, entry, drawnPoints, sample) {
    if (!canvas || !entry) return;
    var ctx = canvas.getContext('2d');
    var spec = dtvpTraceSpec(entry, { width: canvas.width, height: canvas.height });
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.strokeStyle = '#1d1d1f';
    ctx.lineWidth = 3;
    ctx.strokeRect(18, 18, canvas.width - 36, canvas.height - 36);
    ctx.fillStyle = '#1d1d1f';
    ctx.font = '700 20px system-ui, sans-serif';
    ctx.fillText((sample ? 'Sample preview: ' : '') + (entry.title || entry.displayNumber || 'Tracing item'), 34, 52);
    if (drawDtvpReferenceTraceImage(canvas, ctx, entry, drawnPoints, sample)) return;
    drawDtvpTraceIcons(ctx, entry, spec, canvas.width, canvas.height);
    ctx.save();
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.strokeStyle = '#edf2f5';
    ctx.lineWidth = spec.width;
    drawVipPolyline(ctx, spec.points);
    ctx.strokeStyle = '#9099a1';
    ctx.lineWidth = 2;
    var laneCount = entry.traceKind === 'straight-lined' || entry.traceKind === 'curved-s' || entry.traceKind === 'oval-track' ? 6 : 2;
    for (var lane = 0; lane <= laneCount; lane += 1) {
      var offset = -spec.width / 2 + lane * (spec.width / laneCount);
      drawDtvpOffsetPolyline(ctx, spec.points, offset);
    }
    ctx.strokeStyle = '#111111';
    ctx.lineWidth = 4;
    drawVipPolyline(ctx, spec.points);
    ctx.restore();
    drawDtvpTraceMarkers(ctx, spec.points, Number(entry.segments) || 8);
    if (drawnPoints && drawnPoints.length > 1) {
      ctx.save();
      ctx.strokeStyle = '#f1a93b';
      ctx.lineWidth = 7;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      drawVipPolyline(ctx, drawnPoints);
      ctx.restore();
    }
  }

  function drawDtvpReferenceTraceImage(canvas, ctx, entry, drawnPoints, sample) {
    var images = window.OptiplexDtvpHandEyeImages || window.OptiplexDtvpPrintImages || {};
    var src = images['item' + entry.number];
    if (!src) return false;
    window._vtDtvpImageCache = window._vtDtvpImageCache || {};
    var image = window._vtDtvpImageCache[src];
    if (!image) {
      image = new Image();
      window._vtDtvpImageCache[src] = image;
      image.onload = function () {
        drawDtvpTraceCanvas(canvas, entry, drawnPoints || [], sample);
      };
      image.onerror = function () {
        window._vtDtvpImageCache[src] = null;
        drawDtvpTraceCanvas(canvas, entry, drawnPoints || [], sample);
      };
      image.src = src;
    }
    if (image.complete && !image.naturalWidth) return false;
    if (!image.complete) {
      ctx.fillStyle = '#f5f8fa';
      ctx.fillRect(34, 74, canvas.width - 68, canvas.height - 108);
      ctx.fillStyle = '#163158';
      ctx.font = '700 18px system-ui, sans-serif';
      ctx.fillText('Loading reference image...', 52, 112);
      return true;
    }
    var rect = dtvpContainRect(image.naturalWidth, image.naturalHeight, 34, 72, canvas.width - 68, canvas.height - 106);
    ctx.drawImage(image, rect.x, rect.y, rect.width, rect.height);
    if (drawnPoints && drawnPoints.length > 1) {
      ctx.save();
      ctx.strokeStyle = '#f1a93b';
      ctx.lineWidth = 7;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      drawVipPolyline(ctx, drawnPoints);
      ctx.restore();
    }
    return true;
  }

  function dtvpContainRect(sourceWidth, sourceHeight, x, y, width, height) {
    var scale = Math.min(width / Math.max(1, sourceWidth), height / Math.max(1, sourceHeight));
    var drawWidth = sourceWidth * scale;
    var drawHeight = sourceHeight * scale;
    return {
      x: x + (width - drawWidth) / 2,
      y: y + (height - drawHeight) / 2,
      width: drawWidth,
      height: drawHeight
    };
  }

  function drawDtvpOffsetPolyline(ctx, points, offset) {
    if (!ctx || !points || points.length < 2) return;
    ctx.beginPath();
    for (var i = 0; i < points.length; i += 1) {
      var prev = points[Math.max(0, i - 1)];
      var next = points[Math.min(points.length - 1, i + 1)];
      var dx = next.x - prev.x;
      var dy = next.y - prev.y;
      var length = Math.sqrt(dx * dx + dy * dy) || 1;
      var x = points[i].x + (-dy / length) * offset;
      var y = points[i].y + (dx / length) * offset;
      if (i === 0) ctx.moveTo(x, y); else ctx.lineTo(x, y);
    }
    ctx.stroke();
  }

  function drawDtvpTraceMarkers(ctx, points, count) {
    if (!points || points.length < 2) return;
    ctx.save();
    ctx.fillStyle = '#3f4850';
    ctx.font = '700 15px system-ui, sans-serif';
    for (var i = 1; i <= count; i += 1) {
      var point = pointAlongPolyline(points, i / (count + 1));
      ctx.fillText(String(i), point.x - 5, point.y - 24);
    }
    ctx.fillStyle = '#26a86d';
    ctx.beginPath();
    ctx.arc(points[0].x, points[0].y, 16, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = '#163158';
    ctx.fillText('START', points[0].x - 25, points[0].y + 40);
    var end = points[points.length - 1];
    ctx.fillStyle = '#20B7C8';
    ctx.beginPath();
    ctx.arc(end.x, end.y, 16, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = '#163158';
    ctx.fillText('FINISH', end.x - 28, end.y + 40);
    ctx.restore();
  }

  function pointAlongPolyline(points, ratio) {
    var lengths = [];
    var total = 0;
    for (var i = 0; i < points.length - 1; i += 1) {
      var length = vipDistance(points[i], points[i + 1]);
      lengths.push(length);
      total += length;
    }
    var target = total * Math.max(0, Math.min(1, ratio));
    var travelled = 0;
    for (var segment = 0; segment < lengths.length; segment += 1) {
      if (travelled + lengths[segment] >= target) {
        var t = (target - travelled) / Math.max(1, lengths[segment]);
        return {
          x: points[segment].x + (points[segment + 1].x - points[segment].x) * t,
          y: points[segment].y + (points[segment + 1].y - points[segment].y) * t
        };
      }
      travelled += lengths[segment];
    }
    return points[points.length - 1];
  }

  function drawDtvpTraceIcons(ctx, entry, spec, width, height) {
    var start = spec.points[0];
    var end = spec.points[spec.points.length - 1];
    drawDtvpTraceIcon(ctx, entry.traceKind, 'start', start.x - 70, start.y, width, height);
    drawDtvpTraceIcon(ctx, entry.traceKind, 'end', end.x + 70, end.y, width, height);
  }

  function drawDtvpTraceIcon(ctx, kind, side, x, y) {
    ctx.save();
    ctx.translate(x, y);
    ctx.strokeStyle = '#111';
    ctx.fillStyle = '#fff';
    ctx.lineWidth = 3;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    if (kind === 'straight-wide' && side === 'start') {
      ctx.beginPath(); ctx.ellipse(0, 0, 34, 22, 0, 0, Math.PI * 2); ctx.stroke();
      ctx.beginPath(); ctx.arc(28, -8, 10, 0, Math.PI * 2); ctx.stroke();
      ctx.beginPath(); ctx.moveTo(-34, 6); ctx.quadraticCurveTo(-62, 20, -78, 4); ctx.stroke();
      ctx.beginPath(); ctx.arc(32, -10, 2, 0, Math.PI * 2); ctx.fillStyle = '#111'; ctx.fill();
    } else if (kind === 'straight-wide') {
      ctx.beginPath(); ctx.moveTo(-34, 16); ctx.lineTo(-22, -22); ctx.lineTo(32, -10); ctx.lineTo(20, 24); ctx.closePath(); ctx.stroke();
      ctx.beginPath(); ctx.arc(-2, 3, 5, 0, Math.PI * 2); ctx.arc(16, -5, 5, 0, Math.PI * 2); ctx.stroke();
    } else if (kind === 'straight-narrow' && side === 'start') {
      ctx.beginPath(); dtvpCanvasRoundRect(ctx, -44, -18, 78, 34, 10); ctx.stroke();
      ctx.beginPath(); ctx.arc(-28, 18, 8, 0, Math.PI * 2); ctx.arc(24, 18, 8, 0, Math.PI * 2); ctx.stroke();
      ctx.beginPath(); ctx.rect(-8, -28, 22, 12); ctx.stroke();
    } else if (kind === 'straight-narrow') {
      ctx.beginPath(); ctx.moveTo(-36, 20); ctx.lineTo(-36, -8); ctx.lineTo(-2, -32); ctx.lineTo(36, -8); ctx.lineTo(36, 20); ctx.closePath(); ctx.stroke();
      ctx.beginPath(); ctx.rect(-22, -4, 18, 24); ctx.stroke();
    } else if (kind === 'straight-lined' && side === 'start') {
      ctx.beginPath(); ctx.ellipse(0, 0, 28, 20, 0, 0, Math.PI * 2); ctx.stroke();
      ctx.beginPath(); ctx.moveTo(-26, 4); ctx.lineTo(-52, 24); ctx.moveTo(18, 18); ctx.lineTo(30, 36); ctx.stroke();
      ctx.beginPath(); ctx.arc(18, -4, 2, 0, Math.PI * 2); ctx.fillStyle = '#111'; ctx.fill();
    } else if (kind === 'straight-lined') {
      ctx.beginPath(); ctx.moveTo(-46, 0); ctx.quadraticCurveTo(-24, -26, 0, -12); ctx.quadraticCurveTo(26, -26, 46, 0); ctx.quadraticCurveTo(26, 24, 0, 12); ctx.quadraticCurveTo(-24, 24, -46, 0); ctx.stroke();
    } else if (kind === 'curved-s' && side === 'start') {
      ctx.beginPath(); ctx.ellipse(0, 0, 24, 15, 0, 0, Math.PI * 2); ctx.stroke();
      ctx.beginPath(); ctx.moveTo(-18, -4); ctx.lineTo(-40, -18); ctx.moveTo(-16, 4); ctx.lineTo(-42, 16); ctx.moveTo(22, -2); ctx.lineTo(42, -10); ctx.stroke();
    } else if (kind === 'curved-s') {
      for (var p = 0; p < 6; p += 1) {
        var a = -Math.PI / 2 + p * Math.PI * 2 / 6;
        ctx.beginPath(); ctx.ellipse(Math.cos(a) * 18, Math.sin(a) * 14, 9, 18, a, 0, Math.PI * 2); ctx.stroke();
      }
      ctx.beginPath(); ctx.moveTo(0, 12); ctx.lineTo(0, 46); ctx.moveTo(0, 28); ctx.quadraticCurveTo(-20, 28, -24, 48); ctx.stroke();
    } else if (kind === 'oval-track') {
      ctx.beginPath(); dtvpCanvasRoundRect(ctx, -36, -16, 72, 32, 10); ctx.stroke();
      ctx.beginPath(); ctx.arc(-22, 18, 8, 0, Math.PI * 2); ctx.arc(22, 18, 8, 0, Math.PI * 2); ctx.stroke();
      ctx.beginPath(); ctx.rect(-10, -28, 20, 12); ctx.stroke();
    }
    ctx.restore();
  }

  function dtvpCanvasRoundRect(ctx, x, y, width, height, radius) {
    if (ctx.roundRect) {
      ctx.roundRect(x, y, width, height, radius);
      return;
    }
    var r = Math.min(radius, width / 2, height / 2);
    ctx.moveTo(x + r, y);
    ctx.lineTo(x + width - r, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + r);
    ctx.lineTo(x + width, y + height - r);
    ctx.quadraticCurveTo(x + width, y + height, x + width - r, y + height);
    ctx.lineTo(x + r, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - r);
    ctx.lineTo(x, y + r);
    ctx.quadraticCurveTo(x, y, x + r, y);
  }

  function attachDtvpTraceEvents(canvas, module, game, state, entry) {
    if (!canvas || !entry) return;
    state.data.tracePointsById = state.data.tracePointsById || {};
    function pointFromEvent(event) {
      var rect = canvas.getBoundingClientRect();
      var scaleX = canvas.width / rect.width;
      var scaleY = canvas.height / rect.height;
      return {
        x: (event.clientX - rect.left) * scaleX,
        y: (event.clientY - rect.top) * scaleY
      };
    }
    function redraw() {
      drawDtvpTraceCanvas(canvas, entry, state.data.tracePointsById[entry.id] || [], false);
    }
    function addPoint(event) {
      if (!state.data.traceActive) return;
      state.data.tracePointsById[entry.id].push(pointFromEvent(event));
      redraw();
      event.preventDefault();
    }
    canvas.addEventListener('pointerdown', function (event) {
      state.data.traceActive = true;
      state.data.tracePointsById[entry.id] = [pointFromEvent(event)];
      canvas.setPointerCapture(event.pointerId);
      redraw();
      event.preventDefault();
    });
    canvas.addEventListener('pointermove', addPoint);
    canvas.addEventListener('pointerup', function (event) {
      addPoint(event);
      state.data.traceActive = false;
    });
    canvas.addEventListener('pointercancel', function () {
      state.data.traceActive = false;
    });
  }

  function renderVipChoiceGame(module, game, stage, state) {
    state.round += 1;
    var base = vipRandomShapeForGame(game);
    var target = Object.assign({}, base);
    var correct = Object.assign({}, base);
    if (game.kind === 'spatial') {
      correct.rotation = target.rotation;
      correct.fill = target.fill;
      correct.offsetX = target.offsetX;
      correct.offsetY = target.offsetY;
    }
    if (game.kind === 'constancy') {
      correct.scale = vipRandom([0.75, 1.25, 1.45]);
      correct.rotation = (correct.rotation + vipRandom([0, 90, 180])) % 360;
      correct.fill = target.fill;
    }
    var options = vipDistinctChoiceOptions(base, correct, game);
    options = options.map(function (option, index) { return { descriptor: option, correct: index === 0 }; });
    options = vipShuffle(options);
    if (game.kind === 'memory') {
      stage.innerHTML = '<p class="vt-vip-game-prompt">Look carefully. The target will hide after 5 seconds.</p><div class="vt-vip-choice-target" data-vt-vip-memory-target></div><div class="vt-vip-options" data-vt-vip-options hidden></div>';
      vipRenderShape(stage.querySelector('[data-vt-vip-memory-target]'), target, game.kind === 'closure');
      window.setTimeout(function () {
        if (!module._vtVipGames || module._vtVipGames[game.key] !== state || state.complete) return;
        stage.querySelector('[data-vt-vip-memory-target]').innerHTML = '<span class="vt-vip-hidden-target">?</span>';
        var optionWrap = stage.querySelector('[data-vt-vip-options]');
        optionWrap.hidden = false;
        vipRenderOptionButtons(optionWrap, game, options);
      }, game.displayMs || 900);
    } else {
      stage.innerHTML = '<p class="vt-vip-game-prompt">' + vipInstructionForKind(game.kind) + '</p><div class="vt-vip-choice-target"></div><div class="vt-vip-options" data-vt-vip-options></div>';
      vipRenderShape(stage.querySelector('.vt-vip-choice-target'), target, game.kind === 'closure');
      vipRenderOptionButtons(stage.querySelector('[data-vt-vip-options]'), game, options);
    }
  }

  function vipDistinctChoiceOptions(base, correct, game) {
    var shapeSet = ['circle', 'triangle', 'square', 'star', 'arrow'];
    var colourSet = ['#163158'];
    var offsetSet = [-14, 0, 14];
    var optionTarget = vipOptionCount(game);
    var options = [Object.assign({}, correct)];
    var used = {};
    used[vipShapeSignature(correct)] = true;

    function addOption(descriptor) {
      var signature = vipShapeSignature(descriptor);
      if (used[signature]) return false;
      used[signature] = true;
      options.push(descriptor);
      return true;
    }

    var distractorShapes = shapeSet.filter(function (shape) { return shape !== base.shape; });
    if (game.kind === 'constancy' || game.kind === 'closure') {
      distractorShapes.forEach(function (shape, index) {
        if (options.length >= optionTarget) return;
        addOption({
          shape: shape,
          rotation: vipRandom([0, 45, 90, 135, 180, 225, 270]),
          fill: colourSet[(index + 2) % colourSet.length],
          scale: vipRandom([0.75, 1.15, 1.4]),
          mirror: index % 2 === 1,
          offsetX: 0,
          offsetY: 0
        });
      });
    }

    var attempts = 0;
    while (options.length < optionTarget && attempts < 70) {
      attempts += 1;
      var distractor = Object.assign({}, base);
      if (game.kind === 'match') {
        var changeShape = attempts % 2 === 0;
        distractor.shape = changeShape ? vipRandom(distractorShapes) : base.shape;
        distractor.rotation = changeShape ? vipRandom([0, 90, 180, 270]) : (base.rotation + vipRandom([90, 180, 270])) % 360;
        distractor.mirror = !changeShape && attempts % 3 === 0;
        distractor.scale = changeShape ? vipRandom([0.85, 1.2]) : vipRandom([0.7, 1.35]);
        distractor.fill = colourSet[attempts % colourSet.length];
        distractor.offsetX = 0;
        distractor.offsetY = 0;
      } else if (game.kind === 'spatial') {
        distractor.shape = vipRandom(distractorShapes);
        distractor.rotation = (base.rotation + vipRandom([90, 180, 270])) % 360;
        distractor.mirror = attempts % 2 === 0;
        distractor.scale = vipRandom([0.82, 1.18, 1.35]);
        distractor.fill = colourSet[(attempts + 1) % colourSet.length];
        distractor.offsetX = vipRandom(offsetSet);
        distractor.offsetY = vipRandom(offsetSet);
      } else {
        distractor.shape = vipRandom(distractorShapes);
        distractor.rotation = vipRandom([0, 45, 90, 135, 180, 225, 270]);
        distractor.mirror = attempts % 2 === 0;
        distractor.scale = vipRandom([0.72, 1, 1.35]);
        distractor.fill = colourSet[attempts % colourSet.length];
        distractor.offsetX = 0;
        distractor.offsetY = 0;
      }
      addOption(distractor);
    }

    var fallbackIndex = 0;
    while (options.length < optionTarget && fallbackIndex < 18) {
      fallbackIndex += 1;
      addOption({
        shape: distractorShapes[fallbackIndex % distractorShapes.length],
        rotation: (fallbackIndex * 90) % 360,
        fill: colourSet[fallbackIndex % colourSet.length],
        scale: 0.72 + fallbackIndex * 0.04,
        mirror: fallbackIndex % 2 === 0,
        offsetX: game.kind === 'spatial' ? offsetSet[fallbackIndex % offsetSet.length] : 0,
        offsetY: game.kind === 'spatial' ? offsetSet[(fallbackIndex + 1) % offsetSet.length] : 0
      });
    }
    return options.slice(0, optionTarget);
  }

  function vipOptionCount(game) {
    return game && game.options ? game.options : 4;
  }

  function vipShapeSignature(descriptor) {
    return [
      descriptor.shape,
      Math.round(descriptor.rotation || 0),
      descriptor.mirror ? 'm' : 'n',
      Math.round((descriptor.scale || 1) * 100),
      descriptor.fill || '',
      Math.round(descriptor.offsetX || 0),
      Math.round(descriptor.offsetY || 0)
    ].join('|');
  }

  function vipRenderOptionButtons(container, game, options) {
    container.innerHTML = '';
    options.forEach(function (option) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'vt-vip-option';
      button.setAttribute('data-vt-action', 'vip-game-choice');
      button.setAttribute('data-vt-vip-game-key', game.key);
      button.setAttribute('data-vt-correct', option.correct ? 'true' : 'false');
      button.setAttribute('data-vt-descriptor', encodeURIComponent(JSON.stringify(option.descriptor)));
      vipRenderShape(button, option.descriptor, false);
      container.appendChild(button);
    });
  }

  function renderVipSequenceGame(module, game, stage, state) {
    state.round += 1;
    var length = vipSequenceLengthForRound(state.round);
    var palette = vipShuffle(vipSequencePalette());
    var sequence = palette.slice(0, length);
    state.data.sequence = sequence;
    state.data.sequenceKey = vipSequenceSignature(sequence);
    state.data.sequenceInputs = [];
    state.data.totalInputs = state.data.totalInputs || 0;
    stage.innerHTML = '<p class="vt-vip-game-prompt">Get ready. Watch the pattern sequence for 5 seconds, then choose the same sequence.</p><div class="vt-vip-sequence-board" data-vt-vip-sequence-board><span class="vt-vip-ready">Get ready…</span></div><div class="vt-vip-sequence-answer" data-vt-vip-sequence-answer></div><div class="vt-vip-options vt-vip-sequence-options" data-vt-vip-options hidden></div>';
    var board = stage.querySelector('[data-vt-vip-sequence-board]');
    var choices = stage.querySelector('[data-vt-vip-options]');

    function showSequence() {
      if (!module._vtVipGames || module._vtVipGames[game.key] !== state || state.complete) return;
      board.innerHTML = '';
      vipRenderSequenceTokenList(board, sequence);
      window.setTimeout(function () {
        if (!module._vtVipGames || module._vtVipGames[game.key] !== state || state.complete) return;
        board.innerHTML = '<span class="vt-vip-hidden-target">?</span>';
        choices.hidden = false;
        vipRenderSequenceChoices(choices, game, vipSequenceChoiceOptions(sequence, length));
      }, game.displayMs || 5000);
    }

    window.setTimeout(showSequence, 900);
  }

  function vipRenderSequenceChoices(container, game, options) {
    container.innerHTML = '';
    options.forEach(function (sequence) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'vt-vip-option vt-vip-sequence-choice';
      button.setAttribute('data-vt-action', 'vip-game-choice');
      button.setAttribute('data-vt-vip-game-key', game.key);
      button.setAttribute('data-vt-sequence-key', vipSequenceSignature(sequence));
      vipRenderSequenceTokenList(button, sequence);
      container.appendChild(button);
    });
  }

  function vipSequenceChoiceOptions(correctSequence, length) {
    var options = [correctSequence];
    var used = {};
    used[vipSequenceSignature(correctSequence)] = true;
    var attempts = 0;
    while (options.length < 4 && attempts < 80) {
      attempts += 1;
      var candidate = vipShuffle(vipSequencePalette()).slice(0, length);
      if (attempts % 2 === 0 && candidate.length) {
        candidate[0] = Object.assign({}, candidate[0], { rotation: (candidate[0].rotation + 90) % 360 });
      }
      var signature = vipSequenceSignature(candidate);
      if (!used[signature]) {
        used[signature] = true;
        options.push(candidate);
      }
    }
    return vipShuffle(options);
  }

  function vipSequenceSignature(sequence) {
    return sequence.map(vipShapeSignature).join('>');
  }

  function vipRenderSequenceTokenList(container, sequence) {
    container.innerHTML = '';
    sequence.forEach(function (shape) {
      var token = document.createElement('span');
      token.className = 'vt-vip-sequence-token';
      vipRenderShape(token, shape, false);
      container.appendChild(token);
    });
  }

  function vipSequenceLengthForRound(round) {
    return Math.min(6, 3 + Math.floor(Math.max(0, round - 1) / 2));
  }

  function vipSequenceTotalSteps(game) {
    var total = 0;
    for (var index = 1; index <= game.rounds; index += 1) {
      total += vipSequenceLengthForRound(index);
    }
    return total;
  }

  function vipSequencePalette() {
    return [
      { shape: 'circle', rotation: 0, fill: '#163158', scale: 1, mirror: false },
      { shape: 'triangle', rotation: 0, fill: '#163158', scale: 1, mirror: false },
      { shape: 'square', rotation: 45, fill: '#163158', scale: 1, mirror: false },
      { shape: 'star', rotation: 0, fill: '#163158', scale: 1, mirror: false },
      { shape: 'arrow', rotation: 90, fill: '#163158', scale: 1, mirror: false },
      { shape: 'triangle', rotation: 180, fill: '#163158', scale: 1, mirror: false }
    ];
  }

  function renderVipSearchGame(module, game, stage, state) {
    state.round += 1;
    var target = Object.assign({}, vipRandomShapeForGame(game), { fill: '#163158', rotation: 0, mirror: false });
    var options = vipDistinctChoiceOptions(target, Object.assign({}, target), game).map(function (option, index) {
      return { descriptor: option, correct: index === 0 };
    });
    options = vipShuffle(options);
    stage.innerHTML = '<p class="vt-vip-game-prompt">Find the choice that contains the target form.</p><div class="vt-vip-search-target"></div><div class="vt-vip-options vt-vip-search-options" data-vt-vip-options></div>';
    vipRenderShape(stage.querySelector('.vt-vip-search-target'), target, false);
    vipRenderOptionButtons(stage.querySelector('[data-vt-vip-options]'), game, options);
  }

  function renderVipMultiSearchGame(module, game, stage, state) {
    state.round += 1;
    var correctCount = game.key === 'figureGround' ? Math.min(3, 2 + Math.floor(Math.max(0, state.round - 1) / 8)) : 2;
    var shapes = vipShuffle(['circle', 'triangle', 'square', 'star', 'arrow']);
    var correctShapes = shapes.slice(0, correctCount).map(function (shape, index) {
      return {
        shape: shape,
        rotation: game.key === 'formConstancy' ? (index * 90 + state.round * 15) % 360 : vipRandom([0, 45, 90, 135]),
        fill: '#163158',
        scale: game.key === 'formConstancy' ? vipRandom([0.72, 0.95, 1.22, 1.42]) : vipRandom([0.82, 1, 1.18]),
        mirror: index % 2 === 1,
        offsetX: 0,
        offsetY: 0
      };
    });
    var options = correctShapes.map(function (descriptor) {
      return { descriptor: Object.assign({}, descriptor, { rotation: 0, scale: 1, mirror: false }), correct: true };
    });
    var distractorAttempts = 0;
    while (options.length < vipOptionCount(game) && distractorAttempts < 60) {
      distractorAttempts += 1;
      var distractor = {
        shape: vipRandom(shapes),
        rotation: vipRandom([0, 45, 90, 135, 180, 225, 270]),
        fill: '#163158',
        scale: vipRandom([0.78, 1, 1.34]),
        mirror: distractorAttempts % 2 === 0,
        offsetX: 0,
        offsetY: 0
      };
      if (game.key === 'formConstancy') {
        var remainingShapes = shapes.filter(function (shape) {
          return correctShapes.every(function (correct) { return correct.shape !== shape; });
        });
        distractor.shape = vipRandom(remainingShapes.length ? remainingShapes : shapes);
      }
      var duplicateCorrect = correctShapes.some(function (shape) { return vipShapeSignature(shape) === vipShapeSignature(distractor); });
      var duplicateOption = options.some(function (option) { return vipShapeSignature(option.descriptor) === vipShapeSignature(distractor); });
      if (!duplicateCorrect && !duplicateOption) options.push({ descriptor: Object.assign({}, distractor), correct: false });
    }
    options = vipShuffle(options.slice(0, vipOptionCount(game)));
    state.data.multiCorrectCount = correctCount;
    state.data.multiItemMax = state.max / Math.max(1, game.rounds);
    stage.innerHTML = '<p class="vt-vip-game-prompt">' + (game.key === 'figureGround' ? 'Tap every shape that is part of the busy picture. A wrong choice scores this item as zero.' : 'Tap every shape found in the picture, even if it is larger, smaller, or rotated.') + '</p><div class="vt-vip-embedded-field" data-vt-vip-embedded-field></div><div class="vt-vip-options vt-vip-multi-options" data-vt-vip-options></div><div class="vt-actions vt-vip-submit-row"><button class="vt-button" type="button" data-vt-action="vip-game-submit" data-vt-vip-game-key="' + game.key + '">Score item</button></div>';
    drawVipEmbeddedField(stage.querySelector('[data-vt-vip-embedded-field]'), correctShapes, game);
    vipRenderOptionButtons(stage.querySelector('[data-vt-vip-options]'), game, options);
  }

  function drawVipEmbeddedField(container, shapes, game) {
    if (!container) return;
    container.innerHTML = '';
    var canvas = document.createElement('canvas');
    canvas.width = 520;
    canvas.height = 240;
    container.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.strokeStyle = 'rgba(22, 49, 88, 0.18)';
    ctx.lineWidth = 3;
    for (var line = 0; line < 18; line += 1) {
      ctx.beginPath();
      ctx.moveTo(20 + line * 29, 24 + (line % 5) * 18);
      ctx.bezierCurveTo(110 + line * 6, 190 - (line % 4) * 22, 360 - line * 9, 36 + (line % 6) * 24, 500 - (line % 7) * 18, 206 - (line % 5) * 16);
      ctx.stroke();
    }
    var placements = [[105, 82], [252, 154], [400, 88], [330, 62], [168, 174]];
    shapes.forEach(function (descriptor, index) {
      ctx.save();
      ctx.translate(placements[index][0], placements[index][1]);
      ctx.rotate((descriptor.rotation || 0) * Math.PI / 180);
      ctx.scale(descriptor.mirror ? -1 : 1, 1);
      ctx.scale(descriptor.scale || 1, descriptor.scale || 1);
      ctx.beginPath();
      traceVisualShape(ctx, descriptor.shape, game && game.key === 'figureGround' ? 32 : 36);
      ctx.fillStyle = 'rgba(22, 49, 88, 0.12)';
      ctx.strokeStyle = '#163158';
      ctx.lineWidth = 5;
      ctx.lineJoin = 'round';
      ctx.fill();
      ctx.stroke();
      ctx.restore();
    });
  }

  function renderVipOddSpatialGame(module, game, stage, state) {
    state.round += 1;
    var shape = vipRandom(['arrow', 'triangle', 'square']);
    var base = {
      shape: shape,
      rotation: vipRandom([0, 90, 180, 270]),
      fill: '#163158',
      scale: 1,
      mirror: false,
      offsetX: vipRandom([-10, 0, 10]),
      offsetY: vipRandom([-10, 0, 10])
    };
    var odd = Object.assign({}, base);
    if (state.round % 3 === 0) {
      odd.mirror = true;
    } else if (state.round % 3 === 1) {
      odd.rotation = (base.rotation + vipRandom([90, 180, 270])) % 360;
    } else {
      odd.offsetX = base.offsetX === 10 ? -10 : 10;
      odd.offsetY = base.offsetY === -10 ? 10 : -10;
    }
    var options = [0, 1, 2, 3, 4].map(function () {
      return { descriptor: Object.assign({}, base), correct: false };
    });
    options[Math.floor(Math.random() * options.length)] = { descriptor: odd, correct: true };
    stage.innerHTML = '<p class="vt-vip-game-prompt">Look at all five. Which one is different from all the others?</p><div class="vt-vip-options vt-vip-odd-spatial-options" data-vt-vip-options></div>';
    vipRenderOptionButtons(stage.querySelector('[data-vt-vip-options]'), game, options);
  }

  function renderVipTraceGame(module, game, stage, state) {
    state.round = Math.max(state.round, 1);
    state.data.tracePoints = [];
    state.data.traceActive = false;
    state.data.traceItem = vipTracePath(state.round);
    stage.innerHTML = '<p class="vt-vip-game-prompt">Trace from START to FINISH without leaving the grey path. Press Finish when done.</p><div class="vt-vip-trace-wrap"><canvas class="vt-vip-trace-canvas" width="640" height="360" data-vt-vip-trace-canvas></canvas></div><div class="vt-actions vt-vip-submit-row"><button class="vt-button" type="button" data-vt-action="vip-game-trace-finish" data-vt-vip-game-key="' + game.key + '">Finish tracing</button></div>';
    var canvas = stage.querySelector('[data-vt-vip-trace-canvas]');
    drawVipTraceCanvas(canvas, state.data.traceItem, []);
    attachVipTraceEvents(canvas, module, game, state);
  }

  function renderVipPathGame(module, game, stage, state) {
    state.round = 0;
    state.data.next = 1;
    state.data.pressed = 0;
    state.data.pathInputs = [];
    stage.innerHTML = '<p class="vt-vip-game-prompt">Tap every green stepping stone. Try to follow the numbers in order.</p><div class="vt-vip-path-grid"></div>';
    var grid = stage.querySelector('.vt-vip-path-grid');
    for (var i = 1; i <= game.rounds; i += 1) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'vt-vip-path-dot';
      button.textContent = i;
      button.setAttribute('data-vt-action', 'vip-game-choice');
      button.setAttribute('data-vt-vip-game-key', game.key);
      button.setAttribute('data-vt-index', String(i));
      grid.appendChild(button);
    }
  }

  function renderVipCopyGame(module, game, stage, state) {
    state.round += 1;
    stage.innerHTML = '<p class="vt-vip-game-prompt">Copy item ' + state.round + ' of ' + game.rounds + ' on paper. Then rate the copy using the criteria.</p><canvas class="vt-vip-copy-canvas" width="520" height="220"></canvas><div class="vt-vip-rating-buttons vt-vip-copy-criteria"><button type="button" data-vt-action="vip-game-score" data-vt-vip-game-key="' + game.key + '" data-vt-score="1">3-point equivalent: endpoints, crossings, angles, spacing and orientation accurate</button><button type="button" data-vt-action="vip-game-score" data-vt-vip-game-key="' + game.key + '" data-vt-score="0.67">2-point equivalent: complete figure with one measurable endpoint, angle or spacing error</button><button type="button" data-vt-action="vip-game-score" data-vt-vip-game-key="' + game.key + '" data-vt-score="0.33">1-point equivalent: recognisable gestalt but multiple shifted lines, rotations or spacing errors</button><button type="button" data-vt-action="vip-game-score" data-vt-vip-game-key="' + game.key + '" data-vt-score="0">0-point equivalent: omitted, fragmented, reversed or not recognisable</button></div>';
    drawVipCopyPattern(stage.querySelector('canvas'), state.round);
  }

  function chooseVipGameOption(module, game, button) {
    var state = module._vtVipGames && module._vtVipGames[game.key];
    if (!state || state.complete) return;
    if (game.kind === 'dtvpAssessment') {
      chooseDtvpAssessmentOption(module, game, button);
      updateVipGameCounters(module, game);
      return;
    }
    if (game.kind === 'multiSearch') {
      button.classList.toggle('is-selected');
      updateVipGameCounters(module, game);
      return;
    }
    if (game.kind === 'sequence') {
      if (button.disabled) return;
      var expected = state.data.sequenceKey;
      var selected = button.getAttribute('data-vt-sequence-key');
      var isSequenceCorrect = selected === expected;
      state.data.sequenceInputs = state.data.sequenceInputs || [];
      state.data.sequenceInputs.push({ key: selected, correct: isSequenceCorrect });
      state.data.totalInputs = (state.data.totalInputs || 0) + 1;
      button.classList.add(isSequenceCorrect ? 'is-correct' : 'is-error');
      button.disabled = true;
      if (isSequenceCorrect) {
        state.raw += 1;
      } else {
        state.errors += 1;
      }
      vipRenderSequenceAnswer(module, game, state);
      vipAdvanceAfterScoredItem(module, game, state, isSequenceCorrect, 450);
    } else if (game.kind === 'path') {
      if (button.disabled) return;
      var value = parseInt(button.getAttribute('data-vt-index'), 10);
      var isPathCorrect = value === state.data.next;
      state.data.pressed = (state.data.pressed || 0) + 1;
      state.round = state.data.pressed;
      state.data.pathInputs = state.data.pathInputs || [];
      state.data.pathInputs.push(value);
      button.disabled = true;
      button.classList.add(isPathCorrect ? 'is-correct' : 'is-error');
      if (value === state.data.next) {
        state.raw += 1;
        state.data.next += 1;
      } else {
        state.errors += 1;
      }
      if (state.data.pressed >= game.rounds) finishVipGame(module, game);
    } else if (game.kind === 'search') {
      var searchCorrect = button.getAttribute('data-vt-correct') === 'true';
      button.classList.add(searchCorrect ? 'is-correct' : 'is-error');
      if (searchCorrect) state.raw += 1; else state.errors += 1;
      vipAdvanceAfterScoredItem(module, game, state, searchCorrect, 350);
    } else {
      var correct = button.getAttribute('data-vt-correct') === 'true';
      button.classList.add(correct ? 'is-correct' : 'is-error');
      if (game.kind === 'memory') {
        var memoryCard = vipGameCard(module, game.key);
        var memoryTarget = memoryCard ? memoryCard.querySelector('[data-vt-vip-memory-target]') : null;
        var selectedDescriptor = vipDescriptorFromButton(button);
        if (memoryTarget && selectedDescriptor) vipRenderShape(memoryTarget, selectedDescriptor, false);
      }
      if (correct) state.raw += 1; else state.errors += 1;
      vipAdvanceAfterScoredItem(module, game, state, correct, 350);
    }
    updateVipGameCounters(module, game);
  }

  function submitVipMultiSearchGame(module, game) {
    var state = module._vtVipGames && module._vtVipGames[game.key];
    var card = vipGameCard(module, game.key);
    if (!state || !card || state.complete || game.kind !== 'multiSearch') return;
    var buttons = Array.prototype.slice.call(card.querySelectorAll('[data-vt-action="vip-game-choice"][data-vt-vip-game-key="' + game.key + '"]'));
    var selected = buttons.filter(function (button) { return button.classList.contains('is-selected'); });
    var wrongSelected = selected.some(function (button) { return button.getAttribute('data-vt-correct') !== 'true'; });
    var correctSelected = selected.filter(function (button) { return button.getAttribute('data-vt-correct') === 'true'; }).length;
    var correctTotal = Math.max(1, state.data.multiCorrectCount || buttons.filter(function (button) { return button.getAttribute('data-vt-correct') === 'true'; }).length);
    var itemMax = state.data.multiItemMax || (state.max / Math.max(1, game.rounds));
    var credit = wrongSelected || !selected.length ? 0 : Math.min(1, correctSelected / correctTotal);
    buttons.forEach(function (button) {
      var isCorrect = button.getAttribute('data-vt-correct') === 'true';
      if (isCorrect) button.classList.add('is-correct');
      if (button.classList.contains('is-selected') && !isCorrect) button.classList.add('is-error');
      button.disabled = true;
    });
    state.raw += credit * itemMax;
    state.errors += itemMax - credit * itemMax;
    vipAdvanceAfterScoredItem(module, game, state, credit > 0, 650);
    updateVipGameCounters(module, game);
  }

  function finishVipTraceItem(module, game) {
    var state = module._vtVipGames && module._vtVipGames[game.key];
    if (!state || state.complete || game.kind !== 'trace') return;
    var points = state.data.tracePoints || [];
    var path = state.data.traceItem || vipTracePath(1);
    var score = vipTraceAccuracy(points, path);
    state.raw = Math.round(score * state.max);
    state.errors = Math.max(0, state.max - state.raw);
    state.round = game.rounds;
    vipRecordScoredItem(module, game, state, state.raw > state.max * 0.35);
    finishVipGame(module, game);
  }

  function vipTracePath(level) {
    var wave = level || 1;
    return {
      width: 76,
      points: [
        { x: 58, y: 278 },
        { x: 122, y: 230 - wave * 4 },
        { x: 190, y: 260 },
        { x: 250, y: 150 },
        { x: 318, y: 116 + wave * 8 },
        { x: 382, y: 188 },
        { x: 452, y: 94 },
        { x: 578, y: 78 + wave * 5 }
      ]
    };
  }

  function drawVipTraceCanvas(canvas, item, drawnPoints) {
    if (!canvas || !item) return;
    var ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.strokeStyle = '#d7e5ea';
    ctx.lineWidth = item.width || 70;
    drawVipPolyline(ctx, item.points);
    ctx.strokeStyle = '#163158';
    ctx.lineWidth = 4;
    drawVipPolyline(ctx, item.points);
    ctx.fillStyle = '#26a86d';
    ctx.beginPath();
    ctx.arc(item.points[0].x, item.points[0].y, 20, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = '#163158';
    ctx.font = '700 15px system-ui, sans-serif';
    ctx.fillText('START', item.points[0].x - 26, item.points[0].y - 28);
    var end = item.points[item.points.length - 1];
    ctx.fillStyle = '#20B7C8';
    ctx.beginPath();
    ctx.arc(end.x, end.y, 20, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = '#163158';
    ctx.fillText('FINISH', end.x - 32, end.y - 28);
    if (drawnPoints && drawnPoints.length > 1) {
      ctx.strokeStyle = '#f1a93b';
      ctx.lineWidth = 7;
      drawVipPolyline(ctx, drawnPoints);
    }
  }

  function drawVipPolyline(ctx, points) {
    if (!ctx || !points || points.length < 2) return;
    ctx.beginPath();
    ctx.moveTo(points[0].x, points[0].y);
    for (var i = 1; i < points.length; i += 1) {
      ctx.lineTo(points[i].x, points[i].y);
    }
    ctx.stroke();
  }

  function attachVipTraceEvents(canvas, module, game, state) {
    if (!canvas) return;
    function pointFromEvent(event) {
      var rect = canvas.getBoundingClientRect();
      var scaleX = canvas.width / rect.width;
      var scaleY = canvas.height / rect.height;
      return {
        x: (event.clientX - rect.left) * scaleX,
        y: (event.clientY - rect.top) * scaleY
      };
    }
    function addPoint(event) {
      if (!state.data.traceActive) return;
      var point = pointFromEvent(event);
      state.data.tracePoints.push(point);
      drawVipTraceCanvas(canvas, state.data.traceItem, state.data.tracePoints);
      event.preventDefault();
    }
    canvas.addEventListener('pointerdown', function (event) {
      state.data.traceActive = true;
      state.data.tracePoints = [pointFromEvent(event)];
      canvas.setPointerCapture(event.pointerId);
      drawVipTraceCanvas(canvas, state.data.traceItem, state.data.tracePoints);
      event.preventDefault();
    });
    canvas.addEventListener('pointermove', addPoint);
    canvas.addEventListener('pointerup', function (event) {
      addPoint(event);
      state.data.traceActive = false;
    });
    canvas.addEventListener('pointercancel', function () {
      state.data.traceActive = false;
    });
  }

  function vipTraceAccuracy(points, path) {
    if (!points || points.length < 8 || !path || !path.points) return 0;
    var tolerance = (path.width || 76) / 2;
    var inside = 0;
    points.forEach(function (point) {
      if (vipDistanceToPolyline(point, path.points) <= tolerance) inside += 1;
    });
    var pathCoverage = vipTraceCoverage(points, path.points);
    return Math.max(0, Math.min(1, (inside / points.length) * 0.72 + pathCoverage * 0.28));
  }

  function vipTraceCoverage(points, pathPoints) {
    var checkpoints = [];
    for (var segment = 0; segment < pathPoints.length - 1; segment += 1) {
      var start = pathPoints[segment];
      var end = pathPoints[segment + 1];
      for (var step = 0; step <= 4; step += 1) {
        checkpoints.push({
          x: start.x + (end.x - start.x) * (step / 4),
          y: start.y + (end.y - start.y) * (step / 4)
        });
      }
    }
    var hit = checkpoints.filter(function (checkpoint) {
      return points.some(function (point) {
        return vipDistance(point, checkpoint) < 44;
      });
    }).length;
    return checkpoints.length ? hit / checkpoints.length : 0;
  }

  function vipDistanceToPolyline(point, points) {
    var best = Infinity;
    for (var i = 0; i < points.length - 1; i += 1) {
      best = Math.min(best, vipDistanceToSegment(point, points[i], points[i + 1]));
    }
    return best;
  }

  function vipDistanceToSegment(point, start, end) {
    var dx = end.x - start.x;
    var dy = end.y - start.y;
    var lengthSq = dx * dx + dy * dy || 1;
    var t = ((point.x - start.x) * dx + (point.y - start.y) * dy) / lengthSq;
    t = Math.max(0, Math.min(1, t));
    return vipDistance(point, { x: start.x + t * dx, y: start.y + t * dy });
  }

  function vipDistance(a, b) {
    var dx = a.x - b.x;
    var dy = a.y - b.y;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function vipDescriptorFromButton(button) {
    try {
      var encoded = button.getAttribute('data-vt-descriptor');
      return encoded ? JSON.parse(decodeURIComponent(encoded)) : null;
    } catch (error) {
      return null;
    }
  }

  function vipRenderSequenceAnswer(module, game, state) {
    var card = vipGameCard(module, game.key);
    var answer = card ? card.querySelector('[data-vt-vip-sequence-answer]') : null;
    if (!answer) return;
    answer.innerHTML = '';
    (state.data.sequenceInputs || []).forEach(function (input) {
      var item = document.createElement('span');
      item.className = 'vt-vip-sequence-token vt-vip-sequence-mark ' + (input.correct ? 'is-correct' : 'is-error');
      item.textContent = input.correct ? '✓' : '•';
      answer.appendChild(item);
    });
  }

  function scoreVipClinicianGame(module, game, button) {
    var state = module._vtVipGames && module._vtVipGames[game.key];
    if (!state) return;
    if (game.kind === 'dtvpAssessment') {
      scoreDtvpAssessmentItem(module, game, button);
      return;
    }
    var itemMax = state.max / Math.max(1, game.rounds);
    var credit = parseFloat(button.getAttribute('data-vt-score')) || 0;
    state.raw += credit * itemMax;
    state.errors += Math.max(0, itemMax - credit * itemMax);
    vipAdvanceAfterScoredItem(module, game, state, credit > 0, 0);
  }

  function vipAdvanceAfterScoredItem(module, game, state, correct, delay) {
    var reachedCeiling = vipRecordScoredItem(module, game, state, correct);
    if (reachedCeiling || state.round >= game.rounds) {
      window.setTimeout(function () { finishVipGame(module, game); updateModule(module); }, delay || 0);
    } else {
      window.setTimeout(function () { renderVipGameRound(module, game); updateModule(module); }, delay || 0);
    }
  }

  function vipRecordScoredItem(module, game, state, correct) {
    state.data = state.data || {};
    state.data.itemScores = state.data.itemScores || [];
    state.data.itemScores.push(correct ? 1 : 0);
    var suite = module.getAttribute('data-vt-vip-assessment') || 'dtvp';
    if (suite === 'tvps' && state.data.itemScores.length >= 7) {
      var lastSeven = state.data.itemScores.slice(-7);
      var errors = lastSeven.filter(function (score) { return !score; }).length;
      return errors >= 5;
    }
    if (suite === 'dtvp' && game.key !== 'eyeHand' && !dtvpTestingMode(module) && state.data.itemScores.length >= 3) {
      var lastThree = state.data.itemScores.slice(-3);
      return lastThree.every(function (score) { return !score; });
    }
    return false;
  }

  function vipSuppressScoreRow(game) {
    return !!(game && game.kind === 'dtvpAssessment');
  }

  function finishVipGame(module, game) {
    var state = module._vtVipGames && module._vtVipGames[game.key];
    var card = vipGameCard(module, game.key);
    if (!state || !card) return;
    state.complete = true;
    var norm = vipGameNormStatus(module, game, state);
    state.status = norm;
    card.classList.remove('is-vip-running');
    card.classList.add('is-vip-complete');
    renderVipFinishedStage(card, module, game, norm, state);
    vipSetGameCount(card, 'range', vipAverageSummary(norm).heading);
    var scoreRow = card.querySelector('[data-vt-vip-score-row]');
    if (scoreRow) scoreRow.hidden = vipSuppressScoreRow(game);
    var status = card.querySelector('[data-vt-vip-game-status]');
    if (status) status.textContent = norm.label;
    updateVipGameCounters(module, game);
    showVipCompletionDialog(module, game, norm, state);
    renderVipOverallSummary(module.closest('[data-vt-app]'));
    renderVisualRecommendationPanel(module.closest('[data-vt-app]'));
  }

  function renderVipFinishedStage(card, module, game, norm, state) {
    var stage = card ? card.querySelector('[data-vt-vip-stage]') : null;
    if (!stage) return;
    var summary = vipAverageSummary(norm);
    var raw = Math.round(vipDisplayRaw(module, game, state));
    var max = vipNormMax(module, game);
    var subtest = game.kind === 'dtvpAssessment' ? dtvpSubtestForGame(game) : null;
    var ageBand = norm.normAgeBand || vipAssessmentAgeBand(module);
    var ceilingText = subtest && subtest.key === 'eyeHand' ? 'Ceiling: not used for this subtest.' : 'Ceiling reached: ' + (state && state.data && state.data.ceilingReached ? 'yes' : 'no') + (state && state.data && state.data.ceilingIgnored ? ' — testing mode ignored the ceiling.' : '.') ;
    var exactDetails = subtest ? (norm.manualRequired ? '<p>' + norm.range + '</p>' : '<p>Exact DTVP age band: ' + vipAgeBandReadable(ageBand) + '. Scaled score: ' + norm.value + (norm.percentile ? '. Percentile: ' + norm.percentile : '') + (norm.descriptiveTerm ? '. Descriptive term: ' + norm.descriptiveTerm : '') + '.</p>') : '';
    var ceilingDetails = subtest ? '<p>' + ceilingText + '</p>' : '';
    var parentDescription = subtest ? vipParentDescriptionHtml(game.key, game.title) : '';
    stage.innerHTML =
      '<div class="vt-vip-finished-summary" data-vt-vip-status="' + norm.level + '">' +
      '<p class="vt-kicker">Test complete</p>' +
      '<h3>' + escapeHtml(game.title) + ': ' + escapeHtml(vipParentResultLabel(norm)) + '</h3>' +
      '<p><strong>Total score: ' + raw + ' / ' + max + '</strong></p>' +
      '<p>' + summary.heading + (norm.manualRequired ? ' - manual norm lookup required.' : ' - expected range: ' + norm.range + (norm.descriptiveTerm ? ' - ' + norm.descriptiveTerm : '') + '.') + '</p>' +
      parentDescription +
      exactDetails +
      ceilingDetails +
      '</div>';
  }

  function ensureVipCompletionDialog(app) {
    var dialog = app.querySelector('[data-vt-vip-complete-dialog]');
    if (dialog) return dialog;
    dialog = document.createElement('div');
    dialog.className = 'vt-vip-complete-dialog';
    dialog.setAttribute('data-vt-vip-complete-dialog', '');
    dialog.hidden = true;
    dialog.innerHTML =
      '<div class="vt-vip-complete-card" role="dialog" aria-modal="true" aria-labelledby="vt-vip-complete-title">' +
      '<p class="vt-kicker">Assessment game complete</p>' +
      '<h2 id="vt-vip-complete-title" data-vt-vip-complete-title>Game complete</h2>' +
      '<div class="vt-vip-complete-score" data-vt-vip-complete-score></div>' +
      '<div class="vt-vip-complete-range" data-vt-vip-complete-range></div>' +
      '<div class="vt-vip-complete-recommendations" data-vt-vip-complete-recommendations></div>' +
      '<div class="vt-actions"><button class="vt-button" type="button" data-vt-action="vip-complete-close">Review results</button><button class="vt-button vt-button-secondary" type="button" data-vt-action="vip-complete-exit">Exit full screen</button></div>' +
      '</div>';
    app.appendChild(dialog);
    return dialog;
  }

  function showVipCompletionDialog(module, game, norm, state) {
    var app = module.closest('[data-vt-app]');
    if (!app) return;
    var dialog = ensureVipCompletionDialog(app);
    var title = dialog.querySelector('[data-vt-vip-complete-title]');
    var score = dialog.querySelector('[data-vt-vip-complete-score]');
    var range = dialog.querySelector('[data-vt-vip-complete-range]');
    var recommendations = dialog.querySelector('[data-vt-vip-complete-recommendations]');
    var age = vipAgeBandReadable(vipAssessmentAgeBand(module));
    var raw = Math.round(vipDisplayRaw(module, game, state));
    var max = vipNormMax(module, game);
    var recs = norm.level === 'below' ? (game.training || []) : [];
    var averageSummary = vipAverageSummary(norm);
    var parentDescription = game.kind === 'dtvpAssessment' ? vipParentDescriptionHtml(game.key, game.title) : '';
    if (title) title.textContent = game.title + ' complete';
    if (score) {
      score.innerHTML = '<strong>' + escapeHtml(game.title) + ': ' + escapeHtml(vipParentResultLabel(norm)) + '</strong><span>Total score: ' + raw + ' / ' + max + '</span>';
      score.setAttribute('data-vt-vip-status', norm.level);
    }
    if (range) {
      range.innerHTML = '<strong>' + escapeHtml(averageSummary.heading) + '</strong><span>' + (norm.manualRequired ? 'Expected range: manual norm lookup required.' : 'Expected/average range: ' + escapeHtml(norm.range)) + '</span><span>' + escapeHtml(averageSummary.detail) + '</span><span>Selected age band: ' + escapeHtml(age) + '</span>' + parentDescription;
      range.setAttribute('data-vt-vip-status', norm.level);
    }
    if (recommendations) {
      if (recs.length) {
        recommendations.hidden = false;
        recommendations.innerHTML = '<strong>Suggested Next Steps</strong><span>' + recs.join(', ') + '</span>';
      } else {
        recommendations.hidden = true;
        recommendations.innerHTML = '';
      }
    }
    dialog.hidden = false;
    app.classList.add('vt-vip-complete-open');
  }

  function vipAverageSummary(norm) {
    var averageBand = norm.averageBand || 'the expected average band';
    var normDetail = norm.matchedRawRange ? ' Matched raw band: ' + norm.matchedRawRange + '.' : '';
    if (norm.percentile) normDetail += ' Percentile rank: ' + norm.percentile + '.';
    if (norm.descriptiveTerm) normDetail += ' Descriptor: ' + norm.descriptiveTerm + '.';
    if (norm.table) normDetail += ' Table: ' + norm.table + '.';
    var scoreName = norm.scoreType === 'composite' ? 'Composite index' : 'Scaled score';
    if (norm.level === 'manual') {
      return {
        heading: 'Raw score recorded',
        detail: norm.range || 'Manual norm conversion required. No scaled score or range label has been generated.'
      };
    }
    if (norm.level === 'below') {
      return {
        heading: 'Below the average/expected range',
        detail: scoreName + ' ' + norm.value + ' sits below the usual average band of ' + averageBand + '.' + normDetail
      };
    }
    if (norm.level === 'above') {
      return {
        heading: 'Above the average/expected range',
        detail: scoreName + ' ' + norm.value + ' sits above the usual average band of ' + averageBand + '.' + normDetail
      };
    }
    return {
      heading: 'Within the average/expected range',
      detail: scoreName + ' ' + norm.value + ' sits within the usual average band of ' + averageBand + '.' + normDetail
    };
  }

  function closeVipCompletionDialog(app) {
    if (!app) return;
    var dialog = app.querySelector('[data-vt-vip-complete-dialog]');
    if (dialog) dialog.hidden = true;
    app.classList.remove('vt-vip-complete-open');
  }

  function renderVipOverallSummary(app) {
    if (!app) return;
    var panel = app.querySelector('[data-vt-vip-overall-summary]');
    if (!panel) return;
    var resultTarget = panel.querySelector('[data-vt-vip-overall-results]');
    var recTarget = panel.querySelector('[data-vt-vip-overall-recommendations]');
    var modules = Array.prototype.slice.call(app.querySelectorAll('[data-vt-module="vipDtvp"], [data-vt-module="vipTvps"]'));
    var all = [];
    var recommendations = [];
    modules.forEach(function (module) {
      var suiteName = module.getAttribute('data-vt-title') || 'Vision processing assessment';
      vipAssessmentSummary(module, module.getAttribute('data-vt-module')).statuses.forEach(function (entry) {
        all.push({ suite: suiteName, label: entry.label, status: entry.status, training: entry.training || [] });
        if (entry.status.level === 'below' || entry.trainingFlag) {
          entry.training.forEach(function (training) {
            if (training && recommendations.indexOf(training) === -1 && training.indexOf('Use the below-range') !== 0) {
              recommendations.push(training);
            }
          });
        }
      });
    });
    if (resultTarget) {
      if (!all.length) {
        resultTarget.textContent = 'Complete assessment games to build the combined summary.';
      } else {
        var list = document.createElement('ul');
        list.className = 'vt-vip-result-list';
        all.forEach(function (entry) {
          var li = document.createElement('li');
          li.setAttribute('data-vt-vip-status', entry.status.level);
          li.innerHTML = '<strong>' + escapeHtml(entry.label) + ': ' + escapeHtml(vipParentResultLabel(entry.status)) + '</strong><span>' + escapeHtml(entry.suite) + ' — ' + escapeHtml(entry.status.label) + ' | score ' + escapeHtml(entry.status.value) + ' | expected ' + escapeHtml(entry.status.range) + '</span>' + vipParentDescriptionHtml(entry);
          list.appendChild(li);
        });
        resultTarget.innerHTML = '';
        resultTarget.appendChild(list);
      }
    }
    if (recTarget) {
      recTarget.innerHTML = '';
      var age = vipAgeBandReadable(vipAssessmentAgeBand(modules[0] || panel));
      recommendations.forEach(function (training) {
        var li = document.createElement('li');
        li.innerHTML = '<strong>' + training + '</strong><span>Start at the ' + age + ' setting and progress difficulty only when accuracy is controlled.</span>';
        recTarget.appendChild(li);
      });
    }
  }

  function updateVipGameCounters(module, game) {
    var state = module._vtVipGames && module._vtVipGames[game.key];
    var card = vipGameCard(module, game.key);
    if (!state || !card) return;
    vipSetGameCount(card, 'raw', String(Math.round(vipDisplayRaw(module, game, state))));
    vipSetGameCount(card, 'attempts', String(vipGameAttempts(game, state)));
    vipSetGameCount(card, 'round', String(Math.min(game.rounds, state.round || 0)));
  }

  function vipGameAttempts(game, state) {
    if (!state) return 0;
    if (game.kind === 'dtvpAssessment') return state.round || 0;
    if (game.kind === 'path') return state.data && state.data.pressed ? state.data.pressed : 0;
    if (game.kind === 'sequence') return state.data && state.data.totalInputs ? state.data.totalInputs : 0;
    if (game.kind === 'copy' || game.kind === 'trace' || game.kind === 'multiSearch') return state.round || 0;
    return (state.raw || 0) + (state.errors || 0);
  }

  function vipSetGameCount(card, key, value) {
    var field = card.querySelector('[data-vt-vip-count="' + key + '"]');
    if (field) field.textContent = value;
  }

  function vipDisplayRaw(module, game, state) {
    var max = vipNormMax(module, game);
    if (game.kind === 'dtvpAssessment') {
      return state.raw || 0;
    }
    if (game.kind === 'copy' || game.kind === 'trace' || game.kind === 'multiSearch') {
      return state.raw || 0;
    }
    var denominator = game.kind === 'copy' ? max : game.rounds;
    return state.raw / Math.max(1, denominator) * max;
  }

  function vipNormMax(module, game) {
    if (module.getAttribute('data-vt-vip-assessment') === 'tvps') return 18;
    if (game.kind === 'dtvpAssessment') {
      var subtest = dtvpSubtestForGame(game);
      return subtest && subtest.rawMax ? subtest.rawMax : game.maxRaw || game.rounds || 0;
    }
    return { eyeHand: 192, copying: 50, figureGround: 60, visualClosure: 26, formConstancy: 50 }[game.key] || 18;
  }

  function vipAssessmentAgeBand(module) {
    var app = module && module.closest ? module.closest('[data-vt-app]') : null;
    var suite = module && module.getAttribute ? (module.getAttribute('data-vt-vip-assessment') || 'dtvp') : 'dtvp';
    if (suite === 'dtvp') {
      return dtvpResolvedAgeStatus(module).band || '';
    }
    var field = vipAgeBandField(app, suite);
    return field ? field.value : (suite === 'dtvp' ? '' : '8');
  }

  function vipAgeBandField(app, suite) {
    if (!app) return null;
    var targetSuite = suite === 'tvps' ? 'tvps' : 'dtvp';
    return app.querySelector('[data-vt-vip-age-band][data-vt-vip-age-suite="' + targetSuite + '"]') || app.querySelector('[data-vt-vip-age-band]');
  }

  function vipTvpsStartCredit(module, game) {
    if (!module || module.getAttribute('data-vt-vip-assessment') !== 'tvps') return 0;
    if (!game || !game.tvpsCode) return 0;
    return vipTvpsStartsAtItemFour(vipAssessmentAgeBand(module)) ? 3 : 0;
  }

  function vipTvpsStartsAtItemFour(ageBand) {
    return ageBand === '12' || ageBand === '13-17' || ageBand === 'adult';
  }

  function vipTvpsExpectedRaw(gameKey, ageBand) {
    var table = {
      '4-5': { visualDiscrimination: 6, visualMemory: 7, spatialRelationships: 6, formConstancy: 5, sequentialMemory: 6, figureGround: 5, visualClosure: 4 },
      '6': { visualDiscrimination: 8, visualMemory: 9, spatialRelationships: 9, formConstancy: 7, sequentialMemory: 9, figureGround: 8, visualClosure: 7 },
      '7': { visualDiscrimination: 9, visualMemory: 10, spatialRelationships: 11, formConstancy: 8, sequentialMemory: 10, figureGround: 9, visualClosure: 8 },
      '8': { visualDiscrimination: 10, visualMemory: 12, spatialRelationships: 14, formConstancy: 9, sequentialMemory: 11, figureGround: 10, visualClosure: 9 },
      '9': { visualDiscrimination: 11, visualMemory: 13, spatialRelationships: 15, formConstancy: 10, sequentialMemory: 12, figureGround: 12, visualClosure: 11 },
      '10': { visualDiscrimination: 12, visualMemory: 14, spatialRelationships: 16, formConstancy: 12, sequentialMemory: 13, figureGround: 14, visualClosure: 13 },
      '11': { visualDiscrimination: 13, visualMemory: 14, spatialRelationships: 16, formConstancy: 13, sequentialMemory: 14, figureGround: 14, visualClosure: 13 },
      '12': { visualDiscrimination: 13, visualMemory: 14, spatialRelationships: 16, formConstancy: 13, sequentialMemory: 14, figureGround: 14, visualClosure: 13 },
      '13-17': { visualDiscrimination: 14, visualMemory: 15, spatialRelationships: 17, formConstancy: 14, sequentialMemory: 15, figureGround: 15, visualClosure: 15 },
      adult: { visualDiscrimination: 15, visualMemory: 16, spatialRelationships: 17, formConstancy: 15, sequentialMemory: 16, figureGround: 16, visualClosure: 16 }
    };
    return (table[ageBand] || table['8'])[gameKey] || 10;
  }

  function vipGameNormStatus(module, game, state) {
    var suite = module.getAttribute('data-vt-vip-assessment') || 'dtvp';
    var ageBand = vipAssessmentAgeBand(module);
    var raw = vipDisplayRaw(module, game, state);
    if (suite === 'dtvp') {
      return vipDtvpScaledLookupStatus(game.key, raw, vipNormMax(module, game), ageBand) || vipDtvpManualLookupStatus(raw, vipNormMax(module, game), ageBand);
    }
    var tvpsScaled = vipTvpsScaledScore(game, raw, ageBand);
    if (tvpsScaled) {
      return vipLabelFromScaled(tvpsScaled.scaled, raw, tvpsScaled.normalLow, tvpsScaled.normalHigh, tvpsScaled.tableLabel);
    }
    var expected = vipTvpsExpectedRaw(game.key, ageBand);
    var scaledTvps = Math.round(10 + ((raw - expected) / 3) * 3);
    return vipLabelFromScaled(scaledTvps, raw, Math.max(0, expected - 3), Math.min(18, expected + 3), ageBand);
  }

  function vipDtvpManualLookupStatus(raw, max, ageBand) {
    var exactAgeBand = vipDtvpExactAgeBand(ageBand);
    var missingAge = !exactAgeBand;
    return {
      level: 'manual',
      label: missingAge ? 'Select exact DTVP age band' : 'Raw score recorded. Manual norm lookup required.',
      value: Math.round(raw),
      raw: Math.round(raw),
      max: max,
      range: missingAge ? 'Select exact DTVP age band.' : 'Manual norm conversion required for ' + vipAgeBandReadable(exactAgeBand),
      expectedLow: null,
      expectedHigh: null,
      ageBand: ageBand,
      normAgeBand: exactAgeBand || '',
      manualRequired: true
    };
  }

  function vipDtvpScaledLookupStatus(gameKey, raw, max, ageBand) {
    var data = dtvpNormData();
    var exactAgeBand = vipDtvpExactAgeBand(ageBand);
    var rows = (data.rawToScaled || []).filter(function (row) {
      return row.ageBand === exactAgeBand && row.raw && row.raw[gameKey];
    });
    if (!rows.length) return null;
    var roundedRaw = Math.max(0, Math.round(raw));
    var match = rows.filter(function (row) {
      return vipDtvpRawInRange(roundedRaw, row.raw[gameKey]);
    })[0];
    if (!match) return null;
    var averageRange = vipDtvpAverageRawRange(rows, gameKey, data.averageScaledRange || [8, 12]);
    var scaled = Number(match.scaled);
    var avgLow = (data.averageScaledRange && data.averageScaledRange[0]) || 8;
    var avgHigh = (data.averageScaledRange && data.averageScaledRange[1]) || 12;
    var level = scaled < avgLow ? 'below' : scaled > avgHigh ? 'above' : 'normal';
    var descriptiveTerm = vipDtvpDescriptiveTerm('scaled', scaled);
    return {
      level: level,
      label: descriptiveTerm || (level === 'below' ? 'below expected range' : level === 'above' ? 'above expected range' : 'within normal range'),
      value: scaled,
      raw: roundedRaw,
      max: max,
      percentile: match.percentile || '',
      range: (averageRange || 'scaled ' + avgLow + '–' + avgHigh) + ' for ' + vipAgeBandReadable(exactAgeBand),
      matchedRawRange: match.raw[gameKey],
      expectedLow: null,
      expectedHigh: null,
      ageBand: ageBand,
      normAgeBand: exactAgeBand,
      averageBand: avgLow + '–' + avgHigh,
      descriptiveTerm: descriptiveTerm,
      scoreType: 'scaled',
      manualRequired: false,
      table: match.table
    };
  }

  function vipDtvpExactAgeBand(ageBand) {
    var data = dtvpNormData();
    var available = (data.ageBands || []).map(function (band) { return band.value; });
    if (available.indexOf(ageBand) !== -1) return ageBand;
    return '';
  }

  function vipDtvpRawInRange(raw, rangeText) {
    if (!rangeText) return false;
    var text = String(rangeText).replace(/\s+/g, '');
    if (text.charAt(0) === '<') return raw < Number(text.slice(1));
    if (text.charAt(0) === '>') return raw > Number(text.slice(1));
    if (text.indexOf('-') !== -1) {
      var parts = text.split('-').map(Number);
      return raw >= parts[0] && raw <= parts[1];
    }
    return raw === Number(text);
  }

  function vipDtvpDescriptiveTerm(kind, value) {
    var number = Number(value);
    if (!Number.isFinite(number)) return '';
    var field = kind === 'index' ? 'indexRange' : 'scaledRange';
    var match = (dtvpNormData().descriptiveTerms || []).filter(function (term) {
      return vipDtvpRawInRange(number, term[field]);
    })[0];
    return match ? match.label : '';
  }

  function vipDtvpCompositeLookupStatus(compositeKey, scaledSum) {
    var data = dtvpNormData();
    var roundedSum = Math.max(0, Math.round(scaledSum));
    var rows = (data.compositeIndex || []).filter(function (row) {
      return row.sum && row.sum[compositeKey];
    });
    var match = rows.filter(function (row) {
      return vipDtvpRawInRange(roundedSum, row.sum[compositeKey]);
    })[0];
    if (!match) return null;
    var index = Number(match.index);
    var average = data.averageCompositeRange || [90, 110];
    var avgLow = Number(average[0]) || 90;
    var avgHigh = Number(average[1]) || 110;
    var level = index < avgLow ? 'below' : index > avgHigh ? 'above' : 'normal';
    var descriptor = vipDtvpDescriptiveTerm('index', index);
    return {
      level: level,
      label: descriptor || (level === 'below' ? 'below expected range' : level === 'above' ? 'above expected range' : 'within normal range'),
      value: index,
      raw: roundedSum,
      scaledSum: roundedSum,
      scoreType: 'composite',
      percentile: match.percentile || '',
      range: 'index ' + avgLow + '–' + avgHigh + ' average; scaled-sum match ' + match.sum[compositeKey],
      matchedRawRange: match.sum[compositeKey],
      averageBand: avgLow + '–' + avgHigh,
      descriptiveTerm: descriptor,
      manualRequired: false,
      table: match.table
    };
  }

  function vipDtvpRawRangeBounds(rangeText) {
    if (!rangeText) return null;
    var text = String(rangeText).replace(/\s+/g, '');
    if (text.charAt(0) === '<') return [0, Number(text.slice(1)) - 1];
    if (text.charAt(0) === '>') return [Number(text.slice(1)) + 1, null];
    if (text.indexOf('-') !== -1) {
      var parts = text.split('-').map(Number);
      return [parts[0], parts[1]];
    }
    var number = Number(text);
    return Number.isFinite(number) ? [number, number] : null;
  }

  function vipDtvpAverageRawRange(rows, gameKey, averageScaledRange) {
    var low = averageScaledRange[0];
    var high = averageScaledRange[1];
    var bounds = [];
    rows.forEach(function (row) {
      var scaled = Number(row.scaled);
      if (scaled < low || scaled > high) return;
      var range = vipDtvpRawRangeBounds(row.raw && row.raw[gameKey]);
      if (range) bounds.push(range);
    });
    if (!bounds.length) return '';
    var min = bounds.reduce(function (best, range) { return Math.min(best, range[0]); }, Infinity);
    var max = bounds.reduce(function (best, range) {
      return range[1] === null ? best : Math.max(best, range[1]);
    }, -Infinity);
    if (!Number.isFinite(min) || !Number.isFinite(max)) return 'scaled ' + low + '–' + high;
    return min + '–' + max + ' raw (scaled ' + low + '–' + high + ' average)';
  }

  function vipTvpsScaledScore(game, raw, ageBand) {
    var code = game.tvpsCode;
    var tables = vipTvpsScaledTables();
    var tableInfo = vipTvpsTableForAge(ageBand);
    var table = tables[tableInfo.key];
    if (!code || !table || !table[code]) return null;
    var rawRounded = Math.max(0, Math.min(18, Math.round(raw)));
    var values = table[code];
    var scaled = values[rawRounded];
    var normalRange = vipTvpsNormalRawRange(values);
    return {
      scaled: scaled,
      normalLow: normalRange[0],
      normalHigh: normalRange[1],
      tableLabel: tableInfo.label
    };
  }

  function vipTvpsTableForAge(ageBand) {
    var map = {
      '4-5': { key: '6', label: 'nearest TVPS-4 table: 6 years' },
      '6': { key: '6', label: 'TVPS-4 6-year table' },
      '6-7': { key: '6', label: 'nearest TVPS-4 table: 6 years' },
      '7': { key: '6', label: 'nearest TVPS-4 table: 6 years' },
      '8': { key: '10', label: 'nearest available TVPS-4 table: 10 years' },
      '8-9': { key: '10', label: 'nearest available TVPS-4 table: 10 years' },
      '9': { key: '10', label: 'nearest available TVPS-4 table: 10 years' },
      '10': { key: '10', label: 'TVPS-4 10-year table' },
      '10-12': { key: '12', label: 'nearest TVPS-4 table: 12 years' },
      '11': { key: '12', label: 'nearest available TVPS-4 table: 12 years' },
      '12': { key: '12', label: 'TVPS-4 12-year table' },
      '13-17': { key: '13-17', label: 'nearest available TVPS-4 table: 13 years' },
      adult: { key: 'adult', label: 'nearest available TVPS-4 adult table' }
    };
    return map[ageBand] || map['10'];
  }

  function vipTvpsNormalRawRange(values) {
    var low = 0;
    var high = values.length - 1;
    for (var i = 0; i < values.length; i += 1) {
      if (values[i] >= 7) {
        low = i;
        break;
      }
    }
    for (var j = values.length - 1; j >= 0; j -= 1) {
      if (values[j] <= 13) {
        high = j;
        break;
      }
    }
    return [low, high];
  }

  function vipTvpsScaledTables() {
    return {
      '6': {
        DIS: [1, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 19],
        MEM: [1, 1, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19],
        SPA: [3, 3, 4, 5, 6, 7, 7, 8, 9, 10, 10, 11, 12, 13, 14, 14, 15, 16, 17],
        CON: [1, 2, 4, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 19, 19, 19, 19],
        SEQ: [3, 4, 5, 5, 6, 7, 8, 9, 10, 11, 11, 12, 13, 15, 16, 17, 18, 19, 19],
        FGR: [1, 3, 4, 5, 7, 8, 9, 10, 11, 12, 12, 13, 14, 15, 16, 17, 18, 19, 19],
        CLO: [1, 3, 5, 6, 8, 9, 10, 11, 12, 13, 14, 14, 15, 16, 17, 18, 19, 19, 19]
      },
      '10': {
        DIS: [1, 1, 1, 2, 3, 4, 5, 6, 7, 8, 8, 9, 10, 11, 12, 13, 14, 15, 16],
        MEM: [1, 1, 1, 1, 2, 3, 4, 5, 6, 7, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        SPA: [2, 2, 3, 3, 4, 4, 5, 5, 5, 6, 6, 7, 8, 8, 9, 10, 11, 12, 13],
        CON: [1, 1, 2, 3, 4, 5, 6, 7, 8, 9, 9, 10, 11, 12, 13, 13, 14, 15, 16],
        SEQ: [1, 1, 1, 2, 3, 4, 4, 5, 6, 7, 8, 8, 9, 10, 11, 13, 14, 16, 17],
        FGR: [1, 1, 2, 3, 3, 4, 5, 6, 7, 7, 8, 9, 10, 10, 11, 12, 13, 14, 15],
        CLO: [1, 1, 2, 3, 4, 5, 6, 6, 7, 8, 9, 9, 10, 11, 12, 13, 14, 14, 15]
      },
      '12': {
        DIS: [1, 1, 1, 1, 2, 3, 4, 5, 6, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        MEM: [1, 1, 1, 1, 1, 2, 3, 4, 5, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
        SPA: [1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 9, 10, 11, 13],
        CON: [1, 1, 1, 2, 3, 4, 5, 6, 7, 7, 8, 9, 10, 10, 11, 12, 13, 14, 15],
        SEQ: [1, 1, 1, 1, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 15, 17],
        FGR: [1, 1, 1, 2, 3, 3, 4, 5, 6, 6, 7, 8, 8, 9, 10, 11, 12, 12, 13],
        CLO: [1, 1, 2, 2, 3, 4, 4, 5, 6, 6, 7, 8, 8, 9, 10, 11, 12, 13, 14]
      },
      '13-17': {
        DIS: [1, 1, 1, 1, 2, 3, 3, 4, 5, 6, 7, 8, 8, 9, 10, 11, 12, 13, 14],
        MEM: [1, 1, 1, 1, 1, 2, 2, 3, 4, 5, 5, 6, 7, 8, 9, 10, 12, 13, 14],
        SPA: [1, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 8, 9, 10, 11, 13],
        CON: [1, 1, 1, 1, 2, 3, 4, 5, 6, 7, 8, 8, 9, 10, 11, 11, 12, 13, 14],
        SEQ: [1, 1, 1, 1, 1, 2, 3, 4, 5, 5, 6, 7, 8, 9, 10, 12, 13, 15, 16],
        FGR: [1, 1, 1, 2, 2, 3, 4, 5, 5, 6, 7, 7, 8, 9, 9, 10, 11, 12, 13],
        CLO: [1, 1, 1, 2, 3, 3, 4, 5, 5, 6, 6, 7, 8, 9, 9, 10, 11, 12, 13]
      },
      adult: {
        DIS: [1, 1, 1, 1, 1, 2, 3, 3, 4, 5, 6, 7, 7, 8, 9, 10, 11, 12, 14],
        MEM: [1, 1, 1, 1, 1, 1, 1, 2, 3, 3, 4, 5, 6, 7, 8, 9, 11, 12, 14],
        SPA: [1, 1, 1, 1, 1, 1, 2, 2, 3, 3, 4, 5, 5, 6, 7, 7, 9, 10, 12],
        CON: [1, 1, 1, 1, 1, 2, 3, 4, 4, 5, 6, 7, 8, 8, 9, 10, 11, 12, 13],
        SEQ: [1, 1, 1, 1, 1, 1, 1, 2, 2, 3, 4, 5, 6, 7, 8, 10, 12, 13, 15],
        FGR: [1, 1, 1, 1, 1, 2, 3, 3, 4, 5, 6, 6, 7, 8, 9, 9, 10, 11, 12],
        CLO: [1, 1, 1, 1, 1, 1, 1, 2, 3, 4, 4, 5, 6, 7, 8, 9, 10, 12, 13]
      }
    };
  }

  function vipTvpsExactRange(gameKey, ageBand) {
    var ranges = {
      '6-7': {
        visualDiscrimination: [4, 11],
        formConstancy: [4, 10]
      },
      '6': {
        visualDiscrimination: [4, 11],
        formConstancy: [4, 10]
      },
      '10': {
        visualDiscrimination: [8, 15],
        formConstancy: [7, 15]
      },
      '12': {
        visualDiscrimination: [10, 16],
        formConstancy: [8, 16]
      },
      '13-17': {
        visualDiscrimination: [10, 17],
        formConstancy: [9, 18]
      },
      adult: {
        visualDiscrimination: [11, 18],
        formConstancy: [11, 18]
      }
    };
    return ranges[ageBand] && ranges[ageBand][gameKey] ? ranges[ageBand][gameKey] : null;
  }

  function vipLabelFromExactRaw(raw, expectedLow, expectedHigh, ageBand) {
    var roundedRaw = Math.round(raw);
    var level = roundedRaw < expectedLow ? 'below' : roundedRaw > expectedHigh ? 'above' : 'normal';
    var midpoint = (expectedLow + expectedHigh) / 2;
    var spread = Math.max(1, (expectedHigh - expectedLow) / 2);
    var scaled = Math.round(10 + ((raw - midpoint) / spread) * 3);
    return {
      level: level,
      label: level === 'below' ? 'below expected range' : level === 'above' ? 'above expected range' : 'within normal range',
      value: Math.max(1, Math.min(19, scaled)),
      raw: roundedRaw,
      range: expectedLow + '–' + expectedHigh + ' raw for ' + vipAgeBandReadable(ageBand),
      expectedLow: expectedLow,
      expectedHigh: expectedHigh,
      ageBand: ageBand
    };
  }

  function vipLabelFromScaled(scaled, raw, expectedLow, expectedHigh, ageBand) {
    var level = scaled < 7 ? 'below' : scaled > 13 ? 'above' : 'normal';
    return {
      level: level,
      label: level === 'below' ? 'below expected range' : level === 'above' ? 'above expected range' : 'within normal range',
      value: Math.max(1, Math.min(19, scaled)),
      raw: Math.round(raw),
      range: Math.round(expectedLow) + '–' + Math.round(expectedHigh) + ' raw for ' + vipAgeBandReadable(ageBand),
      expectedLow: Math.round(expectedLow),
      expectedHigh: Math.round(expectedHigh),
      ageBand: ageBand,
      averageBand: '7–13'
    };
  }

  function vipAgeBandReadable(ageBand) {
    return {
      '4-5': '4–5 years',
      '6': '6 years',
      '6-7': '6–7 years',
      '7': '7 years',
      '8': '8 years',
      '8-9': '8–9 years',
      '9': '9 years',
      '10': '10 years',
      '10-12': '10–12 years',
      '11': '11 years',
      '12': '12 years',
      '13-17': '13–17 years',
      adult: 'adult / older teen'
    }[ageBand] || (ageBand ? String(ageBand).replace(' to ', '–') : 'selected age band');
  }

  function vipGameStatuses(module) {
    var games = module._vtVipGames || {};
    var suite = module.getAttribute('data-vt-vip-assessment') || 'dtvp';
    return vipGameDefinitions(suite).map(function (game) {
      var state = games[game.key];
      if (!state || !state.complete) return null;
      return {
        key: game.key,
        label: game.title,
        status: state.status || vipGameNormStatus(module, game, state),
        raw: Math.round(vipDisplayRaw(module, game, state)),
        attempts: vipGameAttempts(game, state),
        training: game.training || [],
        trainingFlag: false
      };
    }).filter(Boolean);
  }

  function vipInstructionForKind(kind) {
    return {
      match: 'Choose the option that looks exactly the same.',
      memory: 'Remember the target, then choose the matching option.',
      spatial: 'Find the option with the same spatial relationship.',
      oddSpatial: 'Find the one option that is different from all the others.',
      constancy: 'Find the same form even when size or position changes.',
      closure: 'Choose the complete form that matches the incomplete target.',
      sequence: 'Watch the order, then tap the symbols back in the same sequence.'
    }[kind] || 'Choose the best matching option.';
  }

  function vipRandomShape() {
    return { shape: vipRandom(['circle', 'triangle', 'square', 'star', 'arrow']), rotation: vipRandom([0, 45, 90, 135, 180, 225, 270]), fill: '#163158', scale: 1, mirror: false, offsetX: 0, offsetY: 0 };
  }

  function vipRandomShapeForGame(game) {
    if (game.kind === 'spatial' || game.kind === 'oddSpatial') {
      return { shape: vipRandom(['arrow', 'triangle', 'square']), rotation: vipRandom([0, 90, 180, 270]), fill: '#163158', scale: 1, mirror: false, offsetX: vipRandom([-12, 0, 12]), offsetY: vipRandom([-12, 0, 12]) };
    }
    if (game.kind === 'constancy' || game.kind === 'closure') {
      return { shape: vipRandom(['circle', 'triangle', 'square', 'star', 'arrow']), rotation: 0, fill: '#163158', scale: 1, mirror: false, offsetX: 0, offsetY: 0 };
    }
    if (game.kind === 'search') {
      return { shape: vipRandom(['circle', 'triangle', 'square', 'star', 'arrow']), rotation: 0, fill: '#163158', scale: 1, mirror: false, offsetX: 0, offsetY: 0 };
    }
    return vipRandomShape();
  }

  function vipSampleShape(game) {
    var kind = game && game.kind ? game.kind : 'match';
    if (kind === 'spatial' || kind === 'oddSpatial') return { shape: 'arrow', rotation: 90, fill: '#163158', scale: 1, mirror: false };
    if (kind === 'constancy') return { shape: 'star', rotation: 0, fill: '#163158', scale: 1, mirror: false };
    if (kind === 'closure') return { shape: 'square', rotation: 0, fill: '#163158', scale: 1, mirror: false };
    if (kind === 'search') return { shape: 'triangle', rotation: 0, fill: '#163158', scale: 1, mirror: false };
    return { shape: 'circle', rotation: 0, fill: '#163158', scale: 1, mirror: false };
  }

  function vipRenderShape(container, descriptor, incomplete) {
    container.innerHTML = '';
    var canvas = document.createElement('canvas');
    canvas.width = 120;
    canvas.height = 120;
    container.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, 120, 120);
    ctx.save();
    ctx.translate(60 + (descriptor.offsetX || 0), 60 + (descriptor.offsetY || 0));
    ctx.rotate((descriptor.rotation || 0) * Math.PI / 180);
    ctx.scale(descriptor.mirror ? -1 : 1, 1);
    ctx.scale(descriptor.scale || 1, descriptor.scale || 1);
    ctx.beginPath();
    traceVisualShape(ctx, descriptor.shape, 34);
    ctx.fillStyle = descriptor.fill || '#163158';
    ctx.strokeStyle = '#163158';
    ctx.lineWidth = 5;
    ctx.lineJoin = 'round';
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    if (incomplete) {
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(50, 0, 52, 62);
    }
  }

  function drawVipCopyPattern(canvas, level) {
    if (!canvas) return;
    level = level || 1;
    var ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.strokeStyle = '#163158';
    ctx.lineWidth = 5;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.beginPath();
    ctx.moveTo(70, 160 - (level % 3) * 6);
    ctx.lineTo(170, 60 + (level % 4) * 4);
    ctx.lineTo(280, 160 - (level % 5) * 5);
    ctx.lineTo(390, 70 + (level % 2) * 16);
    ctx.lineTo(460, 150 - (level % 4) * 5);
    ctx.stroke();
    ctx.fillStyle = '#163158';
    [[70,160 - (level % 3) * 6],[170,60 + (level % 4) * 4],[280,160 - (level % 5) * 5],[390,70 + (level % 2) * 16],[460,150 - (level % 4) * 5]].forEach(function (p) {
      ctx.beginPath();
      ctx.arc(p[0], p[1], 11, 0, Math.PI * 2);
      ctx.fill();
    });
    ctx.strokeStyle = '#163158';
    ctx.strokeRect(210, 88, 62 + (level % 4) * 8, 46 + (level % 3) * 7);
    ctx.beginPath();
    ctx.moveTo(248, 55 + (level % 2) * 10);
    ctx.lineTo(298 + (level % 5) * 5, 115);
    ctx.lineTo(248, 175 - (level % 3) * 8);
    ctx.stroke();
  }

  function vipRandom(items) {
    return items[Math.floor(Math.random() * items.length)];
  }

  function vipShuffle(items) {
    return items.slice().sort(function () { return Math.random() - 0.5; });
  }

  function findInModule(module, selector) {
    if (!module) {
      return null;
    }
    return module.querySelector(selector) || (module._vtStage && (module._vtStage.matches(selector) ? module._vtStage : module._vtStage.querySelector(selector)));
  }

  function findAllInModule(module, selector) {
    var items = Array.prototype.slice.call(module.querySelectorAll(selector));
    if (module._vtStage) {
      if (module._vtStage.matches(selector)) {
        items.push(module._vtStage);
      }
      items = items.concat(Array.prototype.slice.call(module._vtStage.querySelectorAll(selector)));
    }
    if (module._vtOverlayControls) {
      if (module._vtOverlayControls.matches(selector)) {
        items.push(module._vtOverlayControls);
      }
      items = items.concat(Array.prototype.slice.call(module._vtOverlayControls.querySelectorAll(selector)));
    }
    return items;
  }

  function valueOrBlank(value) {
    return value || '__';
  }

  function calibrationField(app, fieldName) {
    var field = app.querySelector('[data-vt-calibration-field="' + fieldName + '"]');
    return field ? (field.value || '').trim() : '';
  }

  function calibrationData(app) {
    var reference = calibrationField(app, 'reference');
    var referenceMm = reference === 'custom' ? parseFloat(calibrationField(app, 'customReference')) : parseFloat(reference);
    var pixelWidth = parseFloat(calibrationField(app, 'pixelWidth'));
    var distanceCm = parseFloat(calibrationField(app, 'distance'));
    var denominator = parseFloat(calibrationField(app, 'acuity'));
    var pxPerMm = referenceMm && pixelWidth ? pixelWidth / referenceMm : 0;
    var optotypeMm = distanceCm && denominator ? distanceCm * 10 * Math.tan((5 / 60) * Math.PI / 180 * (denominator / 6)) : 0;
    var optotypePx = pxPerMm && optotypeMm ? optotypeMm * pxPerMm : 0;
    return {
      referenceMm: referenceMm,
      pixelWidth: pixelWidth,
      distanceCm: distanceCm,
      denominator: denominator,
      pxPerMm: pxPerMm,
      optotypeMm: optotypeMm,
      optotypePx: optotypePx
    };
  }

  function updateCalibration(app) {
    var panel = app.querySelector('[data-vt-calibration]');
    if (!panel) {
      return;
    }
    var data = calibrationData(app);
    var card = panel.querySelector('[data-vt-calibration-card]');
    var output = panel.querySelector('[data-vt-calibration-output]');
    if (card && data.pixelWidth) {
      card.style.width = Math.max(80, Math.min(1000, data.pixelWidth)) + 'px';
    }
    if (!output) {
      return;
    }
    if (!data.referenceMm || !data.pixelWidth || !data.distanceCm || !data.denominator || !data.optotypePx) {
      output.textContent = 'Enter calibration details to calculate an on-screen optotype size.';
      return;
    }
    output.textContent = 'Calibration estimate: ' + data.pxPerMm.toFixed(2) + ' px/mm. At ' + data.distanceCm + ' cm, a 6/' + data.denominator + ' optotype is approximately ' + data.optotypeMm.toFixed(1) + ' mm high, or ' + Math.round(data.optotypePx) + ' CSS pixels on this screen.';
  }

  function applyCalibration(app, targetName) {
    var data = calibrationData(app);
    if (!data.optotypePx) {
      updateCalibration(app);
      showToast(app, 'Complete calibration first.');
      return;
    }
    var acuityPx = Math.max(8, Math.round(data.optotypePx));
    var therapyPx = Math.max(86, Math.min(160, Math.round(data.optotypePx * 10)));
    var targets = targetName === 'all' ? ['hart', 'nearfar', 'flipper'] : [targetName];
    var applied = 0;

    targets.forEach(function (name) {
      if (applyCalibrationTarget(app, name, data, acuityPx, therapyPx)) {
        applied += 1;
      }
    });

    if (applied) {
      showToast(app, targetName === 'all' ? 'Calibration applied to Hart, Near-Far, and Flipper.' : 'Applied distance optotype: ' + acuityPx + ' px.');
    }
  }

  function applyCalibrationTarget(app, targetName, data, acuityPx, therapyPx) {
    var module = null;
    var fieldName = 'targetSize';
    if (targetName === 'hart') {
      module = app.querySelector('[data-vt-module="exerciseHart"]');
      fieldName = 'fontSize';
    } else if (targetName === 'nearfar') {
      module = app.querySelector('[data-vt-module="exerciseNearFar"]');
    } else if (targetName === 'flipper') {
      module = app.querySelector('[data-vt-module="exerciseFlipper"]');
    }
    if (!module) {
      return false;
    }
    module.setAttribute('data-vt-calibrated-optotype-px', String(acuityPx));
    module.setAttribute('data-vt-calibrated-distance-cm', String(data.distanceCm));
    var field = module.querySelector('[data-vt-field="' + fieldName + '"]');
    if (field) {
      var targetPx = targetName === 'flipper' ? therapyPx : targetName === 'hart' ? Math.max(32, Math.min(72, Math.round(data.optotypePx * 6))) : parseInt(field.value || '86', 10);
      if (targetName === 'nearfar') {
        targetPx = parseInt(field.value || '86', 10);
      }
      if (targetPx > parseInt(field.max || '0', 10)) {
        field.max = String(targetPx);
      }
      if (targetPx < parseInt(field.min || '0', 10)) {
        field.min = String(targetPx);
      }
      field.value = String(targetPx);
    }
    if (targetName === 'hart' || targetName === 'nearfar') {
      findAllInModule(module, '[data-vt-prompt], [data-vt-hart-prompt]').forEach(function (prompt) {
        prompt.textContent = 'Far';
      });
      randomizeDistanceOptotype(module);
      applyPromptState(module, 'Far');
    }
    updateExerciseVisual(module);
    updateModule(module);
    return true;
  }

  function cyclesPerMinute(cycles, seconds) {
    var parsedCycles = parseFloat(cycles);
    var parsedSeconds = parseFloat(seconds);
    if (!parsedCycles || !parsedSeconds) {
      return '__';
    }
    return ((parsedCycles / parsedSeconds) * 60).toFixed(1);
  }

  function countValue(module, key) {
    var counter = module.querySelector('[data-vt-count="' + key + '"]');
    return counter ? counter.textContent.trim() : '0';
  }

  function exerciseDurationSeconds(module) {
    var selected = getValue(module, 'duration');
    if (selected === 'custom') {
      return parseInt(getValue(module, 'customDuration'), 10) || 0;
    }
    var selectedNumber = parseInt(selected, 10);
    if (selectedNumber) {
      return selectedNumber;
    }
    return 0;
  }

  function exerciseDurationLabel(module) {
    var elapsed = parseInt(module.getAttribute('data-vt-elapsed') || '0', 10) || 0;
    var planned = exerciseDurationSeconds(module);
    if (elapsed) {
      return elapsed + ' seconds';
    }
    if (planned) {
      return planned + ' seconds';
    }
    return '__';
  }

  function exerciseCpm(module) {
    var cycles = countValue(module, 'cycles');
    var elapsed = parseInt(module.getAttribute('data-vt-elapsed') || '0', 10) || 0;
    return cyclesPerMinute(cycles, elapsed || exerciseDurationSeconds(module));
  }

  function flipperLens(module) {
    var lens = getValue(module, 'lensPower');
    if (lens === 'custom') {
      return getValue(module, 'customLens');
    }
    return lens;
  }

  function distanceValue(module) {
    var distance = getValue(module, 'distance');
    if (distance === 'custom') {
      return getValue(module, 'customDistance');
    }
    return distance;
  }

  function updateModule(module) {
    var key = module.getAttribute('data-vt-module');
    var output = module.querySelector('[data-vt-output]');
    if (!output) {
      return;
    }

    var text = '';

    if (key === 'symptoms') {
      text = 'Symptoms reviewed. Age band: ' + valueOrBlank(getValue(module, 'ageBand')) + '. Main concern: ' + valueOrBlank(getValue(module, 'mainConcern')) + '. Symptoms reported: ' + valueOrBlank(getValue(module, 'symptomsReported')) + '. Severity: ' + valueOrBlank(getValue(module, 'severity')) + '. Notes: ' + valueOrBlank(getValue(module, 'notes')) + '. Clinical interpretation required.';
    } else if (key === 'pursuits') {
      text = 'Pursuits assessed. Direction: ' + valueOrBlank(getValue(module, 'direction')) + '. Smoothness: ' + valueOrBlank(getValue(module, 'smoothness')) + '. Head movement: ' + valueOrBlank(getValue(module, 'headMovement')) + '. Fixation loss: ' + valueOrBlank(getValue(module, 'fixationLoss')) + '. Symptoms: ' + valueOrBlank(getValue(module, 'symptoms')) + '. Notes: ' + valueOrBlank(getValue(module, 'notes')) + '.';
    } else if (key === 'saccades') {
      text = 'Saccades/tracking assessed. Task: ' + valueOrBlank(getValue(module, 'taskType')) + '. Duration: ' + valueOrBlank(getValue(module, 'duration')) + ' seconds. BPM: ' + valueOrBlank(getValue(module, 'bpm')) + '. Accuracy: ' + valueOrBlank(getValue(module, 'accuracy')) + '. Fluency: ' + valueOrBlank(getValue(module, 'fluency')) + '. Head movement: ' + valueOrBlank(getValue(module, 'headMovement')) + '. Missed/skipped targets: ' + valueOrBlank(getValue(module, 'missedTargets')) + '. Symptoms: ' + valueOrBlank(getValue(module, 'symptoms')) + '. Notes: ' + valueOrBlank(getValue(module, 'notes')) + '.';
    } else if (key === 'hart') {
      text = 'Hart chart near-far task completed. Duration: ' + valueOrBlank(getValue(module, 'duration')) + ' seconds. Cycles/lines completed: ' + valueOrBlank(getValue(module, 'cycles')) + '. Accuracy: ' + valueOrBlank(getValue(module, 'accuracy')) + '. Blur: ' + valueOrBlank(getValue(module, 'blur')) + '. Diplopia: ' + valueOrBlank(getValue(module, 'diplopia')) + '. Fatigue: ' + valueOrBlank(getValue(module, 'fatigue')) + '. Notes: ' + valueOrBlank(getValue(module, 'notes')) + '.';
    } else if (key === 'accommodationFacility') {
      text = 'Accommodative facility assessed with ' + valueOrBlank(getValue(module, 'lensPower')) + ' flippers. Duration: ' + valueOrBlank(getValue(module, 'duration')) + ' seconds. Cycles: ' + valueOrBlank(getValue(module, 'cycles')) + '. Result: ' + cyclesPerMinute(getValue(module, 'cycles'), getValue(module, 'duration')) + ' cycles/min. Difficulty noted with: ' + valueOrBlank(getValue(module, 'difficulty')) + '. Symptoms: ' + valueOrBlank(getValue(module, 'symptoms')) + '. Notes: ' + valueOrBlank(getValue(module, 'notes')) + '.';
    } else if (key === 'accommodationAmplitude') {
      text = 'Accommodative amplitude recorded. Method: ' + valueOrBlank(getValue(module, 'method')) + '. R: ' + valueOrBlank(getValue(module, 'rightEye')) + '. L: ' + valueOrBlank(getValue(module, 'leftEye')) + '. OU: ' + valueOrBlank(getValue(module, 'bothEyes')) + '. Symptoms/notes: ' + valueOrBlank(getValue(module, 'notes')) + '.';
    } else if (key === 'memNott') {
      text = 'Dynamic retinoscopy recorded. Method: ' + valueOrBlank(getValue(module, 'method')) + '. R: ' + valueOrBlank(getValue(module, 'rightEye')) + '. L: ' + valueOrBlank(getValue(module, 'leftEye')) + '. Impression: ' + valueOrBlank(getValue(module, 'impression')) + '. Notes: ' + valueOrBlank(getValue(module, 'notes')) + '.';
    } else if (key === 'nraPra') {
      text = 'NRA/PRA recorded. NRA: ' + valueOrBlank(getValue(module, 'nra')) + '. PRA: ' + valueOrBlank(getValue(module, 'pra')) + '. Symptoms/notes: ' + valueOrBlank(getValue(module, 'notes')) + '.';
    } else if (key === 'npc') {
      text = 'NPC assessed. Target: ' + valueOrBlank(getValue(module, 'target')) + '. Break: ' + valueOrBlank(getValue(module, 'breakDistance')) + '. Recovery: ' + valueOrBlank(getValue(module, 'recoveryDistance')) + '. Response: ' + valueOrBlank(getValue(module, 'response')) + '. Symptoms: ' + valueOrBlank(getValue(module, 'symptoms')) + '. Notes: ' + valueOrBlank(getValue(module, 'notes')) + '.';
    } else if (key === 'vergenceRanges') {
      text = 'Vergence ranges recorded. Distance BI: ' + valueOrBlank(getValue(module, 'distanceBi')) + '. Distance BO: ' + valueOrBlank(getValue(module, 'distanceBo')) + '. Near BI: ' + valueOrBlank(getValue(module, 'nearBi')) + '. Near BO: ' + valueOrBlank(getValue(module, 'nearBo')) + '. Symptoms/notes: ' + valueOrBlank(getValue(module, 'notes')) + '.';
    } else if (key === 'vergenceFacility') {
      text = 'Vergence facility assessed using ' + valueOrBlank(getValue(module, 'prism')) + '. Duration: ' + valueOrBlank(getValue(module, 'duration')) + ' seconds. Cycles: ' + valueOrBlank(getValue(module, 'cycles')) + '. Result: ' + cyclesPerMinute(getValue(module, 'cycles'), getValue(module, 'duration')) + ' cycles/min. Difficulty: ' + valueOrBlank(getValue(module, 'difficulty')) + '. Symptoms: ' + valueOrBlank(getValue(module, 'symptoms')) + '. Notes: ' + valueOrBlank(getValue(module, 'notes')) + '.';
    } else if (key === 'brock') {
      text = 'Brock string task performed at ' + valueOrBlank(getValue(module, 'beadDistance')) + '. Response: ' + valueOrBlank(getValue(module, 'response')) + '. Vergence control: ' + valueOrBlank(getValue(module, 'control')) + '. Symptoms: ' + valueOrBlank(getValue(module, 'symptoms')) + '. Notes: ' + valueOrBlank(getValue(module, 'notes')) + '.';
    } else if (key.indexOf('other-') === 0) {
      text = valueOrBlank(getValue(module, 'testName')) + ' test completed. Result: ' + valueOrBlank(getValue(module, 'result')) + '. Observations: ' + valueOrBlank(getValue(module, 'observations')) + '. Clinical interpretation required. Notes: ' + valueOrBlank(getValue(module, 'notes')) + '.';
    } else if (key.indexOf('formal-') === 0) {
      var formalRange = formalRangeIndicator(module);
      setModuleFieldValue(module, 'rangeIndicator', formalRange === '__' ? '' : formalRange);
      text = 'Formal licensed-material result entry. ' + valueOrBlank(getValue(module, 'testName')) + '. Age at testing: ' + valueOrBlank(getValue(module, 'ageAtTesting')) + '. Result type: ' + valueOrBlank(formalResultTypeLabel(getValue(module, 'resultType'))) + '. Numeric result: ' + valueOrBlank(getValue(module, 'standardResult')) + '. Result: ' + valueOrBlank(getValue(module, 'result')) + '. Normal range indicator: ' + valueOrBlank(formalRange) + '. Age-based reference from licensed material: ' + valueOrBlank(getValue(module, 'ageReference')) + '. Interpretation recorded from licensed material: ' + valueOrBlank(getValue(module, 'interpretation')) + '. Observations: ' + valueOrBlank(getValue(module, 'observations')) + '. Notes: ' + valueOrBlank(getValue(module, 'notes')) + '.';
    } else if (key === 'vipDtvp' || key === 'vipTvps') {
      text = vipAssessmentNote(module, key);
    } else if (key.indexOf('vp') === 0) {
      text = withVisualGuidance(module, visualProcessingNote(module, key));
    } else if (key === 'exerciseSaccade') {
      text = 'Saccade target jump exercise completed. Direction: ' + valueOrBlank(getValue(module, 'direction')) + '. Duration: ' + exerciseDurationLabel(module) + '. Speed/BPM: ' + valueOrBlank(getValue(module, 'bpm')) + '. Accuracy: ' + valueOrBlank(getValue(module, 'accuracy')) + '. Head movement: ' + valueOrBlank(getValue(module, 'headMovement')) + '. Symptoms: ' + valueOrBlank(getValue(module, 'symptoms')) + '. Notes: ' + valueOrBlank(getValue(module, 'notes')) + '.';
    } else if (key === 'exercisePursuit') {
      text = 'Smooth pursuit exercise completed. Movement: ' + valueOrBlank(getValue(module, 'movement')) + '. Speed: ' + valueOrBlank(getValue(module, 'speed')) + '. Smoothness observed: ' + valueOrBlank(getValue(module, 'smoothness')) + '. Fixation loss: ' + valueOrBlank(getValue(module, 'fixationLoss')) + '. Head movement: ' + valueOrBlank(getValue(module, 'headMovement')) + '. Symptoms: ' + valueOrBlank(getValue(module, 'symptoms')) + '. Notes: ' + valueOrBlank(getValue(module, 'notes')) + '.';
    } else if (key === 'exerciseHart') {
      text = 'Hart chart near-far exercise completed. Duration: ' + exerciseDurationLabel(module) + '. Cycles: ' + countValue(module, 'cycles') + '. Errors: ' + countValue(module, 'errors') + '. Blur reported: ' + countValue(module, 'blur') + '. Diplopia reported: ' + countValue(module, 'diplopia') + '. Notes: ' + valueOrBlank(getValue(module, 'notes')) + '.';
    } else if (key === 'exerciseFlipper') {
      text = 'Accommodative flipper exercise completed using ' + valueOrBlank(flipperLens(module)) + '. Duration: ' + exerciseDurationLabel(module) + '. Cycles: ' + countValue(module, 'cycles') + '. Result: ' + exerciseCpm(module) + ' cycles/min. Difficulty: ' + valueOrBlank(getValue(module, 'difficulty')) + '. Symptoms: ' + valueOrBlank(getValue(module, 'symptoms')) + '. Notes: ' + valueOrBlank(getValue(module, 'notes')) + '.';
    } else if (key === 'exerciseBrock') {
      text = 'Brock string exercise performed at ' + valueOrBlank(distanceValue(module)) + '. Response: ' + valueOrBlank(getValue(module, 'response')) + '. Vergence control: ' + valueOrBlank(getValue(module, 'control')) + '. Symptoms: ' + valueOrBlank(getValue(module, 'symptoms')) + '. Notes: ' + valueOrBlank(getValue(module, 'notes')) + '.';
    } else if (key === 'exerciseNearFar') {
      text = 'Near-far focus jump exercise completed. Duration: ' + exerciseDurationLabel(module) + '. Cycles: ' + countValue(module, 'cycles') + '. Blur: ' + countValue(module, 'blur') + '. Diplopia: ' + countValue(module, 'diplopia') + '. Notes: ' + valueOrBlank(getValue(module, 'notes')) + '.';
    } else if (key === 'exerciseReadingLine') {
      text = 'Visual tracking/reading line task completed. Difficulty: ' + valueOrBlank(getValue(module, 'difficulty')) + '. Errors/skips: ' + countValue(module, 'errors') + '. Support used: ' + valueOrBlank(getValue(module, 'support')) + '. Symptoms: ' + valueOrBlank(getValue(module, 'symptoms')) + '. Notes: ' + valueOrBlank(getValue(module, 'notes')) + '.';
    } else if (key === 'exerciseMarsden') {
      text = 'Marsden ball task completed. Task: ' + valueOrBlank(getValue(module, 'task')) + '. Duration: ' + exerciseDurationLabel(module) + '. Tracking: ' + valueOrBlank(getValue(module, 'tracking')) + '. Head movement: ' + valueOrBlank(getValue(module, 'headMovement')) + '. Balance: ' + valueOrBlank(getValue(module, 'balance')) + '. Symptoms: ' + valueOrBlank(getValue(module, 'symptoms')) + '. Notes: ' + valueOrBlank(getValue(module, 'notes')) + '.';
    } else if (key === 'exerciseEyeWarmup') {
      text = 'Eye movement warm-up completed. Pattern: ' + valueOrBlank(getValue(module, 'pattern')) + '. Duration: ' + exerciseDurationLabel(module) + '. Symptoms: ' + valueOrBlank(getValue(module, 'symptoms')) + '. Notes: ' + valueOrBlank(getValue(module, 'notes')) + '.';
    } else if (key === 'exercisePlan') {
      text = exercisePlanNote(module);
    }

    output.textContent = text;
    if (key.indexOf('vp') === 0) {
      renderVisualResultInterpretation(module);
      var visualApp = module.closest('[data-vt-app]');
      if (visualApp) {
        renderVisualRecommendationPanel(visualApp);
      }
    }
  }

  function visualProcessingNote(module, key) {
    var observations = '';
    var accuracy = visualAccuracy(module);

    if (key === 'vpDiscrimination') {
      observations = visualObservations(module, [
        ['speed', 'speed'], ['impulsivity', 'impulsivity'], ['selfCorrection', 'self-correction'], ['fatigue', 'fatigue']
      ]);
      return 'Original visual discrimination activity completed. Difficulty: ' + valueOrBlank(getValue(module, 'difficulty')) + '. Correct: ' + countValue(module, 'correct') + '. Errors: ' + countValue(module, 'errors') + '. Observations: ' + valueOrBlank(observations) + '. Notes: ' + valueOrBlank(getValue(module, 'notes')) + '.';
    }
    if (key === 'vpMemory') {
      observations = visualObservations(module, [
        ['strategy', 'strategy used'], ['sequencing', 'sequencing'], ['frustration', 'frustration/fatigue']
      ]);
      return 'Original visual memory grid activity completed. Grid: ' + valueOrBlank(getValue(module, 'gridSize')) + 'x' + valueOrBlank(getValue(module, 'gridSize')) + '. Display time: ' + visualDisplayTime(module) + '. Accuracy: ' + accuracy + '. Observations: ' + valueOrBlank(observations) + '. Notes: ' + valueOrBlank(getValue(module, 'notes')) + '.';
    }
    if (key === 'vpSequence') {
      observations = visualObservations(module, [['strategy', 'working memory strategy']]);
      if (parseInt(countValue(module, 'reversals'), 10)) {
        observations = joinObservation(observations, 'reversal errors: ' + countValue(module, 'reversals'));
      }
      return 'Original visual sequential memory activity completed. Sequence length: ' + valueOrBlank(getValue(module, 'sequenceLength')) + '. Accuracy: ' + accuracy + '. Order errors: ' + countValue(module, 'errors') + '. Observations: ' + valueOrBlank(observations) + '. Notes: ' + valueOrBlank(getValue(module, 'notes')) + '.';
    }
    if (key === 'vpFigureGround') {
      observations = visualObservations(module, [
        ['scanningPattern', 'scanning pattern'], ['losesPlace', 'loses place'], ['fatigue', 'fatigue']
      ]);
      observations = visualTimedObservation(module, observations);
      return 'Original figure-ground search activity completed. Clutter level: ' + valueOrBlank(getValue(module, 'clutter')) + '. Found: ' + countValue(module, 'found') + '. Missed: ' + countValue(module, 'missed') + '. False positives: ' + countValue(module, 'falsePositives') + '. Observations: ' + valueOrBlank(observations) + '. Notes: ' + valueOrBlank(getValue(module, 'notes')) + '.';
    }
    if (key === 'vpClosure') {
      observations = visualObservations(module, [['hesitation', 'hesitation'], ['strategy', 'strategy']]);
      return 'Original visual closure activity completed. Difficulty: ' + valueOrBlank(getValue(module, 'difficulty')) + '. Accuracy: ' + accuracy + '. Observations: ' + valueOrBlank(observations) + '. Notes: ' + valueOrBlank(getValue(module, 'notes')) + '.';
    }
    if (key === 'vpSpatial') {
      observations = visualObservations(module, [
        ['rotationErrors', 'rotation errors'], ['mirrorConfusion', 'mirror confusion'], ['leftRight', 'left/right confusion']
      ]);
      observations = visualTimedObservation(module, observations);
      return 'Original spatial relations/rotation activity completed. Condition: ' + valueOrBlank(getValue(module, 'condition')) + '. Accuracy: ' + accuracy + '. Rotation/mirror errors: ' + countValue(module, 'errors') + ' total, ' + countValue(module, 'mirrorErrors') + ' mirror selections. Observations: ' + valueOrBlank(observations) + '. Notes: ' + valueOrBlank(getValue(module, 'notes')) + '.';
    }
    if (key === 'vpReversal') {
      observations = visualObservations(module, [
        ['letterReversals', 'letter reversals'], ['numberReversals', 'number reversals'], ['arrowErrors', 'arrow direction errors'], ['selfCorrection', 'self-correction']
      ]);
      return 'Original reversal awareness activity completed. Target set: ' + visualReversalLabel(getValue(module, 'targetSet')) + '. Accuracy: ' + accuracy + '. Reversal errors observed: ' + countValue(module, 'reversals') + '. Observations: ' + valueOrBlank(observations) + '. Notes: ' + valueOrBlank(getValue(module, 'notes')) + '.';
    }
    if (key === 'vpScanning') {
      observations = visualObservations(module, [
        ['scanningPattern', 'scanning pattern'], ['leftToRight', 'left-to-right organisation'], ['losesPlace', 'loses place']
      ]);
      observations = visualTimedObservation(module, observations);
      return 'Original visual scanning/cancellation activity completed. Target: ' + valueOrBlank(visualTargetText(module)) + '. Found: ' + countValue(module, 'found') + '. Missed: ' + countValue(module, 'missed') + '. False positives: ' + countValue(module, 'falsePositives') + '. Scanning observations: ' + valueOrBlank(observations) + '. Notes: ' + valueOrBlank(getValue(module, 'notes')) + '.';
    }
    if (key === 'vpPattern') {
      return 'Original pattern copying activity completed. Difficulty: ' + valueOrBlank(getValue(module, 'difficulty')) + '. Accuracy: ' + valueOrBlank(getValue(module, 'accuracy')) + '. Spatial organisation: spacing ' + valueOrBlank(getValue(module, 'spacing')) + ', orientation ' + valueOrBlank(getValue(module, 'orientation')) + '. Pencil control/planning observations: pencil control ' + valueOrBlank(getValue(module, 'pencilControl')) + ', planning ' + valueOrBlank(getValue(module, 'planning')) + ', fatigue ' + valueOrBlank(getValue(module, 'fatigue')) + '. Notes: ' + valueOrBlank(getValue(module, 'notes')) + '.';
    }
    if (key === 'vpMaze') {
      observations = visualObservations(module, [['hesitations', 'hesitations'], ['planning', 'planning'], ['fatigue', 'fatigue']]);
      return 'Original maze/path-following activity completed. Difficulty: ' + valueOrBlank(getValue(module, 'difficulty')) + '. Time: ' + valueOrBlank(visualMazeTime(module)) + '. Errors/wall touches: ' + countValue(module, 'wallTouches') + '. Planning observations: ' + valueOrBlank(observations) + '. Notes: ' + valueOrBlank(getValue(module, 'notes')) + '.';
    }
    return '';
  }

  function visualObservations(module, fields) {
    return fields.map(function (entry) {
      var value = getValue(module, entry[0]);
      return value ? entry[1] + ': ' + value : '';
    }).filter(Boolean).join('; ');
  }

  function joinObservation(current, next) {
    return current ? current + '; ' + next : next;
  }

  function visualTimedObservation(module, observations) {
    var elapsed = parseInt(module.getAttribute('data-vt-vp-elapsed') || '0', 10) || 0;
    return elapsed ? joinObservation(observations, 'time: ' + elapsed + ' seconds') : observations;
  }

  function visualDisplayTime(module) {
    var displayTime = getValue(module, 'displayTime');
    if (displayTime === 'custom') {
      displayTime = getValue(module, 'customDisplayTime');
    }
    return valueOrBlank(displayTime) + ' seconds';
  }

  function visualMazeTime(module) {
    var manual = getValue(module, 'time');
    var elapsed = parseInt(module.getAttribute('data-vt-vp-elapsed') || '0', 10) || 0;
    return manual ? manual + ' seconds' : (elapsed ? elapsed + ' seconds' : '');
  }

  function visualAccuracy(module) {
    if (module.getAttribute('data-vt-vp-accuracy')) {
      return module.getAttribute('data-vt-vp-accuracy');
    }
    var correct = parseInt(countValue(module, 'correct'), 10) || 0;
    var errors = parseInt(countValue(module, 'errors'), 10) || 0;
    var total = correct + errors;
    return total ? correct + '/' + total + ' (' + Math.round(correct / total * 100) + '%)' : '__';
  }

  function visualTargetText(module) {
    var target = module.querySelector('[data-vt-vp-target]');
    return target ? target.textContent.trim() : '';
  }

  function visualReversalLabel(value) {
    return { bd: 'b / d', pq: 'p / q', '69': '6 / 9', arrows: 'arrows', shapes: 'rotated shapes' }[value] || valueOrBlank(value);
  }

  function visualAssessmentDefinitions() {
    return {
      discrimination: {
        title: 'Visual Discrimination Match',
        assesses: 'noticing small differences between similar forms, orientation, spacing and shape detail',
        training: '10-round matching with distinct forms, then rotated/mirrored distractors',
        recommendations: ['Visual Discrimination Match', 'Spatial Relations / Rotation', 'Reversal Awareness']
      },
      formConsistency: {
        title: 'Form Consistency Builder',
        assesses: 'recognising the same form across changes in size, rotation, position and visual style',
        training: 'covered by Visual Discrimination Match plus Spatial Relations / Rotation using same-form, changed-position trials',
        recommendations: ['Visual Discrimination Match', 'Spatial Relations / Rotation']
      },
      memory: {
        title: 'Visual Memory Grid',
        assesses: 'short-term visual memory for location and colour patterns',
        training: 'brief grid viewing, chunking strategy, then larger grids',
        recommendations: ['Visual Memory Grid', 'Visual Sequential Memory', 'Pattern Copying']
      },
      sequence: {
        title: 'Visual Sequential Memory',
        assesses: 'remembering the order of visual information',
        training: 'forward shape/colour order tasks with gradual length increase',
        recommendations: ['Visual Sequential Memory', 'Visual Memory Grid', 'Scanning / Cancellation']
      },
      'figure-ground': {
        title: 'Figure-Ground Search',
        assesses: 'finding a target within competing visual clutter',
        training: 'target search from low clutter to closer distractor similarity',
        recommendations: ['Figure-Ground Search', 'Scanning / Cancellation', 'Visual Discrimination Match']
      },
      closure: {
        title: 'Visual Closure',
        assesses: 'identifying incomplete visual forms',
        training: 'incomplete generated shapes with increasing missing sections and rotation',
        recommendations: ['Visual Closure', 'Pattern Copying', 'Spatial Relations / Rotation']
      },
      spatial: {
        title: 'Spatial Relations / Rotation',
        assesses: 'orientation, rotation, mirror discrimination and left/right spatial judgement',
        training: 'same-orientation matching, then rotation, mirror distractors and mixed trials',
        recommendations: ['Spatial Relations / Rotation', 'Reversal Awareness', 'Maze / Path Following']
      },
      reversal: {
        title: 'Reversal Awareness',
        assesses: 'directionality, b/d, p/q, 6/9, arrow and shape reversal confusion',
        training: 'large spacing, one reversal pair at a time, then crowded mixed targets',
        recommendations: ['Reversal Awareness', 'Spatial Relations / Rotation', 'Visual Scanning / Cancellation']
      },
      scanning: {
        title: 'Visual Scanning / Cancellation',
        assesses: 'left-to-right organisation, visual search accuracy, omissions and false positives',
        training: 'rows first, then increased crowding and distractor similarity',
        recommendations: ['Visual Scanning / Cancellation', 'Figure-Ground Search', 'Maze / Path Following']
      },
      pattern: {
        title: 'Pattern Copying',
        assesses: 'visual-motor copying, spacing, orientation, planning and pencil control',
        training: 'dots/lines/boxes first, then arrows, spacing and multi-step designs',
        recommendations: ['Pattern Copying', 'Maze / Path Following', 'Visual Memory Grid']
      },
      maze: {
        title: 'Maze / Path Following',
        assesses: 'hand-eye coordination, visual planning, visual-motor control, tracking and inhibition of wall touches',
        training: 'finger tracing first, then stylus/pencil with tighter pathways',
        recommendations: ['Maze / Path Following', 'Visual Scanning / Cancellation', 'Pattern Copying']
      }
    };
  }

  function visualAssessmentInfo(type) {
    return visualAssessmentDefinitions()[type] || visualAssessmentDefinitions().discrimination;
  }

  function visualAgeBand(appOrModule) {
    var app = appOrModule && appOrModule.matches && appOrModule.matches('[data-vt-app]') ? appOrModule : appOrModule.closest('[data-vt-app]');
    var field = app ? app.querySelector('[data-vt-vp-age-band]') : null;
    return field ? field.value : '8-9';
  }

  function visualAgeLabel(appOrModule) {
    var app = appOrModule && appOrModule.matches && appOrModule.matches('[data-vt-app]') ? appOrModule : appOrModule.closest('[data-vt-app]');
    var field = app ? app.querySelector('[data-vt-vp-age-band]') : null;
    return field && field.options[field.selectedIndex] ? field.options[field.selectedIndex].textContent : visualAgeBand(appOrModule);
  }

  function visualExpectedRange(type, ageBand) {
    var index = ['4-5', '6-7', '8-9', '10-12', '13-17', 'adult'].indexOf(ageBand);
    index = index < 0 ? 2 : index;
    var defaults = [
      { normal: 65, above: 88 },
      { normal: 70, above: 90 },
      { normal: 75, above: 92 },
      { normal: 80, above: 94 },
      { normal: 85, above: 95 },
      { normal: 85, above: 95 }
    ];
    var range = defaults[index];
    var adjustments = {
      memory: -5,
      sequence: -5,
      'figure-ground': 0,
      closure: 0,
      spatial: 0,
      reversal: 0,
      scanning: 0,
      pattern: -5,
      maze: -10
    };
    var adjust = adjustments[type] || 0;
    return {
      normal: Math.max(50, Math.min(95, range.normal + adjust)),
      above: Math.max(65, Math.min(99, range.above + adjust)),
      ageBand: ageBand
    };
  }

  function visualExpectedRangeText(type, ageBand) {
    var range = visualExpectedRange(type, ageBand);
    return 'Optiplex age-reference guide: expected at about ' + range.normal + '% or better with controlled errors; high performance at about ' + range.above + '% or better.';
  }

  function visualPerformanceScore(module) {
    var type = module.getAttribute('data-vt-vp-type');
    var score = null;
    var detail = '';
    var correct = parseInt(countValue(module, 'correct'), 10) || 0;
    var errors = parseInt(countValue(module, 'errors'), 10) || 0;

    if (type === 'figure-ground' || type === 'scanning') {
      var found = parseInt(countValue(module, 'found'), 10) || 0;
      var missed = parseInt(countValue(module, 'missed'), 10) || 0;
      var falsePositives = parseInt(countValue(module, 'falsePositives'), 10) || 0;
      var searchTotal = found + missed + falsePositives;
      if (searchTotal) {
        score = Math.round(found / Math.max(1, searchTotal) * 100);
        detail = found + ' found, ' + missed + ' missed, ' + falsePositives + ' false positives';
      }
    } else if (type === 'pattern') {
      var accuracy = getValue(module, 'accuracy');
      if (accuracy) {
        score = { 'accurate': 96, 'minor differences': 82, 'frequent differences': 55, unable: 20 }[accuracy] || 65;
        if (getValue(module, 'spacing') === 'poorly organised') score -= 10;
        if (getValue(module, 'orientation') === 'frequent errors') score -= 10;
        if (getValue(module, 'planning') === 'limited') score -= 8;
        score = Math.max(0, Math.min(100, score));
        detail = 'accuracy: ' + accuracy + ', spacing: ' + valueOrBlank(getValue(module, 'spacing')) + ', orientation: ' + valueOrBlank(getValue(module, 'orientation'));
      }
    } else if (type === 'maze') {
      var touches = parseInt(countValue(module, 'wallTouches'), 10) || 0;
      var hesitations = parseInt(getValue(module, 'hesitations'), 10) || 0;
      var time = parseInt(getValue(module, 'time') || module.getAttribute('data-vt-vp-elapsed') || '0', 10) || 0;
      if (touches || hesitations || time) {
        score = Math.max(0, 100 - touches * 14 - hesitations * 4 - (time > 120 ? 8 : 0));
        detail = touches + ' wall touches, ' + hesitations + ' hesitations, time ' + (time || 0) + ' seconds';
      }
    } else {
      var total = correct + errors;
      if (total) {
        score = Math.round(correct / total * 100);
        detail = correct + ' correct, ' + errors + ' errors';
      }
    }

    return { percent: score, detail: detail, hasResult: score !== null };
  }

  function visualPerformanceStatus(module) {
    var type = module.getAttribute('data-vt-vp-type');
    var ageBand = visualAgeBand(module);
    var range = visualExpectedRange(type, ageBand);
    var performance = visualPerformanceScore(module);
    if (!performance.hasResult) {
      return {
        level: 'pending',
        label: 'Awaiting result',
        message: 'Run the activity or enter clinician ratings to compare with the Optiplex age-reference guide.',
        recommendation: visualAssessmentInfo(type).training
      };
    }
    if (performance.percent >= range.above) {
      return {
        level: 'above',
        label: 'Above expected range',
        message: 'Result: ' + performance.percent + '%. This is above the Optiplex expected range for ' + visualAgeLabel(module) + '.',
        recommendation: 'Progress training difficulty or use this as a strength while working on weaker areas.'
      };
    }
    if (performance.percent >= range.normal) {
      return {
        level: 'normal',
        label: 'Within normal range',
        message: 'Result: ' + performance.percent + '%. This is within the Optiplex expected range for ' + visualAgeLabel(module) + '.',
        recommendation: 'Maintain with age-appropriate practice if clinically relevant.'
      };
    }
    return {
      level: 'below',
      label: 'Below expected range',
      message: 'Result: ' + performance.percent + '%. This is below the Optiplex expected range for ' + visualAgeLabel(module) + '.',
      recommendation: visualAssessmentInfo(type).training
    };
  }

  function withVisualGuidance(module, text) {
    var status = visualPerformanceStatus(module);
    if (status.level === 'pending') {
      return text + ' Optiplex age-reference comparison: awaiting result. Quick note: ' + visualAssessmentInfo(module.getAttribute('data-vt-vp-type')).assesses + '.';
    }
    return text + ' Optiplex age-reference comparison: ' + status.label + '. Recommended training: ' + status.recommendation + '.';
  }

  function renderVisualResultInterpretation(module) {
    var result = module.querySelector('[data-vt-vp-result-guide]');
    if (!result) return;
    var status = visualPerformanceStatus(module);
    result.setAttribute('data-vt-vp-status', status.level);
    result.innerHTML = '<strong>' + status.label + '</strong><span>' + status.message + '</span><span>Recommended training: ' + status.recommendation + '</span>';
  }

  function visualRecommendationText(app) {
    var recommendations = [];
    app.querySelectorAll('[data-vt-vp-type]').forEach(function (module) {
      var status = visualPerformanceStatus(module);
      if (status.level === 'below') {
        recommendations.push(visualAssessmentInfo(module.getAttribute('data-vt-vp-type')).title + ': ' + status.recommendation);
      }
    });
    return recommendations.join('; ');
  }

  function renderVisualRecommendationPanel(app) {
    var list = app.querySelector('[data-vt-vp-recommendation-list]');
    var empty = app.querySelector('[data-vt-vp-recommendation-empty]');
    if (!list) return;
    var recommendations = [];
    var seen = {};
    function addRecommendation(title, text) {
      var cleanTitle = title || 'Training';
      var cleanText = text || '';
      var key = cleanTitle + '|' + cleanText;
      if (seen[key]) return;
      seen[key] = true;
      recommendations.push({ title: cleanTitle, text: cleanText });
    }
    app.querySelectorAll('[data-vt-vp-type]').forEach(function (module) {
      var status = visualPerformanceStatus(module);
      if (status.level === 'below') {
        addRecommendation(visualAssessmentInfo(module.getAttribute('data-vt-vp-type')).title, status.recommendation);
      }
    });
    app.querySelectorAll('[data-vt-module="vipDtvp"], [data-vt-module="vipTvps"]').forEach(function (module) {
      vipGameStatuses(module).forEach(function (entry) {
        if (entry.status.level === 'below') {
          addRecommendation(entry.label, (entry.training || []).join(', '));
        }
      });
    });
    recommendations.sort(function (a, b) {
      return visualTrainingPriority(a.text || a.title) - visualTrainingPriority(b.text || b.title);
    });
    list.innerHTML = '';
    if (!recommendations.length) {
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    recommendations.forEach(function (item) {
      var li = document.createElement('li');
      li.innerHTML = '<strong>' + item.title + '</strong><span>' + item.text + '</span>';
      list.appendChild(li);
    });
  }

  function visualTrainingPriority(text) {
    var order = [
      'Maze / Path Following',
      'Pattern Copying',
      'Visual Discrimination Match',
      'Spatial Relations / Rotation',
      'Reversal Awareness',
      'Visual Memory Grid',
      'Visual Sequential Memory',
      'Figure-Ground Search',
      'Visual Scanning / Cancellation',
      'Visual Closure'
    ];
    var value = text || '';
    for (var index = 0; index < order.length; index += 1) {
      if (value.indexOf(order[index]) !== -1) return index;
    }
    return order.length;
  }

  function initVisualProcessing(app, state) {
    populateVisualProcessingMap(app);
    setVisualPathway(app, 'assessment');
    app.querySelectorAll('[data-vt-vp-type]').forEach(function (module) {
      ensureVisualActivityControls(module);
      resetVisualProcessingModule(module, state);
      if (module.getAttribute('data-vt-vp-type') === 'maze') {
        initVisualMazeInput(app, state, module);
      }
    });
    updateVisualAgeGuides(app);
    renderVisualRecommendationPanel(app);
  }

  function ensureVisualActivityControls(module) {
    if (module.querySelector('[data-vt-action="vp-fullscreen"]')) {
      return;
    }
    var toolbar = document.createElement('div');
    var button = document.createElement('button');
    toolbar.className = 'vt-vp-toolbar';
    button.type = 'button';
    button.className = 'vt-button vt-button-secondary vt-vp-fullscreen-button';
    button.setAttribute('data-vt-action', 'vp-fullscreen');
    button.setAttribute('aria-pressed', 'false');
    button.textContent = 'Full Screen Activity';
    toolbar.appendChild(button);
    var heading = module.querySelector('h2');
    if (heading) {
      heading.insertAdjacentElement('afterend', toolbar);
    } else {
      module.insertBefore(toolbar, module.firstChild);
    }

    var type = module.getAttribute('data-vt-vp-type');
    var info = visualAssessmentInfo(type);
    var quick = document.createElement('div');
    var quickHeading = document.createElement('strong');
    var quickText = document.createElement('span');
    quick.className = 'vt-vp-quick-note';
    quickHeading.textContent = 'Quick note — assessing';
    quickText.textContent = info.assesses + '.';
    quick.appendChild(quickHeading);
    quick.appendChild(quickText);
    var purpose = module.querySelector('.vt-vp-purpose');
    if (purpose) {
      purpose.insertAdjacentElement('afterend', quick);
    } else {
      toolbar.insertAdjacentElement('afterend', quick);
    }

    var guide = document.createElement('div');
    var guideHeading = document.createElement('strong');
    var guideText = document.createElement('span');
    guide.className = 'vt-vp-age-guide';
    guide.setAttribute('data-vt-vp-age-guide', '');
    guideHeading.textContent = 'Age-based starting guide';
    guideText.setAttribute('data-vt-vp-age-guide-text', '');
    guide.appendChild(guideHeading);
    guide.appendChild(guideText);
    var instruction = module.querySelector('.vt-vp-instruction');
    if (instruction) {
      instruction.insertAdjacentElement('afterend', guide);
    } else {
      toolbar.insertAdjacentElement('afterend', guide);
    }

    var range = document.createElement('div');
    var rangeHeading = document.createElement('strong');
    var rangeText = document.createElement('span');
    range.className = 'vt-vp-range-guide';
    rangeHeading.textContent = 'Result range guide';
    rangeText.setAttribute('data-vt-vp-range-text', '');
    range.appendChild(rangeHeading);
    range.appendChild(rangeText);
    guide.insertAdjacentElement('afterend', range);

    var result = document.createElement('div');
    result.className = 'vt-vp-result-guide';
    result.setAttribute('data-vt-vp-result-guide', '');
    var output = module.querySelector('[data-vt-output]');
    if (output) {
      output.insertAdjacentElement('beforebegin', result);
    } else {
      range.insertAdjacentElement('afterend', result);
    }
  }

  function updateVisualAgeGuides(app) {
    var ageField = app.querySelector('[data-vt-vp-age-band]');
    var ageBand = ageField ? ageField.value : '8-9';
    var ageLabel = ageField && ageField.options[ageField.selectedIndex] ? ageField.options[ageField.selectedIndex].textContent : ageBand;
    var summary = app.querySelector('[data-vt-vp-age-summary]');
    if (summary) {
      summary.textContent = 'Showing suggested starting levels for ' + ageLabel + '. Adjust for the patient and consult context.';
    }
    app.querySelectorAll('[data-vt-vp-type]').forEach(function (module) {
      var target = module.querySelector('[data-vt-vp-age-guide-text]');
      if (target) {
        target.textContent = visualAgeGuide(module.getAttribute('data-vt-vp-type'), ageBand);
      }
      var range = module.querySelector('[data-vt-vp-range-text]');
      if (range) {
        range.textContent = visualExpectedRangeText(module.getAttribute('data-vt-vp-type'), ageBand);
      }
      renderVisualResultInterpretation(module);
    });
    renderVisualRecommendationPanel(app);
  }

  function populateVisualProcessingMap(app) {
    var assessmentList = app.querySelector('[data-vt-vp-assessment-list]');
    var trainingList = app.querySelector('[data-vt-vp-training-list]');
    if (!assessmentList || !trainingList || assessmentList.getAttribute('data-vt-ready') === 'true') {
      return;
    }
    var definitions = visualAssessmentDefinitions();
    Object.keys(definitions).forEach(function (key) {
      var info = definitions[key];
      var assessment = document.createElement('li');
      assessment.innerHTML = '<strong>' + info.title + '</strong><span>' + info.assesses + '</span>';
      assessmentList.appendChild(assessment);
      var training = document.createElement('li');
      training.innerHTML = '<strong>' + info.title + '</strong><span>' + info.training + '</span>';
      trainingList.appendChild(training);
    });
    assessmentList.setAttribute('data-vt-ready', 'true');
    trainingList.setAttribute('data-vt-ready', 'true');
  }

  function setVisualPathway(app, pathway) {
    pathway = pathway === 'training' ? 'training' : 'assessment';
    var panel = app.querySelector('[data-vt-panel="vision-processing-training"]');
    if (panel) {
      panel.setAttribute('data-vt-vp-current-pathway', pathway);
    }
    app.querySelectorAll('[data-vt-action="vp-pathway"][data-vt-vp-pathway]').forEach(function (button) {
      var active = button.getAttribute('data-vt-vp-pathway') === pathway;
      button.classList.toggle('is-active', active);
      button.classList.toggle('vt-button-secondary', !active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    var summary = app.querySelector('[data-vt-vp-pathway-summary]');
    if (summary) {
      summary.textContent = pathway === 'training'
        ? 'Training mode uses the selected age band to start each activity at an appropriate challenge level and progress gradually.'
        : 'Assessment mode compares original activity results to the Optiplex age-reference guide and suggests targeted training.';
    }
  }

  function applyVisualAgeSettings(app, state) {
    var ageBand = visualAgeBand(app);
    app.querySelectorAll('[data-vt-vp-type]').forEach(function (module) {
      applyVisualAgeSettingsToModule(module, ageBand);
      resetVisualProcessingModule(module, state);
      updateModule(module);
    });
    updateVisualAgeGuides(app);
    showToast(app, 'Age-based VIP settings applied.');
  }

  function applyVisualAgeSettingsToModule(module, ageBand) {
    var type = module.getAttribute('data-vt-vp-type');
    var index = ['4-5', '6-7', '8-9', '10-12', '13-17', 'adult'].indexOf(ageBand);
    index = index < 0 ? 2 : index;
    var settings = {
      discrimination: [
        { difficulty: 'easy' }, { difficulty: 'easy' }, { difficulty: 'medium' }, { difficulty: 'medium' }, { difficulty: 'hard' }, { difficulty: 'hard' }
      ],
      memory: [
        { gridSize: '2', displayTime: '5' }, { gridSize: '3', displayTime: '5' }, { gridSize: '3', displayTime: '3' }, { gridSize: '4', displayTime: '3' }, { gridSize: '4', displayTime: '2' }, { gridSize: '4', displayTime: '2' }
      ],
      sequence: [
        { sequenceLength: '3', displayTime: '1.5' }, { sequenceLength: '3', displayTime: '1.5' }, { sequenceLength: '4', displayTime: '1' }, { sequenceLength: '5', displayTime: '1' }, { sequenceLength: '6', displayTime: '0.6' }, { sequenceLength: '6', displayTime: '0.6' }
      ],
      'figure-ground': [
        { clutter: 'low', rows: '3', columns: '4' }, { clutter: 'low', rows: '4', columns: '6' }, { clutter: 'medium', rows: '5', columns: '8' }, { clutter: 'medium', rows: '6', columns: '9' }, { clutter: 'high', rows: '6', columns: '10' }, { clutter: 'high', rows: '6', columns: '10' }
      ],
      closure: [
        { difficulty: 'easy' }, { difficulty: 'easy' }, { difficulty: 'medium' }, { difficulty: 'medium' }, { difficulty: 'hard' }, { difficulty: 'hard' }
      ],
      spatial: [
        { condition: 'same orientation' }, { condition: 'same orientation' }, { condition: 'rotated' }, { condition: 'mixed' }, { condition: 'mixed' }, { condition: 'mixed' }
      ],
      reversal: [
        { targetSet: 'arrows', difficulty: 'large spacing' }, { targetSet: 'bd', difficulty: 'large spacing' }, { targetSet: 'bd', difficulty: 'normal spacing' }, { targetSet: 'bd', difficulty: 'normal spacing' }, { targetSet: 'bd', difficulty: 'crowded' }, { targetSet: 'bd', difficulty: 'crowded' }
      ],
      scanning: [
        { rows: '3', columns: '5', crowding: 'spacious', similarity: 'low' }, { rows: '4', columns: '6', crowding: 'spacious', similarity: 'medium' }, { rows: '5', columns: '8', crowding: 'normal', similarity: 'medium' }, { rows: '6', columns: '10', crowding: 'normal', similarity: 'high' }, { rows: '6', columns: '12', crowding: 'crowded', similarity: 'high' }, { rows: '6', columns: '12', crowding: 'crowded', similarity: 'high' }
      ],
      pattern: [
        { difficulty: 'easy' }, { difficulty: 'easy' }, { difficulty: 'medium' }, { difficulty: 'medium' }, { difficulty: 'hard' }, { difficulty: 'hard' }
      ],
      maze: [
        { difficulty: 'easy' }, { difficulty: 'easy' }, { difficulty: 'medium' }, { difficulty: 'medium' }, { difficulty: 'hard' }, { difficulty: 'hard' }
      ]
    };
    var selected = settings[type] ? settings[type][index] : null;
    if (!selected) return;
    Object.keys(selected).forEach(function (fieldName) {
      setModuleFieldValue(module, fieldName, selected[fieldName]);
    });
  }

  function visualAgeGuide(type, ageBand) {
    var level = ['4-5', '6-7', '8-9', '10-12', '13-17', 'adult'].indexOf(ageBand);
    level = level < 0 ? 2 : level;
    var guides = {
      discrimination: [
        'Start with easy forms, large spacing and no timer.',
        'Start with easy to medium forms and allow deliberate responses.',
        'Start with medium forms; introduce similar rotations when settled.',
        'Start with medium to hard forms and optional timing.',
        'Start with hard forms, subtle rotations and optional timing.',
        'Start with hard forms, subtle rotations and optional timing.'
      ],
      memory: [
        'Start with a 2x2 grid, two coloured squares and a 5-second display.',
        'Start with a 3x3 grid, three coloured squares and a 5-second display.',
        'Start with a 3x3 grid, three coloured squares and a 3-second display.',
        'Start with a 4x4 grid, four to five coloured squares and a 3-second display.',
        'Start with a 4x4 grid, five coloured squares and a 2- to 3-second display.',
        'Start with a 4x4 grid, five coloured squares and a 2- to 3-second display.'
      ],
      sequence: [
        'Start with three items at 1.5 to 2 seconds per item.',
        'Start with three to four items at 1.5 seconds per item.',
        'Start with four items at 1 second per item.',
        'Start with five items at 1 second per item.',
        'Start with five to six items at 0.6 to 1 second per item.',
        'Start with five to six items at 0.6 to 1 second per item.'
      ],
      'figure-ground': [
        'Start with low clutter, 3 rows by 4 columns and no timer.',
        'Start with low to medium clutter, 4 rows by 6 columns and no timer.',
        'Start with medium clutter, 5 rows by 8 columns and optional timing.',
        'Start with medium to high clutter, 6 rows by 9 columns and optional timing.',
        'Start with high clutter, 6 rows by 10 columns and optional timing.',
        'Start with high clutter, 6 rows by 10 columns and optional timing.'
      ],
      closure: [
        'Start with easy shapes and a small missing section.',
        'Start with easy to medium incomplete shapes.',
        'Start with medium incomplete shapes.',
        'Start with medium to hard incomplete or rotated shapes.',
        'Start with hard incomplete and rotated shapes.',
        'Start with hard incomplete and rotated shapes.'
      ],
      spatial: [
        'Start with same orientation and clearly different distractors.',
        'Start with same orientation, then introduce quarter turns.',
        'Start with rotated targets and occasional mirrored distractors.',
        'Start with mixed rotations and mirrored distractors.',
        'Start with mixed rotations and closely matched mirrored distractors.',
        'Start with mixed rotations and closely matched mirrored distractors.'
      ],
      reversal: [
        'Start with arrows or shapes using large spacing.',
        'Start with one letter or number pair using large spacing.',
        'Start with one target pair using normal spacing.',
        'Start with mixed target sets using normal to crowded spacing.',
        'Start with mixed target sets using crowded spacing.',
        'Start with mixed target sets using crowded spacing.'
      ],
      scanning: [
        'Start with 3 rows by 5 columns, spacious layout and low similarity.',
        'Start with 4 rows by 6 columns, spacious to normal layout.',
        'Start with 5 rows by 8 columns and medium similarity.',
        'Start with 6 rows by 10 columns and medium to high similarity.',
        'Start with 6 rows by 12 columns, crowded layout and high similarity.',
        'Start with 6 rows by 12 columns, crowded layout and high similarity.'
      ],
      pattern: [
        'Start with an easy pattern using few elements and paper copying.',
        'Start with an easy to medium geometric pattern.',
        'Start with a medium geometric pattern.',
        'Start with a medium to hard pattern with arrows and more elements.',
        'Start with a hard pattern with multiple spatial relationships.',
        'Start with a hard pattern with multiple spatial relationships.'
      ],
      maze: [
        'Start with an easy maze and allow finger tracing before drawing.',
        'Start with an easy maze, then progress when planning is controlled.',
        'Start with a medium maze using finger or stylus.',
        'Start with a medium to hard maze and optional timing.',
        'Start with a hard maze and optional timing.',
        'Start with a hard maze and optional timing.'
      ]
    };
    var choices = guides[type] || guides.discrimination;
    return choices[level];
  }

  function toggleVisualFullscreen(app, module) {
    var isOpen = module.classList.contains('is-vt-fullscreen');
    closeVisualFullscreen(app);
    if (isOpen) {
      return;
    }
    module.classList.add('is-vt-fullscreen');
    document.documentElement.classList.add('vt-vp-fullscreen-open');
    var button = module.querySelector('[data-vt-action="vp-fullscreen"]');
    if (button) {
      button.textContent = 'Exit Full Screen';
      button.setAttribute('aria-pressed', 'true');
    }
    module.setAttribute('tabindex', '-1');
    module.focus();
  }

  function closeVisualFullscreen(app) {
    var active = app.querySelector('.vt-vp-activity.is-vt-fullscreen');
    if (!active) {
      return;
    }
    active.classList.remove('is-vt-fullscreen');
    active.removeAttribute('tabindex');
    document.documentElement.classList.remove('vt-vp-fullscreen-open');
    var button = active.querySelector('[data-vt-action="vp-fullscreen"]');
    if (button) {
      button.textContent = 'Full Screen Activity';
      button.setAttribute('aria-pressed', 'false');
      button.focus();
    }
  }

  function resetVisualProcessingModule(module, state) {
    if (!module) {
      return;
    }
    if (state) {
      stopVisualTimer(state, module);
      clearVisualTimeouts(state, module);
    }
    module._vtVpState = {};
    module.setAttribute('data-vt-vp-elapsed', '0');
    module.removeAttribute('data-vt-vp-accuracy');
    module.querySelectorAll('[data-vt-count]').forEach(function (counter) {
      counter.textContent = '0';
    });
    module.querySelectorAll('[data-vt-vp-time]').forEach(function (time) {
      time.textContent = '0 seconds';
    });
    var mazeTime = module.querySelector('[data-vt-vp-maze-time]');
    if (mazeTime) mazeTime.textContent = '0 seconds';

    var type = module.getAttribute('data-vt-vp-type');
    if (type === 'discrimination') {
      var target = module.querySelector('[data-vt-vp-target]');
      var options = module.querySelector('[data-vt-vp-options]');
      if (target) target.textContent = '?';
      if (options) options.innerHTML = '';
    } else if (type === 'memory') {
      module._vtVpState.pattern = new Set();
      module._vtVpState.selected = new Set();
      module._vtVpState.accepting = false;
      renderVisualMemoryGrid(module, false);
    } else if (type === 'sequence') {
      module._vtVpState.ready = false;
      renderVisualSequenceChoices(module);
    } else if (type === 'figure-ground' || type === 'scanning') {
      startVisualSearch(module);
    } else if (type === 'closure') {
      newVisualClosure(module);
    } else if (type === 'spatial') {
      newVisualSpatial(module);
    } else if (type === 'reversal') {
      startVisualReversal(module);
    } else if (type === 'pattern') {
      generateVisualPattern(module);
    } else if (type === 'maze') {
      generateVisualMaze(module);
    }
  }

  function handleVisualProcessingAction(app, state, module, button, action) {
    if (action === 'vp-fullscreen') {
      toggleVisualFullscreen(app, module);
    } else if (action === 'vp-timer-toggle') {
      toggleVisualTimer(state, module, button);
    } else if (action === 'vp-timer-reset') {
      resetVisualTimer(state, module);
    } else if (action === 'vp-new-discrimination') {
      startVisualDiscrimination(module, state);
    } else if (action === 'vp-discrimination-choice') {
      chooseVisualDiscrimination(app, state, module, button);
    } else if (action === 'vp-memory-show') {
      showVisualMemory(app, state, module, false);
    } else if (action === 'vp-memory-retry') {
      showVisualMemory(app, state, module, true);
    } else if (action === 'vp-memory-cell') {
      chooseVisualMemoryCell(module, button);
    } else if (action === 'vp-memory-submit') {
      submitVisualMemory(app, module);
    } else if (action === 'vp-sequence-start') {
      startVisualSequence(state, module);
    } else if (action === 'vp-sequence-choice') {
      chooseVisualSequence(app, module, button);
    } else if (action === 'vp-search-start') {
      resetVisualTimer(state, module);
      startVisualSearch(module);
    } else if (action === 'vp-search-cell') {
      chooseVisualSearchCell(module, button);
    } else if (action === 'vp-search-finish') {
      finishVisualSearch(app, state, module);
    } else if (action === 'vp-closure-new') {
      newVisualClosure(module);
    } else if (action === 'vp-closure-choice') {
      chooseVisualClosure(state, module, button);
    } else if (action === 'vp-spatial-new') {
      newVisualSpatial(module);
    } else if (action === 'vp-spatial-choice') {
      chooseVisualSpatial(state, module, button);
    } else if (action === 'vp-reversal-start') {
      startVisualReversal(module);
    } else if (action === 'vp-reversal-cell') {
      chooseVisualReversalCell(module, button);
    } else if (action === 'vp-reversal-finish') {
      finishVisualReversal(app, module);
    } else if (action === 'vp-pattern-new') {
      generateVisualPattern(module);
    } else if (action === 'vp-maze-new') {
      resetVisualTimer(state, module);
      generateVisualMaze(module);
    } else if (action === 'vp-maze-clear') {
      clearVisualMaze(module);
    }
    updateModule(module);
  }

  function toggleVisualTimer(state, module, button) {
    var current = state.visualTimers.get(module);
    if (current) {
      stopVisualTimer(state, module);
      return;
    }
    var elapsed = parseInt(module.getAttribute('data-vt-vp-elapsed') || '0', 10) || 0;
    var startedAt = Date.now() - elapsed * 1000;
    button.textContent = 'Stop timer';
    var interval = window.setInterval(function () {
      var seconds = Math.floor((Date.now() - startedAt) / 1000);
      updateVisualTime(module, seconds);
      updateModule(module);
    }, 250);
    state.visualTimers.set(module, { interval: interval, button: button });
  }

  function updateVisualTime(module, seconds) {
    module.setAttribute('data-vt-vp-elapsed', String(seconds));
    module.querySelectorAll('[data-vt-vp-time]').forEach(function (time) {
      time.textContent = seconds + ' seconds';
    });
    var mazeTime = module.querySelector('[data-vt-vp-maze-time]');
    if (mazeTime) mazeTime.textContent = seconds + ' seconds';
    if (module.getAttribute('data-vt-vp-type') === 'maze') {
      var field = module.querySelector('[data-vt-field="time"]');
      if (field) field.value = seconds;
    }
  }

  function stopVisualTimer(state, module) {
    if (!state || !state.visualTimers) {
      return;
    }
    var current = state.visualTimers.get(module);
    if (!current) {
      return;
    }
    clearInterval(current.interval);
    if (current.button) current.button.textContent = 'Start timer';
    state.visualTimers.delete(module);
  }

  function resetVisualTimer(state, module) {
    stopVisualTimer(state, module);
    updateVisualTime(module, 0);
    if (module.getAttribute('data-vt-vp-type') === 'maze') {
      var field = module.querySelector('[data-vt-field="time"]');
      if (field) field.value = '';
    }
  }

  function addVisualTimeout(state, module, callback, delay) {
    var id = window.setTimeout(callback, delay);
    var items = state.visualTimeouts.get(module) || [];
    items.push(id);
    state.visualTimeouts.set(module, items);
    return id;
  }

  function clearVisualTimeouts(state, module) {
    if (!state || !state.visualTimeouts) {
      return;
    }
    var items = state.visualTimeouts.get(module) || [];
    items.forEach(function (id) { clearTimeout(id); });
    state.visualTimeouts.delete(module);
  }

  function visualShuffle(items) {
    var copy = items.slice();
    for (var index = copy.length - 1; index > 0; index -= 1) {
      var swap = Math.floor(Math.random() * (index + 1));
      var held = copy[index];
      copy[index] = copy[swap];
      copy[swap] = held;
    }
    return copy;
  }

  function visualRandom(items) {
    return items[Math.floor(Math.random() * items.length)];
  }

  function visualSetCount(module, name, value) {
    var counter = module.querySelector('[data-vt-count="' + name + '"]');
    if (counter) counter.textContent = String(value);
  }

  function visualIncrementCount(module, name, amount) {
    var value = parseInt(countValue(module, name), 10) || 0;
    visualSetCount(module, name, value + (amount || 1));
  }

  function visualSymbolPalette() {
    return [
      { key: 'star-blue', glyph: '★', color: '#163158', rotation: 0, mirror: false, spacing: 0, accent: false },
      { key: 'triangle-teal', glyph: '▲', color: '#1699a9', rotation: 0, mirror: false, spacing: 0, accent: true },
      { key: 'arrow-orange', glyph: '➜', color: '#d47c16', rotation: 0, mirror: false, spacing: 0, accent: false },
      { key: 'diamond-purple', glyph: '◆', color: '#7656b5', rotation: 0, mirror: false, spacing: 0, accent: true },
      { key: 'letter-green', glyph: 'L', color: '#27845d', rotation: 0, mirror: false, spacing: 0, accent: false },
      { key: 'circle-red', glyph: '●', color: '#c5525c', rotation: 0, mirror: false, spacing: 0, accent: true }
    ];
  }

  function visualCloneSymbol(symbol) {
    return {
      key: symbol.key,
      glyph: symbol.glyph,
      color: symbol.color,
      rotation: symbol.rotation || 0,
      mirror: !!symbol.mirror,
      spacing: symbol.spacing || 0,
      scaleX: symbol.scaleX || 1,
      accent: !!symbol.accent
    };
  }

  function renderVisualSymbol(container, symbol) {
    container.innerHTML = '';
    container.classList.add('vt-vp-symbol');
    var glyph = document.createElement('span');
    glyph.className = 'vt-vp-symbol-glyph';
    glyph.textContent = symbol.glyph;
    glyph.style.color = symbol.color;
    glyph.style.letterSpacing = (symbol.spacing || 0) + 'px';
    glyph.style.transform = 'rotate(' + (symbol.rotation || 0) + 'deg) scaleX(' + ((symbol.mirror ? -1 : 1) * (symbol.scaleX || 1)) + ')';
    container.appendChild(glyph);
    if (symbol.accent) {
      var accent = document.createElement('span');
      accent.className = 'vt-vp-symbol-accent';
      accent.style.color = symbol.color;
      container.appendChild(accent);
    }
    container.setAttribute('aria-label', 'Symbol ' + symbol.glyph);
  }

  function createVisualSymbolOption(symbol, action, isCorrect) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'vt-vp-option';
    button.setAttribute('data-vt-action', action);
    button.setAttribute('data-vt-correct', isCorrect ? 'true' : 'false');
    var symbolContainer = document.createElement('span');
    renderVisualSymbol(symbolContainer, symbol);
    button.appendChild(symbolContainer);
    return button;
  }

  function startVisualDiscrimination(module, state) {
    clearVisualTimeouts(state, module);
    visualSetCount(module, 'round', 0);
    visualSetCount(module, 'correct', 0);
    visualSetCount(module, 'errors', 0);
    module.removeAttribute('data-vt-vp-accuracy');
    module._vtVpState.locked = false;
    nextVisualDiscriminationRound(module, state);
    var startButton = module.querySelector('[data-vt-action="vp-new-discrimination"]');
    if (startButton) startButton.textContent = 'Restart 10 rounds';
  }

  function nextVisualDiscriminationRound(module, state) {
    var round = (parseInt(countValue(module, 'round'), 10) || 0) + 1;
    if (round > 10) {
      stopVisualTimer(state, module);
      return;
    }
    visualSetCount(module, 'round', round);
    module._vtVpState.locked = false;
    var difficulty = getValue(module, 'difficulty') || 'medium';
    var palette = visualSymbolPalette();
    var targetChoices = difficulty === 'hard' ? palette.filter(function (item) { return item.glyph === '➜' || item.glyph === 'L'; }) : palette;
    var targetSymbol = visualCloneSymbol(visualRandom(targetChoices));
    var options = [{ symbol: visualCloneSymbol(targetSymbol), correct: true }];

    if (difficulty === 'easy') {
      visualShuffle(palette.filter(function (item) { return item.key !== targetSymbol.key; })).slice(0, 3).forEach(function (item) {
        options.push({ symbol: visualCloneSymbol(item), correct: false });
      });
    } else if (difficulty === 'medium') {
      [90, 180].forEach(function (rotation, index) {
        var changed = visualCloneSymbol(targetSymbol);
        changed.rotation = rotation;
        changed.color = index ? '#c5525c' : targetSymbol.color;
        if (!index) changed.accent = !targetSymbol.accent;
        options.push({ symbol: changed, correct: false });
      });
      options.push({ symbol: visualCloneSymbol(visualRandom(palette.filter(function (item) { return item.key !== targetSymbol.key; }))), correct: false });
    } else {
      var rotated = visualCloneSymbol(targetSymbol);
      rotated.rotation = 15;
      var mirrored = visualCloneSymbol(targetSymbol);
      mirrored.mirror = true;
      var spaced = visualCloneSymbol(targetSymbol);
      spaced.scaleX = 1.14;
      options.push({ symbol: rotated, correct: false }, { symbol: mirrored, correct: false }, { symbol: spaced, correct: false });
    }

    renderVisualSymbol(module.querySelector('[data-vt-vp-target]'), targetSymbol);
    var optionContainer = module.querySelector('[data-vt-vp-options]');
    optionContainer.innerHTML = '';
    visualShuffle(options).forEach(function (option) {
      optionContainer.appendChild(createVisualSymbolOption(option.symbol, 'vp-discrimination-choice', option.correct));
    });
    updateModule(module);
  }

  function chooseVisualDiscrimination(app, state, module, button) {
    if (module._vtVpState.locked) {
      return;
    }
    module._vtVpState.locked = true;
    var correct = button.getAttribute('data-vt-correct') === 'true';
    button.classList.add(correct ? 'is-correct' : 'is-error');
    visualIncrementCount(module, correct ? 'correct' : 'errors', 1);
    updateModule(module);
    if ((parseInt(countValue(module, 'round'), 10) || 0) >= 10) {
      stopVisualTimer(state, module);
      showToast(app, 'Ten visual discrimination rounds complete.');
      return;
    }
    addVisualTimeout(state, module, function () {
      nextVisualDiscriminationRound(module, state);
    }, 550);
  }

  function renderVisualMemoryGrid(module, reveal) {
    var size = Math.max(2, Math.min(4, parseInt(getValue(module, 'gridSize'), 10) || 3));
    var container = module.querySelector('[data-vt-vp-grid]');
    if (!container) return;
    container.innerHTML = '';
    container.style.setProperty('--vt-vp-grid-size', size);
    for (var index = 0; index < size * size; index += 1) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'vt-vp-grid-cell';
      button.setAttribute('data-vt-action', 'vp-memory-cell');
      button.setAttribute('data-vt-index', String(index));
      button.setAttribute('aria-label', 'Grid square ' + (index + 1));
      if (reveal && module._vtVpState.pattern.has(index)) button.classList.add('is-pattern');
      if (!reveal && module._vtVpState.selected.has(index)) button.classList.add('is-selected');
      button.disabled = reveal || !module._vtVpState.accepting;
      container.appendChild(button);
    }
  }

  function showVisualMemory(app, state, module, reusePattern) {
    clearVisualTimeouts(state, module);
    var size = Math.max(2, Math.min(4, parseInt(getValue(module, 'gridSize'), 10) || 3));
    if (!reusePattern || !module._vtVpState.pattern || !module._vtVpState.pattern.size || module._vtVpState.gridSize !== size) {
      var cells = visualShuffle(Array.from({ length: size * size }, function (_, index) { return index; }));
      var patternSize = size === 2 ? 2 : size === 3 ? 3 : 5;
      module._vtVpState.pattern = new Set(cells.slice(0, patternSize));
      module._vtVpState.gridSize = size;
    }
    module._vtVpState.selected = new Set();
    module._vtVpState.accepting = false;
    renderVisualMemoryGrid(module, true);
    var prompt = module.querySelector('[data-vt-vp-prompt]');
    if (prompt) prompt.textContent = 'Look carefully…';
    var seconds = parseFloat(getValue(module, 'displayTime'));
    if (getValue(module, 'displayTime') === 'custom') seconds = parseFloat(getValue(module, 'customDisplayTime'));
    seconds = Math.max(0.5, Math.min(30, seconds || 3));
    addVisualTimeout(state, module, function () {
      module._vtVpState.accepting = true;
      renderVisualMemoryGrid(module, false);
      if (prompt) prompt.textContent = 'Now recreate the pattern.';
    }, seconds * 1000);
  }

  function chooseVisualMemoryCell(module, button) {
    if (!module._vtVpState.accepting) return;
    var index = parseInt(button.getAttribute('data-vt-index'), 10);
    if (module._vtVpState.selected.has(index)) {
      module._vtVpState.selected.delete(index);
    } else {
      module._vtVpState.selected.add(index);
    }
    renderVisualMemoryGrid(module, false);
  }

  function submitVisualMemory(app, module) {
    if (!module._vtVpState.accepting) {
      showToast(app, 'Show the pattern before checking it.');
      return;
    }
    var size = Math.max(2, Math.min(4, parseInt(getValue(module, 'gridSize'), 10) || 3));
    var total = size * size;
    var errors = 0;
    var correct = 0;
    for (var index = 0; index < total; index += 1) {
      if (module._vtVpState.pattern.has(index) && module._vtVpState.selected.has(index)) correct += 1;
      if (module._vtVpState.pattern.has(index) !== module._vtVpState.selected.has(index)) errors += 1;
    }
    visualSetCount(module, 'correct', correct);
    visualSetCount(module, 'errors', errors);
    module.setAttribute('data-vt-vp-accuracy', correct + ' correct; ' + errors + ' errors (' + Math.round(correct / Math.max(1, correct + errors) * 100) + '%)');
    module._vtVpState.accepting = false;
    renderVisualMemoryGrid(module, false);
    var prompt = module.querySelector('[data-vt-vp-prompt]');
    if (prompt) prompt.textContent = errors ? errors + ' square' + (errors === 1 ? '' : 's') + ' differed. Retry or show a new pattern.' : 'Pattern matched exactly.';
    updateModule(module);
  }

  function renderVisualSequenceChoices(module) {
    var container = module.querySelector('[data-vt-vp-options]');
    if (!container) return;
    container.innerHTML = '';
    visualSymbolPalette().forEach(function (symbol) {
      var option = createVisualSymbolOption(symbol, 'vp-sequence-choice', false);
      option.setAttribute('data-vt-symbol-key', symbol.key);
      option.disabled = !module._vtVpState.ready;
      container.appendChild(option);
    });
  }

  function startVisualSequence(state, module) {
    clearVisualTimeouts(state, module);
    var length = Math.max(3, Math.min(6, parseInt(getValue(module, 'sequenceLength'), 10) || 4));
    var sequence = visualShuffle(visualSymbolPalette()).slice(0, length);
    module._vtVpState.sequence = sequence;
    module._vtVpState.answer = [];
    module._vtVpState.ready = false;
    module.removeAttribute('data-vt-vp-accuracy');
    visualSetCount(module, 'correct', 0);
    visualSetCount(module, 'errors', 0);
    visualSetCount(module, 'reversals', 0);
    renderVisualSequenceChoices(module);
    renderVisualSequenceAnswer(module);
    var display = module.querySelector('[data-vt-vp-sequence-display]');
    var prompt = module.querySelector('[data-vt-vp-prompt]');
    var milliseconds = Math.max(400, (parseFloat(getValue(module, 'displayTime')) || 1) * 1000);
    sequence.forEach(function (symbol, index) {
      addVisualTimeout(state, module, function () {
        if (prompt) prompt.textContent = 'Item ' + (index + 1) + ' of ' + length;
        renderVisualSymbol(display, symbol);
      }, index * milliseconds);
    });
    addVisualTimeout(state, module, function () {
      display.innerHTML = '';
      display.classList.remove('vt-vp-symbol');
      module._vtVpState.ready = true;
      if (prompt) prompt.textContent = 'Tap the items in the same order.';
      renderVisualSequenceChoices(module);
    }, length * milliseconds);
  }

  function chooseVisualSequence(app, module, button) {
    if (!module._vtVpState.ready) return;
    var key = button.getAttribute('data-vt-symbol-key');
    var symbol = visualSymbolPalette().find(function (item) { return item.key === key; });
    if (!symbol) return;
    module._vtVpState.answer.push(symbol);
    renderVisualSequenceAnswer(module);
    if (module._vtVpState.answer.length >= module._vtVpState.sequence.length) {
      evaluateVisualSequence(app, module);
    }
  }

  function renderVisualSequenceAnswer(module) {
    var container = module.querySelector('[data-vt-vp-sequence-answer]');
    if (!container) return;
    container.innerHTML = '';
    (module._vtVpState.answer || []).forEach(function (symbol) {
      var item = document.createElement('span');
      item.textContent = symbol.glyph;
      item.style.color = symbol.color;
      container.appendChild(item);
    });
  }

  function evaluateVisualSequence(app, module) {
    var sequence = module._vtVpState.sequence;
    var answer = module._vtVpState.answer;
    var correct = sequence.reduce(function (total, symbol, index) {
      return total + (answer[index] && answer[index].key === symbol.key ? 1 : 0);
    }, 0);
    var errors = sequence.length - correct;
    var reversed = answer.map(function (item) { return item.key; }).join('|') === sequence.slice().reverse().map(function (item) { return item.key; }).join('|');
    visualSetCount(module, 'correct', correct);
    visualSetCount(module, 'errors', errors);
    visualSetCount(module, 'reversals', reversed ? errors : 0);
    module.setAttribute('data-vt-vp-accuracy', correct + '/' + sequence.length + ' (' + Math.round(correct / sequence.length * 100) + '%)');
    module._vtVpState.ready = false;
    renderVisualSequenceChoices(module);
    var prompt = module.querySelector('[data-vt-vp-prompt]');
    if (prompt) prompt.textContent = errors ? 'Sequence recorded. Watch another when ready.' : 'Sequence matched.';
    updateModule(module);
    showToast(app, errors ? 'Sequence recorded.' : 'Sequence matched.');
  }

  function visualSearchDefinition(module) {
    var type = module.getAttribute('data-vt-vp-type');
    if (type === 'figure-ground') {
      var clutter = getValue(module, 'clutter') || 'medium';
      if (clutter === 'low') {
        var low = ['★', '▲', '●', '◆', '■', '➜'];
        var lowTarget = visualRandom(low);
        return { target: lowTarget, distractors: low.filter(function (item) { return item !== lowTarget; }) };
      }
      if (clutter === 'high') {
        var closeSet = visualRandom([
          ['➜', '➞', '➝', '➟'], ['◆', '◇', '◈', '◊'], ['▲', '△', '▴', '▵']
        ]);
        return { target: closeSet[0], distractors: closeSet.slice(1) };
      }
      var mediumSet = visualRandom([
        ['★', '✦', '✚', '◆'], ['▲', '△', '◆', '●'], ['➜', '➤', '◆', '▲']
      ]);
      return { target: mediumSet[0], distractors: mediumSet.slice(1) };
    }

    var itemType = getValue(module, 'itemType') || 'letters';
    var similarity = getValue(module, 'similarity') || 'medium';
    var definitions = {
      letters: {
        low: ['R', 'A', 'M', 'X', 'T'], medium: ['R', 'P', 'B', 'K', 'F'], high: ['R', 'P', 'B', 'F', 'K']
      },
      numbers: {
        low: ['6', '1', '3', '4', '7'], medium: ['6', '5', '8', '9', '3'], high: ['6', '9', '8', '5', '0']
      },
      symbols: {
        low: ['➜', '★', '●', '▲', '◆'], medium: ['➜', '➤', '➞', '◆', '▲'], high: ['➜', '➞', '➝', '➟', '➤']
      }
    };
    var selected = definitions[itemType][similarity];
    return { target: selected[0], distractors: selected.slice(1) };
  }

  function startVisualSearch(module) {
    var rows = Math.max(3, Math.min(12, parseInt(getValue(module, 'rows'), 10) || 5));
    var columns = Math.max(4, Math.min(16, parseInt(getValue(module, 'columns'), 10) || 8));
    var definition = visualSearchDefinition(module);
    var total = rows * columns;
    var totalTargets = Math.max(2, Math.round(total * 0.14));
    var targetFlags = visualShuffle(Array.from({ length: total }, function (_, index) {
      return index < totalTargets;
    }));
    var cells = targetFlags.map(function (isTarget) {
      return {
        value: isTarget ? definition.target : visualRandom(definition.distractors),
        isTarget: isTarget,
        clicked: false,
        error: false
      };
    });
    module._vtVpState = module._vtVpState || {};
    module._vtVpState.search = {
      target: definition.target,
      totalTargets: totalTargets,
      cells: cells,
      finished: false
    };
    visualSetCount(module, 'found', 0);
    visualSetCount(module, 'missed', 0);
    visualSetCount(module, 'falsePositives', 0);
    module.removeAttribute('data-vt-vp-accuracy');
    var target = module.querySelector('[data-vt-vp-target]');
    if (target) target.textContent = definition.target;
    renderVisualSearch(module, columns);
    updateModule(module);
  }

  function renderVisualSearch(module, columns) {
    var state = module._vtVpState.search;
    var grid = module.querySelector('[data-vt-vp-grid]');
    if (!state || !grid) return;
    grid.innerHTML = '';
    grid.style.setProperty('--vt-vp-cols', columns || Math.max(4, parseInt(getValue(module, 'columns'), 10) || 8));
    grid.classList.remove('is-crowded', 'is-spacious');
    var density = module.getAttribute('data-vt-vp-type') === 'scanning' ? getValue(module, 'crowding') : getValue(module, 'clutter');
    if (density === 'crowded' || density === 'high') grid.classList.add('is-crowded');
    if (density === 'spacious' || density === 'low') grid.classList.add('is-spacious');
    state.cells.forEach(function (cell, index) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'vt-vp-search-cell';
      button.textContent = cell.value;
      button.setAttribute('data-vt-action', 'vp-search-cell');
      button.setAttribute('data-vt-index', String(index));
      button.setAttribute('aria-label', 'Search item ' + (index + 1) + ': ' + cell.value);
      if (cell.clicked && cell.isTarget) button.classList.add('is-found');
      if (cell.error) button.classList.add('is-error');
      button.disabled = cell.clicked || state.finished;
      grid.appendChild(button);
    });
  }

  function chooseVisualSearchCell(module, button) {
    var state = module._vtVpState.search;
    if (!state || state.finished) return;
    var index = parseInt(button.getAttribute('data-vt-index'), 10);
    var cell = state.cells[index];
    if (!cell || cell.clicked) return;
    cell.clicked = true;
    if (cell.isTarget) {
      visualIncrementCount(module, 'found', 1);
    } else {
      cell.error = true;
      visualIncrementCount(module, 'falsePositives', 1);
    }
    renderVisualSearch(module);
    updateModule(module);
  }

  function finishVisualSearch(app, state, module) {
    var search = module._vtVpState.search;
    if (!search || search.finished) return;
    search.finished = true;
    var found = parseInt(countValue(module, 'found'), 10) || 0;
    var missed = Math.max(0, search.totalTargets - found);
    var falsePositives = parseInt(countValue(module, 'falsePositives'), 10) || 0;
    visualSetCount(module, 'missed', missed);
    var denominator = search.totalTargets + falsePositives;
    module.setAttribute('data-vt-vp-accuracy', found + '/' + search.totalTargets + ' targets (' + Math.round(found / Math.max(1, denominator) * 100) + '% adjusted for false positives)');
    renderVisualSearch(module);
    stopVisualTimer(state, module);
    updateModule(module);
    showToast(app, 'Search results recorded.');
  }

  function visualShapeNames() {
    return ['circle', 'triangle', 'square', 'star', 'arrow'];
  }

  function newVisualClosure(module) {
    module._vtVpState = module._vtVpState || {};
    module._vtVpState.closureLocked = false;
    var difficulty = getValue(module, 'difficulty') || 'medium';
    var shape = visualRandom(visualShapeNames());
    var descriptor = {
      shape: shape,
      rotation: difficulty === 'hard' ? visualRandom([25, 45, 70, 110]) : 0,
      missingSide: visualRandom(['top', 'right', 'bottom', 'left'])
    };
    module._vtVpState.closure = descriptor;
    drawVisualShape(module.querySelector('[data-vt-vp-target]'), descriptor, true, difficulty);
    var names = visualShuffle(visualShapeNames().filter(function (name) { return name !== shape; })).slice(0, 3);
    var options = [{ descriptor: descriptor, correct: true }].concat(names.map(function (name) {
      return { descriptor: { shape: name, rotation: descriptor.rotation }, correct: false };
    }));
    var container = module.querySelector('[data-vt-vp-options]');
    container.innerHTML = '';
    visualShuffle(options).forEach(function (option) {
      var button = document.createElement('button');
      var canvas = document.createElement('canvas');
      button.type = 'button';
      button.className = 'vt-vp-option';
      button.setAttribute('data-vt-action', 'vp-closure-choice');
      button.setAttribute('data-vt-correct', option.correct ? 'true' : 'false');
      button.setAttribute('aria-label', option.descriptor.shape);
      canvas.width = 140;
      canvas.height = 140;
      button.appendChild(canvas);
      container.appendChild(button);
      drawVisualShape(canvas, option.descriptor, false, difficulty);
    });
  }

  function drawVisualShape(canvas, descriptor, incomplete, difficulty) {
    if (!canvas) return;
    var context = canvas.getContext('2d');
    var width = canvas.width;
    var height = canvas.height;
    var radius = Math.min(width, height) * 0.29;
    context.clearRect(0, 0, width, height);
    context.fillStyle = '#ffffff';
    context.fillRect(0, 0, width, height);
    context.save();
    context.translate(width / 2, height / 2);
    context.rotate((descriptor.rotation || 0) * Math.PI / 180);
    context.beginPath();
    traceVisualShape(context, descriptor.shape, radius);
    context.strokeStyle = '#163158';
    context.lineWidth = Math.max(5, width / 30);
    context.lineJoin = 'round';
    context.lineCap = 'round';
    context.stroke();
    context.restore();

    if (incomplete) {
      var size = difficulty === 'easy' ? width * 0.18 : difficulty === 'hard' ? width * 0.44 : width * 0.31;
      context.fillStyle = '#ffffff';
      if (descriptor.missingSide === 'top') context.fillRect((width - size) / 2, 0, size, height * 0.42);
      if (descriptor.missingSide === 'right') context.fillRect(width * 0.58, (height - size) / 2, width * 0.42, size);
      if (descriptor.missingSide === 'bottom') context.fillRect((width - size) / 2, height * 0.58, size, height * 0.42);
      if (descriptor.missingSide === 'left') context.fillRect(0, (height - size) / 2, width * 0.42, size);
    }
  }

  function traceVisualShape(context, shape, radius) {
    if (shape === 'circle') {
      context.arc(0, 0, radius, 0, Math.PI * 2);
    } else if (shape === 'triangle') {
      context.moveTo(0, -radius);
      context.lineTo(radius, radius);
      context.lineTo(-radius, radius);
      context.closePath();
    } else if (shape === 'square') {
      context.rect(-radius, -radius, radius * 2, radius * 2);
    } else if (shape === 'star') {
      for (var point = 0; point < 10; point += 1) {
        var angle = -Math.PI / 2 + point * Math.PI / 5;
        var distance = point % 2 ? radius * 0.43 : radius;
        var x = Math.cos(angle) * distance;
        var y = Math.sin(angle) * distance;
        if (point === 0) context.moveTo(x, y); else context.lineTo(x, y);
      }
      context.closePath();
    } else {
      context.moveTo(-radius, -radius * 0.32);
      context.lineTo(radius * 0.22, -radius * 0.32);
      context.lineTo(radius * 0.22, -radius * 0.72);
      context.lineTo(radius, 0);
      context.lineTo(radius * 0.22, radius * 0.72);
      context.lineTo(radius * 0.22, radius * 0.32);
      context.lineTo(-radius, radius * 0.32);
      context.closePath();
    }
  }

  function chooseVisualClosure(state, module, button) {
    if (module._vtVpState.closureLocked) return;
    module._vtVpState.closureLocked = true;
    var correct = button.getAttribute('data-vt-correct') === 'true';
    button.classList.add(correct ? 'is-correct' : 'is-error');
    visualIncrementCount(module, correct ? 'correct' : 'errors', 1);
    updateModule(module);
    addVisualTimeout(state, module, function () { newVisualClosure(module); }, 650);
  }

  function newVisualSpatial(module) {
    module._vtVpState = module._vtVpState || {};
    module._vtVpState.spatialLocked = false;
    var condition = getValue(module, 'condition') || 'mixed';
    var glyphs = ['➜', 'L', 'F', '↗'];
    var base = {
      key: 'spatial-' + Math.random(), glyph: visualRandom(glyphs), color: visualRandom(['#163158', '#1699a9', '#7656b5']), rotation: 0, mirror: false, spacing: 0, accent: true
    };
    var correct = visualCloneSymbol(base);
    if (condition === 'rotated' || condition === 'mixed') correct.rotation = visualRandom([90, 180, 270]);
    if (condition === 'mirrored distractors') correct.rotation = visualRandom([0, 90]);
    var mirrorOne = visualCloneSymbol(base);
    mirrorOne.rotation = correct.rotation;
    mirrorOne.mirror = true;
    var mirrorTwo = visualCloneSymbol(base);
    mirrorTwo.rotation = (correct.rotation + 90) % 360;
    mirrorTwo.mirror = true;
    var changed = visualCloneSymbol(base);
    changed.glyph = visualRandom(glyphs.filter(function (glyph) { return glyph !== base.glyph; }));
    changed.rotation = correct.rotation;
    var options = [
      { symbol: correct, correct: true, mirror: false },
      { symbol: mirrorOne, correct: false, mirror: true },
      { symbol: mirrorTwo, correct: false, mirror: true },
      { symbol: changed, correct: false, mirror: false }
    ];
    renderVisualSymbol(module.querySelector('[data-vt-vp-target]'), base);
    var container = module.querySelector('[data-vt-vp-options]');
    container.innerHTML = '';
    visualShuffle(options).forEach(function (option) {
      var button = createVisualSymbolOption(option.symbol, 'vp-spatial-choice', option.correct);
      button.setAttribute('data-vt-mirror', option.mirror ? 'true' : 'false');
      container.appendChild(button);
    });
  }

  function chooseVisualSpatial(state, module, button) {
    if (module._vtVpState.spatialLocked) return;
    module._vtVpState.spatialLocked = true;
    var correct = button.getAttribute('data-vt-correct') === 'true';
    button.classList.add(correct ? 'is-correct' : 'is-error');
    visualIncrementCount(module, correct ? 'correct' : 'errors', 1);
    if (!correct && button.getAttribute('data-vt-mirror') === 'true') visualIncrementCount(module, 'mirrorErrors', 1);
    updateModule(module);
    addVisualTimeout(state, module, function () { newVisualSpatial(module); }, 650);
  }

  function visualReversalDefinition(value) {
    if (value === 'pq') return { target: 'p', reversal: 'q', neutral: ['b', 'g'] };
    if (value === '69') return { target: '6', reversal: '9', neutral: ['5', '8'] };
    if (value === 'arrows') return { target: '→', reversal: '←', neutral: ['↑', '↓'] };
    if (value === 'shapes') return { target: '◢', reversal: '◣', neutral: ['◤', '◥'] };
    return { target: 'b', reversal: 'd', neutral: ['p', 'h'] };
  }

  function startVisualReversal(module) {
    var definition = visualReversalDefinition(getValue(module, 'targetSet'));
    var difficulty = getValue(module, 'difficulty') || 'normal spacing';
    var total = difficulty === 'large spacing' ? 18 : difficulty === 'crowded' ? 36 : 24;
    var columns = difficulty === 'large spacing' ? 6 : difficulty === 'crowded' ? 9 : 8;
    var totalTargets = Math.max(3, Math.round(total * 0.18));
    var items = [];
    for (var index = 0; index < total; index += 1) {
      var isTarget = index < totalTargets;
      var isReversal = !isTarget && Math.random() < 0.72;
      items.push({
        value: isTarget ? definition.target : isReversal ? definition.reversal : visualRandom(definition.neutral),
        isTarget: isTarget,
        isReversal: isReversal,
        clicked: false,
        error: false
      });
    }
    module._vtVpState = module._vtVpState || {};
    module._vtVpState.reversal = { items: visualShuffle(items), totalTargets: totalTargets, columns: columns, finished: false };
    visualSetCount(module, 'correct', 0);
    visualSetCount(module, 'errors', 0);
    visualSetCount(module, 'reversals', 0);
    module.removeAttribute('data-vt-vp-accuracy');
    var target = module.querySelector('[data-vt-vp-target]');
    if (target) target.textContent = definition.target;
    renderVisualReversal(module);
    updateModule(module);
  }

  function renderVisualReversal(module) {
    var state = module._vtVpState.reversal;
    var grid = module.querySelector('[data-vt-vp-grid]');
    if (!state || !grid) return;
    grid.innerHTML = '';
    grid.style.setProperty('--vt-vp-cols', state.columns);
    grid.classList.remove('is-crowded', 'is-spacious');
    var difficulty = getValue(module, 'difficulty');
    if (difficulty === 'crowded') grid.classList.add('is-crowded');
    if (difficulty === 'large spacing') grid.classList.add('is-spacious');
    state.items.forEach(function (item, index) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'vt-vp-search-cell';
      button.textContent = item.value;
      button.setAttribute('data-vt-action', 'vp-reversal-cell');
      button.setAttribute('data-vt-index', String(index));
      if (item.clicked && item.isTarget) button.classList.add('is-found');
      if (item.error) button.classList.add('is-error');
      button.disabled = item.clicked || state.finished;
      grid.appendChild(button);
    });
  }

  function chooseVisualReversalCell(module, button) {
    var state = module._vtVpState.reversal;
    if (!state || state.finished) return;
    var item = state.items[parseInt(button.getAttribute('data-vt-index'), 10)];
    if (!item || item.clicked) return;
    item.clicked = true;
    if (item.isTarget) {
      visualIncrementCount(module, 'correct', 1);
    } else {
      item.error = true;
      visualIncrementCount(module, 'errors', 1);
      if (item.isReversal) visualIncrementCount(module, 'reversals', 1);
    }
    renderVisualReversal(module);
    updateModule(module);
  }

  function finishVisualReversal(app, module) {
    var state = module._vtVpState.reversal;
    if (!state || state.finished) return;
    state.finished = true;
    var correct = parseInt(countValue(module, 'correct'), 10) || 0;
    var missed = Math.max(0, state.totalTargets - correct);
    var errors = (parseInt(countValue(module, 'errors'), 10) || 0) + missed;
    visualSetCount(module, 'errors', errors);
    module.setAttribute('data-vt-vp-accuracy', correct + '/' + state.totalTargets + ' targets (' + Math.round(correct / Math.max(1, state.totalTargets + errors - missed) * 100) + '% adjusted for selection errors)');
    renderVisualReversal(module);
    updateModule(module);
    showToast(app, 'Reversal awareness results recorded.');
  }

  function generateVisualPattern(module) {
    var canvas = module.querySelector('[data-vt-vp-canvas]');
    if (!canvas) return;
    var context = canvas.getContext('2d');
    var difficulty = getValue(module, 'difficulty') || 'medium';
    module._vtVpPatternVariation = (module._vtVpPatternVariation || 0) + 1;
    var variation = module._vtVpPatternVariation;
    var nodeCount = difficulty === 'easy' ? 5 : difficulty === 'hard' ? 11 : 8;
    var columns = difficulty === 'easy' ? 3 : difficulty === 'hard' ? 5 : 4;
    var rows = Math.ceil(nodeCount / columns);
    var marginX = 86;
    var marginY = 70;
    var usableWidth = canvas.width - marginX * 2;
    var usableHeight = canvas.height - marginY * 2;
    var points = [];
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.fillStyle = '#ffffff';
    context.fillRect(0, 0, canvas.width, canvas.height);

    for (var index = 0; index < nodeCount; index += 1) {
      var column = index % columns;
      var row = Math.floor(index / columns);
      var x = marginX + (columns === 1 ? 0 : column * usableWidth / (columns - 1));
      var y = marginY + (rows === 1 ? 0 : row * usableHeight / (rows - 1));
      var jitter = difficulty === 'easy' ? 0 : difficulty === 'hard' ? 24 : 14;
      var waveX = Math.sin((variation + 1) * (index + 2.7)) * jitter;
      var waveY = Math.cos((variation + 3) * (index + 1.9)) * jitter;
      points.push({ x: x + waveX + (Math.random() - 0.5) * jitter * 0.35, y: y + waveY + (Math.random() - 0.5) * jitter * 0.35 });
    }

    context.strokeStyle = '#163158';
    context.fillStyle = '#163158';
    context.lineWidth = 5;
    context.lineCap = 'round';
    context.lineJoin = 'round';
    for (var line = 0; line < points.length - 1; line += 1) {
      var from = points[line];
      var toIndex = line + 1;
      if (difficulty !== 'easy' && (line + variation) % 3 === 2 && line + columns < points.length) toIndex = line + columns;
      var to = points[Math.min(toIndex, points.length - 1)];
      context.beginPath();
      context.moveTo(from.x, from.y);
      context.lineTo(to.x, to.y);
      context.stroke();
      if ((difficulty === 'hard' && line % 2 === 0) || (difficulty === 'medium' && line === points.length - 2)) {
        drawVisualArrowhead(context, from, to);
      }
    }

    points.forEach(function (point, index) {
      context.save();
      context.translate(point.x, point.y);
      var markerType = (index + variation) % 3;
      if (markerType === 0) {
        context.beginPath();
        context.arc(0, 0, 11, 0, Math.PI * 2);
        context.fill();
      } else if (markerType === 1) {
        context.fillStyle = '#ffffff';
        context.fillRect(-14, -14, 28, 28);
        context.strokeRect(-14, -14, 28, 28);
      } else {
        context.beginPath();
        context.moveTo(0, -16);
        context.lineTo(15, 12);
        context.lineTo(-15, 12);
        context.closePath();
        context.fillStyle = '#ffffff';
        context.fill();
        context.stroke();
      }
      context.restore();
    });
  }

  function drawVisualArrowhead(context, from, to) {
    var angle = Math.atan2(to.y - from.y, to.x - from.x);
    var size = 16;
    context.beginPath();
    context.moveTo(to.x, to.y);
    context.lineTo(to.x - Math.cos(angle - Math.PI / 6) * size, to.y - Math.sin(angle - Math.PI / 6) * size);
    context.moveTo(to.x, to.y);
    context.lineTo(to.x - Math.cos(angle + Math.PI / 6) * size, to.y - Math.sin(angle + Math.PI / 6) * size);
    context.stroke();
  }

  function generateVisualMaze(module) {
    var canvas = module.querySelector('[data-vt-vp-canvas]');
    if (!canvas) return;
    var difficulty = getValue(module, 'difficulty') || 'medium';
    var dimensions = difficulty === 'easy' ? [4, 6] : difficulty === 'hard' ? [8, 12] : [6, 9];
    var rows = dimensions[0];
    var columns = dimensions[1];
    var cells = Array.from({ length: rows * columns }, function () {
      return { walls: [true, true, true, true], visited: false };
    });
    var stack = [0];
    cells[0].visited = true;
    while (stack.length) {
      var currentIndex = stack[stack.length - 1];
      var row = Math.floor(currentIndex / columns);
      var column = currentIndex % columns;
      var neighbours = [];
      if (row > 0 && !cells[currentIndex - columns].visited) neighbours.push({ index: currentIndex - columns, wall: 0, opposite: 2 });
      if (column < columns - 1 && !cells[currentIndex + 1].visited) neighbours.push({ index: currentIndex + 1, wall: 1, opposite: 3 });
      if (row < rows - 1 && !cells[currentIndex + columns].visited) neighbours.push({ index: currentIndex + columns, wall: 2, opposite: 0 });
      if (column > 0 && !cells[currentIndex - 1].visited) neighbours.push({ index: currentIndex - 1, wall: 3, opposite: 1 });
      if (!neighbours.length) {
        stack.pop();
      } else {
        var next = visualRandom(neighbours);
        cells[currentIndex].walls[next.wall] = false;
        cells[next.index].walls[next.opposite] = false;
        cells[next.index].visited = true;
        stack.push(next.index);
      }
    }
    cells.forEach(function (cell) { delete cell.visited; });
    module._vtVpState = module._vtVpState || {};
    module._vtVpState.maze = {
      rows: rows,
      columns: columns,
      cells: cells,
      trace: [],
      drawing: false,
      touchingWall: false,
      finished: false
    };
    visualSetCount(module, 'wallTouches', 0);
    drawVisualMaze(module);
    updateModule(module);
  }

  function clearVisualMaze(module) {
    var maze = module._vtVpState.maze;
    if (!maze) return;
    maze.trace = [];
    maze.drawing = false;
    maze.touchingWall = false;
    maze.finished = false;
    visualSetCount(module, 'wallTouches', 0);
    drawVisualMaze(module);
    updateModule(module);
  }

  function drawVisualMaze(module) {
    var canvas = module.querySelector('[data-vt-vp-canvas]');
    var maze = module._vtVpState.maze;
    if (!canvas || !maze) return;
    var context = canvas.getContext('2d');
    var cellWidth = canvas.width / maze.columns;
    var cellHeight = canvas.height / maze.rows;
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.fillStyle = '#ffffff';
    context.fillRect(0, 0, canvas.width, canvas.height);

    if (maze.trace.length) {
      context.lineCap = 'round';
      context.lineJoin = 'round';
      context.lineWidth = 8;
      for (var traceIndex = 1; traceIndex < maze.trace.length; traceIndex += 1) {
        var previous = maze.trace[traceIndex - 1];
        var current = maze.trace[traceIndex];
        context.beginPath();
        context.strokeStyle = current.hit ? '#c5525c' : '#20b7c8';
        context.moveTo(previous.x, previous.y);
        context.lineTo(current.x, current.y);
        context.stroke();
      }
    }

    context.strokeStyle = '#163158';
    context.lineWidth = 5;
    context.lineCap = 'square';
    maze.cells.forEach(function (cell, index) {
      var row = Math.floor(index / maze.columns);
      var column = index % maze.columns;
      var left = column * cellWidth;
      var top = row * cellHeight;
      var right = left + cellWidth;
      var bottom = top + cellHeight;
      context.beginPath();
      if (cell.walls[0]) { context.moveTo(left, top); context.lineTo(right, top); }
      if (cell.walls[1]) { context.moveTo(right, top); context.lineTo(right, bottom); }
      if (cell.walls[2]) { context.moveTo(right, bottom); context.lineTo(left, bottom); }
      if (cell.walls[3]) { context.moveTo(left, bottom); context.lineTo(left, top); }
      context.stroke();
    });

    var startX = cellWidth / 2;
    var startY = cellHeight / 2;
    var finishX = canvas.width - cellWidth / 2;
    var finishY = canvas.height - cellHeight / 2;
    context.fillStyle = '#2c9f70';
    context.beginPath();
    context.arc(startX, startY, Math.min(cellWidth, cellHeight) * 0.2, 0, Math.PI * 2);
    context.fill();
    context.fillStyle = '#d47c16';
    context.beginPath();
    context.arc(finishX, finishY, Math.min(cellWidth, cellHeight) * 0.2, 0, Math.PI * 2);
    context.fill();
    context.fillStyle = '#163158';
    context.font = '700 16px Arial';
    context.textAlign = 'center';
    context.fillText('START', startX, startY + 6);
    context.fillText('FINISH', finishX, finishY + 6);
  }

  function initVisualMazeInput(app, state, module) {
    var canvas = module.querySelector('[data-vt-vp-canvas]');
    if (!canvas || canvas.getAttribute('data-vt-vp-input-ready') === 'true') return;
    canvas.setAttribute('data-vt-vp-input-ready', 'true');
    canvas.setAttribute('tabindex', '0');

    canvas.addEventListener('pointerdown', function (event) {
      var maze = module._vtVpState.maze;
      if (!maze || maze.finished) return;
      var point = visualCanvasPoint(canvas, event);
      var cellWidth = canvas.width / maze.columns;
      var cellHeight = canvas.height / maze.rows;
      if (!maze.trace.length && Math.hypot(point.x - cellWidth / 2, point.y - cellHeight / 2) > Math.min(cellWidth, cellHeight) * 0.48) {
        showToast(app, 'Begin at the green START circle.');
        return;
      }
      event.preventDefault();
      maze.drawing = true;
      maze.trace.push({ x: point.x, y: point.y, hit: false });
      if (canvas.setPointerCapture) canvas.setPointerCapture(event.pointerId);
      drawVisualMaze(module);
    });

    canvas.addEventListener('pointermove', function (event) {
      var maze = module._vtVpState.maze;
      if (!maze || !maze.drawing || maze.finished) return;
      event.preventDefault();
      var point = visualCanvasPoint(canvas, event);
      var previous = maze.trace[maze.trace.length - 1];
      var hit = visualMazeSegmentHitsWall(canvas, maze, previous, point);
      if (hit && !maze.touchingWall) visualIncrementCount(module, 'wallTouches', 1);
      maze.touchingWall = hit;
      maze.trace.push({ x: point.x, y: point.y, hit: hit });
      var finishX = canvas.width - canvas.width / maze.columns / 2;
      var finishY = canvas.height - canvas.height / maze.rows / 2;
      if (Math.hypot(point.x - finishX, point.y - finishY) < Math.min(canvas.width / maze.columns, canvas.height / maze.rows) * 0.38) {
        maze.finished = true;
        maze.drawing = false;
        stopVisualTimer(state, module);
        showToast(app, 'Finish reached. Maze observations recorded.');
      }
      drawVisualMaze(module);
      updateModule(module);
    });

    var stopDrawing = function () {
      var maze = module._vtVpState.maze;
      if (maze) {
        maze.drawing = false;
        maze.touchingWall = false;
      }
    };
    canvas.addEventListener('pointerup', stopDrawing);
    canvas.addEventListener('pointercancel', stopDrawing);
    canvas.addEventListener('pointerleave', stopDrawing);
  }

  function visualCanvasPoint(canvas, event) {
    var rectangle = canvas.getBoundingClientRect();
    return {
      x: (event.clientX - rectangle.left) * canvas.width / rectangle.width,
      y: (event.clientY - rectangle.top) * canvas.height / rectangle.height
    };
  }

  function visualMazeSegmentHitsWall(canvas, maze, from, to) {
    if (!from) return false;
    var distance = Math.hypot(to.x - from.x, to.y - from.y);
    var samples = Math.max(1, Math.ceil(distance / 4));
    for (var sample = 0; sample <= samples; sample += 1) {
      var ratio = sample / samples;
      var x = from.x + (to.x - from.x) * ratio;
      var y = from.y + (to.y - from.y) * ratio;
      if (visualMazePointHitsWall(canvas, maze, x, y)) return true;
    }
    return false;
  }

  function visualMazePointHitsWall(canvas, maze, x, y) {
    if (x < 0 || y < 0 || x > canvas.width || y > canvas.height) return true;
    var cellWidth = canvas.width / maze.columns;
    var cellHeight = canvas.height / maze.rows;
    var column = Math.max(0, Math.min(maze.columns - 1, Math.floor(x / cellWidth)));
    var row = Math.max(0, Math.min(maze.rows - 1, Math.floor(y / cellHeight)));
    var cell = maze.cells[row * maze.columns + column];
    var localX = x - column * cellWidth;
    var localY = y - row * cellHeight;
    var threshold = 7;
    return (cell.walls[0] && localY < threshold) ||
      (cell.walls[1] && cellWidth - localX < threshold) ||
      (cell.walls[2] && cellHeight - localY < threshold) ||
      (cell.walls[3] && localX < threshold);
  }

  function exercisePlanNote(module) {
    var selected = getSelectedExercises(module);
    var names = selected.map(function (exercise) {
      return exercise.name;
    }).join(', ');
    var dosages = selected.map(function (exercise) {
      return exercise.name + ': ' + valueOrBlank(exercise.duration);
    }).join('; ');
    var frequencies = selected.map(function (exercise) {
      return exercise.name + ': ' + valueOrBlank(exercise.frequency);
    }).join('; ');
    var weeks = selected.map(function (exercise) {
      return exercise.name + ': ' + valueOrBlank(exercise.weeks);
    }).join('; ');

    return 'Home exercises prescribed: ' + valueOrBlank(names) + '. Dosage: ' + valueOrBlank(dosages) + '. Frequency: ' + valueOrBlank(frequencies) + '. Duration: ' + valueOrBlank(weeks) + ' weeks. Safety advice given. Review planned in ' + valueOrBlank(getValue(module, 'reviewWeeks')) + ' weeks. Notes: ' + valueOrBlank(getValue(module, 'notes')) + '.';
  }

  function getSelectedExercises(module) {
    return Array.prototype.slice.call(module.querySelectorAll('.vt-exercise-row')).map(function (row) {
      var checkbox = row.querySelector('[data-vt-exercise-check]');
      if (!checkbox || !checkbox.checked) {
        return null;
      }
      return {
        name: checkbox.value,
        duration: valueFrom(row, '[data-vt-exercise-duration]'),
        frequency: valueFrom(row, '[data-vt-exercise-frequency]'),
        weeks: valueFrom(row, '[data-vt-exercise-weeks]'),
        notes: valueFrom(row, '[data-vt-exercise-notes]'),
        parent: !!row.querySelector('[data-vt-exercise-parent]:checked')
      };
    }).filter(Boolean);
  }

  function valueFrom(container, selector) {
    var field = container.querySelector(selector);
    return field ? (field.value || '').trim() : '';
  }

  function renderParentInstructions(module) {
    if (!module || module.getAttribute('data-vt-module') !== 'exercisePlan') {
      return;
    }
    var target = module.querySelector('[data-vt-parent-instructions]');
    if (!target) {
      return;
    }
    var selected = getSelectedExercises(module).filter(function (exercise) {
      return exercise.parent;
    });
    target.innerHTML = '';
    selected.forEach(function (exercise) {
      var p = document.createElement('p');
      p.textContent = exercise.name + ': ' + (exerciseInstructions[exercise.name] || exerciseInstructions['custom exercise']);
      target.appendChild(p);
    });
    if (selected.length) {
      var safety = document.createElement('p');
      safety.textContent = 'Safety note: Stop if symptoms become significant, if double vision does not resolve, or if the child becomes distressed.';
      target.appendChild(safety);
    }
  }

  function homePlanName(rawName) {
    var name = (rawName || '').toLowerCase();
    if (name.indexOf('saccad') >= 0) return 'saccadic charts';
    if (name.indexOf('pursuit') >= 0 || name.indexOf('smooth') >= 0) return 'pursuit/tracking target';
    if (name.indexOf('hart') >= 0) return 'Hart chart near-far practice';
    if (name.indexOf('flipper') >= 0) return 'accommodative flippers';
    if (name.indexOf('brock') >= 0) return 'Brock string';
    if (name.indexOf('near-far') >= 0 || name.indexOf('focus jump') >= 0) return 'near-far jumps';
    if (name.indexOf('reading') >= 0 || name.indexOf('tracking') >= 0) return 'home reinforcement task';
    if (name.indexOf('marsden') >= 0) return 'Marsden ball';
    if (name.indexOf('eye') >= 0 || name.indexOf('circles') >= 0) return 'eye stretches / eye circles';
    if (name.indexOf('line walking') >= 0) return 'line walking';
    return rawName || 'custom exercise';
  }

  function addExerciseToHomePlan(app, rawName) {
    var targetName = homePlanName(rawName);
    var plan = app.querySelector('[data-vt-module="exercisePlan"]');
    if (!plan) {
      return;
    }
    var rows = Array.prototype.slice.call(plan.querySelectorAll('.vt-exercise-row'));
    var row = rows.find(function (candidate) {
      var checkbox = candidate.querySelector('[data-vt-exercise-check]');
      return checkbox && checkbox.value === targetName;
    });
    if (!row) {
      row = rows.find(function (candidate) {
        var checkbox = candidate.querySelector('[data-vt-exercise-check]');
        return checkbox && checkbox.value === 'custom exercise';
      });
      var notes = row ? row.querySelector('[data-vt-exercise-notes]') : null;
      if (notes) {
        notes.value = rawName;
      }
    }
    if (!row) {
      return;
    }
    var check = row.querySelector('[data-vt-exercise-check]');
    var parent = row.querySelector('[data-vt-exercise-parent]');
    var duration = row.querySelector('[data-vt-exercise-duration]');
    var frequency = row.querySelector('[data-vt-exercise-frequency]');
    var weeks = row.querySelector('[data-vt-exercise-weeks]');
    if (check) check.checked = true;
    if (parent) parent.checked = true;
    if (duration && !duration.value) duration.value = '5 minutes';
    if (frequency && !frequency.value) frequency.value = '3 times per week';
    if (weeks && !weeks.value) weeks.value = '4';
    renderParentInstructions(plan);
    updateModule(plan);
    showToast(app, targetName + ' added to home plan.');
  }

  function libraryExerciseName(button) {
    var card = button.closest('[data-vt-library-card]');
    return card ? card.getAttribute('data-vt-home-name') : 'custom exercise';
  }

  function showParentPlan(app, state) {
    var plan = app.querySelector('[data-vt-module="exercisePlan"]');
    var overlay = app.querySelector('[data-vt-patient-overlay]');
    var body = app.querySelector('[data-vt-overlay-body]');
    var title = app.querySelector('[data-vt-overlay-title]');
    if (!plan || !overlay || !body) {
      return;
    }
    renderParentInstructions(plan);
    updateModule(plan);
    body.innerHTML = '';
    var screen = document.createElement('div');
    screen.className = 'vt-parent-plan-screen';
    var selected = getSelectedExercises(plan);
    screen.innerHTML = '<h2>Home Exercise Plan</h2>';
    if (!selected.length) {
      screen.innerHTML += '<p>No exercises selected yet.</p>';
    }
    selected.forEach(function (exercise) {
      var instruction = exerciseInstructions[exercise.name] || exerciseInstructions['custom exercise'];
      screen.innerHTML += '<section><h3>' + escapeHtml(exercise.name) + '</h3><p><strong>Equipment:</strong> As supplied or advised by Optiplex.</p><p><strong>How to do it:</strong> ' + escapeHtml(instruction) + '</p><p><strong>How long:</strong> ' + escapeHtml(valueOrBlank(exercise.duration)) + '</p><p><strong>How often:</strong> ' + escapeHtml(valueOrBlank(exercise.frequency)) + '</p><p><strong>Weeks:</strong> ' + escapeHtml(valueOrBlank(exercise.weeks)) + '</p></section>';
    });
    screen.innerHTML += '<p class="vt-parent-stop">Stop if symptoms become significant, double vision does not resolve, or the child becomes distressed. Review as planned with the doctor.</p>';
    body.appendChild(screen);
    if (title) {
      title.textContent = 'Parent Instructions';
    }
    state.activeOverlayModule = plan;
    overlay.hidden = false;
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  function moduleNote(module) {
    updateModule(module);
    var output = module.querySelector('[data-vt-output]');
    return output ? output.textContent.trim() : '';
  }

  function addModuleToSummary(app, state, module) {
    var moduleKey = module.getAttribute('data-vt-module');
    var title = module.getAttribute('data-vt-title') || 'Module';
    var note = moduleNote(module);
    var existing = state.notes.findIndex(function (item) {
      return item.key === moduleKey;
    });

    if (existing >= 0) {
      state.notes[existing] = { key: moduleKey, title: title, note: note };
    } else {
      state.notes.push({ key: moduleKey, title: title, note: note });
    }

    renderSummary(app, state);
    showToast(app, title + ' added to summary.');
  }

  function renderSummary(app, state) {
    var list = app.querySelector('[data-vt-summary-list]');
    var visualList = app.querySelector('[data-vt-summary-vp]');
    var formalList = app.querySelector('[data-vt-summary-formal]');
    var homeList = app.querySelector('[data-vt-summary-home]');
    var mini = app.querySelector('[data-vt-mini-summary]');
    var full = app.querySelector('[data-vt-full-summary]');
    var notes = state.notes;
    var visualNotes = notes.filter(function (item) { return isVisualProcessingNoteKey(item.key); });
    var formalNotes = notes.filter(function (item) { return item.key.indexOf('formal-') === 0; });
    var otherNotes = notes.filter(function (item) {
      return !isVisualProcessingNoteKey(item.key) && item.key.indexOf('formal-') !== 0 && item.key !== 'exercisePlan';
    });
    var homeNames = homeTrainingNames(app);

    renderSummaryGroup(visualList, visualNotes, 'No visual processing activities added yet.');
    renderSummaryGroup(formalList, formalNotes, 'No formal test results added.');
    renderSummaryGroup(list, otherNotes, 'No other module notes added yet.');

    if (homeList) {
      homeList.innerHTML = '';
      if (homeNames.length) {
        homeList.appendChild(noteItem({ title: 'Selected activities', note: homeNames.join(', ') }));
      } else {
        homeList.innerHTML = '<p>No home training activities selected.</p>';
      }
    }

    if (mini) {
      mini.innerHTML = '';
      if (notes.length) {
        notes.forEach(function (item) {
          mini.appendChild(noteItem(item));
        });
      } else {
        mini.textContent = 'No notes added yet.';
      }
    }

    if (full) {
      full.textContent = fullSummaryText(app, notes);
    }
  }

  function renderSummaryGroup(container, notes, emptyText) {
    if (!container) {
      return;
    }
    container.innerHTML = '';
    if (!notes.length) {
      var empty = document.createElement('p');
      empty.textContent = emptyText;
      container.appendChild(empty);
      return;
    }
    notes.forEach(function (item) {
      container.appendChild(noteItem(item));
    });
  }

  function noteItem(item) {
    var div = document.createElement('div');
    var strong = document.createElement('strong');
    var p = document.createElement('p');
    div.className = 'vt-note-item';
    strong.textContent = item.title;
    p.textContent = item.note;
    div.appendChild(strong);
    div.appendChild(p);
    return div;
  }

  function vipOptomateStatusText(entry) {
    if (!entry || !entry.status) return '';
    var status = entry.status;
    var parts = [];
    var result = vipParentResultLabel(status);
    parts.push(entry.label + ': ' + result);
    if (status.raw !== undefined && status.raw !== null && status.raw !== '') {
      parts.push('raw score ' + status.raw + (status.max ? '/' + status.max : ''));
    }
    if (!status.manualRequired && status.value !== undefined && status.value !== null && status.value !== '') {
      parts.push((status.scoreType === 'composite' ? 'index score ' : 'scaled score ') + status.value);
    }
    if (status.percentile) parts.push('percentile ' + status.percentile);
    if (status.range) parts.push('expected range ' + status.range);
    if (status.label && status.label !== result) parts.push(status.label);
    var explanation = vipParentFriendlyDescription(entry.key, entry.label);
    if (explanation) parts.push('Explanation: ' + explanation);
    return parts.join('; ') + '.';
  }

  function vipOptomateAssessmentSummaryText(app) {
    if (!app) return '';
    var modules = Array.prototype.slice.call(app.querySelectorAll('[data-vt-module="vipDtvp"], [data-vt-module="vipTvps"]'));
    var summaries = [];
    modules.forEach(function (module) {
      var suiteName = module.getAttribute('data-vt-title') || 'Vision processing assessment';
      var moduleKey = module.getAttribute('data-vt-module');
      var summary = vipAssessmentSummary(module, moduleKey);
      if (!summary || !summary.statuses || !summary.statuses.length) return;
      var age = vipAgeText(module);
      var resultText = summary.statuses.map(vipOptomateStatusText).filter(Boolean).join(' ');
      if (resultText) {
        summaries.push(suiteName + (age ? ' (' + age + ')' : '') + ': ' + resultText);
      }
    });
    return summaries.join(' ');
  }

  function fullSummaryText(app, providedNotes) {
    var notes = providedNotes || collectRenderedNotes(app);
    var visualNotes = notes.filter(function (item) {
      return isVisualProcessingNoteKey(item.key);
    });
    var formalNotes = notes.filter(function (item) {
      return item.key.indexOf('formal-') === 0;
    });
    var otherNotes = notes.filter(function (item) {
      return !isVisualProcessingNoteKey(item.key) && item.key.indexOf('formal-') !== 0 && item.key !== 'exercisePlan';
    });
    var activities = visualNotes.map(function (item) {
      return item.title;
    }).join(', ');
    var results = visualNotes.map(function (item) {
      return item.note;
    }).join(', ');
    var formalResults = formalNotes.map(function (item) {
      return item.note;
    }).join(' ');
    var assessmentScoreSummary = vipOptomateAssessmentSummaryText(app);
    var assessmentClause = assessmentScoreSummary ? ' Current vision processing assessment score summary: ' + summaryClause(assessmentScoreSummary) : '';
    var visualRecommendations = visualRecommendationText(app);
    var otherResults = otherNotes.map(function (item) {
      return item.note;
    }).join(' ');
    var homeNames = homeTrainingNames(app).join(', ');
    var impression = summaryField(app, 'impression');
    var review = summaryField(app, 'review');
    var managementNotes = summaryField(app, 'managementNotes');
    var ambPanel = app.querySelector('[data-vt-amb-panel]');
    var ambOutput = app.querySelector('[data-vt-amb-full-summary]');
    var ambText = ambPanel && ambPanel.getAttribute('data-vt-amb-has-summary') === 'true' && ambOutput ? ambOutput.textContent.trim() : '';
    var ambClause = ambText ? ' Amblyopia Support Activities: ' + summaryClause(ambText) : '';

    return 'Original Optiplex visual processing screening/training activities completed. Activities trialled: ' + summaryClause(activities) + ' Results/observations: ' + summaryClause(results) + assessmentClause + ' Targeted visual processing training recommendations: ' + summaryClause(visualRecommendations) + ambClause + ' Formal test results entered separately where applicable. Formal result entries: ' + summaryClause(formalResults) + ' Home training activities selected: ' + summaryClause(homeNames) + ' Other consult results/observations: ' + summaryClause(otherResults) + ' Clinical impression selected by the doctor: ' + summaryClause(impression) + ' Review interval: ' + summaryClause(review) + ' Notes: ' + summaryClause(managementNotes) + ' Final clinical interpretation recorded in Optomate.';
  }

  function summaryClause(value) {
    var text = valueOrBlank(value);
    return /[.!?]$/.test(text) ? text : text + '.';
  }

  function isVisualProcessingNoteKey(key) {
    return key.indexOf('vp') === 0 || key.indexOf('vip') === 0;
  }

  function homeTrainingNames(app) {
    var plan = app.querySelector('[data-vt-module="exercisePlan"]');
    if (!plan) {
      return [];
    }
    return getSelectedExercises(plan).map(function (exercise) {
      return exercise.name;
    });
  }

  function collectRenderedNotes(app) {
    return Array.prototype.slice.call(app.querySelectorAll('[data-vt-summary-vp] .vt-note-item, [data-vt-summary-formal] .vt-note-item, [data-vt-summary-list] .vt-note-item')).map(function (item, index) {
      var title = item.querySelector('strong') ? item.querySelector('strong').textContent : 'Module ' + (index + 1);
      var note = item.querySelector('p') ? item.querySelector('p').textContent : item.textContent;
      return { key: title, title: title, note: note };
    });
  }

  function summaryField(app, field) {
    var input = app.querySelector('[data-vt-summary-field="' + field + '"]');
    return input ? (input.value || '').trim() : '';
  }

  function copyText(app, text, successMessage) {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(function () {
        showToast(app, successMessage);
      }).catch(function () {
        fallbackCopy(app, text, successMessage);
      });
    } else {
      fallbackCopy(app, text, successMessage);
    }
  }

  function fallbackCopy(app, text, successMessage) {
    var textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand('copy');
      showToast(app, successMessage);
    } catch (error) {
      showToast(app, 'Copy unavailable. Select the summary text manually.');
    }
    document.body.removeChild(textarea);
  }

  function resetModule(module, state) {
    if (state) {
      stopModuleIntervals(module, state);
    }
    if (state && module.getAttribute('data-vt-live-exercise')) {
      resetLiveExercise(state, module);
    }
    module.querySelectorAll('input, select, textarea').forEach(function (field) {
      if (field.matches('[data-vt-summary-field]')) {
        return;
      }
      if (field.type === 'checkbox' || field.type === 'radio') {
        field.checked = field.defaultChecked;
      } else if (field.tagName === 'SELECT') {
        field.selectedIndex = defaultSelectIndex(field);
      } else {
        field.value = field.defaultValue || '';
      }
    });
    module.querySelectorAll('[data-vt-time]').forEach(function (field) {
      field.textContent = '0 seconds';
    });
    findAllInModule(module, '[data-vt-exercise-time]').forEach(function (field) {
      field.textContent = '0 seconds';
    });
    module.querySelectorAll('[data-vt-vp-time]').forEach(function (field) {
      field.textContent = '0 seconds';
    });
    if (module.getAttribute('data-vt-module').indexOf('vp') === 0) {
      resetVisualProcessingModule(module, state);
    }
    if (module.getAttribute('data-vt-module').indexOf('vip') === 0) {
      module._vtVipGames = {};
      var suite = module.getAttribute('data-vt-vip-assessment') || 'dtvp';
      vipGameDefinitions(suite).forEach(function (game) {
        resetVipGame(module, game);
      });
    }
    if (module.classList.contains('vt-formal-entry')) {
      toggleFormalTestGate(module);
    }
    renderParentInstructions(module);
    updateModule(module);
    updateExerciseVisual(module);
  }

  function resetAll(app, state) {
    if (!window.confirm('Clear all temporary entries and summary notes?')) {
      return;
    }

    clearTemporaryEntries(app, state);
    showToast(app, 'All temporary entries cleared.');
  }

  function clearTemporaryEntries(app, state) {
	    stopAllIntervals(state);
	    closeVisualFullscreen(app);
	    closeVipGameFullscreen(app);
	    closeVipCompletionDialog(app);
	    closePatientScreen(app, state);
    if (typeof app._vtAmbReset === 'function') {
      app._vtAmbReset();
    }
    app.querySelectorAll('[data-vt-module]').forEach(function (module) {
      resetModule(module, state);
    });
    app.querySelectorAll('[data-vt-calibration-field]').forEach(function (field) {
      resetField(field);
    });
    app.querySelectorAll('[data-vt-summary-field]').forEach(function (field) {
      resetField(field);
    });
    app.querySelectorAll('[data-vt-vp-age-band]').forEach(function (field) {
      resetField(field);
    });
    app.querySelectorAll('[data-vt-vip-age-band]').forEach(function (field) {
      resetField(field);
    });
    initDefaultReview(app);
    state.notes = [];
    renderSummary(app, state);
    updateVisualAgeGuides(app);
    updateVipAssessmentModules(app);
    updateCalibration(app);
  }

  function resetField(field) {
    if (field.type === 'checkbox' || field.type === 'radio') {
      field.checked = field.defaultChecked;
    } else if (field.tagName === 'SELECT') {
      field.selectedIndex = defaultSelectIndex(field);
    } else {
      field.value = field.defaultValue || '';
    }
  }

  function defaultSelectIndex(field) {
    var options = Array.prototype.slice.call(field.options || []);
    var selected = options.findIndex(function (option) { return option.defaultSelected; });
    return selected >= 0 ? selected : 0;
  }

  function lockAndClear(app, state) {
    clearTemporaryEntries(app, state);
    app.setAttribute('data-vt-unlocked', 'false');
    var pinPanel = app.querySelector('[data-vt-pin-panel]');
    var tool = app.querySelector('[data-vt-tool]');
    var input = app.querySelector('[data-vt-pin-input]');
    var error = app.querySelector('[data-vt-pin-error]');
    if (tool) {
      tool.hidden = true;
      tool.style.setProperty('display', 'none', 'important');
      tool.classList.add('vt-locked-content');
      tool.setAttribute('aria-hidden', 'true');
    }
    if (pinPanel) {
      pinPanel.hidden = false;
    }
    if (input) {
      input.value = '';
      input.focus();
    }
    if (error) {
      error.hidden = true;
    }
    setUnlockedOnly(app, false);
    showToast(app, 'Locked and cleared.');
  }

  function stopAllIntervals(state) {
    state.metronomes.forEach(function (item) {
      clearInterval(item.interval);
      item.button.textContent = 'Start';
      if (item.pulse) {
        item.pulse.classList.remove('is-on');
      }
    });
    state.metronomes.clear();
    state.timers.forEach(function (item) {
      clearInterval(item.interval);
    });
    state.timers.clear();
    state.exerciseTimers.forEach(function (item) {
      clearInterval(item.interval);
    });
    state.exerciseTimers.clear();
    state.promptTimers.forEach(function (item) {
      clearInterval(item.interval);
    });
    state.promptTimers.clear();
    state.exerciseAnimations.forEach(function (item) {
      if (item.raf) {
        cancelAnimationFrame(item.raf);
      }
      if (item.interval) {
        clearInterval(item.interval);
      }
    });
    state.exerciseAnimations.clear();
    state.visualTimers.forEach(function (item) {
      clearInterval(item.interval);
      if (item.button) item.button.textContent = 'Start timer';
    });
    state.visualTimers.clear();
    state.visualTimeouts.forEach(function (items) {
      items.forEach(function (timeoutId) { clearTimeout(timeoutId); });
    });
    state.visualTimeouts.clear();
  }

  function stopModuleIntervals(module, state) {
    module.querySelectorAll('[data-vt-metronome]').forEach(function (container) {
      var item = state.metronomes.get(container);
      if (!item) {
        return;
      }
      clearInterval(item.interval);
      item.button.textContent = 'Start';
      if (item.pulse) {
        item.pulse.classList.remove('is-on');
      }
      state.metronomes.delete(container);
    });

    module.querySelectorAll('[data-vt-timer]').forEach(function (container) {
      var item = state.timers.get(container);
      if (!item) {
        return;
      }
      clearInterval(item.interval);
      state.timers.delete(container);
    });
    stopVisualTimer(state, module);
    clearVisualTimeouts(state, module);
    pauseLiveExercise(state, module);
  }

  function startLiveExercise(app, state, module) {
    updateExerciseVisual(module);
    startExerciseTimer(state, module);
    startExerciseMotion(state, module);
    var key = module.getAttribute('data-vt-module');
    if (key === 'exerciseHart' || key === 'exerciseNearFar') {
      startPromptTimer(state, module);
    }
    updateOverlayControls(app, module);
    showToast(app, 'Exercise started.');
  }

  function startExerciseTimer(state, module) {
    if (state.exerciseTimers.has(module)) {
      return;
    }
    var current = parseInt(module.getAttribute('data-vt-elapsed') || '0', 10) || 0;
    var startedAt = Date.now() - current * 1000;
    var interval = window.setInterval(function () {
      var elapsed = Math.floor((Date.now() - startedAt) / 1000);
      module.setAttribute('data-vt-elapsed', String(elapsed));
      findAllInModule(module, '[data-vt-exercise-time]').forEach(function (time) {
        time.textContent = elapsed + ' seconds';
      });
      updateModule(module);
      var planned = exerciseDurationSeconds(module);
      if (planned && elapsed >= planned) {
        pauseLiveExercise(state, module);
      }
    }, 1000);
    state.exerciseTimers.set(module, { interval: interval });
  }

  function pauseLiveExercise(state, module) {
    var timer = state.exerciseTimers.get(module);
    if (timer) {
      clearInterval(timer.interval);
      state.exerciseTimers.delete(module);
    }
    var prompt = state.promptTimers.get(module);
    if (prompt) {
      clearInterval(prompt.interval);
      state.promptTimers.delete(module);
    }
    var animation = state.exerciseAnimations.get(module);
    if (animation) {
      if (animation.raf) {
        cancelAnimationFrame(animation.raf);
      }
      if (animation.interval) {
        clearInterval(animation.interval);
      }
      state.exerciseAnimations.delete(module);
    }
  }

  function resetLiveExercise(state, module) {
    pauseLiveExercise(state, module);
    module.setAttribute('data-vt-elapsed', '0');
    findAllInModule(module, '[data-vt-exercise-time]').forEach(function (time) {
      time.textContent = '0 seconds';
    });
    findAllInModule(module, '[data-vt-count]').forEach(function (count) {
      count.textContent = count.getAttribute('data-vt-count') === 'cpm' ? '__' : '0';
    });
    var prompt = findInModule(module, '[data-vt-prompt]');
    var stagePrompt = findInModule(module, '[data-vt-hart-prompt]');
    if (prompt) prompt.textContent = 'Near';
    if (stagePrompt) stagePrompt.textContent = 'Near';
    applyPromptState(module, 'Near');
    module.setAttribute('data-vt-line-index', '0');
    var stage = findInModule(module, '.vt-reading-stage');
    if (stage) {
      stage.setAttribute('data-vt-line-index', '0');
      setReadingLine(module, 0);
    }
    updateExerciseVisual(module);
  }

  function startPromptTimer(state, module) {
    var intervalValue = getValue(module, 'interval');
    var seconds = parseInt(intervalValue, 10);
    if (!seconds || intervalValue === 'manual') {
      return;
    }
    if (state.promptTimers.has(module)) {
      clearInterval(state.promptTimers.get(module).interval);
    }
    state.promptTimers.set(module, {
      interval: window.setInterval(function () {
        switchPrompt(module);
        updateModule(module);
      }, seconds * 1000)
    });
  }

  function switchPrompt(module) {
    var prompt = findInModule(module, '[data-vt-prompt]');
    var stagePrompt = findInModule(module, '[data-vt-hart-prompt]');
    var current = prompt ? prompt.textContent : 'Near';
    var next = current === 'Near' ? 'Far' : 'Near';
    if (prompt) prompt.textContent = next;
    if (stagePrompt) stagePrompt.textContent = next;
    if (next === 'Far') {
      randomizeDistanceOptotype(module);
    }
    applyPromptState(module, next);
    if (next === 'Near') {
      incrementExerciseCounter(module, 'cycles');
    }
  }

  function applyPromptState(module, value) {
    var stage = findInModule(module, '.vt-hart-stage') || findInModule(module, '.vt-nearfar-stage');
    if (!stage) {
      return;
    }
    stage.classList.toggle('is-far', value === 'Far');
    stage.classList.toggle('is-near', value !== 'Far');
  }

  function incrementExerciseCounter(module, counterName) {
    if (!counterName) {
      return;
    }
    var counter = module.querySelector('[data-vt-count="' + counterName + '"]');
    if (!counter) {
      return;
    }
    counter.textContent = String((parseInt(counter.textContent, 10) || 0) + 1);
    var cpm = findInModule(module, '[data-vt-count="cpm"]');
    if (cpm) {
      cpm.textContent = exerciseCpm(module);
    }
  }

  function startExerciseMotion(state, module) {
    var key = module.getAttribute('data-vt-module');
    var existing = state.exerciseAnimations.get(module);
    if (existing) {
      if (existing.raf) {
        cancelAnimationFrame(existing.raf);
      }
      if (existing.interval) {
        clearInterval(existing.interval);
      }
      state.exerciseAnimations.delete(module);
    }
    if (key === 'exerciseSaccade') {
      var bpm = parseInt(getValue(module, 'bpm'), 10) || 70;
      var interval = window.setInterval(function () {
        moveSaccadeTarget(module, state);
      }, Math.max(220, 60000 / bpm));
      moveSaccadeTarget(module, state);
      state.exerciseAnimations.set(module, { interval: interval });
      return;
    }
    if (key === 'exercisePursuit' || key === 'exerciseEyeWarmup' || key === 'exerciseMarsden') {
      animateSmoothTarget(state, module);
      return;
    }
    if (key === 'exerciseReadingLine') {
      var speed = parseInt(getValue(module, 'autoSpeed'), 10) || 0;
      if (speed > 0) {
        state.exerciseAnimations.set(module, {
          interval: window.setInterval(function () {
            moveReadingLine(module, 1);
          }, speed * 1000)
        });
      }
    }
  }

  function moveSaccadeTarget(module, state) {
    var target = findInModule(module, '[data-vt-saccade-target]');
    if (!target) {
      return;
    }
    var index = (parseInt(module.getAttribute('data-vt-saccade-index') || '0', 10) || 0) + 1;
    module.setAttribute('data-vt-saccade-index', String(index));
    var direction = getValue(module, 'direction');
    var difficulty = getValue(module, 'difficulty');
    var positions = [[20, 55], [80, 55]];
    if (direction === 'vertical jumps') positions = [[50, 28], [50, 82]];
    if (direction === 'diagonal jumps') positions = [[22, 28], [78, 82]];
    if (direction === 'random jumps') positions = [[20 + Math.random() * 60, 28 + Math.random() * 54]];
    var pos = positions[index % positions.length];
    target.style.left = pos[0] + '%';
    target.style.top = pos[1] + '%';
    target.textContent = nextTargetLabel(module, index);
    var size = difficulty === 'hard' ? 58 : difficulty === 'medium' ? 76 : 96;
    target.style.width = size + 'px';
    target.style.height = size + 'px';
    target.style.fontSize = Math.max(1.6, size / 30) + 'rem';
    if (getValue(module, 'metronome') && getValue(module, 'muted') !== 'on') {
      beep(state);
    }
  }

  function nextTargetLabel(module, index) {
    var type = getValue(module, 'targetType');
    var letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var shapes = ['●', '■', '▲', '◆', '★'];
    var arrows = ['↑', '↓', '←', '→'];
    if (type === 'numbers') return String((index % 9) + 1);
    if (type === 'shapes') return shapes[index % shapes.length];
    if (type === 'arrows') return arrows[index % arrows.length];
    return letters[Math.floor(Math.random() * letters.length)];
  }

  function animateSmoothTarget(state, module) {
    var started = performance.now();
    var run = function (now) {
      var stage = findInModule(module, '[data-vt-stage]');
      var target = findInModule(module, '[data-vt-pursuit-target]') || findInModule(module, '[data-vt-warmup-target]') || findInModule(module, '[data-vt-marsden-target]');
      if (!stage || !target) {
        return;
      }
      var key = module.getAttribute('data-vt-module');
      var speed = getValue(module, 'speed') === 'fast' ? 0.0018 : getValue(module, 'speed') === 'medium' ? 0.0012 : 0.00075;
      var t = (now - started) * speed;
      var x = 50;
      var y = 50;
      if (key === 'exerciseEyeWarmup') {
        var pattern = getValue(module, 'pattern');
        x = 50 + Math.sin(t) * (pattern === 'diagonals' ? 32 : 38);
        y = 50 + Math.cos(pattern === 'circle' ? t : t * 0.7) * 30;
      } else if (key === 'exerciseMarsden') {
        var difficulty = getValue(module, 'difficulty');
        var multiplier = difficulty === 'fast' ? 1.45 : difficulty === 'medium' ? 1.05 : 0.75;
        x = 50 + Math.sin(t * multiplier) * 34;
        y = 55 + Math.sin(t * 1.7 * multiplier) * 24;
        updateMarsdenTarget(module, Math.floor(t * 3));
      } else {
        var movement = getValue(module, 'movement');
        if (movement === 'vertical') {
          y = 50 + Math.sin(t) * 34;
        } else if (movement === 'circular') {
          x = 50 + Math.cos(t) * 34;
          y = 55 + Math.sin(t) * 25;
        } else if (movement === 'figure-8') {
          x = 50 + Math.sin(t) * 36;
          y = 55 + Math.sin(t * 2) * 22;
        } else if (movement === 'diagonal') {
          x = 50 + Math.sin(t) * 36;
          y = 55 + Math.sin(t) * 26;
        } else {
          x = 50 + Math.sin(t) * 38;
        }
      }
      target.style.left = x + '%';
      target.style.top = y + '%';
      updatePursuitTarget(module);
      state.exerciseAnimations.set(module, { raf: requestAnimationFrame(run) });
    };
    state.exerciseAnimations.set(module, { raf: requestAnimationFrame(run) });
  }

  function moveReadingLine(module, direction) {
    var lines = findAllInModule(module, '[data-vt-reading-lines] p');
    if (!lines.length) {
      return;
    }
    var stage = findInModule(module, '.vt-reading-stage');
    var current = parseInt(stage ? stage.getAttribute('data-vt-line-index') : '0', 10) || 0;
    setReadingLine(module, current + direction);
  }

  function setReadingLine(module, index) {
    var lines = findAllInModule(module, '[data-vt-reading-lines] p');
    if (!lines.length) {
      return;
    }
    var next = Math.max(0, Math.min(lines.length - 1, index));
    lines.forEach(function (line, lineIndex) {
      line.classList.toggle('is-active', lineIndex === next);
    });
    var stage = findInModule(module, '.vt-reading-stage');
    if (stage) {
      stage.setAttribute('data-vt-line-index', String(next));
      stage.setAttribute('data-vt-difficulty', getValue(module, 'difficulty'));
      stage.setAttribute('data-vt-support', getValue(module, 'support'));
    }
  }

  function updateReadingContent(module) {
    if (module.getAttribute('data-vt-module') !== 'exerciseReadingLine') {
      return;
    }
    var container = findInModule(module, '[data-vt-reading-lines]');
    if (!container) {
      return;
    }
    var content = getValue(module, 'content');
    if (container.getAttribute('data-vt-current-content') === content) {
      return;
    }
    container.setAttribute('data-vt-current-content', content);
    var lines = [
      'The blue fish can swim fast.',
      'Sam looks up and finds the star.',
      'Keep your place on this line.',
      'The small boat moves slowly.',
      'Read each word from left to right.'
    ];
    if (content === 'rows of letters') {
      lines = ['A S D F G H J K', 'P O I U Y T R E', 'M N B V C X Z L', 'F T P O Z L E D', 'R K H S A M N P'];
    } else if (content === 'rows of words') {
      lines = ['blue star fish moon', 'jump read look find', 'small boat slow fast', 'near far clear focus', 'line place word track'];
    }
    container.innerHTML = lines.map(function (line, index) {
      return '<p class="' + (index === 0 ? 'is-active' : '') + '">' + escapeHtml(line) + '</p>';
    }).join('');
  }

  function updateExerciseVisual(module) {
    if (!module || !module.getAttribute('data-vt-live-exercise')) {
      return;
    }
    findAllInModule(module, '[data-vt-range-output]').forEach(function (range) {
      var output = module.querySelector('[data-vt-range-readout="' + range.getAttribute('data-vt-range-output') + '"]');
      if (output) {
        output.textContent = range.value;
      }
    });
    updatePursuitTarget(module);
    updateWarmupTarget(module);
    updateHartGrid(module);
    updateFlipperTarget(module);
    updateDistanceOptotype(module);
    applyPromptState(module, (findInModule(module, '[data-vt-prompt]') || {}).textContent || 'Near');
    updateReadingContent(module);
    setReadingLine(module, parseInt((findInModule(module, '.vt-reading-stage') || module).getAttribute('data-vt-line-index') || '0', 10) || 0);
  }

  function updatePursuitTarget(module) {
    var target = findInModule(module, '[data-vt-pursuit-target]');
    var stage = findInModule(module, '.vt-pursuit-stage');
    if (target) {
      var choice = getValue(module, 'target');
      target.textContent = choice === 'star' ? '★' : choice === 'animal emoji' ? 'fish' : choice === 'letter' ? 'A' : '●';
    }
    if (stage) {
      stage.classList.toggle('is-trail', !!getValue(module, 'trail'));
    }
  }

  function updateMarsdenTarget(module, index) {
    var target = findInModule(module, '[data-vt-marsden-target]');
    if (!target) {
      return;
    }
    var step = String(Math.abs(index));
    if (module.getAttribute('data-vt-marsden-step') === step) {
      return;
    }
    module.setAttribute('data-vt-marsden-step', step);
    var labels = ['A', '7', 'B', '3', 'C', '9', 'D', '5', 'E', '2', 'H', '6', 'K', '4'];
    var previous = module.getAttribute('data-vt-marsden-last') || '';
    var next = previous;
    var attempts = 0;
    while (next === previous && attempts < 12) {
      next = labels[Math.floor(Math.random() * labels.length)];
      attempts += 1;
    }
    module.setAttribute('data-vt-marsden-last', next);
    target.textContent = next;
  }

  function updateWarmupTarget(module) {
    var target = findInModule(module, '[data-vt-warmup-target]');
    if (target) {
      target.textContent = '+';
    }
  }

  function updateHartGrid(module) {
    var grid = findInModule(module, '[data-vt-hart-grid]');
    if (!grid) {
      return;
    }
    var size = parseInt(getValue(module, 'fontSize'), 10) || 32;
    grid.style.fontSize = size + 'px';
    var contrast = getValue(module, 'contrast');
    grid.style.opacity = contrast === 'soft' ? '0.55' : contrast === 'medium' ? '0.75' : '1';
    updateRandomGridButton(module);
  }

  function updateFlipperTarget(module) {
    var target = findInModule(module, '[data-vt-flipper-target]');
    if (!target) {
      return;
    }
    var text = getValue(module, 'targetText');
    target.textContent = text || 'FOCUS';
    var size = parseInt(getValue(module, 'targetSize'), 10);
    if (size) {
      target.style.fontSize = size + 'px';
    }
  }

  function updateDistanceOptotype(module) {
    var optotype = findInModule(module, '[data-vt-distance-optotype]');
    if (!optotype) {
      return;
    }
    var size = parseInt(module.getAttribute('data-vt-calibrated-optotype-px') || '72', 10) || 72;
    optotype.style.fontSize = size + 'px';
    var label = findInModule(module, '[data-vt-distance-label]');
    if (label) {
      var distance = module.getAttribute('data-vt-calibrated-distance-cm');
      label.textContent = distance ? 'View from ' + distance + ' cm' : 'Set distance in calibration';
    }
  }

  function randomizeDistanceOptotype(module) {
    var optotype = findInModule(module, '[data-vt-distance-optotype]');
    if (!optotype) {
      return;
    }
    var letters = hartGridLetters(module);
    var previous = module.getAttribute('data-vt-distance-last') || '';
    var next = previous;
    var attempts = 0;
    while (next === previous && attempts < 12) {
      next = letters[Math.floor(Math.random() * letters.length)];
      attempts += 1;
    }
    module.setAttribute('data-vt-distance-last', next);
    optotype.textContent = next;
  }

  function hartGridLetters(module) {
    var grid = findInModule(module, '[data-vt-hart-grid]');
    var letters = grid ? (grid.textContent || '').match(/[A-Z]/g) : null;
    return letters && letters.length ? letters : ['C', 'D', 'E', 'F', 'H', 'K', 'N', 'O', 'P', 'R', 'S', 'V', 'Z'];
  }

  function toggleRandomGrid(module, button) {
    var active = module.getAttribute('data-vt-random-grid') !== 'true';
    module.setAttribute('data-vt-random-grid', active ? 'true' : 'false');
    if (active) {
      randomizeHartGrid(module);
    } else {
      resetHartGrid(module);
    }
    randomizeDistanceOptotype(module);
    updateRandomGridButton(module, button);
    updateExerciseVisual(module);
  }

  function updateRandomGridButton(module, providedButton) {
    var button = providedButton || module.querySelector('[data-vt-action="toggle-random-grid"]');
    if (!button) {
      return;
    }
    var active = module.getAttribute('data-vt-random-grid') === 'true';
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
  }

  function randomizeHartGrid(module) {
    var grid = findInModule(module, '[data-vt-hart-grid]');
    if (!grid) {
      return;
    }
    var letters = 'F T P O Z L P E D F P E C F D E D F C Z D E F P O'.split(' ');
    var shuffled = letters.slice().sort(function () {
      return Math.random() - 0.5;
    });
    grid.textContent = shuffled.reduce(function (rows, letter, index) {
      rows += letter + ((index + 1) % 5 === 0 ? '\n' : ' ');
      return rows;
    }, '').trim();
  }

  function resetHartGrid(module) {
    var grid = findInModule(module, '[data-vt-hart-grid]');
    if (!grid) {
      return;
    }
    grid.textContent = 'F T P O Z\nL P E D F\nP E C F D\nE D F C Z\nD E F P O';
  }

  function updateOverlayTargetSize(module, value) {
    if (!module) {
      return;
    }
    var field = module.querySelector('[data-vt-field="targetSize"]');
    if (!field) {
      return;
    }
    field.value = value;
    updateExerciseVisual(module);
    updateModule(module);
    if (module._vtOverlayControls) {
      module._vtOverlayControls.querySelectorAll('[data-vt-overlay-size-readout]').forEach(function (readout) {
        readout.textContent = value + ' px';
      });
    }
  }

  function openPatientScreen(app, state, module) {
    var overlay = app.querySelector('[data-vt-patient-overlay]');
    var body = app.querySelector('[data-vt-overlay-body]');
    var title = app.querySelector('[data-vt-overlay-title]');
    var stage = findInModule(module, '[data-vt-stage]');
    if (!overlay || !body || !stage) {
      return;
    }
    closePatientScreen(app, state);
    state.overlayStage = stage;
    state.overlayParent = stage.parentNode;
    state.overlayNext = stage.nextSibling;
    state.activeOverlayModule = module;
    module._vtStage = stage;
    body.innerHTML = '';
    body.appendChild(stage);
    var controls = createOverlayControls(module);
    module._vtOverlayControls = controls;
    body.appendChild(controls);
    if (title) {
      title.textContent = module.getAttribute('data-vt-title') || 'Patient Screen';
    }
    overlay.hidden = false;
  }

  function createOverlayControls(module) {
    var controls = document.createElement('div');
    var key = module.getAttribute('data-vt-module');
    var elapsed = parseInt(module.getAttribute('data-vt-elapsed') || '0', 10) || 0;
    controls.className = 'vt-overlay-controls';
    controls.innerHTML = '<span class="vt-overlay-time" data-vt-exercise-time>' + elapsed + ' seconds</span><button class="vt-button" type="button" data-vt-action="exercise-start" data-vt-overlay-control>Start</button><button class="vt-button vt-button-secondary" type="button" data-vt-action="exercise-pause" data-vt-overlay-control>Pause</button><button class="vt-button vt-button-ghost" type="button" data-vt-action="exercise-reset" data-vt-overlay-control>Reset</button>';

    if (key === 'exerciseHart' || key === 'exerciseNearFar') {
      controls.innerHTML += '<button class="vt-button vt-button-secondary" type="button" data-vt-action="exercise-next-prompt" data-vt-overlay-control>Switch Near/Far</button>';
      controls.innerHTML += '<button class="vt-button vt-button-secondary" type="button" data-vt-action="exercise-counter" data-vt-counter="cycles" data-vt-overlay-control>Clear / Correct</button><button class="vt-button vt-button-ghost" type="button" data-vt-action="exercise-counter" data-vt-counter="blur" data-vt-overlay-control>Blurry</button><button class="vt-button vt-button-ghost" type="button" data-vt-action="exercise-counter" data-vt-counter="diplopia" data-vt-overlay-control>Double</button>';
    } else if (key === 'exerciseFlipper') {
      var sizeField = module.querySelector('[data-vt-field="targetSize"]');
      var targetSize = sizeField ? sizeField.value : '86';
      var minSize = sizeField ? sizeField.min : '48';
      var maxSize = sizeField ? sizeField.max : '160';
      controls.innerHTML += '<label class="vt-overlay-slider">Target size <input type="range" min="' + minSize + '" max="' + maxSize + '" value="' + targetSize + '" data-vt-overlay-size><span data-vt-overlay-size-readout>' + targetSize + ' px</span></label>';
      controls.innerHTML += '<button class="vt-button vt-button-ghost" type="button" data-vt-action="exercise-counter" data-vt-counter="plusClear" data-vt-overlay-control>Plus clear</button><button class="vt-button vt-button-ghost" type="button" data-vt-action="exercise-counter" data-vt-counter="minusClear" data-vt-overlay-control>Minus clear</button><button class="vt-button vt-button-secondary" type="button" data-vt-action="exercise-counter" data-vt-counter="cycles" data-vt-overlay-control>Completed cycle</button>';
    } else if (key === 'exerciseReadingLine') {
      controls.innerHTML += '<button class="vt-button vt-button-ghost" type="button" data-vt-action="line-prev" data-vt-overlay-control>Previous line</button><button class="vt-button vt-button-secondary" type="button" data-vt-action="line-next" data-vt-overlay-control>Next line</button><button class="vt-button vt-button-ghost" type="button" data-vt-action="exercise-counter" data-vt-counter="errors" data-vt-overlay-control>Error / skip</button>';
    }

    return controls;
  }

  function updateOverlayControls(app, module) {
    var body = app.querySelector('[data-vt-overlay-body]');
    var overlay = app.querySelector('[data-vt-patient-overlay]');
    if (!body || !overlay || overlay.hidden || !module) {
      return;
    }
    var existing = body.querySelector('.vt-overlay-controls');
    if (existing) {
      var controls = createOverlayControls(module);
      existing.replaceWith(controls);
      module._vtOverlayControls = controls;
    }
  }

  function closePatientScreen(app, state) {
    var overlay = app.querySelector('[data-vt-patient-overlay]');
    var body = app.querySelector('[data-vt-overlay-body]');
    if (state.overlayStage && state.overlayParent) {
      state.overlayParent.insertBefore(state.overlayStage, state.overlayNext || null);
    }
    if (body) {
      body.innerHTML = '';
    }
    if (overlay) {
      overlay.hidden = true;
    }
    if (state.activeOverlayModule) {
      delete state.activeOverlayModule._vtStage;
      delete state.activeOverlayModule._vtOverlayControls;
    }
    state.overlayStage = null;
    state.overlayParent = null;
    state.overlayNext = null;
    state.activeOverlayModule = null;
  }

  function showToast(app, message) {
    var toast = app.querySelector('[data-vt-toast]');
    if (!toast) {
      return;
    }
    toast.textContent = message;
    toast.hidden = false;
    window.clearTimeout(app._vtToastTimer);
    app._vtToastTimer = window.setTimeout(function () {
      toast.hidden = true;
    }, 2600);
  }

  function toggleMetronome(app, state, button) {
    var container = button.closest('[data-vt-metronome]');
    if (!container) {
      return;
    }
    var running = state.metronomes.get(container);
    if (running) {
      clearInterval(running.interval);
      state.metronomes.delete(container);
      button.textContent = 'Start';
      if (running.pulse) {
        running.pulse.classList.remove('is-on');
      }
      return;
    }

    var bpmField = container.querySelector('[data-vt-metronome-bpm]');
    var pulse = container.querySelector('[data-vt-pulse]');
    var muted = container.querySelector('[data-vt-metronome-muted]');
    var bpm = Math.max(20, Math.min(240, parseInt(bpmField ? bpmField.value : '60', 10) || 60));
    var intervalMs = 60000 / bpm;

    var tick = function () {
      if (pulse) {
        pulse.classList.add('is-on');
        window.setTimeout(function () {
          pulse.classList.remove('is-on');
        }, 110);
      }
      if (!muted || !muted.checked) {
        beep(state);
      }
    };

    tick();
    button.textContent = 'Stop';
    state.metronomes.set(container, {
      interval: window.setInterval(tick, intervalMs),
      button: button,
      pulse: pulse
    });
  }

  function beep(state) {
    var AudioContext = window.AudioContext || window.webkitAudioContext;
    if (!AudioContext) {
      return;
    }
    if (!state.audioContext) {
      state.audioContext = new AudioContext();
    }
    var oscillator = state.audioContext.createOscillator();
    var gain = state.audioContext.createGain();
    oscillator.frequency.value = 880;
    gain.gain.value = 0.05;
    oscillator.connect(gain);
    gain.connect(state.audioContext.destination);
    oscillator.start();
    oscillator.stop(state.audioContext.currentTime + 0.04);
  }

  function handleTimer(app, state, button, action) {
    var container = button.closest('[data-vt-timer]');
    var module = button.closest('[data-vt-module]');
    if (!container || !module) {
      return;
    }
    var item = state.timers.get(container);

    if (action === 'timer-start') {
      if (item) {
        return;
      }
      var timeOutput = container.querySelector('[data-vt-time]');
      var durationField = module.querySelector('[data-vt-field="duration"]');
      var startValue = parseInt(durationField ? durationField.value : '0', 10) || 0;
      var startedAt = Date.now() - startValue * 1000;
      var interval = window.setInterval(function () {
        var seconds = Math.floor((Date.now() - startedAt) / 1000);
        if (timeOutput) {
          timeOutput.textContent = seconds + ' seconds';
        }
        if (durationField) {
          durationField.value = seconds;
        }
        updateModule(module);
      }, 1000);
      state.timers.set(container, { interval: interval });
      return;
    }

    if (action === 'timer-stop') {
      if (item) {
        clearInterval(item.interval);
        state.timers.delete(container);
      }
      return;
    }

    if (action === 'timer-reset') {
      if (item) {
        clearInterval(item.interval);
        state.timers.delete(container);
      }
      var output = container.querySelector('[data-vt-time]');
      var field = module.querySelector('[data-vt-field="duration"]');
      if (output) {
        output.textContent = '0 seconds';
      }
      if (field) {
        field.value = '';
      }
      updateModule(module);
    }
  }
})();

(function () {
  if (window.OptiplexVtAmblyopiaInitialized) return;
  window.OptiplexVtAmblyopiaInitialized = true;

  var apps = document.querySelectorAll('[data-vt-app]');

  apps.forEach(function (app) {
    var panel = app.querySelector('[data-vt-amb-panel]');
    if (!panel) return;

    var state = {
      settings: defaultAmbSettings(),
      suggested: defaultAmbSettings(),
      timers: new Map(),
      notes: new Map(),
      fullscreen: null,
      completionModule: null,
      sound: false,
      audioContext: null
    };

    app._vtAmbState = state;
    app._vtAmbReset = function () { resetAmbSection(app, state, false); };
    initAmbPanel(app, state);
    app.dataset.vtAmbPrimaryReady = 'true';

    app.addEventListener('click', function (event) {
      var actionButton = event.target.closest('[data-vt-action]');
      var tab = event.target.closest('[data-vt-tab]');
      if (tab && tab.getAttribute('data-vt-tab') !== 'amblyopia') closeAmbFullscreen(state);
      if (!actionButton || !app.contains(actionButton)) return;
      var action = actionButton.getAttribute('data-vt-action');
      if (action.indexOf('amb-') !== 0) return;
      var module = actionButton.closest('[data-vt-amb-module]');
      handleAmbAction(app, state, module, actionButton, action, event);
    });

    app.addEventListener('click', function (event) {
      var module = event.target.closest('[data-vt-amb-module="target-tap"]');
      var stage = event.target.closest('[data-vt-amb-module="target-tap"] [data-vt-amb-stage]');
      if (!module || !stage || event.target.closest('[data-vt-action="amb-target-hit"]')) return;
      if (module._vtAmb && module._vtAmb.active) {
        incrementAmbCount(module, 'falseTaps', 1);
        showAmbTapFeedback(stage, event, false, 'miss');
        playAmbSound(state, 'miss');
        updateAmbOutput(app, state, module);
      }
    });

    app.addEventListener('click', function (event) {
      var module = event.target.closest('[data-vt-amb-module="dichoptic-catch"]');
      var stage = event.target.closest('[data-vt-amb-module="dichoptic-catch"] [data-vt-amb-stage]');
      if (!module || !stage || event.target.closest('[data-vt-action="amb-catch-hit"]')) return;
      if (module._vtAmb && module._vtAmb.active) {
        incrementAmbCount(module, 'misses', 1);
        showAmbTapFeedback(stage, event, false, 'miss');
        playAmbSound(state, 'miss');
        updateAmbOutput(app, state, module);
      }
    });

    app.addEventListener('pointerdown', function (event) {
      var canvas = event.target.closest('[data-vt-amb-fruit-canvas]');
      if (!canvas) return;
      canvas.setPointerCapture && canvas.setPointerCapture(event.pointerId);
      handleAmbFruitPointer(app, state, canvas.closest('[data-vt-amb-module]'), event, true);
    });

    app.addEventListener('pointermove', function (event) {
      var canvas = event.target.closest('[data-vt-amb-fruit-canvas]');
      if (!canvas || !(canvas.closest('[data-vt-amb-module]')._vtAmbGame || {}).slicing) return;
      handleAmbFruitPointer(app, state, canvas.closest('[data-vt-amb-module]'), event, false);
    });

    app.addEventListener('pointerup', function (event) {
      var module = event.target.closest('[data-vt-amb-module="game-fruit-slice"]');
      if (module && module._vtAmbGame) module._vtAmbGame.slicing = false;
    });

    app.addEventListener('input', function (event) {
      handleAmbFieldChange(app, state, event.target);
    });

    app.addEventListener('change', function (event) {
      handleAmbFieldChange(app, state, event.target);
    });

    app.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeAmbFullscreen(state);
        return;
      }
      if (event.target.matches('input, select, textarea')) return;
      var gameModule = event.target.closest('[data-vt-amb-module^="game-"]') || app.querySelector('[data-vt-amb-module^="game-"].vt-amb-is-fullscreen');
      if (!gameModule) return;
      if ((event.key === ' ' || event.key === 'Spacebar') && gameModule.getAttribute('data-vt-amb-module') === 'game-sky-flight') {
        flapAmbSky(gameModule);
        event.preventDefault();
      }
      if ((event.key === ' ' || event.key === 'Spacebar') && gameModule.getAttribute('data-vt-amb-module') === 'game-dino-dash') {
        jumpAmbDino(gameModule);
        event.preventDefault();
      }
      var directions = { ArrowUp: 'up', ArrowDown: 'down', ArrowLeft: 'left', ArrowRight: 'right' };
      if (directions[event.key]) {
        steerAmbGame(gameModule, directions[event.key]);
        event.preventDefault();
      }
    });
  });

  function defaultAmbSettings() {
    return { targetSize: 'medium', contrast: 'high', crowding: 'mild', speed: 'medium', duration: 60 };
  }

  function initAmbPanel(app, state) {
    updateAmbSuggestion(app, state);
    applyAmbSettings(app, state);
    app.querySelectorAll('[data-vt-amb-module]').forEach(function (module) {
      resetAmbModule(app, state, module, false);
    });
    renderAmbBuilder(app.querySelector('[data-vt-amb-module="two-eye-builder"]'), state);
    renderAmbDots(app.querySelector('[data-vt-amb-module="balance-dots"]'), state);
    updateAmbColours(app, state);
    renderAmbStereo(app.querySelector('[data-vt-amb-module="fusion-lock"]'));
    renderAmbSummary(app, state);
  }

  function handleAmbFieldChange(app, state, target) {
    if (!target.closest('[data-vt-amb-panel]')) return;
    if (target.matches('[data-vt-amb-calibrate]')) {
      updateAmbCalibrationLabels(app);
      updateAmbColours(app, state);
    }
    if (target.matches('[data-vt-amb-field="amblyopicEye"], [data-vt-amb-field="rightVa"], [data-vt-amb-field="leftVa"], [data-vt-amb-field="crowdingNotes"], [data-vt-amb-field="fixation"], [data-vt-amb-field="suppression"]')) {
      updateAmbSuggestion(app, state);
    }
    if (target.matches('[data-vt-amb-colour]')) {
      var globalColour = app.querySelector('[data-vt-amb-global="ambColour"]');
      if (globalColour && (target.value === 'red' || target.value === 'green')) globalColour.value = target.value;
      updateAmbColours(app, state);
    }
    if (target.matches('[data-vt-amb-global], [data-vt-amb-channel]')) updateAmbColours(app, state);
    var module = target.closest('[data-vt-amb-module]');
    if (module) {
      applyAmbModuleSettings(module, state);
      if (module.getAttribute('data-vt-amb-module') === 'balance-dots' && target.matches('[data-vt-amb-field="redDots"], [data-vt-amb-field="greenDots"], [data-vt-amb-field="dotSize"], [data-vt-amb-field="spacing"], [data-vt-amb-channel]')) renderAmbDots(module, state);
      if (module.getAttribute('data-vt-amb-module') === 'two-eye-builder' && target.matches('[data-vt-amb-field="imageType"]')) renderAmbBuilder(module, state);
      if (module.getAttribute('data-vt-amb-module') === 'fusion-lock' && target.matches('[data-vt-amb-field^="stereo"]')) renderAmbStereo(module);
      updateAmbFieldValueLabel(target);
      updateAmbOutput(app, state, module);
    }
  }

  function handleAmbAction(app, state, module, button, action, event) {
    if (action === 'amb-complete-close') {
      closeAmbCompletion(app, state);
      return;
    }
    if (action === 'amb-complete-exit') {
      closeAmbCompletion(app, state);
      closeAmbFullscreen(state);
      return;
    }
    if (action === 'amb-complete-next') {
      var nextModule = state.completionModule;
      closeAmbCompletion(app, state);
      if (nextModule) startAmbActivity(app, state, nextModule);
      return;
    }
    if (action === 'amb-apply-colours') {
      updateAmbColours(app, state);
      showAmbToast(app, 'Red/green filter colours applied.');
      return;
    }
    if (action === 'amb-reset-colours') {
      resetAmbColourCalibration(app, state);
      return;
    }
    if (action === 'amb-toggle-sound') {
      state.sound = !state.sound;
      button.textContent = state.sound ? 'Sound: On' : 'Sound: Off';
      button.setAttribute('aria-pressed', state.sound ? 'true' : 'false');
      if (state.sound) playAmbSound(state, 'star');
      return;
    }
    if (action === 'amb-apply-suggested') {
      state.settings = cloneAmbSettings(state.suggested);
      syncAmbManualControls(app, state.settings);
      applyAmbSettings(app, state);
      showAmbToast(app, 'Suggested display settings applied.');
      return;
    }
    if (action === 'amb-use-manual') {
      state.settings = readAmbManualSettings(app);
      applyAmbSettings(app, state);
      showAmbToast(app, 'Manual display settings applied.');
      return;
    }
    if (action === 'amb-swap-colours') {
      swapAmbColours(app, state);
      return;
    }
    if (action === 'amb-copy-summary') {
      renderAmbSummary(app, state);
      copyAmbText(app, ambSummaryText(app, state), 'Amblyopia Optomate summary copied.');
      return;
    }
    if (action === 'amb-reset-section') {
      if (window.confirm('Clear all temporary amblyopia support entries?')) resetAmbSection(app, state, true);
      return;
    }
    if (!module) return;
    if (action === 'amb-toggle-run') {
      toggleAmbRun(app, state, module);
    } else if (action === 'amb-start') {
      startAmbActivity(app, state, module);
    } else if (action === 'amb-pause') {
      pauseAmbActivity(state, module);
    } else if (action === 'amb-reset') {
      resetAmbModule(app, state, module, true);
    } else if (action === 'amb-fullscreen') {
      toggleAmbFullscreen(state, module, button);
    } else if (action === 'amb-target-hit') {
      hitAmbTapTarget(app, state, module, event);
    } else if (action === 'amb-catch-hit') {
      hitAmbCatchTarget(app, state, module, event);
    } else if (action === 'amb-letter-cell') {
      chooseAmbLetter(app, state, module, button, event);
    } else if (action === 'amb-match-choice') {
      chooseAmbMatch(app, state, module, button, event);
    } else if (action === 'amb-maze-cell') {
      chooseAmbMazeCell(app, state, module, button, event);
    } else if (action === 'amb-dot-click') {
      clearAmbDot(app, state, module, button, event);
    } else if (action === 'amb-toggle-depth') {
      toggleAmbDepth(module, button);
    } else if (action === 'amb-builder-response' || action === 'amb-fusion-response') {
      chooseAmbResponse(app, state, module, button);
    } else if (action === 'amb-game-flap') {
      flapAmbSky(module);
    } else if (action === 'amb-game-jump') {
      jumpAmbDino(module);
    } else if (action === 'amb-game-direction') {
      steerAmbGame(module, button.getAttribute('data-vt-direction'));
    } else if (action === 'amb-toggle-easy') {
      toggleAmbEasyMode(module, button);
    } else if (action === 'amb-add-summary') {
      addAmbSummary(app, state, module);
    } else if (action === 'amb-copy-module') {
      copyAmbText(app, ambModuleNote(app, state, module), 'Module note copied.');
    }
    if (event) event.preventDefault();
  }

  function cloneAmbSettings(settings) {
    return {
      targetSize: settings.targetSize,
      contrast: settings.contrast,
      crowding: settings.crowding,
      speed: settings.speed,
      duration: settings.duration
    };
  }

  function updateAmbSuggestion(app, state) {
    var eye = ambSetupValue(app, 'amblyopicEye');
    var right = ambSetupValue(app, 'rightVa');
    var left = ambSetupValue(app, 'leftVa');
    var acuity = ambAcuityForEye(eye, right, left);
    var denominator = ambAcuityDenominator(acuity);
    var settings;
    var details = [];
    var severe = false;

    if (denominator > 0 && denominator <= 9) {
      settings = { targetSize: 'medium', contrast: 'high', crowding: 'mild', speed: 'medium', duration: 60 };
    } else if (denominator > 9 && denominator <= 18) {
      settings = { targetSize: 'large', contrast: 'high', crowding: 'mild', speed: 'slow', duration: 60 };
    } else if (denominator > 18 && denominator <= 36) {
      settings = { targetSize: 'very large', contrast: 'high', crowding: 'none', speed: 'very slow', duration: 30 };
    } else {
      settings = { targetSize: 'very large', contrast: 'high', crowding: 'none', speed: 'very slow', duration: 30 };
      severe = true;
    }

    var crowding = ambSetupValue(app, 'crowdingNotes').toLowerCase();
    var fixation = ambSetupValue(app, 'fixation').toLowerCase();
    var suppression = ambSetupValue(app, 'suppression').toLowerCase();
    if (crowding.indexOf('significant') >= 0) {
      settings.crowding = 'none';
      details.push('Use isolated targets first, increase spacing, and reduce distractors.');
    }
    if (fixation.indexOf('unstable') >= 0 || fixation.indexOf('eccentric') >= 0) {
      settings.targetSize = 'very large';
      settings.contrast = 'high';
      settings.speed = 'very slow';
      settings.duration = 30;
      details.push('Use large high-contrast targets, slow speed, and a short clinician-supervised trial.');
    }
    if (suppression.indexOf('suspected') >= 0 || suppression.indexOf('intermittent') >= 0 || suppression.indexOf('constant') >= 0) {
      if (settings.targetSize === 'medium') settings.targetSize = 'large';
      settings.speed = settings.speed === 'medium' || settings.speed === 'fast' ? 'slow' : settings.speed;
      details.push('Complete calibration and begin with balance or suppression-awareness targets before faster games.');
    }

    state.suggested = settings;
    var output = app.querySelector('[data-vt-amb-suggestion]');
    if (output) {
      output.textContent = ambSettingsLabel(settings) + (details.length ? ' ' + details.join(' ') : '');
    }
    var warning = app.querySelector('[data-vt-amb-warning]');
    if (warning) warning.hidden = !severe;
    updateAmbOutput(app, state, app.querySelector('[data-vt-amb-module="setup"]'));
  }

  function ambAcuityForEye(eye, right, left) {
    var lower = (eye || '').toLowerCase();
    if (lower.indexOf('right') >= 0) return right;
    if (lower.indexOf('left') >= 0) return left;
    var rightDenom = ambAcuityDenominator(right);
    var leftDenom = ambAcuityDenominator(left);
    if (!rightDenom) return left;
    if (!leftDenom) return right;
    return rightDenom >= leftDenom ? right : left;
  }

  function ambAcuityDenominator(value) {
    var text = String(value || '').toLowerCase().trim();
    if (!text || text === 'other' || text.indexOf('counting') >= 0 || text.indexOf('hand') >= 0) return 0;
    var match = text.match(/6\s*\/\s*([0-9]+(?:\.[0-9]+)?)/);
    return match ? parseFloat(match[1]) : 0;
  }

  function readAmbManualSettings(app) {
    var durationField = app.querySelector('[data-vt-amb-manual="duration"]');
    var customField = app.querySelector('[data-vt-amb-manual="customDuration"]');
    var duration = durationField ? durationField.value : '60';
    if (duration === 'custom') duration = customField ? customField.value : '30';
    return {
      targetSize: ambControlValue(app, '[data-vt-amb-manual="targetSize"]', 'medium'),
      contrast: ambControlValue(app, '[data-vt-amb-manual="contrast"]', 'high'),
      crowding: ambControlValue(app, '[data-vt-amb-manual="crowding"]', 'mild'),
      speed: ambControlValue(app, '[data-vt-amb-manual="speed"]', 'medium'),
      duration: Math.max(10, parseInt(duration, 10) || 60)
    };
  }

  function syncAmbManualControls(app, settings) {
    ['targetSize', 'contrast', 'crowding', 'speed'].forEach(function (name) {
      var field = app.querySelector('[data-vt-amb-manual="' + name + '"]');
      if (field) field.value = settings[name];
    });
    var duration = app.querySelector('[data-vt-amb-manual="duration"]');
    var custom = app.querySelector('[data-vt-amb-manual="customDuration"]');
    var presets = ['30', '60', '90', '300', '600', '1200', '1800'];
    if (duration && presets.indexOf(String(settings.duration)) >= 0) duration.value = String(settings.duration);
    else if (duration) duration.value = 'custom';
    if (custom) custom.value = presets.indexOf(String(settings.duration)) >= 0 ? '' : String(settings.duration);
  }

  function applyAmbSettings(app, state) {
    app.querySelectorAll('[data-vt-amb-module]').forEach(function (module) {
      applyAmbModuleSettings(module, state);
      updateAmbOutput(app, state, module);
    });
    updateAmbColours(app, state);
  }

  function applyAmbModuleSettings(module, state) {
    if (!module) return;
    var settings = ambModuleSettings(module, state);
    var sizeMap = { 'very large': 92, large: 74, medium: 58, small: 46, 'very small': 36 };
    var contrastMap = { high: 1, medium: 0.72, low: 0.46 };
    var crowdMap = { none: 22, mild: 14, moderate: 8, crowded: 3 };
    var speedMap = { 'very slow': 3200, slow: 2300, medium: 1500, fast: 900 };
    module.style.setProperty('--vt-amb-target-size', (sizeMap[settings.targetSize] || 58) + 'px');
    module.style.setProperty('--vt-amb-target-opacity', String(contrastMap[settings.contrast] || 1));
    module.style.setProperty('--vt-amb-gap', (crowdMap[settings.crowding] || 14) + 'px');
    module.style.setProperty('--vt-amb-speed-ms', (speedMap[settings.speed] || 1500) + 'ms');
    module.setAttribute('data-vt-amb-crowding', settings.crowding);
    module.querySelectorAll('[data-vt-amb-settings-display]').forEach(function (display) {
      display.textContent = 'Current display settings: ' + ambSettingsLabel(settings);
    });
  }

  function ambModuleSettings(module, state) {
    var settings = cloneAmbSettings(state.settings);
    module.querySelectorAll('[data-vt-amb-override]').forEach(function (field) {
      var name = field.getAttribute('data-vt-amb-override');
      if (name !== 'customDuration' && field.value) settings[name] = field.value;
    });
    var durationField = module.querySelector('[data-vt-amb-override="duration"]');
    if (durationField && durationField.value) {
      if (durationField.value === 'custom') {
        var custom = module.querySelector('[data-vt-amb-override="customDuration"]');
        settings.duration = Math.max(10, parseInt(custom ? custom.value : '', 10) || state.settings.duration);
      } else {
        settings.duration = parseInt(durationField.value, 10) || state.settings.duration;
      }
    }
    return settings;
  }

  function ambSettingsLabel(settings) {
    return 'Target size ' + settings.targetSize + ' | Contrast ' + settings.contrast + ' | Crowding ' + settings.crowding + ' | Speed ' + settings.speed + ' | Duration ' + settings.duration + 's';
  }

  function ambControlValue(root, selector, fallback) {
    var field = root.querySelector(selector);
    return field && field.value ? field.value : fallback;
  }

  function ambSetupValue(app, name) {
    var setup = app.querySelector('[data-vt-amb-module="setup"]');
    return ambFieldValue(setup, name);
  }

  function ambFieldValue(module, name) {
    if (!module) return '';
    var field = module.querySelector('[data-vt-amb-field="' + name + '"]');
    return field ? String(field.value || '').trim() : '';
  }

  function ambValueOrBlank(value) {
    return value || '__';
  }

  function toggleAmbRun(app, state, module) {
    var runtime = ensureAmbRuntime(module);
    var type = module.getAttribute('data-vt-amb-module');
    var game = module._vtAmbGame;
    if (runtime.active || (game && game.running) || runtime.preparing) {
      pauseAmbActivity(state, module);
      return;
    }
    if (runtime.hasStarted && runtime.paused) {
      runtime.paused = false;
      if (type.indexOf('game-') === 0) startAmbGame(app, state, module);
      else startAmbTimer(app, state, module, type === 'target-tap' || type === 'dichoptic-catch');
      return;
    }
    startAmbActivity(app, state, module);
  }

  function setAmbRunButton(module, stateName) {
    if (!module) return;
    var button = module.querySelector('[data-vt-amb-run]');
    if (!button) return;
    button.textContent = stateName === 'running' ? 'Pause' : stateName === 'paused' ? 'Resume' : 'Start';
    button.setAttribute('aria-pressed', stateName === 'running' ? 'true' : 'false');
  }

  function showAmbTapFeedback(stage, event, correct, label) {
    if (!stage) return;
    var rect = stage.getBoundingClientRect();
    var x = event && Number.isFinite(event.clientX) ? event.clientX - rect.left : rect.width / 2;
    var y = event && Number.isFinite(event.clientY) ? event.clientY - rect.top : rect.height / 2;
    var feedback = document.createElement('span');
    feedback.className = 'vt-amb-tap-feedback ' + (correct ? 'vt-amb-feedback-correct' : 'vt-amb-feedback-miss');
    feedback.style.left = x + 'px';
    feedback.style.top = y + 'px';
    feedback.textContent = label || (correct ? '+1' : 'miss');
    stage.appendChild(feedback);
    window.setTimeout(function () { feedback.remove(); }, 650);
  }

  function showAmbElementFeedback(stage, element, correct, label) {
    if (!stage || !element) return;
    var stageRect = stage.getBoundingClientRect();
    var elementRect = element.getBoundingClientRect();
    showAmbTapFeedback(stage, { clientX: elementRect.left + elementRect.width / 2, clientY: elementRect.top + elementRect.height / 2 }, correct, label);
  }

  function playAmbSound(state, kind) {
    if (!state || !state.sound) return;
    var AudioCtor = window.AudioContext || window.webkitAudioContext;
    if (!AudioCtor) return;
    if (!state.audioContext) state.audioContext = new AudioCtor();
    var context = state.audioContext;
    if (context.state === 'suspended') context.resume();
    var tones = kind === 'miss' ? [190] : kind === 'level' ? [440, 554, 659] : kind === 'star' ? [659, 784, 988] : [620];
    tones.forEach(function (frequency, index) {
      var oscillator = context.createOscillator();
      var gain = context.createGain();
      var start = context.currentTime + index * 0.08;
      oscillator.type = kind === 'miss' ? 'triangle' : 'sine';
      oscillator.frequency.value = frequency;
      gain.gain.setValueAtTime(0.0001, start);
      gain.gain.exponentialRampToValueAtTime(0.055, start + 0.012);
      gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.12);
      oscillator.connect(gain);
      gain.connect(context.destination);
      oscillator.start(start);
      oscillator.stop(start + 0.13);
    });
  }

  function updateAmbFieldValueLabel(field) {
    if (!field || !field.getAttribute) return;
    var name = field.getAttribute('data-vt-amb-field');
    var module = field.closest('[data-vt-amb-module]');
    if (!name || !module) return;
    var output = module.querySelector('[data-vt-amb-field-value="' + name + '"]');
    if (output) output.textContent = field.value + (name.toLowerCase().indexOf('contrast') >= 0 || name === 'stereoSize' ? '%' : '');
  }

  function chooseAmbResponse(app, state, module, button) {
    if (!module || !button) return;
    var fieldName = button.getAttribute('data-vt-action') === 'amb-builder-response' ? 'builderResponse' : 'fusionResponse';
    var field = module.querySelector('[data-vt-amb-field="' + fieldName + '"]');
    if (field) field.value = button.getAttribute('data-vt-value') || '';
    button.parentNode.querySelectorAll('button').forEach(function (item) { item.classList.toggle('vt-amb-is-selected', item === button); });
    updateAmbOutput(app, state, module);
  }

  function startAmbActivity(app, state, module) {
    var type = module.getAttribute('data-vt-amb-module');
    var runtime = ensureAmbRuntime(module);
    runtime.hasStarted = true;
    runtime.paused = false;
    applyAmbModuleSettings(module, state);
    if (type === 'target-tap') {
      runtime.elapsed = 0;
      setAmbCount(module, 'hits', 0); setAmbCount(module, 'misses', 0); setAmbCount(module, 'falseTaps', 0); setAmbCount(module, 'reaction', '__');
      ensureAmbRuntime(module).active = true;
      moveAmbTapTarget(module, false);
      startAmbTimer(app, state, module, true);
    } else if (type === 'letter-hunt') {
      generateAmbLetterHunt(module, state);
      startAmbTimer(app, state, module, false);
    } else if (type === 'fine-detail') {
      var matchRuntime = ensureAmbRuntime(module);
      matchRuntime.elapsed = 0;
      matchRuntime.active = true;
      setAmbCount(module, 'round', 0);
      setAmbCount(module, 'correct', 0);
      setAmbCount(module, 'errors', 0);
      updateAmbTime(module, 0);
      generateAmbMatch(module);
      startAmbTimer(app, state, module, false);
    } else if (type === 'dichoptic-catch') {
      runtime.elapsed = 0;
      setAmbCount(module, 'hits', 0); setAmbCount(module, 'misses', 0);
      setAmbCount(module, 'level', 1);
      generateAmbCatchField(module);
      moveAmbCatchTarget(module, false);
      startAmbTimer(app, state, module, true);
    } else if (type === 'two-eye-builder') {
      renderRandomAmbBuilder(module);
    } else if (type === 'dichoptic-maze') {
      var mazeRuntime = ensureAmbRuntime(module);
      mazeRuntime.elapsed = 0;
      mazeRuntime.mazeLevel = mazeRuntime.mazeLevel || parseInt(ambCount(module, 'level'), 10) || 1;
      setAmbCount(module, 'level', mazeRuntime.mazeLevel);
      generateAmbMaze(module);
      showAmbLevelBanner(module, 'Level ' + mazeRuntime.mazeLevel);
      startAmbTimer(app, state, module, false);
    } else if (type === 'balance-dots') {
      var dotsRuntime = ensureAmbRuntime(module);
      dotsRuntime.dotsLevel = dotsRuntime.dotsLevel || parseInt(ambCount(module, 'level'), 10) || 1;
      dotsRuntime.elapsed = 0;
      dotsRuntime.active = true;
      setAmbCount(module, 'level', dotsRuntime.dotsLevel);
      renderAmbDots(module, state);
      updateAmbTime(module, 0);
      showAmbLevelBanner(module, 'Level ' + dotsRuntime.dotsLevel);
      startAmbTimer(app, state, module, false);
    } else if (type.indexOf('game-') === 0) {
      startAmbGame(app, state, module);
    }
    if (type !== 'two-eye-builder') setAmbRunButton(module, 'running');
    updateAmbOutput(app, state, module);
  }

  function ensureAmbRuntime(module) {
    if (!module._vtAmb) module._vtAmb = { active: false, elapsed: 0, startedAt: 0, targetShownAt: 0, lastMoveAt: 0 };
    return module._vtAmb;
  }

  function startAmbTimer(app, state, module, moving) {
    pauseAmbActivity(state, module);
    var runtime = ensureAmbRuntime(module);
    var settings = ambModuleSettings(module, state);
    runtime.active = true;
    runtime.hasStarted = true;
    runtime.paused = false;
    setAmbRunButton(module, 'running');
    runtime.startedAt = Date.now() - runtime.elapsed * 1000;
    runtime.lastMoveAt = Date.now();
    var speedMs = { 'very slow': 3200, slow: 2300, medium: 1500, fast: 900 }[settings.speed] || 1500;
    var interval = window.setInterval(function () {
      runtime.elapsed = Math.floor((Date.now() - runtime.startedAt) / 1000);
      updateAmbTime(module, runtime.elapsed);
      var level = Math.max(1, parseInt(ambCount(module, 'level'), 10) || 1);
      var currentSpeedMs = speedMs / Math.min(2, 1 + (level - 1) * 0.12);
      if (moving && Date.now() - runtime.lastMoveAt >= currentSpeedMs) {
        if (module.getAttribute('data-vt-amb-module') === 'target-tap') {
          incrementAmbCount(module, 'misses', 1);
          showAmbElementFeedback(module.querySelector('[data-vt-amb-stage]'), module.querySelector('[data-vt-action="amb-target-hit"]'), false, 'miss');
          moveAmbTapTarget(module, true);
        } else {
          incrementAmbCount(module, 'misses', 1);
          showAmbElementFeedback(module.querySelector('[data-vt-amb-stage]'), module.querySelector('[data-vt-action="amb-catch-hit"]'), false, 'miss');
          moveAmbCatchTarget(module, true);
        }
        playAmbSound(state, 'miss');
        runtime.lastMoveAt = Date.now();
      }
      updateAmbOutput(app, state, module);
      if (runtime.elapsed >= settings.duration) completeAmbTimedActivity(app, state, module);
    }, 250);
    state.timers.set(module, interval);
  }

  function completeAmbTimedActivity(app, state, module) {
    var type = module.getAttribute('data-vt-amb-module');
    var runtime = ensureAmbRuntime(module);
    pauseAmbActivity(state, module);
    if (type === 'letter-hunt') finishAmbLetterHunt(module);
    updateAmbOutput(app, state, module);
    var message = 'Great work! Finished in ' + runtime.elapsed + ' seconds.';
    if (type === 'target-tap') message += ' ' + ambCount(module, 'hits') + ' targets caught with ' + ambCount(module, 'misses') + ' misses.';
    if (type === 'dichoptic-catch') message += ' ' + ambCount(module, 'hits') + ' catches with ' + ambCount(module, 'misses') + ' misses.';
    if (type === 'fine-detail') message += ' ' + ambCount(module, 'correct') + ' correct from ' + ambCount(module, 'round') + ' rounds.';
    if (type === 'letter-hunt') message += ' ' + ambCount(module, 'found') + ' found with ' + ambCount(module, 'falsePositives') + ' false taps.';
    showAmbCompletion(app, state, module, 'Activity Complete', message, 'Play Again');
  }

  function showAmbCompletion(app, state, module, title, message, nextLabel) {
    var dialog = app.querySelector('[data-vt-amb-complete-dialog]');
    if (!dialog) return;
    var titleOutput = dialog.querySelector('[data-vt-amb-complete-title]');
    var messageOutput = dialog.querySelector('[data-vt-amb-complete-message]');
    var next = dialog.querySelector('[data-vt-amb-complete-next]');
    var stars = dialog.querySelector('[data-vt-amb-stars]');
    if (titleOutput) titleOutput.textContent = title || 'Activity Complete';
    if (messageOutput) messageOutput.textContent = message || 'Great work.';
    if (next) {
      next.hidden = !nextLabel;
      next.textContent = nextLabel || 'Next Level';
    }
    var rating = ambPerformanceStars(module);
    if (stars) {
      stars.textContent = '★★★'.slice(0, rating) + '☆☆☆'.slice(0, 3 - rating);
      stars.setAttribute('aria-label', rating + ' out of 3 game performance stars');
    }
    if (module) {
      var runtime = ensureAmbRuntime(module);
      runtime.hasStarted = false;
      runtime.paused = false;
      setAmbRunButton(module, 'start');
      playAmbSound(state, rating === 3 ? 'star' : 'correct');
    }
    state.completionModule = module || null;
    if (dialog.open && dialog.close) dialog.close();
    if (dialog.showModal) dialog.showModal();
    else dialog.setAttribute('open', '');
  }

  function ambPerformanceStars(module) {
    if (!module) return 1;
    var type = module.getAttribute('data-vt-amb-module');
    var score = parseInt(ambCount(module, 'score'), 10) || parseInt(ambCount(module, 'hits'), 10) || parseInt(ambCount(module, 'correct'), 10) || parseInt(ambCount(module, 'found'), 10) || parseInt(ambCount(module, 'correctMoves'), 10) || parseInt(ambCount(module, 'dotsCleared'), 10) || 0;
    var errors = (parseInt(ambCount(module, 'errors'), 10) || 0) + (parseInt(ambCount(module, 'misses'), 10) || 0) + (parseInt(ambCount(module, 'falsePositives'), 10) || 0) + (parseInt(ambCount(module, 'wrongSlices'), 10) || 0);
    var thresholds = {
      'game-sky-flight': [3, 10], 'game-colour-snake': [2, 7], 'game-road-crossing': [1, 4], 'game-dino-dash': [3, 10], 'game-fruit-slice': [8, 20],
      'target-tap': [8, 18], 'dichoptic-catch': [8, 18], 'fine-detail': [5, 8], 'letter-hunt': [4, 7], 'dichoptic-maze': [1, 3]
    }[type] || [4, 10];
    var rating = score >= thresholds[1] ? 3 : score >= thresholds[0] ? 2 : 1;
    var level = parseInt(ambCount(module, 'level'), 10) || 1;
    var accuracy = score + errors > 0 ? score / (score + errors) : 0;
    if (level >= 3 && accuracy >= 0.7) rating = Math.min(3, rating + 1);
    if (accuracy > 0 && accuracy < 0.55) rating = Math.max(1, rating - 1);
    if (errors > Math.max(3, score)) rating = Math.max(1, rating - 1);
    return rating;
  }

  function closeAmbCompletion(app, state) {
    var dialog = app.querySelector('[data-vt-amb-complete-dialog]');
    if (dialog) {
      if (dialog.open && dialog.close) dialog.close();
      else dialog.removeAttribute('open');
    }
    state.completionModule = null;
  }

  function showAmbLevelBanner(module, text) {
    if (!module) return;
    var old = module.querySelector('[data-vt-amb-level-banner]');
    if (old) old.remove();
    var banner = document.createElement('div');
    banner.className = 'vt-amb-level-banner';
    banner.setAttribute('data-vt-amb-level-banner', '');
    banner.textContent = text;
    var stage = module.querySelector('[data-vt-amb-stage]') || module;
    if (stage.tagName === 'CANVAS') {
      module.appendChild(banner);
      banner.style.bottom = 'auto';
      banner.style.top = Math.max(12, stage.offsetTop + stage.offsetHeight - 64) + 'px';
    } else stage.appendChild(banner);
    playAmbSound((module.closest('[data-vt-app]') || {})._vtAmbState, 'level');
    window.setTimeout(function () { banner.classList.add('vt-amb-level-banner-hide'); }, 1200);
    window.setTimeout(function () { if (banner.parentNode) banner.remove(); }, 1650);
  }

  function pauseAmbActivity(state, module) {
    if (!module) return;
    var interval = state.timers.get(module);
    if (interval && typeof interval === 'object') {
      if (interval.kind === 'frame') window.cancelAnimationFrame(interval.id);
      if (interval.kind === 'timeout') window.clearTimeout(interval.id);
    } else if (interval) window.clearInterval(interval);
    state.timers.delete(module);
    var runtime = ensureAmbRuntime(module);
    runtime.active = false;
    runtime.preparing = false;
    runtime.paused = !!runtime.hasStarted;
    if (module._vtAmbGame) {
      module._vtAmbGame.running = false;
      if (module._vtAmbGame.prepareTimeout) window.clearTimeout(module._vtAmbGame.prepareTimeout);
    }
    setAmbRunButton(module, runtime.paused ? 'paused' : 'start');
  }

  function updateAmbTime(module, seconds) {
    var output = module.querySelector('[data-vt-amb-time]');
    if (output) output.textContent = seconds + 's';
  }

  function moveAmbTapTarget(module, keepGlyph) {
    var target = module.querySelector('[data-vt-action="amb-target-hit"]');
    var stage = module.querySelector('[data-vt-amb-stage]');
    if (!target || !stage) return;
    var type = ambFieldValue(module, 'targetType') || 'letters';
    var sets = {
      letters: ['A', 'H', 'K', 'M', 'S', 'T'],
      numbers: ['2', '4', '5', '7', '8', '9'],
      shapes: ['●', '■', '▲', '◆', '★'],
      'animals / emoji': ['🐶', '🐱', '🐰', '🐸', '🦋']
    };
    if (!keepGlyph) target.textContent = ambRandom(sets[type] || sets.letters);
    target.style.left = (8 + Math.random() * 76) + '%';
    target.style.top = (10 + Math.random() * 68) + '%';
    target.hidden = false;
    var runtime = ensureAmbRuntime(module);
    runtime.targetShownAt = Date.now();
    runtime.lastMoveAt = Date.now();
    var message = module.querySelector('[data-vt-amb-stage-message]');
    if (message) message.textContent = '';
  }

  function hitAmbTapTarget(app, state, module, event) {
    var runtime = ensureAmbRuntime(module);
    if (!runtime.active) return;
    incrementAmbCount(module, 'hits', 1);
    showAmbTapFeedback(module.querySelector('[data-vt-amb-stage]'), event, true, '+1');
    playAmbSound(state, 'correct');
    var reaction = Math.max(0, Date.now() - runtime.targetShownAt);
    setAmbCount(module, 'reaction', reaction + ' ms');
    moveAmbTapTarget(module, false);
    updateAmbOutput(app, state, module);
  }

  function generateAmbLetterHunt(module) {
    var grid = module.querySelector('[data-vt-amb-stage]');
    var targetOutput = module.querySelector('[data-vt-amb-target-letter]');
    if (!grid) return;
    var target = ambRandom(['A', 'E', 'F', 'H', 'K', 'M', 'N', 'R']);
    var letters = ['A', 'E', 'F', 'H', 'K', 'M', 'N', 'R', 'P', 'B', 'D', 'G', 'Q', 'T'];
    var settings = module.getAttribute('data-vt-amb-crowding') || 'mild';
    var total = settings === 'crowded' ? 60 : settings === 'moderate' ? 48 : 40;
    var targetTotal = Math.max(5, Math.round(total * 0.18));
    var items = [];
    for (var i = 0; i < total; i += 1) items.push(i < targetTotal ? target : ambRandom(letters.filter(function (letter) { return letter !== target; })));
    items = ambShuffle(items);
    grid.innerHTML = '';
    items.forEach(function (letter) {
      var button = document.createElement('button');
      button.type = 'button';
      button.textContent = letter;
      button.className = 'vt-amb-letter-cell';
      button.setAttribute('data-vt-action', 'amb-letter-cell');
      button.setAttribute('data-vt-target', letter === target ? 'true' : 'false');
      grid.appendChild(button);
    });
    if (targetOutput) targetOutput.textContent = target;
    module.setAttribute('data-vt-amb-target-total', String(targetTotal));
    setAmbCount(module, 'found', 0);
    setAmbCount(module, 'missed', 0);
    setAmbCount(module, 'falsePositives', 0);
    var runtime = ensureAmbRuntime(module);
    runtime.elapsed = 0;
    runtime.active = true;
    updateAmbTime(module, 0);
  }

  function chooseAmbLetter(app, state, module, button, event) {
    var runtime = ensureAmbRuntime(module);
    if (!runtime.active || button.disabled) return;
    if (button.getAttribute('data-vt-target') === 'true') {
      incrementAmbCount(module, 'found', 1);
      button.classList.add('vt-amb-is-found');
      showAmbTapFeedback(module.querySelector('[data-vt-amb-stage]'), event, true, '+1');
      playAmbSound(state, 'correct');
    } else {
      incrementAmbCount(module, 'falsePositives', 1);
      button.classList.add('vt-amb-is-error');
      showAmbTapFeedback(module.querySelector('[data-vt-amb-stage]'), event, false, 'miss');
      playAmbSound(state, 'miss');
    }
    button.disabled = true;
    var total = parseInt(module.getAttribute('data-vt-amb-target-total') || '0', 10);
    var found = parseInt(ambCount(module, 'found'), 10) || 0;
    if (found >= total) {
      pauseAmbActivity(state, module);
      finishAmbLetterHunt(module);
      updateAmbOutput(app, state, module);
      showAmbCompletion(app, state, module, 'Letter Hunt Complete', 'Brilliant spotting! You found all ' + found + ' target letters in ' + runtime.elapsed + ' seconds with ' + ambCount(module, 'falsePositives') + ' false taps.', 'Play Again');
    }
    updateAmbOutput(app, state, module);
  }

  function finishAmbLetterHunt(module) {
    var total = parseInt(module.getAttribute('data-vt-amb-target-total') || '0', 10);
    var found = parseInt(ambCount(module, 'found'), 10) || 0;
    setAmbCount(module, 'missed', Math.max(0, total - found));
  }

  function generateAmbMatch(module) {
    var target = module.querySelector('[data-vt-amb-match-target]');
    var options = module.querySelector('[data-vt-amb-match-options]');
    if (!target || !options) return;
    var groups = [
      ['▲', '△', '▶', '◀'],
      ['E', 'F', 'Ǝ', 'P'],
      ['◆', '◇', '◈', '■'],
      ['→', '←', '↗', '⇒']
    ];
    var group = ambRandom(groups);
    target.textContent = group[0];
    options.innerHTML = '';
    ambShuffle(group.slice()).forEach(function (glyph) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'vt-amb-match-choice';
      button.textContent = glyph;
      button.setAttribute('data-vt-action', 'amb-match-choice');
      button.setAttribute('data-vt-correct', glyph === group[0] ? 'true' : 'false');
      options.appendChild(button);
    });
  }

  function chooseAmbMatch(app, state, module, button, event) {
    var runtime = ensureAmbRuntime(module);
    if (!runtime.active || button.disabled) return;
    module.querySelectorAll('[data-vt-action="amb-match-choice"]').forEach(function (choice) { choice.disabled = true; });
    var correct = button.getAttribute('data-vt-correct') === 'true';
    incrementAmbCount(module, correct ? 'correct' : 'errors', 1);
    incrementAmbCount(module, 'round', 1);
    button.classList.add(correct ? 'vt-amb-is-found' : 'vt-amb-is-error');
    showAmbTapFeedback(module.querySelector('[data-vt-amb-stage]'), event, correct, correct ? '+1' : 'miss');
    playAmbSound(state, correct ? 'correct' : 'miss');
    if ((parseInt(ambCount(module, 'round'), 10) || 0) >= 10) {
      pauseAmbActivity(state, module);
      updateAmbOutput(app, state, module);
      showAmbCompletion(app, state, module, 'Fine Detail Match Complete', 'Excellent looking! 10 rounds finished in ' + runtime.elapsed + ' seconds. Correct: ' + ambCount(module, 'correct') + '. Errors: ' + ambCount(module, 'errors') + '.', 'Play Again');
    } else {
      window.setTimeout(function () { if (runtime.active) generateAmbMatch(module); }, 450);
    }
    updateAmbOutput(app, state, module);
  }

  function generateAmbCatchField(module) {
    var field = module.querySelector('[data-vt-amb-fellow-field]');
    if (!field) return;
    field.innerHTML = '';
    for (var i = 0; i < 18; i += 1) {
      var dot = document.createElement('span');
      dot.style.left = (3 + Math.random() * 92) + '%';
      dot.style.top = (4 + Math.random() * 88) + '%';
      field.appendChild(dot);
    }
  }

  function moveAmbCatchTarget(module) {
    var target = module.querySelector('[data-vt-action="amb-catch-hit"]');
    if (!target) return;
    target.style.left = (8 + Math.random() * 76) + '%';
    target.style.top = (10 + Math.random() * 68) + '%';
    target.hidden = false;
    var runtime = ensureAmbRuntime(module);
    runtime.targetShownAt = Date.now();
    runtime.lastMoveAt = Date.now();
  }

  function hitAmbCatchTarget(app, state, module, event) {
    var runtime = ensureAmbRuntime(module);
    if (!runtime.active) return;
    incrementAmbCount(module, 'hits', 1);
    var hits = parseInt(ambCount(module, 'hits'), 10) || 0;
    var nextLevel = 1 + Math.floor(hits / 10);
    if (nextLevel > (parseInt(ambCount(module, 'level'), 10) || 1)) {
      setAmbCount(module, 'level', nextLevel);
      showAmbLevelBanner(module, 'Level ' + nextLevel + ' — targets moving faster');
    }
    showAmbTapFeedback(module.querySelector('[data-vt-amb-stage]'), event, true, '+1');
    playAmbSound(state, 'correct');
    moveAmbCatchTarget(module);
    updateAmbOutput(app, state, module);
  }

  function renderAmbBuilder(module) {
    if (!module) return;
    var svg = module.querySelector('[data-vt-amb-builder-svg]');
    if (!svg) return;
    var image = ambFieldValue(module, 'imageType') || 'house';
    var images = {
      house: '<g class="vt-amb-builder-red"><path d="M92 145 L210 55 L328 145"></path><path d="M132 132 L132 238"></path></g><g class="vt-amb-builder-green"><path d="M132 132 H288 V238 H132 Z"></path><path d="M188 238 V180 H235 V238 M252 157 H275 V184 H252 Z"></path></g>',
      star: '<g class="vt-amb-builder-red"><path d="M210 42 L236 118 L318 120 L252 169"></path></g><g class="vt-amb-builder-green"><path d="M252 169 L275 250 L210 202 L145 250 L168 169 L102 120 L184 118 L210 42"></path></g>',
      'smiley face': '<g class="vt-amb-builder-red"><path d="M210 52 A98 98 0 0 0 210 248"></path><circle cx="172" cy="125" r="9"></circle></g><g class="vt-amb-builder-green"><path d="M210 52 A98 98 0 0 1 210 248"></path><circle cx="248" cy="125" r="9"></circle><path d="M160 178 Q210 224 260 178"></path></g>',
      butterfly: '<g class="vt-amb-builder-red"><path d="M202 145 Q112 42 88 122 Q76 190 190 180"></path><circle cx="202" cy="124" r="10"></circle></g><g class="vt-amb-builder-green"><path d="M218 145 Q308 42 332 122 Q344 190 230 180"></path><path d="M210 105 V215 M210 105 Q190 72 177 62 M210 105 Q230 72 243 62"></path></g>',
      'simple animal': '<g class="vt-amb-builder-red"><path d="M115 150 Q112 90 172 92 L192 60 L207 96"></path><circle cx="164" cy="128" r="7"></circle><path d="M110 148 Q78 128 70 104"></path></g><g class="vt-amb-builder-green"><path d="M207 96 L232 60 L248 98 Q306 106 302 166 Q284 220 188 214 Q116 210 115 150"></path><circle cx="238" cy="128" r="7"></circle><path d="M158 214 V250 M255 210 V250"></path></g>',
      'geometric pattern': '<g class="vt-amb-builder-red"><path d="M95 150 L155 72 L210 150 L155 228 Z"></path><circle cx="155" cy="150" r="28"></circle></g><g class="vt-amb-builder-green"><path d="M210 150 L265 72 L325 150 L265 228 Z"></path><circle cx="265" cy="150" r="28"></circle><path d="M155 150 H265"></path></g>'
    };
    svg.innerHTML = images[image] || images.star;
  }

  function renderRandomAmbBuilder(module) {
    if (!module) return;
    var field = module.querySelector('[data-vt-amb-field="imageType"]');
    if (field && field.options.length > 1) {
      var current = field.selectedIndex;
      var next = current;
      while (next === current) next = Math.floor(Math.random() * field.options.length);
      field.selectedIndex = next;
    }
    renderAmbBuilder(module);
  }

  function generateAmbMaze(module) {
    var grid = module.querySelector('[data-vt-amb-stage]');
    if (!grid) return;
    grid.innerHTML = '';
    var difficulty = ambFieldValue(module, 'difficulty') || 'medium';
    var level = ensureAmbRuntime(module).mazeLevel || 1;
    var rows = Math.min(10, (difficulty === 'hard' ? 8 : difficulty === 'easy' ? 5 : 6) + Math.floor((level - 1) / 3));
    var cols = Math.min(12, (difficulty === 'hard' ? 10 : difficulty === 'easy' ? 7 : 8) + Math.floor((level - 1) / 2));
    var path = {};
    var pathOrder = [];
    var routeRow = Math.floor(Math.random() * rows);
    for (var routeCol = 0; routeCol < cols; routeCol += 1) {
      var routeKey = routeRow + '-' + routeCol;
      if (!path[routeKey]) pathOrder.push(routeKey);
      path[routeKey] = true;
      if (routeCol < cols - 1) {
        var nextRow = Math.max(0, Math.min(rows - 1, routeRow + ambRandom([-1, 0, 1])));
        if (nextRow !== routeRow) {
          var connectorKey = nextRow + '-' + routeCol;
          if (!path[connectorKey]) pathOrder.push(connectorKey);
          path[connectorKey] = true;
        }
        routeRow = nextRow;
      }
    }
    var targets = {};
    pathOrder.forEach(function (key, index) { if (index > 1 && index < pathOrder.length - 1 && index % 3 === 0) targets[key] = true; });
    var orderByKey = {};
    pathOrder.forEach(function (key, index) { orderByKey[key] = index; });
    grid.style.setProperty('--vt-amb-maze-cols', String(cols));
    for (var r = 0; r < rows; r += 1) {
      for (var c = 0; c < cols; c += 1) {
        var key = r + '-' + c;
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'vt-amb-maze-cell' + (path[key] ? ' vt-amb-is-path' : '');
        button.setAttribute('data-vt-action', 'amb-maze-cell');
        button.setAttribute('data-vt-target', targets[key] ? 'true' : 'false');
        button.setAttribute('data-vt-order', path[key] ? String(orderByKey[key]) : '-1');
        button.setAttribute('aria-label', targets[key] ? 'Collect target' : (path[key] ? 'Next path cell' : 'Maze wall'));
        button.textContent = key === pathOrder[0] ? 'S' : key === pathOrder[pathOrder.length - 1] ? 'F' : targets[key] ? '●' : '';
        grid.appendChild(button);
      }
    }
    module.setAttribute('data-vt-amb-target-total', String(Object.keys(targets).length));
    setAmbCount(module, 'collected', 0);
    setAmbCount(module, 'errors', 0);
    var runtime = ensureAmbRuntime(module);
    runtime.active = true;
    runtime.mazeExpected = 0;
    setAmbCount(module, 'correctMoves', 0);
    var first = grid.querySelector('[data-vt-order="0"]');
    if (first) first.classList.add('vt-amb-is-current');
  }

  function chooseAmbMazeCell(app, state, module, button, event) {
    var runtime = ensureAmbRuntime(module);
    if (!runtime.active || button.disabled) return;
    var order = parseInt(button.getAttribute('data-vt-order') || '-1', 10);
    if (order === runtime.mazeExpected) {
      button.classList.remove('vt-amb-is-error');
      button.classList.add('vt-amb-is-collected');
      button.disabled = true;
      incrementAmbCount(module, 'correctMoves', 1);
      module.querySelectorAll('.vt-amb-is-current').forEach(function (cell) { cell.classList.remove('vt-amb-is-current'); });
      var next = module.querySelector('[data-vt-order="' + (runtime.mazeExpected + 1) + '"]');
      if (next) next.classList.add('vt-amb-is-current');
      showAmbTapFeedback(module.querySelector('[data-vt-amb-stage]'), event, true, '+1');
      playAmbSound(state, 'correct');
      if (button.getAttribute('data-vt-target') === 'true') incrementAmbCount(module, 'collected', 1);
      runtime.mazeExpected += 1;
      var remaining = module.querySelectorAll('.vt-amb-maze-cell.vt-amb-is-path:not(:disabled)').length;
      if (!remaining) {
        var completedLevel = runtime.mazeLevel || 1;
        runtime.mazeLevel = completedLevel + 1;
        setAmbCount(module, 'level', runtime.mazeLevel);
        updateAmbOutput(app, state, module);
        showAmbLevelBanner(module, 'Level ' + runtime.mazeLevel + ' — maze getting harder');
        window.setTimeout(function () { if (runtime.active) generateAmbMaze(module); }, 700);
      }
    } else {
      incrementAmbCount(module, 'errors', 1);
      button.classList.add('vt-amb-is-error');
      showAmbTapFeedback(module.querySelector('[data-vt-amb-stage]'), event, false, 'miss');
      playAmbSound(state, 'miss');
    }
    updateAmbOutput(app, state, module);
  }

  function renderAmbDots(module) {
    if (!module) return;
    var stage = module.querySelector('[data-vt-amb-stage]');
    if (!stage) return;
    stage.querySelectorAll('.vt-amb-dot').forEach(function (dot) { dot.remove(); });
    var level = ensureAmbRuntime(module).dotsLevel || 1;
    var redCount = Math.max(1, Math.min(20, (parseInt(ambFieldValue(module, 'redDots'), 10) || 6) + level - 1));
    var greenCount = Math.max(1, Math.min(20, (parseInt(ambFieldValue(module, 'greenDots'), 10) || 6) + level - 1));
    var size = Math.max(16, (parseInt(ambFieldValue(module, 'dotSize'), 10) || 34) - (level - 1) * 2);
    addAmbDots(stage, redCount, 'vt-amb-is-red', size);
    addAmbDots(stage, greenCount, 'vt-amb-is-green', size);
    setAmbCount(module, 'dotsCleared', 0);
    setAmbCount(module, 'dotsRemaining', redCount + greenCount);
  }

  function addAmbDots(stage, count, colourClass, size) {
    for (var i = 0; i < count; i += 1) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'vt-amb-dot ' + colourClass;
      dot.setAttribute('data-vt-action', 'amb-dot-click');
      dot.setAttribute('aria-label', colourClass.indexOf('red') >= 0 ? 'Red dot' : 'Green dot');
      dot.style.width = size + 'px';
      dot.style.height = size + 'px';
      dot.style.left = (4 + Math.random() * 88) + '%';
      dot.style.top = (5 + Math.random() * 82) + '%';
      stage.appendChild(dot);
    }
  }

  function clearAmbDot(app, state, module, dot, event) {
    var runtime = ensureAmbRuntime(module);
    if (!dot || dot.disabled || !runtime.active) return;
    dot.disabled = true;
    dot.classList.add('vt-amb-is-cleared');
    showAmbTapFeedback(module.querySelector('[data-vt-amb-stage]'), event, true, '+1');
    playAmbSound(state, 'correct');
    incrementAmbCount(module, 'dotsCleared', 1);
    setAmbCount(module, 'dotsRemaining', Math.max(0, parseInt(ambCount(module, 'dotsRemaining'), 10) - 1));
    window.setTimeout(function () { dot.remove(); }, 180);
    if ((parseInt(ambCount(module, 'dotsRemaining'), 10) || 0) === 0) {
      var completedLevel = runtime.dotsLevel || 1;
      runtime.dotsLevel = completedLevel + 1;
      setAmbCount(module, 'level', runtime.dotsLevel);
      updateAmbOutput(app, state, module);
      showAmbLevelBanner(module, 'Level ' + runtime.dotsLevel + ' — more dots');
      window.setTimeout(function () { if (runtime.active) renderAmbDots(module); }, 650);
    }
    updateAmbOutput(app, state, module);
  }

  function toggleAmbDepth(module, button) {
    var stage = module.querySelector('[data-vt-amb-stage]');
    var depth = module.querySelector('[data-vt-amb-depth-image]');
    if (!stage) return;
    var showing = stage.classList.toggle('vt-amb-show-depth');
    if (button) {
      button.textContent = showing ? 'Show Four-Dot View' : 'Show Stereo Gallery';
      button.setAttribute('aria-pressed', showing ? 'true' : 'false');
    }
    if (depth) depth.setAttribute('aria-hidden', showing ? 'false' : 'true');
  }

  function renderAmbStereo(module) {
    if (!module) return;
    var svg = module.querySelector('[data-vt-amb-stereo-svg]');
    if (!svg) return;
    var image = ambFieldValue(module, 'stereoImage') || 'cat';
    var depth = parseInt(ambFieldValue(module, 'stereoDepth'), 10) || 0;
    var redContrast = (parseInt(ambFieldValue(module, 'stereoRedContrast'), 10) || 90) / 100;
    var greenContrast = (parseInt(ambFieldValue(module, 'stereoGreenContrast'), 10) || 90) / 100;
    var app = module.closest('[data-vt-app]');
    redContrast *= parseInt(ambControlValue(app, '[data-vt-amb-global="redVisibility"]', '100'), 10) / 100;
    greenContrast *= parseInt(ambControlValue(app, '[data-vt-amb-global="greenVisibility"]', '100'), 10) / 100;
    var size = (parseInt(ambFieldValue(module, 'stereoSize'), 10) || 100) / 100;
    var shapes = {
      cat: '<path d="M126 117 L145 72 L176 105 Q210 88 244 105 L276 72 L291 124 Q311 172 278 213 Q231 247 164 222 Q113 202 118 153 Q118 133 126 117 Z"></path><path d="M160 142 Q176 127 191 142 M229 142 Q244 127 260 142 M195 169 Q210 183 225 169 M210 180 V196"></path><path d="M277 198 Q348 181 330 237 Q318 261 286 238"></path>',
      star: '<path d="M210 47 L238 121 L317 125 L255 174 L275 251 L210 207 L145 251 L165 174 L103 125 L182 121 Z"></path>',
      fish: '<path d="M94 151 Q153 74 263 116 Q300 131 322 151 Q300 171 263 186 Q153 228 94 151 Z"></path><path d="M95 151 L53 103 L58 199 Z"></path><circle cx="267" cy="143" r="7"></circle><path d="M151 111 Q181 151 151 191"></path>',
      butterfly: '<path d="M202 148 Q130 56 74 99 Q49 150 112 180 Q151 196 201 169"></path><path d="M218 148 Q290 56 346 99 Q371 150 308 180 Q269 196 219 169"></path><path d="M210 105 V225 M210 107 Q184 70 163 58 M210 107 Q236 70 257 58"></path>',
      ball: '<circle cx="210" cy="150" r="92"></circle><path d="M126 111 Q210 150 294 111 M126 189 Q210 150 294 189 M210 58 Q170 150 210 242 M210 58 Q250 150 210 242"></path>',
      house: '<path d="M92 146 L210 55 L328 146 L298 146 V244 H122 V146 Z"></path><path d="M181 244 V178 H239 V244 M258 159 H282 V187 H258 Z"></path>',
      rocket: '<path d="M210 48 Q263 93 252 178 L210 231 L168 178 Q157 93 210 48 Z"></path><circle cx="210" cy="132" r="25"></circle><path d="M168 166 L126 220 L176 208 M252 166 L294 220 L244 208 M190 230 L210 276 L230 230"></path>',
      cube: '<path d="M210 56 L306 111 V220 L210 274 L114 220 V111 Z"></path><path d="M114 111 L210 166 L306 111 M210 166 V274"></path>'
    };
    var shape = shapes[image] || shapes.cat;
    var scale = 'translate(210 150) scale(' + size + ') translate(-210 -150)';
    svg.innerHTML = '<g class="vt-amb-stereo-red" opacity="' + redContrast + '" transform="translate(' + (-depth / 2) + ' 0) ' + scale + '">' + shape + '</g><g class="vt-amb-stereo-green" opacity="' + greenContrast + '" transform="translate(' + (depth / 2) + ' 0) ' + scale + '">' + shape + '</g>';
  }

  function resetAmbDepth(module) {
    var stage = module.querySelector('[data-vt-amb-stage]');
    var depth = module.querySelector('[data-vt-amb-depth-image]');
    var button = module.querySelector('[data-vt-action="amb-toggle-depth"]');
    if (stage) stage.classList.remove('vt-amb-show-depth');
    if (depth) depth.setAttribute('aria-hidden', 'true');
    if (button) {
      button.textContent = 'Show Stereo Gallery';
      button.setAttribute('aria-pressed', 'false');
    }
    renderAmbStereo(module);
  }

  function initAmbGame(app, state, module) {
    if (!module) return;
    pauseAmbActivity(state, module);
    var type = module.getAttribute('data-vt-amb-module');
    var game = { type: type, running: false, elapsed: 0, startedAt: 0, app: app, state: state, level: 1, fixedSpeed: false, gameOver: false };
    if (type === 'game-sky-flight') {
      game.y = 210;
      game.velocity = 0;
      game.lastCrash = 0;
      game.cloudOffset = 0;
      game.fx = [];
      game.pipes = [{ x: 540, gap: 155, passed: false }, { x: 880, gap: 260, passed: false }];
    } else if (type === 'game-colour-snake') {
      game.snake = [{ x: 6, y: 7 }, { x: 5, y: 7 }, { x: 4, y: 7 }];
      game.direction = 'right';
      game.nextDirection = 'right';
      game.food = randomAmbFood(game.snake, 24, 14);
    } else if (type === 'game-road-crossing') {
      game.chick = { x: 4, y: 5 };
      game.vehicles = createAmbVehicles();
      game.lastCrash = 0;
    } else if (type === 'game-dino-dash') {
      game.dinoY = 0;
      game.dinoVelocity = 0;
      game.jumpsUsed = 0;
      game.cloudOffset = 0;
      game.fx = [];
      game.obstacles = [{ x: 720, width: 32, height: 58, passed: false }];
    } else if (type === 'game-fruit-slice') {
      game.fruits = [];
      game.fx = [];
      game.trail = [];
      game.spawnElapsed = 0;
      game.slicing = false;
    }
    module._vtAmbGame = game;
    setAmbCount(module, 'level', 1);
    var mode = module.querySelector('[data-vt-amb-game-mode]');
    if (mode) mode.textContent = type === 'game-sky-flight' || type === 'game-dino-dash' ? 'Normal (progressive)' : 'Progressive';
    drawAmbGame(module, game, true);
  }

  function startAmbGame(app, state, module) {
    if (!module._vtAmbGame) initAmbGame(app, state, module);
    var game = module._vtAmbGame;
    var runtime = ensureAmbRuntime(module);
    var resuming = !!runtime.paused && !game.gameOver;
    pauseAmbActivity(state, module);
    if (game.gameOver) resetAmbGameAttempt(module, game);
    if (game.newLevel) {
      game.newLevel = false;
      game.elapsed = 0;
      game.chick = { x: 4, y: 5 };
      game.vehicles = createAmbVehicles();
    }
    var settings = ambModuleSettings(module, state);
    game.gameOver = false;
    runtime.hasStarted = true;
    runtime.paused = false;
    setAmbRunButton(module, 'running');
    if (game.type === 'game-sky-flight' && game.elapsed === 0 && !resuming) {
      runtime.preparing = true;
      drawAmbGame(module, game, false);
      drawAmbGamePrompt(ambGameContext(module), ambGameCanvas(module), 'Level 1 — Get ready');
      game.prepareTimeout = window.setTimeout(function () {
        runtime.preparing = false;
        beginAmbGameLoop(app, state, module, game, settings);
      }, 700);
      state.timers.set(module, { kind: 'timeout', id: game.prepareTimeout });
      return;
    }
    beginAmbGameLoop(app, state, module, game, settings);
  }

  function beginAmbGameLoop(app, state, module, game, settings) {
    var runtime = ensureAmbRuntime(module);
    game.running = true;
    runtime.active = true;
    runtime.paused = false;
    game.startedAt = Date.now() - game.elapsed * 1000;
    game.lastFrameAt = 0;
    game.snakeAccumulator = 0;
    game.lastOutputAt = 0;
    function frame(now) {
      if (!game.running) return;
      var delta = game.lastFrameAt ? Math.min(48, now - game.lastFrameAt) : 16;
      game.lastFrameAt = now;
      var scale = delta / 32;
      var seconds = Math.floor((Date.now() - game.startedAt) / 1000);
      if (seconds !== game.elapsed) {
        game.elapsed = seconds;
        runtime.elapsed = seconds;
        updateAmbTime(module, seconds);
      }
      if (game.type === 'game-sky-flight') tickAmbSky(module, game, settings, scale);
      if (game.type === 'game-colour-snake') {
        game.snakeAccumulator += delta;
        var baseDelay = { 'very slow': 360, slow: 285, medium: 215, fast: 150 }[settings.speed] || 215;
        var snakeDelay = Math.max(90, baseDelay - (parseInt(ambCount(module, 'score'), 10) || 0) * 5);
        if (game.snakeAccumulator >= snakeDelay) {
          game.snakeAccumulator = 0;
          tickAmbSnake(module, game);
        }
      }
      if (game.type === 'game-road-crossing') tickAmbRoad(module, game, settings, scale);
      if (game.type === 'game-dino-dash') tickAmbDino(module, game, settings, scale);
      if (game.type === 'game-fruit-slice') tickAmbFruit(module, game, settings, scale);
      if (!game.running) return;
      drawAmbGame(module, game, false);
      if (now - game.lastOutputAt > 250) {
        game.lastOutputAt = now;
        updateAmbOutput(app, state, module);
      }
      if ((game.type === 'game-road-crossing' || game.type === 'game-fruit-slice') && game.elapsed >= settings.duration) {
        completeAmbGameTime(app, state, module, game);
        return;
      }
      var id = window.requestAnimationFrame(frame);
      state.timers.set(module, { kind: 'frame', id: id });
    }
    var id = window.requestAnimationFrame(frame);
    state.timers.set(module, { kind: 'frame', id: id });
    if (!game.elapsed && game.type !== 'game-colour-snake') showAmbLevelBanner(module, 'Level 1');
  }

  function resetAmbGameAttempt(module, game) {
    game.gameOver = false;
    game.elapsed = 0;
    if (game.type === 'game-sky-flight') {
      game.level = 1;
      game.y = 210;
      game.velocity = 0;
      game.cloudOffset = 0;
      game.fx = [];
      game.pipes = [{ x: 540, gap: 155, passed: false }, { x: 880, gap: 260, passed: false }];
      setAmbCount(module, 'score', 0);
      setAmbCount(module, 'errors', 0);
      setAmbCount(module, 'level', 1);
    } else if (game.type === 'game-colour-snake') {
      game.snake = [{ x: 6, y: 7 }, { x: 5, y: 7 }, { x: 4, y: 7 }];
      game.direction = 'right';
      game.nextDirection = 'right';
      game.food = randomAmbFood(game.snake, 24, 14);
      setAmbCount(module, 'score', 0);
      setAmbCount(module, 'errors', 0);
      setAmbCount(module, 'length', 3);
    } else if (game.type === 'game-road-crossing') {
      game.chick = { x: 4, y: 5 };
      game.vehicles = createAmbVehicles();
    } else if (game.type === 'game-dino-dash') {
      game.level = 1;
      game.dinoY = 0;
      game.dinoVelocity = 0;
      game.jumpsUsed = 0;
      game.cloudOffset = 0;
      game.fx = [];
      game.obstacles = [{ x: 720, width: 32, height: 58, passed: false }];
      setAmbCount(module, 'score', 0);
      setAmbCount(module, 'level', 1);
    } else if (game.type === 'game-fruit-slice') {
      game.fruits = [];
      game.fx = [];
      game.trail = [];
      game.spawnElapsed = 0;
      setAmbCount(module, 'score', 0);
      setAmbCount(module, 'misses', 0);
      setAmbCount(module, 'wrongSlices', 0);
      setAmbCount(module, 'combo', 0);
    }
    updateAmbTime(module, 0);
  }

  function completeAmbGameTime(app, state, module, game) {
    if (!game.running) return;
    pauseAmbActivity(state, module);
    game.gameOver = true;
    var type = game.type;
    var message = type === 'game-fruit-slice'
      ? 'Time complete — excellent slicing! Score: ' + ambCount(module, 'score') + '. Misses: ' + ambCount(module, 'misses') + '. Wrong slices: ' + ambCount(module, 'wrongSlices') + '.'
      : 'Time complete — great crossing! You completed ' + ambCount(module, 'score') + ' roads and reached level ' + ambCount(module, 'level') + '.';
    showAmbCompletion(app, state, module, 'Game Complete', message, 'Play Again');
  }

  function finishAmbGame(module, game, title, message, nextLabel) {
    if (!game || !game.running) return;
    pauseAmbActivity(game.state, module);
    game.gameOver = true;
    updateAmbOutput(game.app, game.state, module);
    drawAmbGame(module, game, false);
    showAmbCompletion(game.app, game.state, module, title, message, nextLabel || 'Play Again');
  }

  function toggleAmbEasyMode(module, button) {
    if (!module) return;
    var game = module._vtAmbGame;
    if (!game) return;
    game.fixedSpeed = !game.fixedSpeed;
    var mode = module.querySelector('[data-vt-amb-game-mode]');
    var childModeGame = game.type === 'game-sky-flight' || game.type === 'game-dino-dash';
    if (mode) mode.textContent = childModeGame ? (game.fixedSpeed ? 'Child (fixed)' : 'Normal (progressive)') : (game.fixedSpeed ? 'Fixed easy' : 'Progressive');
    if (button) {
      button.textContent = childModeGame ? (game.fixedSpeed ? 'Use Normal Mode' : 'Use Child Mode') : (game.fixedSpeed ? 'Use Progressive Speed' : 'Use Fixed Easy Speed');
      button.setAttribute('aria-pressed', game.fixedSpeed ? 'true' : 'false');
    }
  }

  function ambGameCanvas(module) {
    return module ? module.querySelector('[data-vt-amb-stage]') : null;
  }

  function ambGameContext(module) {
    var canvas = ambGameCanvas(module);
    return canvas && canvas.getContext ? canvas.getContext('2d') : null;
  }

  function ambGamePalette(module) {
    var app = module.closest('[data-vt-app]');
    var colour = ambControlValue(app, '[data-vt-amb-global="ambColour"]', 'red');
    var ambOpacity = parseInt(ambControlValue(app, '[data-vt-amb-global="ambContrast"]', '100'), 10) / 100;
    var fellowOpacity = parseInt(ambControlValue(app, '[data-vt-amb-global="fellowContrast"]', '45'), 10) / 100;
    var redVisibility = parseInt(ambControlValue(app, '[data-vt-amb-global="redVisibility"]', '100'), 10) / 100;
    var greenVisibility = parseInt(ambControlValue(app, '[data-vt-amb-global="greenVisibility"]', '100'), 10) / 100;
    return {
      amb: colour === 'red' ? ambTunedColours(app).red : ambTunedColours(app).green,
      fellow: colour === 'red' ? ambTunedColours(app).green : ambTunedColours(app).red,
      ambOpacity: ambOpacity * (colour === 'red' ? redVisibility : greenVisibility),
      fellowOpacity: fellowOpacity * (colour === 'red' ? greenVisibility : redVisibility),
      white: '#ffffff',
      dark: '#0d1725'
    };
  }

  function ambGameTargetRadius(module) {
    var size = ambModuleSettings(module, module.closest('[data-vt-app]')._vtAmbState).targetSize;
    return { 'very large': 25, large: 22, medium: 19, small: 16, 'very small': 13 }[size] || 19;
  }

  function drawAmbGame(module, game, paused) {
    var canvas = ambGameCanvas(module);
    var context = ambGameContext(module);
    if (!canvas || !context || !game) return;
    if (game.type === 'game-sky-flight') drawAmbSky(module, game, context, canvas);
    if (game.type === 'game-colour-snake') drawAmbSnake(module, game, context, canvas);
    if (game.type === 'game-road-crossing') drawAmbRoad(module, game, context, canvas);
    if (game.type === 'game-dino-dash') drawAmbDino(module, game, context, canvas);
    if (game.type === 'game-fruit-slice') drawAmbFruit(module, game, context, canvas);
    if (paused) drawAmbGamePrompt(context, canvas, 'Press Start Game');
  }

  function drawAmbGamePrompt(context, canvas, text) {
    context.save();
    context.fillStyle = 'rgba(13,23,37,0.72)';
    context.fillRect(0, canvas.height / 2 - 42, canvas.width, 84);
    context.fillStyle = '#ffffff';
    context.font = '700 28px Arial';
    context.textAlign = 'center';
    context.fillText(text, canvas.width / 2, canvas.height / 2 + 10);
    context.restore();
  }

  function flapAmbSky(module) {
    if (!module || module.getAttribute('data-vt-amb-module') !== 'game-sky-flight') return;
    var game = module._vtAmbGame;
    if (game && game.running) game.velocity = -7.1;
  }

  function tickAmbSky(module, game, settings, scale) {
    var canvas = ambGameCanvas(module);
    if (!canvas) return;
    var baseSpeed = { 'very slow': 1.35, slow: 1.8, medium: 2.35, fast: 3.1 }[settings.speed] || 2.35;
    var speed = baseSpeed * (game.fixedSpeed ? 0.62 : Math.min(1.85, 1 + (game.level - 1) * 0.12));
    var radius = ambGameTargetRadius(module);
    game.cloudOffset = (game.cloudOffset + speed * 0.12 * scale) % canvas.width;
    game.velocity += 0.31 * scale;
    game.y += game.velocity * scale;
    game.fx.forEach(function (fx) { fx.life -= 0.035 * scale; fx.y -= 0.5 * scale; });
    game.fx = game.fx.filter(function (fx) { return fx.life > 0; });
    var maxX = Math.max.apply(null, game.pipes.map(function (pipe) { return pipe.x; }));
    game.pipes.forEach(function (pipe) {
      pipe.x -= speed * scale;
      if (!pipe.passed && pipe.x + 56 < 125) {
        pipe.passed = true;
        incrementAmbCount(module, 'score', 1);
        game.fx.push({ x: 125, y: game.y - 30, life: 1, text: '+1' });
        playAmbSound(game.state, 'correct');
        var nextLevel = 1 + Math.floor((parseInt(ambCount(module, 'score'), 10) || 0) / 5);
        if (nextLevel > game.level) {
          game.level = nextLevel;
          setAmbCount(module, 'level', game.level);
          showAmbLevelBanner(module, 'Level ' + game.level + ' — speed increasing');
        }
      }
      if (pipe.x < -70) {
        pipe.x = maxX + 330;
        pipe.gap = 120 + Math.random() * 180;
        pipe.passed = false;
        maxX = pipe.x;
      }
      var inPipe = 125 + radius > pipe.x && 125 - radius < pipe.x + 56;
      var gapTop = pipe.gap - 74;
      var gapBottom = pipe.gap + 74;
      if (inPipe && (game.y - radius < gapTop || game.y + radius > gapBottom)) crashAmbGame(module, game, 'sky');
    });
    if (game.y - radius < 0 || game.y + radius > canvas.height) crashAmbGame(module, game, 'sky');
  }

  function crashAmbGame(module, game, type) {
    if (Date.now() - game.lastCrash < 500) return;
    game.lastCrash = Date.now();
    incrementAmbCount(module, 'errors', 1);
    if (type === 'sky') {
      finishAmbGame(module, game, 'Flight Complete', 'Great flying! You passed ' + ambCount(module, 'score') + ' gates and reached level ' + ambCount(module, 'level') + '.', 'Fly Again');
    } else if (type === 'road') {
      finishAmbGame(module, game, 'Road Attempt Complete', 'Good trying! You reached level ' + ambCount(module, 'level') + ' with ' + ambCount(module, 'score') + ' crossings.', 'Try This Level Again');
    }
  }

  function drawAmbSky(module, game, context, canvas) {
    var palette = ambGamePalette(module);
    var radius = ambGameTargetRadius(module);
    context.clearRect(0, 0, canvas.width, canvas.height);
    var sky = context.createLinearGradient(0, 0, 0, canvas.height);
    sky.addColorStop(0, '#163158');
    sky.addColorStop(1, '#287fa0');
    context.fillStyle = sky;
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.save();
    context.globalAlpha = 0.22;
    context.fillStyle = '#ffffff';
    [90, 340, 620, 880].forEach(function (base, index) {
      var cx = ((base - game.cloudOffset * (index % 2 ? 0.65 : 1)) % 940) - 110;
      var cy = 58 + (index % 3) * 54;
      context.beginPath();
      context.arc(cx, cy, 25, 0, Math.PI * 2);
      context.arc(cx + 30, cy - 10, 34, 0, Math.PI * 2);
      context.arc(cx + 66, cy, 25, 0, Math.PI * 2);
      context.fill();
    });
    context.restore();
    context.save();
    context.globalAlpha = palette.fellowOpacity;
    context.fillStyle = palette.fellow;
    context.strokeStyle = 'rgba(255,255,255,0.35)';
    context.lineWidth = 3;
    context.shadowColor = 'rgba(0,0,0,0.22)';
    context.shadowBlur = 10;
    game.pipes.forEach(function (pipe) {
      var topHeight = pipe.gap - 74;
      var bottomY = pipe.gap + 74;
      roundedRectPath(context, pipe.x, -16, 58, topHeight + 16, 14); context.fill(); context.stroke();
      roundedRectPath(context, pipe.x - 8, topHeight - 24, 74, 28, 10); context.fill(); context.stroke();
      roundedRectPath(context, pipe.x, bottomY, 58, canvas.height - bottomY + 16, 14); context.fill(); context.stroke();
      roundedRectPath(context, pipe.x - 8, bottomY - 4, 74, 28, 10); context.fill(); context.stroke();
    });
    context.restore();
    context.save();
    context.globalAlpha = palette.ambOpacity;
    context.fillStyle = palette.amb;
    context.shadowColor = 'rgba(0,0,0,0.25)';
    context.shadowBlur = 8;
    context.beginPath();
    context.arc(125, game.y, radius, 0, Math.PI * 2);
    context.fill();
    context.fillStyle = 'rgba(255,255,255,0.34)';
    context.beginPath();
    context.ellipse(116, game.y + 3, radius * 0.52, radius * 0.34, -0.35, 0, Math.PI * 2);
    context.fill();
    context.shadowBlur = 0;
    context.fillStyle = '#ffffff';
    context.beginPath(); context.arc(132, game.y - 6, Math.max(3, radius * 0.16), 0, Math.PI * 2); context.fill();
    context.fillStyle = '#163158';
    context.beginPath(); context.arc(133, game.y - 6, Math.max(1.5, radius * 0.07), 0, Math.PI * 2); context.fill();
    context.fillStyle = '#f4b942';
    context.beginPath(); context.moveTo(143, game.y); context.lineTo(155, game.y + 4); context.lineTo(143, game.y + 8); context.closePath(); context.fill();
    context.restore();
    drawAmbGameHud(context, 'Gates ' + ambCount(module, 'score'), 'Level ' + ambCount(module, 'level'));
    drawAmbCanvasFx(context, game.fx);
  }

  function roundedRectPath(context, x, y, width, height, radius) {
    var r = Math.max(0, Math.min(radius, Math.abs(width) / 2, Math.abs(height) / 2));
    context.beginPath();
    context.moveTo(x + r, y);
    context.lineTo(x + width - r, y);
    context.quadraticCurveTo(x + width, y, x + width, y + r);
    context.lineTo(x + width, y + height - r);
    context.quadraticCurveTo(x + width, y + height, x + width - r, y + height);
    context.lineTo(x + r, y + height);
    context.quadraticCurveTo(x, y + height, x, y + height - r);
    context.lineTo(x, y + r);
    context.quadraticCurveTo(x, y, x + r, y);
    context.closePath();
  }

  function drawAmbGameHud(context, leftText, rightText) {
    context.save();
    context.fillStyle = 'rgba(13,23,37,0.64)';
    roundedRectPath(context, 16, 14, 205, 48, 14); context.fill();
    context.fillStyle = '#ffffff';
    context.font = '700 21px Arial';
    context.textAlign = 'left';
    context.fillText(leftText, 32, 46);
    context.textAlign = 'right';
    context.fillText(rightText || '', 205, 46);
    context.restore();
  }

  function drawAmbCanvasFx(context, effects) {
    context.save();
    context.font = '800 25px Arial';
    context.textAlign = 'center';
    (effects || []).forEach(function (fx) {
      context.globalAlpha = Math.max(0, fx.life);
      context.fillStyle = fx.correct === false ? '#ff665f' : '#91f2b8';
      context.strokeStyle = context.fillStyle;
      context.lineWidth = 5;
      context.beginPath();
      context.arc(fx.x, fx.y + 8, 22 + (1 - fx.life) * 22, 0, Math.PI * 2);
      context.stroke();
      context.fillText(fx.text || '+1', fx.x, fx.y);
    });
    context.restore();
  }

  function jumpAmbDino(module) {
    if (!module || module.getAttribute('data-vt-amb-module') !== 'game-dino-dash') return;
    var game = module._vtAmbGame;
    if (game && game.running && game.jumpsUsed < 2) {
      game.dinoVelocity = game.jumpsUsed === 0 ? 12.6 : 10.2;
      game.jumpsUsed += 1;
    }
  }

  function tickAmbDino(module, game, settings, scale) {
    var canvas = ambGameCanvas(module);
    if (!canvas || !game.running) return;
    var baseSpeed = { 'very slow': 2.5, slow: 3.1, medium: 3.8, fast: 4.6 }[settings.speed] || 3.8;
    var speed = baseSpeed * (game.fixedSpeed ? 0.72 : Math.min(2, 1 + (game.level - 1) * 0.1));
    game.cloudOffset = (game.cloudOffset + speed * 0.09 * scale) % canvas.width;
    game.dinoY += game.dinoVelocity * scale;
    game.dinoVelocity -= 0.46 * scale;
    if (game.dinoY < 0) {
      game.dinoY = 0;
      game.dinoVelocity = 0;
      game.jumpsUsed = 0;
    }
    game.fx.forEach(function (fx) { fx.life -= 0.035 * scale; fx.y -= 0.4 * scale; });
    game.fx = game.fx.filter(function (fx) { return fx.life > 0; });
    game.obstacles.forEach(function (obstacle) {
      obstacle.x -= speed * scale;
      if (!obstacle.passed && obstacle.x + obstacle.width < 108) {
        obstacle.passed = true;
        incrementAmbCount(module, 'score', 1);
        game.fx.push({ x: 108, y: 210 - game.dinoY, life: 1, text: '+1' });
        playAmbSound(game.state, 'correct');
        var nextLevel = 1 + Math.floor((parseInt(ambCount(module, 'score'), 10) || 0) / 5);
        if (nextLevel > game.level) {
          game.level = nextLevel;
          setAmbCount(module, 'level', game.level);
          showAmbLevelBanner(module, 'Level ' + game.level + ' — speed increasing');
        }
      }
      if (obstacle.x < -obstacle.width - 10) {
        obstacle.x = canvas.width + 170 + Math.random() * 260;
        obstacle.width = 26 + Math.random() * 18;
        obstacle.height = 42 + Math.random() * 38;
        obstacle.passed = false;
      }
      var dinoLeft = 88;
      var dinoRight = 132;
      var dinoBottom = 300 - game.dinoY;
      var dinoTop = dinoBottom - 56;
      var obstacleLeft = obstacle.x + 4;
      var obstacleRight = obstacle.x + obstacle.width - 4;
      var obstacleTop = 300 - obstacle.height;
      if (dinoRight > obstacleLeft && dinoLeft < obstacleRight && dinoBottom > obstacleTop && dinoTop < 300) {
        finishAmbGame(module, game, 'Dino Dash Complete', 'Roarsome jumping! Your final score is ' + ambCount(module, 'score') + ' and you reached level ' + ambCount(module, 'level') + '.', 'Run Again');
      }
    });
  }

  function drawAmbDino(module, game, context, canvas) {
    var palette = ambGamePalette(module);
    var groundY = 300;
    var x = 106;
    var y = groundY - game.dinoY;
    context.clearRect(0, 0, canvas.width, canvas.height);
    var desert = context.createLinearGradient(0, 0, 0, canvas.height);
    desert.addColorStop(0, '#163158');
    desert.addColorStop(0.72, '#2e8198');
    desert.addColorStop(0.73, '#d8b875');
    desert.addColorStop(1, '#a47d43');
    context.fillStyle = desert;
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.save();
    context.globalAlpha = 0.25;
    context.fillStyle = '#ffffff';
    [120, 430, 760].forEach(function (base, index) {
      var cloudX = ((base - game.cloudOffset * (0.7 + index * 0.12)) % 900) - 100;
      var cloudY = 55 + index * 42;
      context.beginPath(); context.arc(cloudX, cloudY, 22, 0, Math.PI * 2); context.arc(cloudX + 30, cloudY - 8, 29, 0, Math.PI * 2); context.arc(cloudX + 62, cloudY, 21, 0, Math.PI * 2); context.fill();
    });
    context.restore();
    context.strokeStyle = 'rgba(255,255,255,0.75)';
    context.lineWidth = 3;
    context.beginPath();
    context.moveTo(0, groundY + 3);
    context.lineTo(canvas.width, groundY + 3);
    context.stroke();
    context.save();
    context.globalAlpha = palette.fellowOpacity;
    context.fillStyle = palette.fellow;
    context.strokeStyle = 'rgba(255,255,255,0.36)';
    context.lineWidth = 2;
    context.shadowColor = 'rgba(0,0,0,0.2)';
    context.shadowBlur = 6;
    game.obstacles.forEach(function (obstacle) {
      roundedRectPath(context, obstacle.x, groundY - obstacle.height, obstacle.width, obstacle.height, obstacle.width * 0.42); context.fill(); context.stroke();
      roundedRectPath(context, obstacle.x - obstacle.width * 0.38, groundY - obstacle.height * 0.66, obstacle.width * 0.48, obstacle.height * 0.17, 7); context.fill();
      roundedRectPath(context, obstacle.x - obstacle.width * 0.42, groundY - obstacle.height * 0.78, obstacle.width * 0.17, obstacle.height * 0.29, 7); context.fill();
      roundedRectPath(context, obstacle.x + obstacle.width * 0.9, groundY - obstacle.height * 0.5, obstacle.width * 0.48, obstacle.height * 0.17, 7); context.fill();
      roundedRectPath(context, obstacle.x + obstacle.width * 1.22, groundY - obstacle.height * 0.62, obstacle.width * 0.17, obstacle.height * 0.29, 7); context.fill();
    });
    context.restore();
    context.save();
    context.globalAlpha = palette.ambOpacity;
    context.fillStyle = palette.amb;
    context.shadowColor = 'rgba(0,0,0,0.25)';
    context.shadowBlur = 8;
    context.beginPath(); context.ellipse(x, y - 29, 27, 25, -0.12, 0, Math.PI * 2); context.fill();
    roundedRectPath(context, x + 8, y - 61, 42, 29, 12); context.fill();
    context.beginPath();
    context.moveTo(x - 21, y - 38); context.quadraticCurveTo(x - 56, y - 58, x - 62, y - 34); context.quadraticCurveTo(x - 43, y - 39, x - 22, y - 17);
    context.closePath();
    context.fill();
    roundedRectPath(context, x - 17, y - 15, 11, 22, 4); context.fill();
    roundedRectPath(context, x + 12, y - 15, 11, 22, 4); context.fill();
    context.beginPath(); context.moveTo(x - 2, y - 50); context.lineTo(x - 10, y - 65); context.lineTo(x + 5, y - 55); context.closePath(); context.fill();
    context.shadowBlur = 0;
    context.fillStyle = palette.white;
    context.beginPath();
    context.arc(x + 33, y - 48, 3.4, 0, Math.PI * 2);
    context.fill();
    context.restore();
    drawAmbGameHud(context, 'Score ' + ambCount(module, 'score'), 'Level ' + ambCount(module, 'level'));
    drawAmbCanvasFx(context, game.fx);
  }

  function randomAmbFood(snake, cols, rows) {
    var food;
    do {
      food = { x: Math.floor(Math.random() * cols), y: Math.floor(Math.random() * rows) };
    } while (snake.some(function (cell) { return cell.x === food.x && cell.y === food.y; }));
    return food;
  }

  function steerAmbGame(module, direction) {
    if (!module || !direction || !module._vtAmbGame) return;
    var game = module._vtAmbGame;
    if (game.type === 'game-colour-snake') {
      var opposite = { up: 'down', down: 'up', left: 'right', right: 'left' };
      if (opposite[game.direction] !== direction) game.nextDirection = direction;
    }
    if (game.type === 'game-road-crossing' && game.running) {
      if (direction === 'up') game.chick.y = Math.max(0, game.chick.y - 1);
      if (direction === 'down') game.chick.y = Math.min(5, game.chick.y + 1);
      if (direction === 'left') game.chick.x = Math.max(0, game.chick.x - 1);
      if (direction === 'right') game.chick.x = Math.min(8, game.chick.x + 1);
      if (game.chick.y === 0) {
        incrementAmbCount(module, 'score', 1);
        var completedLevel = game.level || 1;
        game.level = completedLevel + 1;
        setAmbCount(module, 'level', game.level);
        game.chick = { x: 4, y: 5 };
        game.vehicles = createAmbVehicles();
        playAmbSound(game.state, 'level');
        showAmbLevelBanner(module, 'Level ' + game.level + ' — traffic moving faster');
      }
      drawAmbGame(module, game, false);
    }
  }

  function tickAmbSnake(module, game) {
    game.direction = game.nextDirection;
    var head = { x: game.snake[0].x, y: game.snake[0].y };
    if (game.direction === 'up') head.y -= 1;
    if (game.direction === 'down') head.y += 1;
    if (game.direction === 'left') head.x -= 1;
    if (game.direction === 'right') head.x += 1;
    head.x = (head.x + 24) % 24;
    head.y = (head.y + 14) % 14;
    var hitSelf = game.snake.some(function (cell) { return cell.x === head.x && cell.y === head.y; });
    if (hitSelf) {
      incrementAmbCount(module, 'errors', 1);
      finishAmbGame(module, game, 'Snake Game Complete', 'Terrific collecting! Your final score is ' + ambCount(module, 'score') + ' target' + (ambCount(module, 'score') === '1' ? '' : 's') + '.', 'Play Again');
      return;
    }
    game.snake.unshift(head);
    if (head.x === game.food.x && head.y === game.food.y) {
      incrementAmbCount(module, 'score', 1);
      setAmbCount(module, 'length', game.snake.length);
      playAmbSound(game.state, 'correct');
      game.food = randomAmbFood(game.snake, 24, 14);
    } else {
      game.snake.pop();
    }
  }

  function drawAmbSnake(module, game, context, canvas) {
    var palette = ambGamePalette(module);
    var cellW = canvas.width / 24;
    var cellH = canvas.height / 14;
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.fillStyle = palette.dark;
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.save();
    context.globalAlpha = palette.fellowOpacity;
    context.fillStyle = palette.fellow;
    context.beginPath();
    context.arc((game.food.x + 0.5) * cellW, (game.food.y + 0.5) * cellH, Math.min(cellW, cellH) * 0.42, 0, Math.PI * 2);
    context.fill();
    context.restore();
    context.save();
    context.globalAlpha = palette.ambOpacity;
    context.fillStyle = palette.amb;
    game.snake.forEach(function (cell, index) {
      var isHead = index === 0;
      var isTail = index === game.snake.length - 1;
      var inset = isHead ? 2 : isTail ? 8 : 4;
      context.globalAlpha = palette.ambOpacity * (isTail ? 0.58 : 1);
      context.fillRect(cell.x * cellW + inset, cell.y * cellH + inset, cellW - inset * 2, cellH - inset * 2);
      if (isHead) {
        context.strokeStyle = palette.white;
        context.lineWidth = 3;
        context.strokeRect(cell.x * cellW + 2, cell.y * cellH + 2, cellW - 4, cellH - 4);
        context.fillStyle = palette.white;
        var eyeY = cell.y * cellH + cellH * 0.35;
        var eyeX1 = cell.x * cellW + cellW * 0.35;
        var eyeX2 = cell.x * cellW + cellW * 0.68;
        if (game.direction === 'left' || game.direction === 'right') {
          eyeX1 = game.direction === 'right' ? cell.x * cellW + cellW * 0.7 : cell.x * cellW + cellW * 0.3;
          eyeX2 = eyeX1;
          eyeY = cell.y * cellH + cellH * 0.32;
          context.beginPath(); context.arc(eyeX1, eyeY, 2.8, 0, Math.PI * 2); context.fill();
          context.beginPath(); context.arc(eyeX2, cell.y * cellH + cellH * 0.68, 2.8, 0, Math.PI * 2); context.fill();
        } else {
          eyeY = game.direction === 'down' ? cell.y * cellH + cellH * 0.7 : cell.y * cellH + cellH * 0.3;
          context.beginPath(); context.arc(eyeX1, eyeY, 2.8, 0, Math.PI * 2); context.fill();
          context.beginPath(); context.arc(eyeX2, eyeY, 2.8, 0, Math.PI * 2); context.fill();
        }
        context.fillStyle = palette.amb;
      }
    });
    context.restore();
  }

  function createAmbVehicles() {
    var vehicles = [];
    for (var lane = 1; lane <= 4; lane += 1) {
      vehicles.push({ x: Math.random() * 9, y: lane, direction: lane % 2 ? 1 : -1, speed: 0.025 + Math.random() * 0.025 });
      vehicles.push({ x: Math.random() * 9, y: lane, direction: lane % 2 ? 1 : -1, speed: 0.025 + Math.random() * 0.025 });
    }
    return vehicles;
  }

  function tickAmbRoad(module, game, settings, scale) {
    var base = { 'very slow': 0.55, slow: 0.75, medium: 1, fast: 1.35 }[settings.speed] || 1;
    var multiplier = base * (game.fixedSpeed ? 0.5 : Math.min(1.9, 1 + (game.level - 1) * 0.13));
    game.vehicles.forEach(function (vehicle) {
      vehicle.x += vehicle.speed * vehicle.direction * multiplier * scale * 1.75;
      if (vehicle.x > 9.8) vehicle.x = -0.8;
      if (vehicle.x < -0.8) vehicle.x = 9.8;
      if (Math.abs(vehicle.x - game.chick.x) < 0.55 && vehicle.y === game.chick.y) crashAmbGame(module, game, 'road');
    });
  }

  function drawAmbRoad(module, game, context, canvas) {
    var palette = ambGamePalette(module);
    var cellW = canvas.width / 9;
    var cellH = canvas.height / 6;
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.fillStyle = '#3f7c56';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.fillStyle = '#35445a';
    context.fillRect(0, cellH, canvas.width, cellH * 4);
    context.fillStyle = 'rgba(255,255,255,0.13)';
    context.fillRect(0, cellH - 7, canvas.width, 7);
    context.fillRect(0, cellH * 5, canvas.width, 7);
    context.strokeStyle = 'rgba(255,255,255,0.55)';
    context.lineWidth = 3;
    context.setLineDash([26, 20]);
    for (var lane = 1; lane <= 3; lane += 1) {
      context.beginPath();
      context.moveTo(0, (lane + 1) * cellH);
      context.lineTo(canvas.width, (lane + 1) * cellH);
      context.stroke();
    }
    context.setLineDash([]);
    context.save();
    context.globalAlpha = palette.fellowOpacity;
    context.fillStyle = palette.fellow;
    context.strokeStyle = 'rgba(255,255,255,0.45)';
    context.lineWidth = 2;
    game.vehicles.forEach(function (vehicle) {
      var carX = vehicle.x * cellW - cellW * 0.33;
      var carY = vehicle.y * cellH + cellH * 0.18;
      var carW = cellW * 0.66;
      var carH = cellH * 0.62;
      context.shadowColor = 'rgba(0,0,0,0.25)'; context.shadowBlur = 6;
      roundedRectPath(context, carX, carY, carW, carH, 13); context.fill(); context.stroke();
      context.shadowBlur = 0;
      context.fillStyle = 'rgba(22,49,88,0.65)';
      roundedRectPath(context, carX + carW * 0.2, carY + carH * 0.2, carW * 0.6, carH * 0.28, 7); context.fill();
      context.fillStyle = '#ffffff';
      context.globalAlpha = palette.fellowOpacity * 0.9;
      context.fillRect(carX + 5, carY + 6, 6, 10); context.fillRect(carX + carW - 11, carY + 6, 6, 10);
      context.fillStyle = palette.fellow;
    });
    context.restore();
    context.save();
    context.globalAlpha = palette.ambOpacity;
    context.fillStyle = palette.amb;
    var x = (game.chick.x + 0.5) * cellW;
    var y = (game.chick.y + 0.5) * cellH;
    var radius = ambGameTargetRadius(module);
    context.shadowColor = 'rgba(0,0,0,0.28)'; context.shadowBlur = 8;
    context.beginPath(); context.ellipse(x, y + radius * 0.12, radius * 0.95, radius * 1.15, 0, 0, Math.PI * 2); context.fill();
    context.beginPath();
    context.arc(x, y - radius * 0.92, radius * 0.5, 0, Math.PI * 2);
    context.fill();
    context.shadowBlur = 0;
    context.beginPath();
    context.moveTo(x, y - radius * 1.48);
    context.lineTo(x + radius * 0.34, y - radius * 1.18);
    context.lineTo(x, y - radius * 1.1);
    context.closePath();
    context.fill();
    context.beginPath();
    context.ellipse(x - radius * 0.75, y + radius * 0.1, radius * 0.42, radius * 0.72, -0.45, 0, Math.PI * 2);
    context.ellipse(x + radius * 0.75, y + radius * 0.1, radius * 0.42, radius * 0.72, 0.45, 0, Math.PI * 2);
    context.fill();
    context.fillStyle = '#ffffff'; context.beginPath(); context.arc(x + radius * 0.18, y - radius, 3.5, 0, Math.PI * 2); context.fill();
    context.fillStyle = '#163158'; context.beginPath(); context.arc(x + radius * 0.5, y - radius, 1.8, 0, Math.PI * 2); context.fill();
    context.strokeStyle = palette.amb; context.lineWidth = 5; context.beginPath(); context.moveTo(x - radius * 0.45, y + radius * 1.05); context.lineTo(x - radius * 0.55, y + radius * 1.45); context.moveTo(x + radius * 0.35, y + radius * 1.05); context.lineTo(x + radius * 0.45, y + radius * 1.45); context.stroke();
    context.restore();
    drawAmbGameHud(context, 'Crossings ' + ambCount(module, 'score'), 'Level ' + ambCount(module, 'level'));
  }

  function spawnAmbFruit(module, game, canvas) {
    var mode = ambFieldValue(module, 'fruitMode') || 'both colours';
    var ambColour = ambControlValue(game.app, '[data-vt-amb-global="ambColour"]', 'red');
    var includeGrey = !!module.querySelector('[data-vt-amb-field="greyDistractors"]:checked');
    var roll = Math.random();
    var colour = includeGrey && roll < 0.18 ? 'grey' : roll < 0.58 ? 'red' : 'green';
    var target = colour !== 'grey' && (mode === 'both colours' || colour === ambColour);
    var radius = Math.max(24, ambGameTargetRadius(module) + 8);
    game.fruits.push({
      x: 70 + Math.random() * (canvas.width - 140), y: canvas.height + radius,
      vx: -1.2 + Math.random() * 2.4, vy: -(8.4 + Math.random() * 2.4),
      radius: radius, colour: colour, target: target, sliced: false, rotation: Math.random() * Math.PI * 2
    });
  }

  function tickAmbFruit(module, game, settings, scale) {
    var canvas = ambGameCanvas(module);
    if (!canvas || !game.running) return;
    var speedFactor = { 'very slow': 0.72, slow: 0.86, medium: 1, fast: 1.2 }[settings.speed] || 1;
    game.spawnElapsed += 32 * scale;
    var spawnEvery = Math.max(360, 850 - Math.min(360, game.elapsed * 7));
    if (game.spawnElapsed >= spawnEvery) {
      game.spawnElapsed = 0;
      spawnAmbFruit(module, game, canvas);
    }
    game.fruits.forEach(function (fruit) {
      fruit.x += fruit.vx * speedFactor * scale;
      fruit.y += fruit.vy * speedFactor * scale;
      fruit.vy += 0.22 * speedFactor * scale;
      fruit.rotation += 0.025 * scale;
      if (!fruit.sliced && fruit.y - fruit.radius > canvas.height && fruit.vy > 0) {
        fruit.sliced = true;
        if (fruit.target) {
          incrementAmbCount(module, 'misses', 1);
          setAmbCount(module, 'combo', 0);
          playAmbSound(game.state, 'miss');
        }
      }
    });
    game.fruits = game.fruits.filter(function (fruit) { return !fruit.sliced && fruit.y < canvas.height + fruit.radius * 3; });
    game.trail.forEach(function (point) { point.life -= 0.06 * scale; });
    game.trail = game.trail.filter(function (point) { return point.life > 0; });
    game.fx.forEach(function (fx) { fx.life -= 0.045 * scale; fx.y -= 0.6 * scale; });
    game.fx = game.fx.filter(function (fx) { return fx.life > 0; });
  }

  function handleAmbFruitPointer(app, state, module, event, isStart) {
    if (!module || !module._vtAmbGame || !module._vtAmbGame.running) return;
    var game = module._vtAmbGame;
    var canvas = ambGameCanvas(module);
    var rect = canvas.getBoundingClientRect();
    var x = (event.clientX - rect.left) * (canvas.width / rect.width);
    var y = (event.clientY - rect.top) * (canvas.height / rect.height);
    game.slicing = true;
    game.trail.push({ x: x, y: y, life: 1 });
    var hit = false;
    game.fruits.forEach(function (fruit) {
      if (fruit.sliced || Math.hypot(fruit.x - x, fruit.y - y) > fruit.radius * 1.2) return;
      fruit.sliced = true;
      hit = true;
      if (fruit.target) {
        incrementAmbCount(module, 'score', 1);
        incrementAmbCount(module, 'combo', 1);
        game.fx.push({ x: fruit.x, y: fruit.y, life: 1, text: '+1', correct: true });
        playAmbSound(state, 'correct');
      } else {
        incrementAmbCount(module, 'wrongSlices', 1);
        setAmbCount(module, 'combo', 0);
        game.fx.push({ x: fruit.x, y: fruit.y, life: 1, text: 'miss', correct: false });
        playAmbSound(state, 'miss');
      }
    });
    if (!hit && isStart) {
      incrementAmbCount(module, 'wrongSlices', 1);
      setAmbCount(module, 'combo', 0);
      game.fx.push({ x: x, y: y, life: 1, text: 'miss', correct: false });
      playAmbSound(state, 'miss');
    }
    updateAmbOutput(app, state, module);
  }

  function drawAmbFruit(module, game, context, canvas) {
    var app = module.closest('[data-vt-app]');
    var tuned = ambTunedColours(app);
    var redVisibility = parseInt(ambControlValue(app, '[data-vt-amb-global="redVisibility"]', '100'), 10) / 100;
    var greenVisibility = parseInt(ambControlValue(app, '[data-vt-amb-global="greenVisibility"]', '100'), 10) / 100;
    var background = context.createLinearGradient(0, 0, 0, canvas.height);
    background.addColorStop(0, '#163158'); background.addColorStop(1, '#0d203c');
    context.fillStyle = background; context.fillRect(0, 0, canvas.width, canvas.height);
    context.save(); context.globalAlpha = 0.12; context.fillStyle = '#20B7C8';
    for (var i = 0; i < 7; i += 1) { context.beginPath(); context.arc(65 + i * 115, 70 + (i % 2) * 110, 38, 0, Math.PI * 2); context.fill(); }
    context.restore();
    game.fruits.forEach(function (fruit) {
      context.save();
      context.translate(fruit.x, fruit.y); context.rotate(fruit.rotation);
      context.globalAlpha = fruit.colour === 'red' ? redVisibility : fruit.colour === 'green' ? greenVisibility : 0.65;
      context.fillStyle = fruit.colour === 'red' ? tuned.red : fruit.colour === 'green' ? tuned.green : '#aab4c3';
      context.shadowColor = 'rgba(0,0,0,0.28)'; context.shadowBlur = 8;
      context.beginPath(); context.arc(0, 0, fruit.radius, 0, Math.PI * 2); context.fill();
      context.shadowBlur = 0;
      context.fillStyle = 'rgba(255,255,255,0.28)'; context.beginPath(); context.arc(-fruit.radius * 0.3, -fruit.radius * 0.35, fruit.radius * 0.2, 0, Math.PI * 2); context.fill();
      context.strokeStyle = '#7a5731'; context.lineWidth = 5; context.beginPath(); context.moveTo(0, -fruit.radius); context.lineTo(4, -fruit.radius - 13); context.stroke();
      context.fillStyle = '#7bc96f'; context.beginPath(); context.ellipse(13, -fruit.radius - 9, 11, 6, -0.45, 0, Math.PI * 2); context.fill();
      context.restore();
    });
    context.save(); context.lineCap = 'round'; context.lineJoin = 'round'; context.strokeStyle = 'rgba(255,255,255,0.86)'; context.lineWidth = 7;
    if (game.trail.length > 1) { context.beginPath(); game.trail.forEach(function (point, index) { context.globalAlpha = point.life; if (!index) context.moveTo(point.x, point.y); else context.lineTo(point.x, point.y); }); context.stroke(); }
    context.restore();
    drawAmbGameHud(context, 'Score ' + ambCount(module, 'score'), 'Combo ' + ambCount(module, 'combo'));
    drawAmbCanvasFx(context, game.fx);
  }

  function updateAmbColours(app) {
    var panel = app.querySelector('[data-vt-amb-panel]');
    if (!panel) return;
    var tuned = ambTunedColours(app);
    panel.style.setProperty('--vt-amb-red', tuned.red);
    panel.style.setProperty('--vt-amb-green', tuned.green);
    updateAmbCalibrationLabels(app);
    var colour = ambControlValue(app, '[data-vt-amb-global="ambColour"]', 'red');
    var ambContrast = parseInt(ambControlValue(app, '[data-vt-amb-global="ambContrast"]', '100'), 10) / 100;
    var fellowContrast = parseInt(ambControlValue(app, '[data-vt-amb-global="fellowContrast"]', '45'), 10) / 100;
    var redVisibility = parseInt(ambControlValue(app, '[data-vt-amb-global="redVisibility"]', '100'), 10) / 100;
    var greenVisibility = parseInt(ambControlValue(app, '[data-vt-amb-global="greenVisibility"]', '100'), 10) / 100;
    var redOpacity = (colour === 'red' ? ambContrast : fellowContrast) * redVisibility;
    var greenOpacity = (colour === 'green' ? ambContrast : fellowContrast) * greenVisibility;
    panel.style.setProperty('--vt-amb-red-opacity', String(redOpacity));
    panel.style.setProperty('--vt-amb-green-opacity', String(greenOpacity));
    panel.setAttribute('data-vt-amb-colour', colour);
    app.querySelectorAll('[data-vt-amb-global-value]').forEach(function (output) {
      var name = output.getAttribute('data-vt-amb-global-value');
      var field = app.querySelector('[data-vt-amb-global="' + name + '"]');
      if (field) output.textContent = field.value + '%';
    });
    panel.querySelectorAll('[data-vt-amb-module]').forEach(function (module) {
      var ambChannel = module.querySelector('[data-vt-amb-channel="amb"]');
      var fellowChannel = module.querySelector('[data-vt-amb-channel="fellow"]');
      if (ambChannel) module.style.setProperty('--vt-amb-local-amb-opacity', String(parseInt(ambChannel.value, 10) / 100));
      if (fellowChannel) module.style.setProperty('--vt-amb-local-fellow-opacity', String(parseInt(fellowChannel.value, 10) / 100));
      var red = module.querySelector('[data-vt-amb-channel="red"]');
      var green = module.querySelector('[data-vt-amb-channel="green"]');
      if (red) module.style.setProperty('--vt-amb-local-red-opacity', String(parseInt(red.value, 10) / 100));
      if (green) module.style.setProperty('--vt-amb-local-green-opacity', String(parseInt(green.value, 10) / 100));
      if (module.getAttribute('data-vt-amb-module') === 'fusion-lock') renderAmbStereo(module);
      if (module._vtAmbGame) drawAmbGame(module, module._vtAmbGame, !module._vtAmbGame.running);
    });
  }

  function ambCalibrationNumber(app, name, fallback) {
    var field = app.querySelector('[data-vt-amb-calibrate="' + name + '"]');
    var value = field ? parseFloat(field.value) : fallback;
    return Number.isFinite(value) ? value : fallback;
  }

  function ambTunedColours(app) {
    return {
      red: '#e31b23',
      green: '#00a651',
      label: 'red visibility ' + ambControlValue(app, '[data-vt-amb-global="redVisibility"]', '100') + '%, green/cyan visibility ' + ambControlValue(app, '[data-vt-amb-global="greenVisibility"]', '100') + '%'
    };
  }

  function updateAmbCalibrationLabels(app) {
    app.querySelectorAll('[data-vt-amb-cal-value]').forEach(function (output) {
      var name = output.getAttribute('data-vt-amb-cal-value');
      var field = app.querySelector('[data-vt-amb-calibrate="' + name + '"]');
      if (!field) return;
      output.textContent = name.toLowerCase().indexOf('hue') >= 0 ? field.value + '°' : field.value + '%';
    });
  }

  function resetAmbColourCalibration(app, state) {
    app.querySelectorAll('[data-vt-amb-global]').forEach(function (field) {
      if (field.tagName === 'SELECT') field.selectedIndex = 0;
      else field.value = field.defaultValue || '';
    });
    updateAmbColours(app, state);
    var module = app.querySelector('[data-vt-amb-module="calibration"]');
    if (module) updateAmbOutput(app, state, module);
    showAmbToast(app, 'Red/green filter colours reset.');
  }

  function swapAmbColours(app, state) {
    var global = app.querySelector('[data-vt-amb-global="ambColour"]');
    if (global) global.value = global.value === 'red' ? 'green' : 'red';
    var calibration = app.querySelector('[data-vt-amb-colour]');
    if (calibration && (calibration.value === 'red' || calibration.value === 'green')) calibration.value = calibration.value === 'red' ? 'green' : 'red';
    updateAmbColours(app, state);
    app.querySelectorAll('[data-vt-amb-module]').forEach(function (module) { updateAmbOutput(app, state, module); });
    showAmbToast(app, 'Red and green channels swapped.');
  }

  function updateAmbOutput(app, state, module) {
    if (!module) return;
    var output = module.querySelector('[data-vt-amb-output]');
    if (output) output.textContent = ambModuleNote(app, state, module);
  }

  function ambModuleNote(app, state, module) {
    var type = module.getAttribute('data-vt-amb-module');
    var eye = ambValueOrBlank(ambSetupValue(app, 'amblyopicEye'));
    var rightVa = ambValueOrBlank(ambSetupValue(app, 'rightVa'));
    var leftVa = ambValueOrBlank(ambSetupValue(app, 'leftVa'));
    var correction = ambValueOrBlank(ambSetupValue(app, 'correction'));
    var acuity = ambValueOrBlank(ambAcuityForEye(ambSetupValue(app, 'amblyopicEye'), ambSetupValue(app, 'rightVa'), ambSetupValue(app, 'leftVa')));
    var settings = ambModuleSettings(module, state);
    var notes = ambValueOrBlank(ambFieldValue(module, 'notes'));
    var colour = ambControlValue(app, '[data-vt-amb-global="ambColour"]', 'red');
    var colourLabel = ambColourLabel(colour);
    var fellow = colour === 'red' ? 'green' : 'red';
    var elapsed = ensureAmbRuntime(module).elapsed;
    if (type === 'setup') return 'Amblyopia setup completed. Amblyopic eye: ' + eye + '. RE VA: ' + rightVa + '. LE VA: ' + leftVa + '. Correction during task: ' + correction + '. Suggested display settings: ' + ambSettingsLabel(state.settings) + '. Crowding/separation: ' + ambValueOrBlank(ambSetupValue(app, 'crowdingNotes')) + '. Fixation: ' + ambValueOrBlank(ambSetupValue(app, 'fixation')) + '. Suppression/binocular status: ' + ambValueOrBlank(ambSetupValue(app, 'suppression')) + '. Notes: ' + ambValueOrBlank(ambSetupValue(app, 'setupNotes')) + '.';
    if (type === 'calibration') return 'Red/green setup completed. Amblyopic-eye colour: ' + colourLabel + '. ' + ambTunedColours(app).label + '. Amblyopic-eye contrast: ' + ambControlValue(app, '[data-vt-amb-global="ambContrast"]', '100') + '%. Fellow-eye contrast: ' + ambControlValue(app, '[data-vt-amb-global="fellowContrast"]', '45') + '%. Notes: ' + notes + '.';
    if (type === 'target-tap') return 'Monocular target tap activity completed. Eye/mode: ' + eye + '. VA setup: ' + acuity + '. Duration: ' + (elapsed || settings.duration) + 's. Target size: ' + settings.targetSize + '. Contrast: ' + settings.contrast + '. Crowding: ' + settings.crowding + '. Hits: ' + ambCount(module, 'hits') + '. Misses: ' + ambCount(module, 'misses') + '. False taps: ' + ambCount(module, 'falseTaps') + '. Notes: ' + notes + '.';
    if (type === 'letter-hunt') return 'Monocular letter hunt completed. Target: ' + ambValueOrBlank(module.querySelector('[data-vt-amb-target-letter]') ? module.querySelector('[data-vt-amb-target-letter]').textContent : '') + '. VA setup: ' + acuity + '. Crowding: ' + settings.crowding + '. Font size: ' + settings.targetSize + '. Contrast: ' + settings.contrast + '. Time: ' + elapsed + 's. Found: ' + ambCount(module, 'found') + '. Missed: ' + ambCount(module, 'missed') + '. False positives: ' + ambCount(module, 'falsePositives') + '. Notes: ' + notes + '.';
    if (type === 'fine-detail') return 'Monocular fine-detail matching completed. VA setup: ' + acuity + '. Difficulty: ' + ambDifficultyFromSettings(settings) + '. Target size: ' + settings.targetSize + '. Contrast: ' + settings.contrast + '. Rounds: ' + ambCount(module, 'round') + '/10. Time: ' + elapsed + 's. Correct: ' + ambCount(module, 'correct') + '. Errors: ' + ambCount(module, 'errors') + '. Notes: ' + notes + '.';
    if (type === 'dichoptic-catch') return 'Red/green dichoptic catch completed. Level: ' + ambCount(module, 'level') + '. Amblyopic eye: ' + eye + '. Amblyopic-eye VA: ' + acuity + '. Amblyopic-eye colour: ' + colourLabel + '. Fellow-eye colour: ' + fellow + '. Duration: ' + (elapsed || settings.duration) + 's. Target size: ' + settings.targetSize + '. Speed: ' + settings.speed + '. Hits: ' + ambCount(module, 'hits') + '. Misses: ' + ambCount(module, 'misses') + '. Notes: ' + notes + '.';
    if (type === 'two-eye-builder') return 'Two-eye builder dichoptic task completed. Amblyopic eye: ' + eye + '. Amblyopic-eye VA: ' + acuity + '. Image type: ' + ambValueOrBlank(ambFieldValue(module, 'imageType')) + '. Response: ' + ambValueOrBlank(ambFieldValue(module, 'builderResponse')) + '. Notes: ' + notes + '.';
    if (type === 'dichoptic-maze') return 'Red/green maze completed. Level: ' + ambCount(module, 'level') + '. Time: ' + elapsed + 's. Correct moves: ' + ambCount(module, 'correctMoves') + '. Errors: ' + ambCount(module, 'errors') + '. Targets collected: ' + ambCount(module, 'collected') + '. Notes: ' + notes + '.';
    if (type === 'balance-dots') return 'Red/green balance dots completed. Level: ' + ambCount(module, 'level') + '. Amblyopic eye: ' + eye + '. Amblyopic-eye VA: ' + acuity + '. Red/green settings: ' + ambFieldValue(module, 'redDots') + ' red, ' + ambFieldValue(module, 'greenDots') + ' green, spacing ' + ambFieldValue(module, 'spacing') + '. Time: ' + elapsed + 's. Dots cleared: ' + ambCount(module, 'dotsCleared') + '. Dots remaining: ' + ambCount(module, 'dotsRemaining') + '. Response: ' + ambValueOrBlank(ambFieldValue(module, 'response')) + '. Suppression: ' + ambValueOrBlank(ambFieldValue(module, 'suppressionResponse')) + '. Notes: ' + notes + '.';
    if (type === 'game-sky-flight') return 'Optiplex Sky Flight completed. Level: ' + ambCount(module, 'level') + '. Speed mode: ' + (module.querySelector('[data-vt-amb-game-mode]') ? module.querySelector('[data-vt-amb-game-mode]').textContent : 'Progressive') + '. Amblyopic eye: ' + eye + '. Amblyopic-eye VA: ' + acuity + '. Amblyopic-eye colour: ' + colourLabel + '. Duration: ' + elapsed + 's. Gates: ' + ambCount(module, 'score') + '. Collisions: ' + ambCount(module, 'errors') + '. Notes: ' + notes + '.';
    if (type === 'game-colour-snake') return 'Optiplex Colour Snake completed. Amblyopic eye: ' + eye + '. Amblyopic-eye VA: ' + acuity + '. Amblyopic-eye colour: ' + colourLabel + '. Duration: ' + elapsed + 's. Score: ' + ambCount(module, 'score') + '. Length: ' + ambCount(module, 'length') + '. Collisions: ' + ambCount(module, 'errors') + '. Notes: ' + notes + '.';
    if (type === 'game-road-crossing') return 'Optiplex Chick Road Crossing completed. Level: ' + ambCount(module, 'level') + '. Speed mode: ' + (module.querySelector('[data-vt-amb-game-mode]') ? module.querySelector('[data-vt-amb-game-mode]').textContent : 'Progressive') + '. Amblyopic eye: ' + eye + '. Amblyopic-eye VA: ' + acuity + '. Amblyopic-eye colour: ' + colourLabel + '. Duration: ' + elapsed + 's. Crossings: ' + ambCount(module, 'score') + '. Collisions: ' + ambCount(module, 'errors') + '. Notes: ' + notes + '.';
    if (type === 'game-dino-dash') return 'Optiplex Dino Dash completed. Level: ' + ambCount(module, 'level') + '. Speed mode: ' + (module.querySelector('[data-vt-amb-game-mode]') ? module.querySelector('[data-vt-amb-game-mode]').textContent : 'Normal (progressive)') + '. Amblyopic eye: ' + eye + '. Amblyopic-eye VA: ' + acuity + '. Amblyopic-eye colour: ' + colourLabel + '. Duration: ' + elapsed + 's. Score: ' + ambCount(module, 'score') + '. Notes: ' + notes + '.';
    if (type === 'game-fruit-slice') return 'Optiplex Fruit Slice activity completed. Mode: ' + ambValueOrBlank(ambFieldValue(module, 'fruitMode')) + '. Amblyopic-eye colour: ' + colourLabel + '. Duration: ' + elapsed + 's. Score: ' + ambCount(module, 'score') + '. Misses: ' + ambCount(module, 'misses') + '. Wrong slices: ' + ambCount(module, 'wrongSlices') + '. Notes: ' + notes + '.';
    if (type === 'suppression-check') return 'Colour suppression check completed. Amblyopic eye: ' + eye + '. Amblyopic-eye VA: ' + acuity + '. Red seen: ' + ambValueOrBlank(ambFieldValue(module, 'redSeen')) + '. Green seen: ' + ambValueOrBlank(ambFieldValue(module, 'greenSeen')) + '. Fixation: ' + ambValueOrBlank(ambFieldValue(module, 'fixationSeen')) + '. Stability: ' + ambValueOrBlank(ambFieldValue(module, 'stability')) + '. Notes: ' + notes + '.';
    if (type === 'fusion-lock' && module.querySelector('[data-vt-amb-stage]').classList.contains('vt-amb-show-depth')) return 'Red/green stereo/fusion image viewed. Image: ' + ambValueOrBlank(ambFieldValue(module, 'stereoImage')) + '. Depth setting: ' + ambValueOrBlank(ambFieldValue(module, 'stereoDepth')) + '. Response: ' + ambValueOrBlank(ambFieldValue(module, 'fusionResponse')) + '. Notes: ' + notes + '.';
    if (type === 'fusion-lock') return 'Fusion awareness task completed. Response: ' + ambValueOrBlank(ambFieldValue(module, 'fusionResponse')) + '. Suppression pattern: ' + ambValueOrBlank(ambFieldValue(module, 'suppressionResponse')) + '. Notes: ' + notes + '.';
    return '';
  }

  function ambDifficultyFromSettings(settings) {
    if (settings.targetSize === 'very large' || settings.speed === 'very slow') return 'easy';
    if (settings.targetSize === 'small' || settings.targetSize === 'very small' || settings.crowding === 'crowded') return 'hard';
    return 'medium';
  }

  function ambColourLabel(value) {
    return value === 'green' ? 'green' : value;
  }

  function ambCount(module, name) {
    var counter = module.querySelector('[data-vt-amb-count="' + name + '"]');
    return counter ? counter.textContent.trim() : '0';
  }

  function setAmbCount(module, name, value) {
    var counter = module.querySelector('[data-vt-amb-count="' + name + '"]');
    if (counter) counter.textContent = String(value);
  }

  function incrementAmbCount(module, name, amount) {
    setAmbCount(module, name, (parseInt(ambCount(module, name), 10) || 0) + amount);
  }

  function addAmbSummary(app, state, module) {
    var key = module.getAttribute('data-vt-amb-module');
    var title = module.getAttribute('data-vt-amb-title') || 'Amblyopia support activity';
    state.notes.set(key, { title: title, note: ambModuleNote(app, state, module) });
    renderAmbSummary(app, state);
    showAmbToast(app, title + ' added to summary.');
  }

  function renderAmbSummary(app, state) {
    var items = Array.from(state.notes.values());
    renderAmbList(app.querySelector('[data-vt-amb-summary-list]'), items, 'No amblyopia support activities added yet.');
    renderAmbList(app.querySelector('[data-vt-summary-amb]'), items, 'No amblyopia support activities added yet.');
    var output = app.querySelector('[data-vt-amb-full-summary]');
    if (output) output.textContent = ambSummaryText(app, state);
    var panel = app.querySelector('[data-vt-amb-panel]');
    if (panel) panel.setAttribute('data-vt-amb-has-summary', items.length ? 'true' : 'false');
    refreshMainSummary(app);
  }

  function renderAmbList(container, items, emptyText) {
    if (!container) return;
    container.innerHTML = '';
    if (!items.length) {
      var empty = document.createElement('p');
      empty.textContent = emptyText;
      container.appendChild(empty);
      return;
    }
    items.forEach(function (entry) {
      var item = document.createElement('div');
      var title = document.createElement('strong');
      var note = document.createElement('p');
      item.className = 'vt-note-item';
      title.textContent = entry.title;
      note.textContent = entry.note;
      item.appendChild(title);
      item.appendChild(note);
      container.appendChild(item);
    });
  }

  function ambSummaryText(app, state) {
    var entries = Array.from(state.notes.entries());
    var activities = entries.filter(function (entry) { return entry[0] !== 'setup' && entry[0] !== 'calibration'; }).map(function (entry) { return entry[1].title; }).join(', ');
    var observations = entries.map(function (entry) { return entry[1].note; }).join(' ');
    var suppression = [ambSetupValue(app, 'suppression')];
    app.querySelectorAll('[data-vt-amb-module]').forEach(function (module) {
      var suppressionValue = ambFieldValue(module, 'suppressionResponse');
      if (suppressionValue) suppression.push(suppressionValue);
    });
    suppression = ambUnique(suppression.filter(Boolean)).join(', ');
    return 'Amblyopia support activities trialled under clinician supervision. Amblyopic eye: ' + ambValueOrBlank(ambSetupValue(app, 'amblyopicEye')) + '. RE VA: ' + ambValueOrBlank(ambSetupValue(app, 'rightVa')) + '. LE VA: ' + ambValueOrBlank(ambSetupValue(app, 'leftVa')) + '. Correction during task: ' + ambValueOrBlank(ambSetupValue(app, 'correction')) + '. Suggested display settings used: ' + ambSettingsLabel(state.settings) + '. Activities: ' + ambValueOrBlank(activities) + '. Observations: ' + ambSentence(observations) + 'Suppression/binocular response: ' + ambValueOrBlank(suppression) + '. Safety advice discussed. These clinician-supervised support tools do not claim to cure amblyopia. Final clinical interpretation recorded in Optomate.';
  }

  function ambSentence(value) {
    var text = ambValueOrBlank(value);
    return text + (/[.!?]$/.test(text) ? ' ' : '. ');
  }

  function ambUnique(values) {
    return values.filter(function (value, index) { return value && values.indexOf(value) === index; });
  }

  function refreshMainSummary(app) {
    var field = app.querySelector('[data-vt-summary-field]');
    if (field) field.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function resetAmbModule(app, state, module, announce) {
    if (!module) return;
    pauseAmbActivity(state, module);
    module.querySelectorAll('input, select, textarea').forEach(function (field) {
      if (field.type === 'checkbox' || field.type === 'radio') field.checked = field.defaultChecked;
      else if (field.tagName === 'SELECT') {
        var selected = Array.prototype.slice.call(field.options).findIndex(function (option) { return option.defaultSelected; });
        field.selectedIndex = selected >= 0 ? selected : 0;
      } else field.value = field.defaultValue || '';
    });
    module._vtAmb = { active: false, elapsed: 0, startedAt: 0, targetShownAt: 0, lastMoveAt: 0 };
    module.querySelectorAll('.vt-amb-is-selected').forEach(function (item) { item.classList.remove('vt-amb-is-selected'); });
    module.querySelectorAll('[data-vt-amb-count]').forEach(function (counter) {
      counter.textContent = counter.getAttribute('data-vt-amb-count') === 'reaction' ? '__' : '0';
    });
    updateAmbTime(module, 0);
    var type = module.getAttribute('data-vt-amb-module');
    if (type === 'letter-hunt') generateAmbLetterHunt(module, state);
    if (type === 'fine-detail') generateAmbMatch(module);
    if (type === 'dichoptic-catch') generateAmbCatchField(module);
    if (type === 'two-eye-builder') renderAmbBuilder(module, state);
    if (type === 'dichoptic-maze') {
      module._vtAmb.mazeLevel = 1;
      setAmbCount(module, 'level', 1);
      generateAmbMaze(module);
    }
    if (type === 'balance-dots') {
      module._vtAmb.dotsLevel = 1;
      setAmbCount(module, 'level', 1);
      renderAmbDots(module, state);
    }
    if (type === 'fusion-lock') resetAmbDepth(module);
    if (type.indexOf('game-') === 0) {
      initAmbGame(app, state, module);
      if (type === 'game-colour-snake') setAmbCount(module, 'length', 3);
      var easyButton = module.querySelector('[data-vt-action="amb-toggle-easy"]');
      if (easyButton) {
        easyButton.textContent = type === 'game-sky-flight' || type === 'game-dino-dash' ? 'Use Child Mode' : 'Use Fixed Easy Speed';
        easyButton.setAttribute('aria-pressed', 'false');
      }
    }
    ensureAmbRuntime(module).active = false;
    ensureAmbRuntime(module).hasStarted = false;
    ensureAmbRuntime(module).paused = false;
    setAmbRunButton(module, 'start');
    state.notes.delete(type);
    applyAmbModuleSettings(module, state);
    if (type === 'setup') updateAmbSuggestion(app, state);
    updateAmbOutput(app, state, module);
    renderAmbSummary(app, state);
    if (announce) showAmbToast(app, 'Activity reset.');
  }

  function resetAmbSection(app, state, announce) {
    state.timers.forEach(function (interval) {
      if (interval && typeof interval === 'object' && interval.kind === 'frame') window.cancelAnimationFrame(interval.id);
      else if (interval && typeof interval === 'object' && interval.kind === 'timeout') window.clearTimeout(interval.id);
      else window.clearInterval(interval);
    });
    state.timers.clear();
    closeAmbFullscreen(state);
    closeAmbCompletion(app, state);
    state.settings = defaultAmbSettings();
    state.suggested = defaultAmbSettings();
    state.notes.clear();
    state.sound = false;
    app.querySelectorAll('[data-vt-amb-module]').forEach(function (module) { resetAmbModule(app, state, module, false); });
    app.querySelectorAll('[data-vt-amb-global]').forEach(function (field) {
      if (field.tagName === 'SELECT') field.selectedIndex = 0;
      else field.value = field.defaultValue || '';
    });
    var soundButton = app.querySelector('[data-vt-action="amb-toggle-sound"]');
    if (soundButton) { soundButton.textContent = 'Sound: Off'; soundButton.setAttribute('aria-pressed', 'false'); }
    syncAmbManualControls(app, state.settings);
    updateAmbSuggestion(app, state);
    applyAmbSettings(app, state);
    renderAmbSummary(app, state);
    if (announce) showAmbToast(app, 'Amblyopia support entries cleared.');
  }

  function toggleAmbFullscreen(state, module, button) {
    if (state.fullscreen === module) {
      closeAmbFullscreen(state);
      return;
    }
    closeAmbFullscreen(state);
    module.classList.add('vt-amb-is-fullscreen');
    document.documentElement.classList.add('vt-amb-fullscreen-open');
    state.fullscreen = module;
    button.textContent = 'Exit Patient Screen';
    button.setAttribute('aria-pressed', 'true');
    module.setAttribute('tabindex', '-1');
    module.focus();
  }

  function closeAmbFullscreen(state) {
    if (!state.fullscreen) return;
    var module = state.fullscreen;
    module.classList.remove('vt-amb-is-fullscreen');
    module.removeAttribute('tabindex');
    var button = module.querySelector('[data-vt-action="amb-fullscreen"]');
    if (button) {
      button.textContent = 'Open Patient Screen';
      button.setAttribute('aria-pressed', 'false');
    }
    document.documentElement.classList.remove('vt-amb-fullscreen-open');
    state.fullscreen = null;
  }

  function copyAmbText(app, text, message) {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(function () { showAmbToast(app, message); }).catch(function () { fallbackAmbCopy(app, text, message); });
    } else fallbackAmbCopy(app, text, message);
  }

  function fallbackAmbCopy(app, text, message) {
    var field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();
    try {
      document.execCommand('copy');
      showAmbToast(app, message);
    } catch (error) {
      showAmbToast(app, 'Copy unavailable. Select the note manually.');
    }
    field.remove();
  }

  function showAmbToast(app, message) {
    var toast = app.querySelector('[data-vt-toast]');
    if (!toast) return;
    toast.textContent = message;
    toast.hidden = false;
    window.clearTimeout(app._vtAmbToast);
    app._vtAmbToast = window.setTimeout(function () { toast.hidden = true; }, 2400);
  }

  function ambRandom(items) {
    return items[Math.floor(Math.random() * items.length)];
  }

  function ambShuffle(items) {
    for (var i = items.length - 1; i > 0; i -= 1) {
      var index = Math.floor(Math.random() * (i + 1));
      var value = items[i];
      items[i] = items[index];
      items[index] = value;
    }
    return items;
  }

  window.OptiplexDtvpRunQa = function () {
    var config = dtvpSubtestConfig();
    var report = {
      generatedAt: new Date().toISOString(),
      summary: [],
      issues: []
    };
    Object.keys(config || {}).forEach(function (subtestKey) {
      var subtest = config[subtestKey];
      var examples = subtest.examples || [];
      var items = subtest.items || [];
      var scoredMax = items.reduce(function (total, item) {
        return total + (Number(item.maxPoints) || 0);
      }, 0);
      report.summary.push({
        key: subtestKey,
        title: subtest.title,
        examples: examples.length,
        scoredItems: items.length,
        rawMax: subtest.rawMax,
        summedItemMax: scoredMax
      });
      if (subtestKey === 'eyeHand' && items.length !== 5) report.issues.push(subtest.title + ': expected 5 hand-eye items.');
      if (subtestKey === 'copying' && items.length !== 18) report.issues.push(subtest.title + ': expected 18 copying items.');
      if (subtestKey === 'figureGround' && (examples.length !== 2 || items.length !== 23)) report.issues.push(subtest.title + ': expected 2 examples and 23 scored Figure-Ground items.');
      if (subtestKey === 'visualClosure' && items.length !== 26) report.issues.push(subtest.title + ': expected 26 scored visual-closure items.');
      if (subtestKey === 'formConstancy' && (examples.length !== 2 || items.length !== 24)) report.issues.push(subtest.title + ': expected 2 examples and 24 scored Form Constancy items.');
      if ((subtestKey === 'figureGround' || subtestKey === 'formConstancy') && scoredMax !== subtest.rawMax) {
        report.issues.push(subtest.title + ': summed item max ' + scoredMax + ' does not equal raw max ' + subtest.rawMax + '.');
      }
      if (subtestKey === 'visualClosure' && items.length !== subtest.rawMax) {
        report.issues.push(subtest.title + ': item count should equal raw max ' + subtest.rawMax + '.');
      }
      examples.concat(items).forEach(function (item) {
        var label = subtest.title + ' ' + (item.isPractice ? 'Example ' : 'Item ') + item.number;
        var imageSrc = dtvpEntryImageSrc(item, subtest);
        if ((item.imageAsset || item.svgAssetKey || item.imageKey) && !imageSrc) report.issues.push(label + ': asset key has no mapped URL.');
        (item.options || []).forEach(function (option) {
          if (!option.label) report.issues.push(label + ': option missing label.');
        });
        (item.correctAnswerIds || []).forEach(function (id) {
          var exists = (item.options || []).some(function (option) { return option.label === id; });
          if (!exists && subtest.mode !== 'copying' && subtest.mode !== 'tracing') report.issues.push(label + ': correct answer ' + id + ' is not in option list.');
        });
        if (!item.maxPoints) report.issues.push(label + ': missing maxPoints.');
      });
    });
    return report;
  };
})();
